/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string | Date; output: string | Date; }
  JSONObject: { input: any; output: any; }
  ObjectID: { input: string; output: string; }
  Upload: { input: File; output: File; }
};

export type AdditionalDetails = {
  __typename: 'AdditionalDetails';
  description?: Maybe<TranslatedString>;
  id: Scalars['ObjectID']['output'];
  image?: Maybe<UploadedFileWithPreview>;
  title?: Maybe<TranslatedString>;
};

export type AdditionalDetailsInput = {
  description: TranslatedStringInput;
  title: TranslatedStringInput;
};

export type AdditionalIntegrationParameter = {
  __typename: 'AdditionalIntegrationParameter';
  purpose: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AdditionalIntegrationParameterInput = {
  purpose: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum AddressType {
  Office = 'Office',
  Residential = 'Residential'
}

export type AdvancedVersioning = {
  __typename: 'AdvancedVersioning';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Author>;
  isLatest: Scalars['Boolean']['output'];
  suiteId: Scalars['ObjectID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Author>;
};

export type AdyenPaymentModule = Module & {
  __typename: 'AdyenPaymentModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Payment Settings */
  paymentSettings: Array<AdyenPaymentSetting>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type AdyenPaymentModuleSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
};

export type AdyenPaymentSetting = PaymentSetting & {
  __typename: 'AdyenPaymentSetting';
  /** Amount */
  amount: Scalars['Float']['output'];
  /** API key */
  apiKey: Scalars['String']['output'];
  /** Client key */
  clientKey: Scalars['String']['output'];
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Currency */
  currency: Scalars['String']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Environment */
  environment: Environment;
  /** HMAC key */
  hmacKeys: Array<Scalars['String']['output']>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Live Endpoint Url Prefix */
  liveEndpointUrlPrefix?: Maybe<Scalars['String']['output']>;
  /** Merchant account ID */
  merchantAccount: Scalars['String']['output'];
  /** Notification Password */
  password: Scalars['String']['output'];
  /** Payment module ID */
  paymentModuleId: Scalars['ObjectID']['output'];
  /** Notification Username */
  username: Scalars['String']['output'];
};

export type AdyenPaymentSettingsInput = {
  /** Amount */
  amount: Scalars['Float']['input'];
  /** API key */
  apiKey: Scalars['String']['input'];
  /** Client key */
  clientKey: Scalars['String']['input'];
  /** Currency */
  currency: Scalars['String']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Environment */
  environment: Environment;
  /** HMAC key */
  hmacKeys: Array<Scalars['String']['input']>;
  /** Live Endpoint Url Prefix */
  liveEndpointUrlPrefix?: InputMaybe<Scalars['String']['input']>;
  /** Merchant account ID */
  merchantAccount: Scalars['String']['input'];
  /** Notification Password */
  password: Scalars['String']['input'];
  /** Notification Username */
  username: Scalars['String']['input'];
};

export type AdyenRedirectionLink = {
  __typename: 'AdyenRedirectionLink';
  path: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export enum AffinAutoFinanceCentre {
  AlorSetar = 'AlorSetar',
  BandarBaruBangi = 'BandarBaruBangi',
  BatuPahat = 'BatuPahat',
  Ipoh = 'Ipoh',
  JalanIpoh = 'JalanIpoh',
  JohorBahru = 'JohorBahru',
  JohorJaya = 'JohorJaya',
  Juru = 'Juru',
  KotaBharu = 'KotaBharu',
  KotaKinabalu = 'KotaKinabalu',
  KualaTerengganu = 'KualaTerengganu',
  Kuantan = 'Kuantan',
  Kuching = 'Kuching',
  Melaka = 'Melaka',
  Penang = 'Penang',
  PjSs2 = 'PjSS2',
  PjState = 'PjState',
  Sandakan = 'Sandakan',
  Seremban = 'Seremban',
  SeriKembangan = 'SeriKembangan',
  Sibu = 'Sibu',
  TamanMaluri = 'TamanMaluri'
}

export type AmendMobilityApplicationAccess = {
  __typename: 'AmendMobilityApplicationAccess';
  url?: Maybe<Scalars['String']['output']>;
};

export enum AmountUnit {
  Currency = 'Currency',
  Percentage = 'Percentage'
}

export type ApplicantAgreementSettings = {
  /** Consent ID */
  id: Scalars['ObjectID']['input'];
  /** Marketing platforms agreed, for marketing consents */
  platformsAgreed?: InputMaybe<MarketingPlatformsAgreedInput>;
};

export type Application = {
  appointmentStage?: Maybe<AppointmentStage>;
  /** assignees this application can be assigned to */
  availableAssignees: Array<User>;
  financingStage?: Maybe<FinancingStage>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  insuranceStage?: Maybe<InsuranceStage>;
  latestStage?: Maybe<ApplicationStageDetails>;
  leadStage?: Maybe<LeadStage>;
  mobilityStage?: Maybe<MobilityStage>;
  module: Module;
  /** ModuleId */
  moduleId: Scalars['ObjectID']['output'];
  permissions: Array<Maybe<Scalars['String']['output']>>;
  remarks: Scalars['String']['output'];
  reservationStage?: Maybe<ReservationStage>;
  stages: Array<ApplicationStage>;
  /** Versioning */
  versioning: AdvancedVersioning;
};

export type ApplicationAdyenDeposit = ApplicationDeposit & {
  __typename: 'ApplicationAdyenDeposit';
  amount: Scalars['Float']['output'];
  clientKey: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  environment: Scalars['String']['output'];
  gateway: Scalars['String']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  sessionData?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  skipped?: Maybe<Scalars['Boolean']['output']>;
  status: PaymentStatus;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type ApplicationAgreement = {
  /** Conditions */
  conditions?: Maybe<Array<Condition>>;
  /** Data field */
  dataField: DataField;
  /** Description */
  description?: Maybe<TranslatedString>;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is agreed by the customer */
  isAgreed: Scalars['Boolean']['output'];
  /** Order Number */
  orderNumber: Scalars['Int']['output'];
  /** Purpose */
  purpose: Array<ConsentsAndDeclarationsPurpose>;
  /** Title */
  title?: Maybe<TranslatedString>;
  /** C&D type */
  type: ConsentsAndDeclarationsType;
};

export type ApplicationComboOption = {
  __typename: 'ApplicationComboOption';
  charLimit?: Maybe<Scalars['Int']['output']>;
  comboType: ComboType;
  descriptions?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ObjectID']['output'];
  label: TranslatedString;
  placeholder?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type ApplicationComboSettings = {
  __typename: 'ApplicationComboSettings';
  kind?: Maybe<OptionKind>;
  options?: Maybe<Array<Maybe<ApplicationComboOption>>>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type ApplicationConfiguration = {
  __typename: 'ApplicationConfiguration';
  isAffinAutoFinanceCentreRequired?: Maybe<Scalars['Boolean']['output']>;
  testDrive: Scalars['Boolean']['output'];
  tradeIn: Scalars['Boolean']['output'];
  withFinancing: Scalars['Boolean']['output'];
  withInsurance: Scalars['Boolean']['output'];
};

export type ApplicationConfiguratorBlock = ApplicationConfiguratorColorSetting | ApplicationConfiguratorOptionSetting | ApplicationConfiguratorPackageSetting | ApplicationConfiguratorTrimSetting;

export type ApplicationConfiguratorColorSetting = {
  __typename: 'ApplicationConfiguratorColorSetting';
  blockId: Scalars['ObjectID']['output'];
  type: BlockType;
  value?: Maybe<ColorAndTrimSettings>;
};

export type ApplicationConfiguratorOptionSetting = {
  __typename: 'ApplicationConfiguratorOptionSetting';
  blockId: Scalars['ObjectID']['output'];
  type: BlockType;
  value?: Maybe<ApplicationOptionSettings>;
};

export type ApplicationConfiguratorPackageSetting = {
  __typename: 'ApplicationConfiguratorPackageSetting';
  blockId: Scalars['ObjectID']['output'];
  type: BlockType;
  value?: Maybe<PackageSettings>;
};

export type ApplicationConfiguratorTrimSetting = {
  __typename: 'ApplicationConfiguratorTrimSetting';
  blockId: Scalars['ObjectID']['output'];
  type: BlockType;
  value?: Maybe<ColorAndTrimSettings>;
};

export type ApplicationCustomerDraft = {
  existingLocalCustomer?: InputMaybe<Scalars['ObjectID']['input']>;
  newLocalCustomer?: InputMaybe<ApplicationNewLocalCustomerDraft>;
};

export type ApplicationDeposit = {
  amount: Scalars['Float']['output'];
  gateway: Scalars['String']['output'];
  skipped?: Maybe<Scalars['Boolean']['output']>;
  status: PaymentStatus;
};

export type ApplicationDocument = UploadFileInterface & {
  __typename: 'ApplicationDocument';
  /** E-Tag */
  etag: Scalars['String']['output'];
  /** Original filename */
  filename: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is this file temporay */
  isTemporary?: Maybe<Scalars['Boolean']['output']>;
  /** Kind of application */
  kind: ApplicationDocumentKind;
  /** Preview image */
  preview?: Maybe<UploadedFile>;
  /** Filesize */
  size: Scalars['Int']['output'];
  /** Upload date */
  uploadedAt: Scalars['DateTime']['output'];
  /**
   * Signed URL
   *
   * Private image will return a signed URL with a 1H validity
   */
  url?: Maybe<Scalars['String']['output']>;
};

export enum ApplicationDocumentKind {
  Agreement = 'Agreement',
  ApprovalAdvice = 'ApprovalAdvice',
  /** Corporate KYC's related documents */
  CorporateIdentity = 'CorporateIdentity',
  CustomerDlCopy = 'CustomerDLCopy',
  CustomerEidPassportCopy = 'CustomerEIDPassportCopy',
  /** Applicant KYC's related documents */
  CustomerIdentity = 'CustomerIdentity',
  /** Guarantor KYC's related documents */
  GuarantorIdentity = 'GuarantorIdentity',
  IdentityCardBack = 'IdentityCardBack',
  IdentityCardFront = 'IdentityCardFront',
  InsuranceAgreement = 'InsuranceAgreement',
  InsuranceCoverNote = 'InsuranceCoverNote',
  Invoice = 'Invoice',
  KycIdentityUpload = 'KYCIdentityUpload',
  KycLicenseUpload = 'KYCLicenseUpload',
  KycOtherDocumentUpload = 'KYCOtherDocumentUpload',
  KycPassportUpload = 'KYCPassportUpload',
  /** KYC salary transferred bank set */
  KycSalaryTransferredBankUpload = 'KYCSalaryTransferredBankUpload',
  /** KYC UAE identity set */
  KycUaeIdentityUpload = 'KYCUaeIdentityUpload',
  LogCard = 'LogCard',
  OtherAttachment = 'OtherAttachment',
  ReleaseLetter = 'ReleaseLetter',
  SignedVsa = 'SignedVsa',
  TestDriveAgreement = 'TestDriveAgreement',
  VsoUpload = 'VSOUpload'
}

export type ApplicationDocumentPayload = {
  kind: ApplicationDocumentKind;
  upload: Scalars['Upload']['input'];
};

export type ApplicationFilter = {
  __typename: 'ApplicationFilter';
  applicationStatus: Array<ApplicationStatus>;
  companies: Array<Company>;
  mobilityLocations: Array<MobilityBookingLocation>;
  modules: Array<Module>;
};

export type ApplicationFilteringRule = {
  /** Filter by applicant IDs (customer ID) */
  applicantIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by Appointment Date Range */
  appointmentDateRange?: InputMaybe<PeriodPayload>;
  /** Filter by Assignee */
  assignee?: InputMaybe<Scalars['String']['input']>;
  /** Filter by bank */
  bank?: InputMaybe<Scalars['String']['input']>;
  /** Filter by C@P Lead ID */
  capLeadId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by company ID */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by configurator ID */
  configuratorId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by Booking Submitted Date Range */
  createdDateRange?: InputMaybe<PeriodPayload>;
  /** Current Month */
  currentMonth?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by customer fullName */
  customer?: InputMaybe<Scalars['String']['input']>;
  /** Filter by dealer ids */
  dealerIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Dealer Name */
  dealerName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Booking End Date Range */
  endDateRange?: InputMaybe<PeriodPayload>;
  /** Filter by event ID */
  eventId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by finance product */
  financeProduct?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Finder Vehicle VIN */
  finderVehicleVin?: InputMaybe<Scalars['String']['input']>;
  /** Filter by kind */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Filter by insurer */
  insurer?: InputMaybe<Scalars['String']['input']>;
  inventoryStockId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Search Keyword */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Filter by kind */
  kind?: InputMaybe<ApplicationKind>;
  /** Last Month */
  lastMonth?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mobility Booking Location */
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by application module ID */
  moduleIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Module Name */
  moduleName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by application stage */
  stage?: InputMaybe<ApplicationStage>;
  /** Filter by Booking Start Date Range */
  startDateRange?: InputMaybe<PeriodPayload>;
  /** Application Status */
  status?: InputMaybe<Array<ApplicationStatus>>;
  /** Filter by TransactionId */
  transactionId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by vehicle */
  vehicle?: InputMaybe<Scalars['String']['input']>;
  /** Filter by vehicle names */
  vehicleNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by stock vin */
  vin?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationFinanceSettings = {
  /** Default finance settings for applications. */
  default?: InputMaybe<DefaultApplicationFinanceSettings>;
  /** Finance settings for New Zealand applications */
  newZealand?: InputMaybe<NewZealandApplicationFinanceSettings>;
  /** Finance settings for singapore applications (including COE) */
  singapore?: InputMaybe<SingaporeApplicationFinanceSettings>;
};

export type ApplicationFinancing = {
  /** Market */
  market: ApplicationMarket;
};

export type ApplicationFiservDeposit = ApplicationDeposit & {
  __typename: 'ApplicationFiservDeposit';
  amount: Scalars['Float']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  gateway: Scalars['String']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  skipped?: Maybe<Scalars['Boolean']['output']>;
  status: PaymentStatus;
  storeName: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type ApplicationInsuranceSettings = {
  /** Default insurancing settings for application */
  default?: InputMaybe<DefaultApplicationInsuranceSettings>;
  /** Insurance settings for new zealand market */
  newZealand?: InputMaybe<NewZealandApplicationInsuranceSettings>;
  /** Insurance settings for singapore market */
  singapore?: InputMaybe<SingaporeApplicationInsuranceSettings>;
};

export type ApplicationInsurancing = {
  /** Market */
  market: ApplicationMarket;
};

export type ApplicationJourney = {
  __typename: 'ApplicationJourney';
  /** Application running on the journey */
  application: Application;
  /** Redirection Link */
  redirectionLink?: Maybe<Scalars['String']['output']>;
  /** Token to be used when operating on the application journey */
  token: Scalars['String']['output'];
};

export enum ApplicationJourneySigningMode {
  Namirial = 'Namirial',
  Otp = 'OTP'
}

export enum ApplicationKind {
  AudiFinancingApplication = 'AudiFinancingApplication',
  BmwApplication = 'BmwApplication',
  Configurator = 'Configurator',
  Event = 'Event',
  Finder = 'Finder',
  Mobility = 'Mobility',
  SdmApplication = 'SDMApplication',
  Standard = 'Standard'
}

export type ApplicationListEndpoint = Endpoint & {
  __typename: 'ApplicationListEndpoint';
  /** Application module IDs */
  applicationModuleIds: Array<Scalars['ObjectID']['output']>;
  /** Application modules */
  applicationModules: Array<Module>;
  /** Application Stage */
  applicationStage: ApplicationStage;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Pathname */
  pathname: Scalars['String']['output'];
  /** Endpoint Listing Title */
  title: Scalars['String']['output'];
};

export type ApplicationListEndpointSettings = {
  /** Application module IDs */
  applicationModuleIds: Array<Scalars['ObjectID']['input']>;
  /** Application Stage */
  applicationStage: ApplicationStage;
  /** Pathname */
  pathname: Scalars['String']['input'];
  /** Endpoint Listing Title */
  title: Scalars['String']['input'];
};

export enum ApplicationMarket {
  /** Generic market */
  Default = 'Default',
  /** New Zealand market */
  NewZealand = 'NewZealand',
  /** Singapore market */
  Singapore = 'Singapore'
}

export type ApplicationMarketType = {
  type: ApplicationMarket;
};

export type ApplicationMarketTypeInput = {
  newZealand?: InputMaybe<NewZealandApplicationMarketTypeInput>;
  singapore?: InputMaybe<SingaporeApplicationMarketTypeInput>;
};

export type ApplicationMessage = {
  __typename: 'ApplicationMessage';
  originPath?: Maybe<Scalars['String']['output']>;
};

export type ApplicationModuleCondition = Condition & {
  __typename: 'ApplicationModuleCondition';
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  type: ConditionType;
};

export type ApplicationModuleConditionSettings = {
  moduleId: Scalars['ObjectID']['input'];
};

export type ApplicationModuleMarketTypeInput = {
  newZealand?: InputMaybe<NewZealandApplicationModuleMarketTypeInput>;
  singapore?: InputMaybe<SingaporeApplicationModuleMarketTypeInput>;
};

export type ApplicationMonthlyInstalment = {
  __typename: 'ApplicationMonthlyInstalment';
  amount: Scalars['Float']['output'];
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type ApplicationMonthlyInstalmentPayload = {
  amount: Scalars['Float']['input'];
  end: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
};

export type ApplicationNamirialSigning = ApplicationSigning & {
  __typename: 'ApplicationNamirialSigning';
  envelopeId?: Maybe<Scalars['String']['output']>;
  kind: ApplicationJourneySigningMode;
  redirectionUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ApplicationSigningStatus>;
};

export type ApplicationNewLocalCustomerDraft = {
  fields: Array<LocalCustomerFieldSettings>;
};

export type ApplicationOtpSigning = ApplicationSigning & {
  __typename: 'ApplicationOTPSigning';
  kind: ApplicationJourneySigningMode;
};

export type ApplicationOptionSettings = ApplicationComboSettings | DropdownOptionSettings | MultiSelectOptionSettings | SingleSelectOptionSettings;

export type ApplicationPayGateDeposit = ApplicationDeposit & {
  __typename: 'ApplicationPayGateDeposit';
  amount: Scalars['Float']['output'];
  apiKey: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  gateway: Scalars['String']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  skipped?: Maybe<Scalars['Boolean']['output']>;
  status: PaymentStatus;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type ApplicationPorscheDeposit = ApplicationDeposit & {
  __typename: 'ApplicationPorscheDeposit';
  amount: Scalars['Float']['output'];
  apiKey: Scalars['String']['output'];
  assortment: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  environment: Scalars['String']['output'];
  gateway: Scalars['String']['output'];
  minorUnitsAmount: Scalars['Float']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  redirectUrl: Scalars['String']['output'];
  skipped?: Maybe<Scalars['Boolean']['output']>;
  status: PaymentStatus;
  transactionId?: Maybe<Scalars['String']['output']>;
  widgetUrl: Scalars['String']['output'];
};

export type ApplicationQuotation = {
  /** Quotation Source */
  source: ApplicationQuotationSource;
};

export enum ApplicationQuotationDownPaymentTarget {
  Branch = 'Branch',
  Dealer = 'Dealer'
}

export type ApplicationQuotationOption = {
  __typename: 'ApplicationQuotationOption';
  amount: Scalars['Float']['output'];
  amountIncludingVat: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isVatIncluded: Scalars['Boolean']['output'];
};

export type ApplicationQuotationOptionSetting = {
  amountIncludingVat: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isVatIncluded: Scalars['Boolean']['input'];
};

export type ApplicationQuotationSettings = {
  enbd?: InputMaybe<EnbdApplicationQuotationSettings>;
  source: ApplicationQuotationSource;
};

export enum ApplicationQuotationSource {
  Enbd = 'ENBD'
}

export enum ApplicationScenario {
  Appointment = 'Appointment',
  Booking = 'Booking',
  Financing = 'Financing',
  Insurance = 'Insurance',
  LeadCapture = 'LeadCapture',
  Payment = 'Payment'
}

export type ApplicationSigning = {
  kind: ApplicationJourneySigningMode;
};

export enum ApplicationSigningPurpose {
  /** Signing is for finance application */
  Finance = 'Finance',
  /** Signing is for insurance application */
  Insurance = 'Insurance',
  /** Signing for mobility application */
  Mobility = 'Mobility',
  /** Test Drive */
  TestDrive = 'TestDrive'
}

export enum ApplicationSigningStatus {
  Completed = 'Completed',
  Error = 'Error',
  InProgress = 'InProgress',
  Initialized = 'Initialized',
  Rejected = 'Rejected',
  Timeout = 'Timeout'
}

export enum ApplicationSortingField {
  ApplicationDate = 'ApplicationDate',
  ApplicationStatus = 'ApplicationStatus',
  AppointmentDate = 'AppointmentDate',
  Assignee = 'Assignee',
  Bank = 'Bank',
  BookingEndDate = 'BookingEndDate',
  BookingLocation = 'BookingLocation',
  BookingStartDate = 'BookingStartDate',
  BookingSubmitted = 'BookingSubmitted',
  CapLeadId = 'CapLeadId',
  Company = 'Company',
  Customer = 'Customer',
  FinanceProduct = 'FinanceProduct',
  FinderVin = 'FinderVin',
  Identifier = 'Identifier',
  InsurancePremium = 'InsurancePremium',
  Insurer = 'Insurer',
  LastActivity = 'LastActivity',
  Module = 'Module',
  TotalAmountPaid = 'TotalAmountPaid',
  TransactionId = 'TransactionId',
  Vehicle = 'Vehicle',
  VehicleName = 'VehicleName'
}

export type ApplicationSortingRule = {
  field: ApplicationSortingField;
  order: SortingOrder;
};

export enum ApplicationStage {
  /** Application is an appointment */
  Appointment = 'Appointment',
  /** Application is a finance application */
  Financing = 'Financing',
  /** Application is an insurance */
  Insurance = 'Insurance',
  /** Application is a lead */
  Lead = 'Lead',
  /** Application is a mobility booking */
  Mobility = 'Mobility',
  /** Application is a reservation */
  Reservation = 'Reservation'
}

export type ApplicationStageDetails = {
  assignee?: Maybe<User>;
  /** Assignee */
  assigneeId?: Maybe<Scalars['ObjectID']['output']>;
  /** Identifier */
  identifier: Scalars['String']['output'];
  /** Current status */
  status: ApplicationStatus;
};

export enum ApplicationStatus {
  /** Application is activated */
  Activated = 'Activated',
  /** Agreement Concluded */
  AgreementConcluded = 'AgreementConcluded',
  /** Pending for user update KYC */
  ApplicantDetailsPendingUpdate = 'ApplicantDetailsPendingUpdate',
  /** Applicant details for the application have been received */
  ApplicantDetailsReceived = 'ApplicantDetailsReceived',
  /** Application is received */
  ApplicationReceived = 'ApplicationReceived',
  /** CheckIn for appointment */
  AppointmentCheckIn = 'AppointmentCheckIn',
  /** Application is approved */
  Approved = 'Approved',
  /** Bank review in progress, renamed from `BankCustomerInfoReceived` */
  BankReviewInProgress = 'BankReviewInProgress',
  /** Booking Confirmed */
  BookingConfirmed = 'BookingConfirmed',
  /** Application cancellation is failed */
  CancellationdFailed = 'CancellationdFailed',
  /** Application is cancelled */
  Cancelled = 'Cancelled',
  /** CheckIn for mobility */
  CheckIn = 'CheckIn',
  /** Application is completed */
  Completed = 'Completed',
  /** Connection Failed */
  ConnectionFailed = 'ConnectionFailed',
  /** Appointment Contacted */
  Contacted = 'Contacted',
  /** Application is declined */
  Declined = 'Declined',
  /** Application is drafted */
  Drafted = 'Drafted',
  /** Financing Application Expired (by bank) */
  Expired = 'Expired',
  /** Financing Request */
  FinancingRequest = 'FinancingRequest',
  /** Pending for Guarantor update KYC */
  GuarantorDetailsPendingUpdate = 'GuarantorDetailsPendingUpdate',
  /** Guarantor details for the application have been received */
  GuarantorDetailsReceived = 'GuarantorDetailsReceived',
  /** Guarantor Signing Completed */
  GuarantorSigningCompleted = 'GuarantorSigningCompleted',
  /** Guarantor Signing Initiated */
  GuarantorSigningInitiated = 'GuarantorSigningInitiated',
  /** Guarantor Signing Pending */
  GuarantorSigningPending = 'GuarantorSigningPending',
  /** Guarantor Signing Rejected */
  GuarantorSigningRejected = 'GuarantorSigningRejected',
  /** Insurance Approved */
  InsuranceApproved = 'InsuranceApproved',
  /** Insurance Cancelled */
  InsuranceCancelled = 'InsuranceCancelled',
  /** Insurance company review in progress */
  InsuranceCompanyReviewInProgress = 'InsuranceCompanyReviewInProgress',
  /** Insurance Declined */
  InsuranceDeclined = 'InsuranceDeclined',
  /** Application is a Lead */
  Lead = 'Lead',
  /** New Appointment */
  NewAppointment = 'NewAppointment',
  /** New Lead */
  NewLead = 'NewLead',
  /** New Mobility */
  NewMobility = 'NewMobility',
  /** OTP is completed */
  OtpCompleted = 'OTPCompleted',
  /** OTP is pending */
  OtpPending = 'OTPPending',
  /** Payment is completed */
  PaymentCompleted = 'PaymentCompleted',
  /** Payment has failed */
  PaymentFailed = 'PaymentFailed',
  /** Payment Pending */
  PaymentPending = 'PaymentPending',
  /** Payment received */
  PaymentReceived = 'PaymentReceived',
  /** Payment is received offline */
  PaymentReceivedOffline = 'PaymentReceivedOffline',
  /** Payment refunded */
  PaymentRefunded = 'PaymentRefunded',
  /** Payment took long to finish */
  PaymentTimeout = 'PaymentTimeout',
  /** Pending for applicant confirmation */
  PendingCustomerConfirmation = 'PendingCustomerConfirmation',
  /** Pending Disbursement */
  PendingDisbursement = 'PendingDisbursement',
  /** Lead Application Qualified */
  Qualified = 'Qualified',
  /** Application resubmission failed to bank */
  ResubmissionToBankFailed = 'ResubmissionToBankFailed',
  /** Application is resubmitted to bank */
  ResubmittedToBank = 'ResubmittedToBank',
  /** Application is resubmitted in our system */
  ResubmittedToSystem = 'ResubmittedToSystem',
  /** Application is shared */
  Shared = 'Shared',
  /** Signing Completed */
  SigningCompleted = 'SigningCompleted',
  /** Signing Creation Failed */
  SigningCreationFailed = 'SigningCreationFailed',
  /** Signing Initiated */
  SigningInitiated = 'SigningInitiated',
  /** Signing Pending */
  SigningPending = 'SigningPending',
  /** Signing Rejected */
  SigningRejected = 'SigningRejected',
  /** Signing took long to finish */
  SigningTimeout = 'SigningTimeout',
  /** Application submission is failed */
  SubmissionFailed = 'SubmissionFailed',
  /** Application submission failed to bank */
  SubmissionToBankFailed = 'SubmissionToBankFailed',
  /** Submission to insurance company failed */
  SubmissionToInsuranceCompanyFailed = 'SubmissionToInsuranceCompanyFailed',
  /** Application is submitted to bank */
  SubmittedToBank = 'SubmittedToBank',
  /** Submitted to insurance company */
  SubmittedToInsuranceCompany = 'SubmittedToInsuranceCompany',
  /** Application is submitted in our system */
  SubmittedToSystem = 'SubmittedToSystem',
  /** Test Drive Completed */
  TestDriveCompleted = 'TestDriveCompleted',
  /** Test Drive Details Pending Update */
  TestDriveDetailsPendingUpdate = 'TestDriveDetailsPendingUpdate',
  /** Test Drive Details Received */
  TestDriveDetailsReceived = 'TestDriveDetailsReceived',
  /** Test Drive Namirial Completed */
  TestDriveSigningCompleted = 'TestDriveSigningCompleted',
  /** Test Drive Namirial */
  TestDriveSigningInitiated = 'TestDriveSigningInitiated',
  /** Test Drive Namirial Pending */
  TestDriveSigningPending = 'TestDriveSigningPending',
  /** Test Drive Namirial Reject */
  TestDriveSigningRejected = 'TestDriveSigningRejected',
  /** Test Drive Started */
  TestDriveStarted = 'TestDriveStarted',
  /** Application is unable to be cancelled */
  UnableToCancel = 'UnableToCancel',
  /** Unable to Connect */
  UnableToConnect = 'UnableToConnect',
  /** Application is unable to submitted in our system */
  UnableToSubmit = 'UnableToSubmit',
  /** Unable to make payment */
  UnabletoMakePayment = 'UnabletoMakePayment',
  /** Lead Application Unqualified */
  Unqualified = 'Unqualified'
}

export type ApplicationSubmitFinancing = {
  financing: ApplicationFinanceSettings;
  promoCodeId?: InputMaybe<Scalars['ObjectID']['input']>;
  variantId: Scalars['ObjectID']['input'];
};

export type ApplicationSubmitInsurance = {
  insurancing: ApplicationInsuranceSettings;
  variantId: Scalars['ObjectID']['input'];
};

export type ApplicationSubmitMobilityBooking = {
  location: MobilityBookingLocationPayload;
  period: PeriodPayload;
  userTimezone: Scalars['String']['input'];
};

export type ApplicationTtbDeposit = ApplicationDeposit & {
  __typename: 'ApplicationTtbDeposit';
  amount: Scalars['Float']['output'];
  apiKey: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  controllerInternalId?: Maybe<Scalars['String']['output']>;
  gateway: Scalars['String']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  pspReferenceNo?: Maybe<Scalars['String']['output']>;
  skipped?: Maybe<Scalars['Boolean']['output']>;
  status: PaymentStatus;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type ApplicationUpdate = {
  configuration?: InputMaybe<ApplicationUpdateConfiguration>;
  otherVehicleInformation?: InputMaybe<OtherVehicleInformationSettings>;
  updateAppointmentDetails?: InputMaybe<ApplicationUpdateAppointmentDetails>;
  updateFinancing?: InputMaybe<ApplicationSubmitFinancing>;
  updateInsurance?: InputMaybe<ApplicationSubmitInsurance>;
  updateLocalCustomer?: InputMaybe<Array<LocalCustomerFieldSettings>>;
  updateMobilityBooking?: InputMaybe<ApplicationSubmitMobilityBooking>;
  updateQuotationDetails?: InputMaybe<ApplicationQuotationSettings>;
};

export type ApplicationUpdateAppointmentDateTimeData = {
  bookingTimeSlot?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApplicationUpdateAppointmentDetails = {
  bookingTimeSlot?: InputMaybe<Scalars['DateTime']['input']>;
  mileage?: InputMaybe<ApplicationUpdateAppointmentMileage>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationUpdateAppointmentMileage = {
  end?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type ApplicationUpdateConfiguration = {
  isAffinAutoFinanceCentreRequired?: InputMaybe<Scalars['Boolean']['input']>;
  testDrive?: InputMaybe<Scalars['Boolean']['input']>;
  tradeIn?: InputMaybe<Scalars['Boolean']['input']>;
  withFinancing?: InputMaybe<Scalars['Boolean']['input']>;
  withInsurance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationUpdateTestDriveDetails = {
  changedVehicle?: InputMaybe<AppointmentChangedVehicleInput>;
  hasChangedVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  mileage?: InputMaybe<ApplicationUpdateAppointmentMileage>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationValueSetting = {
  __typename: 'ApplicationValueSetting';
  amount: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
};

export type ApplicationVehicleDraft = {
  existingSimpleLocalVehicleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type ApplyNewRedirectionLink = {
  __typename: 'ApplyNewRedirectionLink';
  applicationJourney: ApplicationJourney;
  endpoint: Endpoint;
  router: Router;
};

export type AppointmentBlockedTimeSlot = {
  __typename: 'AppointmentBlockedTimeSlot';
  dateTimeSlot: Array<Scalars['DateTime']['output']>;
};

export type AppointmentBookingTimeSlot = {
  __typename: 'AppointmentBookingTimeSlot';
  bookingLimit: Scalars['Int']['output'];
  slot?: Maybe<Scalars['DateTime']['output']>;
};

export type AppointmentChangedVehicle = AppointmentChangedVehicleLocal | AppointmentChangedVehicleText;

export type AppointmentChangedVehicleInput = {
  kind: AppointmentChangedVehicleKind;
  local?: InputMaybe<AppointmentChangedVehicleLocalInput>;
  text?: InputMaybe<AppointmentChangedVehicleTextInput>;
};

export enum AppointmentChangedVehicleKind {
  Local = 'Local',
  Text = 'Text'
}

export type AppointmentChangedVehicleLocal = {
  __typename: 'AppointmentChangedVehicleLocal';
  /** Kind */
  kind?: Maybe<AppointmentChangedVehicleKind>;
  /** Vehicle ID, in this case variant id */
  vehicleId: Scalars['ObjectID']['output'];
};

export type AppointmentChangedVehicleLocalInput = {
  vehicleId: Scalars['ObjectID']['input'];
};

export type AppointmentChangedVehicleText = {
  __typename: 'AppointmentChangedVehicleText';
  /** Kind */
  kind?: Maybe<AppointmentChangedVehicleKind>;
  /** Model */
  model?: Maybe<Scalars['String']['output']>;
  /** Submodel */
  subModel?: Maybe<Scalars['String']['output']>;
  /** Variant */
  variant: Scalars['String']['output'];
};

export type AppointmentChangedVehicleTextInput = {
  model?: InputMaybe<Scalars['String']['input']>;
  subModel?: InputMaybe<Scalars['String']['input']>;
  variant: Scalars['String']['input'];
};

export type AppointmentMileage = {
  __typename: 'AppointmentMileage';
  end?: Maybe<Scalars['Float']['output']>;
  start?: Maybe<Scalars['Float']['output']>;
};

export type AppointmentModule = Module & {
  __typename: 'AppointmentModule';
  /** Advanced Booking Limit */
  advancedBookingLimit: Scalars['Int']['output'];
  /** Booking Information */
  bookingInformation?: Maybe<TranslatedString>;
  /** Booking Time Slot */
  bookingTimeSlot: Array<AppointmentTimeSlot>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Email Contents */
  emailContents: AppointmentModuleEmailContents;
  /** Test Drive */
  hasTestDriveProcess: Scalars['Boolean']['output'];
  /** has Test Drive Signing */
  hasTestDriveSigning?: Maybe<Scalars['Boolean']['output']>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Max Advanced Booking Limit */
  maxAdvancedBookingLimit?: Maybe<Scalars['Int']['output']>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /**
   * Show Remote Flow
   * Proceed with Customer Device
   */
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['output'];
  /** Signing Module */
  signingModule?: Maybe<Module>;
  /** Signing Module ID */
  signingModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Unavailable Day of Week */
  unavailableDayOfWeek: Array<DayOfWeek>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export enum AppointmentModuleAsset {
  CustomerBookingAmendment = 'CustomerBookingAmendment',
  CustomerBookingConfirmation = 'CustomerBookingConfirmation',
  CustomerEndTestDrive = 'CustomerEndTestDrive',
  CustomerSubmitConfirmation = 'CustomerSubmitConfirmation',
  SalesPersonFinderReservation = 'SalesPersonFinderReservation',
  SalesPersonSubmitConfirmation = 'SalesPersonSubmitConfirmation'
}

export type AppointmentModuleEmailContent = {
  __typename: 'AppointmentModuleEmailContent';
  contentText: DealerTranslatedStringSetting;
  introImage?: Maybe<UploadedFileWithPreview>;
  introTitle: DealerTranslatedStringSetting;
  subject: DealerTranslatedStringSetting;
};

export type AppointmentModuleEmailContentCustomer = {
  __typename: 'AppointmentModuleEmailContentCustomer';
  bookingAmendment: AppointmentModuleEmailContent;
  bookingConfirmation: AppointmentModuleEmailContent;
  endTestDrive: AppointmentModuleEmailContent;
  submitConfirmation: AppointmentModuleEmailContent;
};

export type AppointmentModuleEmailContentCustomerInput = {
  bookingAmendment: AppointmentModuleEmailContentInput;
  bookingConfirmation: AppointmentModuleEmailContentInput;
  endTestDrive: AppointmentModuleEmailContentInput;
  submitConfirmation: AppointmentModuleEmailContentInput;
};

export type AppointmentModuleEmailContentFinderReservation = {
  __typename: 'AppointmentModuleEmailContentFinderReservation';
  contentText: DealerTranslatedStringSetting;
  introImage?: Maybe<UploadedFileWithPreview>;
  introTitle: DealerTranslatedStringSetting;
  listTestDriveItem?: Maybe<DealerTranslatedStringSetting>;
  listTestDriveTitle?: Maybe<DealerTranslatedStringSetting>;
  subject: DealerTranslatedStringSetting;
};

export type AppointmentModuleEmailContentFinderReservationInput = {
  contentText: DealerTranslatedStringSettingInput;
  introTitle: DealerTranslatedStringSettingInput;
  listTestDriveItem?: InputMaybe<DealerTranslatedStringSettingInput>;
  listTestDriveTitle?: InputMaybe<DealerTranslatedStringSettingInput>;
  subject: DealerTranslatedStringSettingInput;
};

export type AppointmentModuleEmailContentInput = {
  contentText: DealerTranslatedStringSettingInput;
  introTitle: DealerTranslatedStringSettingInput;
  subject: DealerTranslatedStringSettingInput;
};

export type AppointmentModuleEmailContentSalesPerson = {
  __typename: 'AppointmentModuleEmailContentSalesPerson';
  finderReservation: AppointmentModuleEmailContentFinderReservation;
  submitConfirmation: AppointmentModuleEmailContent;
};

export type AppointmentModuleEmailContentSalesPersonInput = {
  finderReservation: AppointmentModuleEmailContentFinderReservationInput;
  submitConfirmation: AppointmentModuleEmailContentInput;
};

export type AppointmentModuleEmailContents = {
  __typename: 'AppointmentModuleEmailContents';
  customer: AppointmentModuleEmailContentCustomer;
  salesPerson: AppointmentModuleEmailContentSalesPerson;
};

export type AppointmentModuleEmailContentsInput = {
  customer: AppointmentModuleEmailContentCustomerInput;
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentUpdateType: EmailContentUpdateType;
  salesPerson: AppointmentModuleEmailContentSalesPersonInput;
};

export type AppointmentModuleInitialSettings = {
  advancedBookingLimit: Scalars['Int']['input'];
  bookingInformation?: InputMaybe<TranslatedStringInput>;
  bookingTimeSlot: Array<AppointmentTimeSlotInput>;
  displayName: Scalars['String']['input'];
  hasTestDriveProcess: Scalars['Boolean']['input'];
  hasTestDriveSigning?: InputMaybe<Scalars['Boolean']['input']>;
  maxAdvancedBookingLimit?: InputMaybe<Scalars['Int']['input']>;
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['input'];
  signingModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  unavailableDayOfWeek: Array<DayOfWeek>;
};

export type AppointmentStage = ApplicationStageDetails & {
  __typename: 'AppointmentStage';
  appointmentModule: AppointmentModule;
  /** Appointment module */
  appointmentModuleId: Scalars['ObjectID']['output'];
  assignee?: Maybe<User>;
  /** Assignee */
  assigneeId?: Maybe<Scalars['ObjectID']['output']>;
  /** Appointment Slot */
  bookingTimeSlot: AppointmentBookingTimeSlot;
  changedVehicle?: Maybe<AppointmentChangedVehicle>;
  checkInTime?: Maybe<Scalars['DateTime']['output']>;
  checkOutTime?: Maybe<Scalars['DateTime']['output']>;
  hasChangedVehicle?: Maybe<Scalars['Boolean']['output']>;
  /** Identifier */
  identifier: Scalars['String']['output'];
  mileage?: Maybe<AppointmentMileage>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Current status */
  status: ApplicationStatus;
};

export type AppointmentTimeSlot = {
  __typename: 'AppointmentTimeSlot';
  bookingLimit: Scalars['Int']['output'];
  slot: Scalars['DateTime']['output'];
};

export type AppointmentTimeSlotInput = {
  bookingLimit: Scalars['Int']['input'];
  slot: Scalars['DateTime']['input'];
};

export enum AssetCondition {
  Demo = 'Demo',
  New = 'New',
  Used = 'Used'
}

export type AudiCalculationModule = Module & {
  __typename: 'AudiCalculationModule';
  /** Audi Calculation Settings */
  audiCalculationSettings: Array<AudiCalculationSetting>;
  /** Authorization settings for Audi Calculation */
  authorization?: Maybe<Authorization>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type AudiCalculationModuleInitialSettings = {
  /** Display name (for module) */
  displayName: Scalars['String']['input'];
};

export type AudiCalculationModuleUpdateSettings = {
  /** Display name (for module) */
  displayName: Scalars['String']['input'];
};

export type AudiCalculationSetting = {
  __typename: 'AudiCalculationSetting';
  /** Financing module */
  bankModule?: Maybe<BankModule>;
  /** Financing module ID */
  bankModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Dealer Price Disclaimer */
  dealerPriceDisclaimer?: Maybe<DealerPriceDisclaimer>;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** Finance product suite IDs */
  financeProductSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Finance products */
  financeProducts: Array<FinanceProduct>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Identifier */
  identifier: Scalars['String']['output'];
  /** Insurance module */
  insuranceModule?: Maybe<InsuranceModule>;
  /** Insurance module ID */
  insuranceModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Insurance product suite IDs */
  insuranceProductSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Insurance products */
  insuranceProducts: Array<InsuranceProduct>;
  /** Market */
  market: ApplicationMarket;
  /** Market setting */
  marketType: ApplicationMarketType;
  /** Dealer for Preowned Price Disclaimer */
  preownedDealerPriceDisclaimer?: Maybe<DealerPriceDisclaimer>;
  /** Vehicle module IDs, can be Simple Vehicle Management or Finder Vehicle Management */
  vehicleModuleIds: Array<Scalars['ObjectID']['output']>;
  /** Vehicle modules, can be Simple Vehicle Management or Finder Vehicle Management */
  vehicleModules: Array<Module>;
};

export type AudiCalculationSettingInitialInput = {
  /** Bank module ID */
  bankModuleId: Scalars['ObjectID']['input'];
  /** Display name (for setting) */
  displayName: Scalars['String']['input'];
  /** Identifier */
  identifier: Scalars['String']['input'];
  /** Insurance module ID */
  insuranceModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Market specific inputs */
  market?: InputMaybe<ApplicationMarket>;
  marketType?: InputMaybe<ApplicationModuleMarketTypeInput>;
  /** Preowned Disclaimer */
  preownedPriceDisclaimer?: InputMaybe<DealerPriceDisclaimerInput>;
  /** Disclaimer */
  priceDisclaimer?: InputMaybe<DealerPriceDisclaimerInput>;
  /** Vehicle Module Ids */
  vehicleModuleIds: Array<Scalars['ObjectID']['input']>;
};

export type AudiCalculationSettingUpdateInput = {
  /** Display name (for setting) */
  displayName: Scalars['String']['input'];
  /** Identifier */
  identifier: Scalars['String']['input'];
  /** Insurance module ID */
  insuranceModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Market specific inputs */
  market?: InputMaybe<ApplicationMarket>;
  marketType?: InputMaybe<ApplicationModuleMarketTypeInput>;
  /** Preowned Disclaimer */
  preownedPriceDisclaimer?: InputMaybe<DealerPriceDisclaimerInput>;
  /** Disclaimer */
  priceDisclaimer?: InputMaybe<DealerPriceDisclaimerInput>;
};

export type AudiFinancingApplication = Application & {
  __typename: 'AudiFinancingApplication';
  appointmentStage?: Maybe<AppointmentStage>;
  /** AudiFinancing Customer */
  audiFinancingCustomer?: Maybe<AudiFinancingCustomer>;
  /** AudiFinancing Document */
  audiFinancingDocuments: Array<AudiFinancingDocument>;
  /** AudiFinancing Insurancing */
  audiFinancingInsurancing?: Maybe<AudiFinancingInsurancing>;
  /** AudiFinancing State */
  audiFinancingState?: Maybe<AudiFinancingState>;
  /** AudiFinancing Vehicle */
  audiFinancingVehicle: AudiFinancingVehicle;
  /** assignees this application can be assigned to */
  availableAssignees: Array<User>;
  /** Bank */
  bank?: Maybe<ExternalBank>;
  /** Bank ID */
  bankId?: Maybe<Scalars['ObjectID']['output']>;
  /** Financial Product */
  financeProduct?: Maybe<FinanceProduct>;
  /** AudiFinancing Financing */
  financingDetails?: Maybe<AudiFinancingDetails>;
  financingStage?: Maybe<FinancingStage>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Insurance Product */
  insuranceProduct?: Maybe<InsuranceProduct>;
  insuranceStage?: Maybe<InsuranceStage>;
  /** Insurer */
  insurer?: Maybe<Insurer>;
  latestStage?: Maybe<ApplicationStageDetails>;
  leadStage?: Maybe<LeadStage>;
  mobilityStage?: Maybe<MobilityStage>;
  /** Module */
  module: Module;
  /** ModuleId */
  moduleId: Scalars['ObjectID']['output'];
  permissions: Array<Maybe<Scalars['String']['output']>>;
  remarks: Scalars['String']['output'];
  reservationStage?: Maybe<ReservationStage>;
  /** Sales Name */
  salesName: Scalars['String']['output'];
  /** Sales Reference */
  salesRef: Scalars['String']['output'];
  stages: Array<ApplicationStage>;
  /** AdvancedVersioning */
  versioning: AdvancedVersioning;
};

export type AudiFinancingCustomer = {
  __typename: 'AudiFinancingCustomer';
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Full Name */
  fullName: Scalars['String']['output'];
  /** Customer ID */
  id: Scalars['String']['output'];
  /** Mobile */
  mobile: Scalars['String']['output'];
  /** NRIC */
  nric: Scalars['String']['output'];
};

export type AudiFinancingDbsNewCarFinance = AudiFinancingDetails & {
  __typename: 'AudiFinancingDBSNewCarFinance';
  bank: Scalars['String']['output'];
  discountPrice?: Maybe<Scalars['Float']['output']>;
  financeProductId?: Maybe<Scalars['ObjectID']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  type: AudiFinancingFinanceType;
};

export type AudiFinancingDbsUsedCarFinance = AudiFinancingDetails & {
  __typename: 'AudiFinancingDBSUsedCarFinance';
  bank: Scalars['String']['output'];
  discountPrice?: Maybe<Scalars['Float']['output']>;
  financeProductId?: Maybe<Scalars['ObjectID']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  type: AudiFinancingFinanceType;
};

export type AudiFinancingDetails = {
  bank: Scalars['String']['output'];
  financeProductId?: Maybe<Scalars['ObjectID']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  type: AudiFinancingFinanceType;
};

export type AudiFinancingDocument = {
  __typename: 'AudiFinancingDocument';
  name: Scalars['String']['output'];
  type: AudiFinancingDocumentType;
};

export enum AudiFinancingDocumentType {
  FinPassBack = 'FINPassBack',
  FinPassFront = 'FINPassFront',
  IncomeDocument = 'IncomeDocument',
  InsuranceAgreement = 'InsuranceAgreement',
  InsuranceCoverNote = 'InsuranceCoverNote',
  Invoice = 'Invoice',
  LogCard = 'LogCard',
  MyIdentityCardBack = 'MYIdentityCardBack',
  MyIdentityCardFront = 'MYIdentityCardFront',
  OtherDisbursement = 'OtherDisbursement',
  Passport = 'Passport',
  SgIdentityCardBack = 'SGIdentityCardBack',
  SgIdentityCardFront = 'SGIdentityCardFront',
  VehicleSalesAgreement = 'VehicleSalesAgreement'
}

export enum AudiFinancingEngineType {
  Diesel = 'Diesel',
  DieselElectric = 'DieselElectric',
  Electric = 'Electric',
  Hybrid = 'Hybrid',
  Petrol = 'Petrol',
  PetrolCng = 'PetrolCNG',
  PetrolElectric = 'PetrolElectric',
  PetrolElectricDashed = 'PetrolElectricDashed',
  PetrolElectricPlugIn = 'PetrolElectricPlugIn',
  PetrolElectricPlugInDashed = 'PetrolElectricPlugInDashed'
}

export enum AudiFinancingFinanceType {
  /** DBS New Car */
  DbsNew = 'DBSNew',
  /** DBS Used Car */
  DbsUsed = 'DBSUsed',
  /** HLF New Car */
  HlfNew = 'HLFNew',
  /** HLF Used Car */
  HlfUsed = 'HLFUsed',
  /** UOB New Car */
  UobNew = 'UOBNew',
  /** UOB Used Car */
  UobUsed = 'UOBUsed'
}

export type AudiFinancingHlfNewCarFinance = AudiFinancingDetails & {
  __typename: 'AudiFinancingHLFNewCarFinance';
  bank: Scalars['String']['output'];
  downPayment?: Maybe<Scalars['Float']['output']>;
  financeProductId?: Maybe<Scalars['ObjectID']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  tenure: Scalars['Int']['output'];
  type: AudiFinancingFinanceType;
};

export type AudiFinancingHlfUsedCarFinance = AudiFinancingDetails & {
  __typename: 'AudiFinancingHLFUsedCarFinance';
  bank: Scalars['String']['output'];
  coeExpiryDate: Scalars['DateTime']['output'];
  downPayment?: Maybe<Scalars['Float']['output']>;
  financeProductId?: Maybe<Scalars['ObjectID']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  tenure: Scalars['Int']['output'];
  type: AudiFinancingFinanceType;
};

export type AudiFinancingInsurancing = {
  __typename: 'AudiFinancingInsurancing';
  insurancePremium: Scalars['Float']['output'];
  noClaimDiscount: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  vehicleEngineDisplacement: Scalars['Float']['output'];
  vehicleOriginalRegistrationDate?: Maybe<Scalars['DateTime']['output']>;
  yearsOfDriving: Scalars['Int']['output'];
};

export type AudiFinancingModule = Module & {
  __typename: 'AudiFinancingModule';
  /** Authorization */
  authorization?: Maybe<Authorization>;
  /** Bank Module */
  bankModule?: Maybe<Module>;
  /** Bank Module Id */
  bankModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Bank Integrations */
  banks: Array<SystemBank>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Sales Force Setting */
  salesForceSetting: SalesForceSetting;
  /** Sales Person Code Mappings */
  salesPersonCodeMappings: Array<SalesPersonCodeMapping>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type AudiFinancingModuleSalesPersonCodeMapping = {
  bankCode: Scalars['String']['input'];
  bankIds: Array<Scalars['ObjectID']['input']>;
  salesPersonCode: Scalars['String']['input'];
};

export type AudiFinancingModuleSettings = {
  /** bank module id */
  bankModuleId: Scalars['ObjectID']['input'];
  /** Display Name */
  displayName: Scalars['String']['input'];
};

export type AudiFinancingNewVehicle = AudiFinancingVehicle & {
  __typename: 'AudiFinancingNewVehicle';
  accessories?: Maybe<Scalars['String']['output']>;
  condition: AudiFinancingVehicleCondition;
  engineType: AudiFinancingEngineType;
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  ownerIdType: Scalars['String']['output'];
  parallelImport: Scalars['Boolean']['output'];
  scheme?: Maybe<AudiFinancingVehicleScheme>;
};

export type AudiFinancingSalesPersonCodeMapping = {
  __typename: 'AudiFinancingSalesPersonCodeMapping';
  bankCode: Scalars['String']['output'];
  bankIds: Array<Scalars['ObjectID']['output']>;
  salesPersonCode: Scalars['String']['output'];
};

export type AudiFinancingState = {
  __typename: 'AudiFinancingState';
  approvalExpiry?: Maybe<Scalars['String']['output']>;
  approvedAmount?: Maybe<Scalars['Float']['output']>;
  approvedPeriod?: Maybe<Scalars['Int']['output']>;
  creditProposalReference?: Maybe<Scalars['String']['output']>;
  status: AudiFinancingStateStatus;
  statusRemark?: Maybe<Scalars['String']['output']>;
};

export enum AudiFinancingStateStatus {
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Expired = 'Expired',
  FailedInsuranceSubmission = 'FailedInsuranceSubmission',
  FailedToSubmit = 'FailedToSubmit',
  InsuranceSubmitted = 'InsuranceSubmitted',
  PendingDisbursement = 'PendingDisbursement',
  PendingSubmission = 'PendingSubmission',
  Rejected = 'Rejected',
  ReviewInProgress = 'ReviewInProgress',
  Submitted = 'Submitted'
}

export type AudiFinancingUobNewCarFinance = AudiFinancingDetails & {
  __typename: 'AudiFinancingUOBNewCarFinance';
  bank: Scalars['String']['output'];
  financeProductId?: Maybe<Scalars['ObjectID']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  type: AudiFinancingFinanceType;
};

export type AudiFinancingUobUsedCarFinance = AudiFinancingDetails & {
  __typename: 'AudiFinancingUOBUsedCarFinance';
  arf: Scalars['String']['output'];
  bank: Scalars['String']['output'];
  coe: Scalars['Float']['output'];
  financeProductId?: Maybe<Scalars['ObjectID']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  type: AudiFinancingFinanceType;
  vehicleOriginalRegistrationDate: Scalars['String']['output'];
  vehicleRegistrationNumber: Scalars['String']['output'];
};

export type AudiFinancingUsedVehicle = AudiFinancingVehicle & {
  __typename: 'AudiFinancingUsedVehicle';
  accessories?: Maybe<Scalars['String']['output']>;
  condition: AudiFinancingVehicleCondition;
  engineType: AudiFinancingEngineType;
  inspected: Scalars['Boolean']['output'];
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  ownerIdType: Scalars['String']['output'];
  parallelImport: Scalars['Boolean']['output'];
  scheme?: Maybe<AudiFinancingVehicleScheme>;
};

export type AudiFinancingVehicle = {
  accessories?: Maybe<Scalars['String']['output']>;
  condition: AudiFinancingVehicleCondition;
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  ownerIdType: Scalars['String']['output'];
  parallelImport: Scalars['Boolean']['output'];
  scheme?: Maybe<AudiFinancingVehicleScheme>;
};

export enum AudiFinancingVehicleCondition {
  New = 'New',
  Used = 'Used'
}

export enum AudiFinancingVehicleScheme {
  Normal = 'Normal',
  Opc = 'OPC'
}

export type AudiSalesForceModule = Module & {
  __typename: 'AudiSalesForceModule';
  /** Authorization */
  authorization?: Maybe<Authorization>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Audi Sales Force Setting */
  setting: AudiSalesForceSetting;
  /** Trade-In Module */
  tradeInModule: Module;
  /** Trade-In Module ID */
  tradeInModuleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: SimpleVersioning;
};

export type AudiSalesForceModuleSettings = {
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** Audi Sales Force Setting */
  setting: AudiSalesForceSettingInput;
};

export type AudiSalesForceSetting = {
  __typename: 'AudiSalesForceSetting';
  /** CA, used for mTLS */
  authority?: Maybe<Scalars['String']['output']>;
  /** Base url */
  baseUrl: Scalars['String']['output'];
  /** Client ID */
  clientId: Scalars['String']['output'];
  /** Client Secret */
  clientSecret: Scalars['String']['output'];
  /** ID */
  id: Scalars['ObjectID']['output'];
  /** Audi Sales Force Module ID */
  moduleId: Scalars['ObjectID']['output'];
  /** Private Key, used for mTLS */
  privateKey?: Maybe<Scalars['String']['output']>;
  /** Public Key, used for mTLS */
  publicCert?: Maybe<Scalars['String']['output']>;
};

export type AudiSalesForceSettingInput = {
  /** CA, used for mTLS */
  authority?: InputMaybe<Scalars['String']['input']>;
  /** Base url */
  baseUrl: Scalars['String']['input'];
  /** Client ID */
  clientId: Scalars['String']['input'];
  /** Client Secret */
  clientSecret: Scalars['String']['input'];
  /** Private Key, used for mTLS */
  privateKey?: InputMaybe<Scalars['String']['input']>;
  /** Public Key, used for mTLS */
  publicCert?: InputMaybe<Scalars['String']['input']>;
  /** Trade-In Module ID */
  tradeInModuleId: Scalars['ObjectID']['input'];
};

export type AudiTradeIn = TradeIn & {
  __typename: 'AudiTradeIn';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  bids?: Maybe<Array<BidType>>;
  chassisNumber?: Maybe<Scalars['String']['output']>;
  coeExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  conditions: Array<TradeInCondition>;
  engineNumber?: Maybe<Scalars['String']['output']>;
  finalOffer?: Maybe<Scalars['Float']['output']>;
  firstRegistrationDate?: Maybe<Scalars['DateTime']['output']>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** TradeIn Transaction No. */
  identifier?: Maybe<Scalars['String']['output']>;
  /** License Plate Number */
  licensePlateNumber: Scalars['String']['output'];
  manufacturingYear?: Maybe<Scalars['Int']['output']>;
  /** Mileage Value */
  mileage: Scalars['Float']['output'];
  /** TradeIn Module */
  module: Module;
  /** TradeIn Module Id */
  moduleId: Scalars['ObjectID']['output'];
  noOfTransfers?: Maybe<Scalars['Int']['output']>;
  /** Number of Keys */
  numberOfKeys?: Maybe<Scalars['Int']['output']>;
  /** Owner ID */
  ownerId: Scalars['String']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  selectedDealer?: Maybe<BidType>;
  selectedDealerId?: Maybe<Scalars['String']['output']>;
  status: TradeInStatus;
  vehicleEquipments?: Maybe<Scalars['String']['output']>;
  vehicleMake?: Maybe<Scalars['String']['output']>;
  vehicleModel?: Maybe<Scalars['String']['output']>;
  versioning: SimpleVersioning;
};

export type AuditTrail = {
  __typename: 'AuditTrail';
  consentId?: Maybe<Scalars['ObjectID']['output']>;
  customerKind?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  id: Scalars['ObjectID']['output'];
  kind: AuditTrailKind;
  message: Scalars['String']['output'];
};

export enum AuditTrailKind {
  AgreementConcluded = 'AgreementConcluded',
  ApplicationAmendments = 'ApplicationAmendments',
  ApplicationApplicantGuarantorKycReceived = 'ApplicationApplicantGuarantorKYCReceived',
  ApplicationApplyForFinanceCreation = 'ApplicationApplyForFinanceCreation',
  ApplicationApplyForInsuranceCreation = 'ApplicationApplyForInsuranceCreation',
  ApplicationApplyForReservationCreation = 'ApplicationApplyForReservationCreation',
  ApplicationAppointmentMade = 'ApplicationAppointmentMade',
  ApplicationApproved = 'ApplicationApproved',
  ApplicationCancellationToBankFailed = 'ApplicationCancellationToBankFailed',
  ApplicationCancellationToInsuranceCompanyFailed = 'ApplicationCancellationToInsuranceCompanyFailed',
  ApplicationCancelled = 'ApplicationCancelled',
  ApplicationCheckIn = 'ApplicationCheckIn',
  ApplicationComment = 'ApplicationComment',
  ApplicationCompleted = 'ApplicationCompleted',
  ApplicationConfirmedBookingAuditTrail = 'ApplicationConfirmedBookingAuditTrail',
  ApplicationContacted = 'ApplicationContacted',
  ApplicationCustomerAgreedOnCnD = 'ApplicationCustomerAgreedOnCnD',
  ApplicationDeclined = 'ApplicationDeclined',
  ApplicationDrafted = 'ApplicationDrafted',
  ApplicationEmailSent = 'ApplicationEmailSent',
  ApplicationExpired = 'ApplicationExpired',
  ApplicationFinancingRequested = 'ApplicationFinancingRequested',
  ApplicationKycReceived = 'ApplicationKYCReceived',
  ApplicationOtpCompleted = 'ApplicationOTPCompleted',
  ApplicationOtpInitiated = 'ApplicationOTPInitiated',
  ApplicationPaymentCapturing = 'ApplicationPaymentCapturing',
  ApplicationPaymentCompleted = 'ApplicationPaymentCompleted',
  ApplicationPaymentFailed = 'ApplicationPaymentFailed',
  ApplicationPaymentPending = 'ApplicationPaymentPending',
  ApplicationPaymentRefunded = 'ApplicationPaymentRefunded',
  ApplicationPaymentSkipped = 'ApplicationPaymentSkipped',
  ApplicationPendingDisbursement = 'ApplicationPendingDisbursement',
  ApplicationPendingInfoFromCustomer = 'ApplicationPendingInfoFromCustomer',
  ApplicationProceedWithCustomerDevice = 'ApplicationProceedWithCustomerDevice',
  ApplicationRemarksSubmitted = 'ApplicationRemarksSubmitted',
  ApplicationResubmissionToBankFailed = 'ApplicationResubmissionToBankFailed',
  ApplicationResubmittedToBank = 'ApplicationResubmittedToBank',
  ApplicationResubmittedToSystem = 'ApplicationResubmittedToSystem',
  ApplicationRetrieveStatus = 'ApplicationRetrieveStatus',
  ApplicationShared = 'ApplicationShared',
  ApplicationSigningCompleted = 'ApplicationSigningCompleted',
  ApplicationSigningInitiated = 'ApplicationSigningInitiated',
  ApplicationSigningRejected = 'ApplicationSigningRejected',
  ApplicationSubmissionToBankFailed = 'ApplicationSubmissionToBankFailed',
  ApplicationSubmissionToInsuranceCompanyFailed = 'ApplicationSubmissionToInsuranceCompanyFailed',
  ApplicationSubmittedToBank = 'ApplicationSubmittedToBank',
  ApplicationSubmittedToInsuranceCompany = 'ApplicationSubmittedToInsuranceCompany',
  ApplicationSubmittedToSystem = 'ApplicationSubmittedToSystem',
  ApplicationTestDriveCnDAuditTrail = 'ApplicationTestDriveCnDAuditTrail',
  ApplicationTestDriveEndedAuditTrail = 'ApplicationTestDriveEndedAuditTrail',
  ApplicationTestDriveKycAuditTrail = 'ApplicationTestDriveKYCAuditTrail',
  ApplicationTestDriveOtpCompleted = 'ApplicationTestDriveOTPCompleted',
  ApplicationTestDriveOtpInitiated = 'ApplicationTestDriveOTPInitiated',
  ApplicationTestDriveSigningCompleted = 'ApplicationTestDriveSigningCompleted',
  ApplicationTestDriveSigningInitiated = 'ApplicationTestDriveSigningInitiated',
  ApplicationTestDriveSigningRejected = 'ApplicationTestDriveSigningRejected',
  ApplicationTestDriveStartedAuditTrail = 'ApplicationTestDriveStartedAuditTrail',
  AudiFinancingUpdateStatusFailed = 'AudiFinancingUpdateStatusFailed',
  AudiFinancingUpdateStatusSuccess = 'AudiFinancingUpdateStatusSuccess',
  BankCustomerInfoReceived = 'BankCustomerInfoReceived',
  BankReviewInProgress = 'BankReviewInProgress',
  BmwUpdateStatusFailed = 'BmwUpdateStatusFailed',
  BmwUpdateStatusSuccess = 'BmwUpdateStatusSuccess',
  BookingAmended = 'BookingAmended',
  BookingAmendmentEmailSent = 'BookingAmendmentEmailSent',
  BookingCancellationEmailSent = 'BookingCancellationEmailSent',
  BookingCompletionEmailSent = 'BookingCompletionEmailSent',
  BookingConfirmationEmailSent = 'BookingConfirmationEmailSent',
  BookingSubmitted = 'BookingSubmitted',
  CapActivityEndTestDriveSubmitted = 'CapActivityEndTestDriveSubmitted',
  CapActivitySubmitted = 'CapActivitySubmitted',
  CapBpCreated = 'CapBPCreated',
  CapBpIsExist = 'CapBPIsExist',
  CapBpUpdated = 'CapBPUpdated',
  CapConsentNotFound = 'CapConsentNotFound',
  CapConsentSubmitted = 'CapConsentSubmitted',
  CapLeadCampaignNotFound = 'CapLeadCampaignNotFound',
  CapLeadCreated = 'CapLeadCreated',
  CapLeadIsExist = 'CapLeadIsExist',
  CapLeadUpdated = 'CapLeadUpdated',
  ConfiguratorInventoryCreated = 'ConfiguratorInventoryCreated',
  ConfiguratorInventoryDeleted = 'ConfiguratorInventoryDeleted',
  ConfiguratorInventoryStockUpdated = 'ConfiguratorInventoryStockUpdated',
  ConfiguratorInventoryUpdated = 'ConfiguratorInventoryUpdated',
  CustomerAmendments = 'CustomerAmendments',
  CustomerComment = 'CustomerComment',
  GiftVoucherApplied = 'GiftVoucherApplied',
  GiftVoucherCreated = 'GiftVoucherCreated',
  GiftVoucherCustomerAgreedOnCnD = 'GiftVoucherCustomerAgreedOnCnD',
  GiftVoucherExpired = 'GiftVoucherExpired',
  GiftVoucherPaymentCapturing = 'GiftVoucherPaymentCapturing',
  GiftVoucherPaymentCompleted = 'GiftVoucherPaymentCompleted',
  GiftVoucherPaymentFailed = 'GiftVoucherPaymentFailed',
  GiftVoucherPaymentPending = 'GiftVoucherPaymentPending',
  GiftVoucherPaymentRefunded = 'GiftVoucherPaymentRefunded',
  GiftVoucherPaymentSkipped = 'GiftVoucherPaymentSkipped',
  GiftVoucherSubmittedToSystem = 'GiftVoucherSubmittedToSystem',
  InsuranceApplicationApproved = 'InsuranceApplicationApproved',
  InsuranceApplicationCancelled = 'InsuranceApplicationCancelled',
  InsuranceApplicationDeclined = 'InsuranceApplicationDeclined',
  InsuranceCompanyReviewInProgress = 'InsuranceCompanyReviewInProgress',
  InventoryAmendments = 'InventoryAmendments',
  InventoryComment = 'InventoryComment',
  InventoryStockAdded = 'InventoryStockAdded',
  InventoryStockDeleted = 'InventoryStockDeleted',
  LeadApplicationQualified = 'LeadApplicationQualified',
  LeadApplicationUnqualified = 'LeadApplicationUnqualified',
  MobilityInventoryCreated = 'MobilityInventoryCreated',
  MobilityInventoryDeleted = 'MobilityInventoryDeleted',
  MobilityInventoryStockUpdated = 'MobilityInventoryStockUpdated',
  MobilityInventoryUpdated = 'MobilityInventoryUpdated',
  ModelConfiguratorCreated = 'ModelConfiguratorCreated',
  ModelConfiguratorDeleted = 'ModelConfiguratorDeleted',
  ModelConfiguratorUpdated = 'ModelConfiguratorUpdated',
  PromoCodeCreated = 'PromoCodeCreated',
  PromoCodeDeleted = 'PromoCodeDeleted',
  PromoCodeUpdated = 'PromoCodeUpdated',
  ReassignBankAssignee = 'ReassignBankAssignee',
  ReminderEmailSent = 'ReminderEmailSent',
  RequestDisbursement = 'RequestDisbursement',
  RequestDisbursementFail = 'RequestDisbursementFail',
  RequestReleaseLetter = 'RequestReleaseLetter',
  SdmUpdateStatusFailed = 'SDMUpdateStatusFailed',
  SdmUpdateStatusSuccess = 'SDMUpdateStatusSuccess',
  StockAmendments = 'StockAmendments',
  StockUpdated = 'StockUpdated',
  TradeInBidCloseRequestReceived = 'TradeInBidCloseRequestReceived',
  TradeInBidCloseRequestSendingFailed = 'TradeInBidCloseRequestSendingFailed',
  TradeInBidCloseRequestSent = 'TradeInBidCloseRequestSent',
  TradeInComment = 'TradeInComment',
  TradeInConfirmationRequestReceived = 'TradeInConfirmationRequestReceived',
  TradeInConfirmationRequestSendingFailed = 'TradeInConfirmationRequestSendingFailed',
  TradeInConfirmationRequestSent = 'TradeInConfirmationRequestSent',
  TradeInDraftRequestReceived = 'TradeInDraftRequestReceived',
  TradeInDraftRequestSendingFailed = 'TradeInDraftRequestSendingFailed',
  TradeInDraftRequestSent = 'TradeInDraftRequestSent',
  TradeInDrafted = 'TradeInDrafted',
  UserGroupCreated = 'UserGroupCreated',
  UserGroupDealersAttached = 'UserGroupDealersAttached',
  UserGroupDealersRemoved = 'UserGroupDealersRemoved',
  UserGroupDeleted = 'UserGroupDeleted',
  UserGroupUpdated = 'UserGroupUpdated',
  UserGroupUsersAttached = 'UserGroupUsersAttached',
  UserGroupUsersRemoved = 'UserGroupUsersRemoved',
  VariantConfiguratorCreated = 'VariantConfiguratorCreated',
  VariantConfiguratorDeleted = 'VariantConfiguratorDeleted',
  VariantConfiguratorUpdated = 'VariantConfiguratorUpdated'
}

export type AuthenticationRequiresNewPassword = {
  __typename: 'AuthenticationRequiresNewPassword';
  /** Token to use with the mutation `changePasswordFromAuthentication` */
  token: Scalars['String']['output'];
  /** User authenticated */
  user: User;
};

export type AuthenticationRequiresSmsOtp = {
  __typename: 'AuthenticationRequiresSmsOTP';
  /** Token to use with the mutation `authenticateWithSmsOTP` */
  token: Scalars['String']['output'];
};

export type AuthenticationRequiresTotp = {
  __typename: 'AuthenticationRequiresTOTP';
  /** Token to use with the mutation `authenticateWithTOTP` */
  token: Scalars['String']['output'];
};

export type AuthenticationResponse = AuthenticationRequiresNewPassword | AuthenticationRequiresSmsOtp | AuthenticationRequiresTotp | AuthenticationSuccessful;

export type AuthenticationSuccessful = {
  __typename: 'AuthenticationSuccessful';
  /** Bearer token to use in the Authorization header */
  token: Scalars['String']['output'];
  /** User authenticated */
  user: User;
};

export type AuthenticationWithWebPublicKeyCredential = {
  __typename: 'AuthenticationWithWebPublicKeyCredential';
  /** Allowed credentials */
  allowCredentials: Array<Scalars['JSONObject']['output']>;
  /** Challenge for the request */
  challenge: Scalars['String']['output'];
  /** Timeout */
  timeout?: Maybe<Scalars['Int']['output']>;
  /** Token to use with the mutation `authenticateWithWebPublicKeyCredential` */
  token: Scalars['String']['output'];
};

export type AuthenticatorSetup = {
  __typename: 'AuthenticatorSetup';
  /** QRCode URI for the given authenticator secret */
  qrcodeUri: Scalars['String']['output'];
  /** Authenticator secret */
  secret: Scalars['String']['output'];
};

export type Author = CorporateCustomer | ExternalBank | Guarantor | LocalCustomer | Salesforce | SystemBank | User;

export type Authorization = {
  __typename: 'Authorization';
  accessKey: Scalars['String']['output'];
  lastUsage: Scalars['DateTime']['output'];
  secretKey: Scalars['String']['output'];
  versioning: SimpleVersioning;
};

export enum AutoplayApiVersion {
  V3 = 'V3'
}

export type AutoplayModule = Module & {
  __typename: 'AutoplayModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Autoplay Settings */
  settings: Array<AutoplaySetting>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type AutoplayModulePayload = {
  displayName: Scalars['String']['input'];
};

export type AutoplaySetting = {
  __typename: 'AutoplaySetting';
  /** API Endpoint */
  apiEndpoint: Scalars['String']['output'];
  /** API Key */
  apiKey: Scalars['String']['output'];
  /** API Token */
  apiToken: Scalars['String']['output'];
  /** API Version */
  apiVersion: AutoplayApiVersion;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Concurrent delay task allowed between number of task to perform API call */
  concurrentSeconds: Scalars['Int']['output'];
  /** Concurrent number of task allowed to perform API call */
  concurrentTasks: Scalars['Int']['output'];
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Reference to autoplay module */
  moduleId: Scalars['ObjectID']['output'];
};

export type AutoplaySettingPayload = {
  /** API Endpoint */
  apiEndpoint: Scalars['String']['input'];
  /** API Key */
  apiKey: Scalars['String']['input'];
  /** API Token */
  apiToken: Scalars['String']['input'];
  /** API Version */
  apiVersion: AutoplayApiVersion;
  /** Concurrent second limit */
  concurrentSeconds: Scalars['Int']['input'];
  /** Concurrent task limit */
  concurrentTasks: Scalars['Int']['input'];
  /** Display name (for setting) */
  displayName: Scalars['String']['input'];
};

export type AvailableModules = {
  __typename: 'AvailableModules';
  /** Does the company has agreement modules */
  hasAgreementModules: Scalars['Boolean']['output'];
  /** Does the company has application modules */
  hasApplicationModules: Scalars['Boolean']['output'];
  /** Does the company has appointment modules */
  hasAppointmentModules: Scalars['Boolean']['output'];
  /** Does the company has Audi Calculation modules */
  hasAudiCalculationModules: Scalars['Boolean']['output'];
  /** Does the company has Audi Financing Module */
  hasAudiFinancingModules: Scalars['Boolean']['output'];
  /** Does the company has autoplay module */
  hasAutoplayModules: Scalars['Boolean']['output'];
  /** Does the company has banks (all bank kinds) */
  hasBanks: Scalars['Boolean']['output'];
  /** Does the company has Porsche C@P modules */
  hasCapModules: Scalars['Boolean']['output'];
  /** Does the company has configurator modules */
  hasConfiguratorModules: Scalars['Boolean']['output'];
  /** Does the company has consent module */
  hasConsentModules: Scalars['Boolean']['output'];
  /** Does the company has cts modules */
  hasCtsModules: Scalars['Boolean']['output'];
  /** Does the company has customer modules */
  hasCustomerModules: Scalars['Boolean']['output'];
  /** Does the company has events */
  hasEventModules: Scalars['Boolean']['output'];
  /** Does the company has finance products */
  hasFinanceProducts: Scalars['Boolean']['output'];
  /** Does the company has finder vehicle modules */
  hasFinderVehicleManagementModules: Scalars['Boolean']['output'];
  /** Does the company has gift voucher module */
  hasGiftVoucherModules: Scalars['Boolean']['output'];
  /** Does the company has insurance module */
  hasInsuranceModules: Scalars['Boolean']['output'];
  /** Does the company has inventories */
  hasInventories: Scalars['Boolean']['output'];
  /** Does the company has labels modules */
  hasLabelsModules: Scalars['Boolean']['output'];
  /** Does the company has mobility modules */
  hasMobilityModules: Scalars['Boolean']['output'];
  /** Does the company has payment modules */
  hasPaymentModules: Scalars['Boolean']['output'];
  /** Does the company has Porsche MasterData modules */
  hasPorscheMasterDataModules: Scalars['Boolean']['output'];
  /** Does the company has promotion code modules */
  hasPromotionCodeModules: Scalars['Boolean']['output'];
  /** Does the company has banks (system only) */
  hasSystemBanks: Scalars['Boolean']['output'];
  /** Does the company has tradeIn modules */
  hasTradeInModules: Scalars['Boolean']['output'];
  /** Does the company has vehicle management modules */
  hasVehicleManagementModules: Scalars['Boolean']['output'];
  /** Does the company has website modules */
  hasWebsiteModules: Scalars['Boolean']['output'];
};

export type AverageMileageSettings = {
  __typename: 'AverageMileageSettings';
  default: Scalars['Float']['output'];
  defaultUnit: AverageMileageValueUnit;
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  step: Scalars['Float']['output'];
};

export type AverageMileageSettingsPayload = {
  default: Scalars['Float']['input'];
  defaultUnit: AverageMileageValueUnit;
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
  step: Scalars['Float']['input'];
};

export enum AverageMileageValueUnit {
  Km = 'Km'
}

/**
 * Balloon calculation reference
 *
 * Used in Hire Purchase with Balloon
 */
export enum BalloonBasedOn {
  CarPrice = 'CarPrice',
  LoanAmount = 'LoanAmount',
  TotalPrice = 'TotalPrice'
}

export type BalloonGfvSettings = {
  __typename: 'BalloonGFVSettings';
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  reducedMonthlyPayment: Scalars['Float']['output'];
  residualValueUnit: AmountUnit;
  settlementInstalmentOn: SettlementInstalmentOn;
  table: Array<BalloonTableCell>;
  vehicleFilterParameterTable: Array<BalloonValueTableCellForVehicleParameterFilter>;
};

export type BalloonGfvSettingsPayload = {
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
  reducedMonthlyPayment: Scalars['Float']['input'];
  residualValueUnit: AmountUnit;
  settlementInstalmentOn: SettlementInstalmentOn;
  table: Array<BalloonTableCellPayload>;
  vehicleFilterParameterTable: Array<BalloonValueTableCellForVehicleParameterFilterPayload>;
};

export type BalloonRangeSettings = BalloonSettings & {
  __typename: 'BalloonRangeSettings';
  /** Calculation of balloon will refer to */
  basedOn: BalloonBasedOn;
  /** Default value of the field, based on unit */
  default: Scalars['Float']['output'];
  /**
   * Is field editable in calculator?
   *
   * Should be only true when field isViewable is true
   */
  isEditable: Scalars['Boolean']['output'];
  /** Is field shown in calculator? */
  isViewable: Scalars['Boolean']['output'];
  /** Maximum value of the field, based on unit */
  max: Scalars['Float']['output'];
  /** Maximum value in unit */
  maxUnit: AmountUnit;
  /** Minimum value of the field, based on unit */
  min: Scalars['Float']['output'];
  /** Minimum value in unit */
  minUnit: AmountUnit;
  /** Step inputted values, based on unit */
  step: Scalars['Float']['output'];
  /** Step value in unit */
  stepUnit: AmountUnit;
  /**
   * Type of the balloon settings
   * should be an enum from document
   */
  type: Scalars['String']['output'];
  /**
   * Unit used for the field
   * in Range, it would be for default value
   */
  unit: AmountUnit;
};

/** Hire Purchase with Balloon settings */
export type BalloonSettings = {
  /** Calculation of balloon will refer to */
  basedOn: BalloonBasedOn;
  /** Is field shown in calculator? */
  isViewable: Scalars['Boolean']['output'];
  /**
   * Type of the balloon settings
   * should be an enum from document
   */
  type: Scalars['String']['output'];
  /** Unit used for the field */
  unit: AmountUnit;
};

export type BalloonSettingsPayload = {
  basedOn: BalloonBasedOn;
  default?: InputMaybe<Scalars['Float']['input']>;
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isViewable: Scalars['Boolean']['input'];
  max?: InputMaybe<Scalars['Float']['input']>;
  maxUnit?: InputMaybe<AmountUnit>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minUnit?: InputMaybe<AmountUnit>;
  step?: InputMaybe<Scalars['Float']['input']>;
  stepUnit?: InputMaybe<AmountUnit>;
  table?: InputMaybe<Array<BalloonTableCellPayload>>;
  type: Scalars['String']['input'];
  unit: AmountUnit;
  vehicleFilterParameterTable?: InputMaybe<Array<BalloonValueTableCellForVehicleParameterFilterPayload>>;
};

/** Balloon table cell currently shared between HP with Balloon and HP with Balloon GFV */
export type BalloonTableCell = {
  __typename: 'BalloonTableCell';
  term: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
  variant: Vehicle;
  variantSuiteId: Scalars['ObjectID']['output'];
};

export type BalloonTableCellPayload = {
  term: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
  variantSuiteId: Scalars['ObjectID']['input'];
};

export type BalloonTableSettings = BalloonSettings & {
  __typename: 'BalloonTableSettings';
  /** Calculation of balloon will refer to */
  basedOn: BalloonBasedOn;
  /** Is field shown in calculator? */
  isViewable: Scalars['Boolean']['output'];
  /** Table settings */
  table: Array<BalloonTableCell>;
  /**
   * Type of the balloon settings
   * should be an enum from document
   */
  type: Scalars['String']['output'];
  /** Unit used for the field */
  unit: AmountUnit;
  vehicleFilterParameterTable: Array<BalloonValueTableCellForVehicleParameterFilter>;
};

export type BalloonValueTableCellForVehicleParameterFilter = {
  __typename: 'BalloonValueTableCellForVehicleParameterFilter';
  term: Scalars['Int']['output'];
  type: VehicleKind;
  value: Scalars['Float']['output'];
};

export type BalloonValueTableCellForVehicleParameterFilterPayload = {
  term: Scalars['Int']['input'];
  type: VehicleKind;
  value: Scalars['Float']['input'];
};

export type Bank = {
  displayName: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  integration: BankIntegration;
  kind: BankKind;
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
};

export enum BankAsset {
  EnbdStampBottom = 'EnbdStampBottom',
  EnbdStampRight = 'EnbdStampRight',
  Font = 'Font',
  Logo = 'Logo'
}

export type BankAvailableFinanceProductTypesUpdateSetting = {
  availableFinanceProductTypes: Array<FinanceProductType>;
  showMarginOfFinance: Scalars['Boolean']['input'];
};

export type BankCondition = Condition & {
  __typename: 'BankCondition';
  bank: SystemBank;
  bankId: Scalars['ObjectID']['output'];
  type: ConditionType;
};

export type BankConditionSettings = {
  bankId: Scalars['ObjectID']['input'];
};

export type BankDealershipMarket = {
  __typename: 'BankDealershipMarket';
  editable: Scalars['Boolean']['output'];
  overrides: Array<BankDealershipMarketOverrides>;
};

export type BankDealershipMarketInput = {
  /** Editable */
  editable: Scalars['Boolean']['input'];
  /** Overrides */
  overrides: Array<BankDealershipMarketOverridesInput>;
};

export type BankDealershipMarketOverrides = {
  __typename: 'BankDealershipMarketOverrides';
  dealer: Dealer;
  dealerId: Scalars['ObjectID']['output'];
  editable: Scalars['Boolean']['output'];
};

export type BankDealershipMarketOverridesInput = {
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['input'];
  /** Editable */
  editable: Scalars['Boolean']['input'];
};

export enum BankDisplayInSharePdf {
  FollowCalculator = 'FollowCalculator',
  Hidden = 'Hidden'
}

export type BankFilteringRule = {
  /** Allow Variant Code Mapping */
  allowVariantCodeMapping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by bank integration providers */
  bankIntegrationProviders?: InputMaybe<Array<BankIntegrationProvider>>;
  /** Filter by company display name */
  companyDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by bank display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by module ID */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type BankIntegration = {
  provider: BankIntegrationProvider;
};

export enum BankIntegrationProvider {
  BmwFs = 'BmwFs',
  Dbs = 'DBS',
  Enbd = 'ENBD',
  Email = 'Email',
  Hlf = 'HLF',
  Hlfv2 = 'HLFV2',
  Maybank = 'Maybank',
  Uob = 'UOB'
}

export type BankIntegrationSettings = {
  bmwFs?: InputMaybe<BmwFsBankIntegrationSettings>;
  dbs?: InputMaybe<DbsBankIntegrationSettings>;
  email?: InputMaybe<EmailBankIntegrationSettings>;
  enbd?: InputMaybe<EnbdBankIntegrationSettings>;
  hlf?: InputMaybe<HlfBankIntegrationSettings>;
  hlfV2?: InputMaybe<HlfBankV2IntegrationSettings>;
  maybank?: InputMaybe<MaybankIntegrationSettings>;
  uob?: InputMaybe<UobBankIntegrationSettings>;
};

export type BankIntegrationUpdateSettings = {
  bmwFs?: InputMaybe<BmwFsBankIntegrationUpdateSettings>;
  dbs?: InputMaybe<DbsBankIntegrationSettings>;
  email?: InputMaybe<EmailBankIntegrationSettings>;
  enbd?: InputMaybe<EnbdBankIntegrationSettings>;
  hlf?: InputMaybe<HlfBankIntegrationSettings>;
  hlfV2?: InputMaybe<HlfBankV2IntegrationSettings>;
  maybank?: InputMaybe<MaybankIntegrationUpdateSettings>;
  uob?: InputMaybe<UobBankIntegrationSettings>;
};

export enum BankKind {
  External = 'External',
  System = 'System'
}

export type BankModule = Module & {
  __typename: 'BankModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type BankModuleSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
};

export type BankOption = {
  __typename: 'BankOption';
  allowVariantCodeMapping: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
};

export type BankOptionFilteringRule = {
  /** Allow Variant Code Mapping */
  allowVariantCodeMapping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by company display name */
  companyDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by bank display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by module ID */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type BankSettings = {
  allowVariantCodeMapping: Scalars['Boolean']['input'];
  color: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  /**
   * Bank Establishment Fee
   *
   * For NZ market, other than that it will be 9
   */
  estFee: Scalars['Float']['input'];
  financingDisclaimer?: InputMaybe<DealerDisclaimersConfiguratorInput>;
  hasUploadDocuments: Scalars['Boolean']['input'];
  hasVSOUpload: Scalars['Boolean']['input'];
  isActive: Scalars['Boolean']['input'];
  legalName: TranslatedStringInput;
  moduleId: Scalars['ObjectID']['input'];
  order: Scalars['Int']['input'];
  reSubmissionApprovalModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  remoteFlowAcknowledgmentInfo: Scalars['String']['input'];
  sendEmailToCustomer: Scalars['Boolean']['input'];
  sendPDFToCustomer: Scalars['Boolean']['input'];
  showCommentsField?: InputMaybe<Scalars['Boolean']['input']>;
  submissionApprovalModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum BankSortingField {
  CompanyDisplayName = 'CompanyDisplayName',
  DisplayName = 'DisplayName',
  Order = 'Order'
}

export type BankSortingRule = {
  /** Field on which apply the sorting */
  field: BankSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type Banner = {
  __typename: 'Banner';
  bannerImage?: Maybe<UploadedFileWithPreview>;
  bannerText: TranslatedString;
  bannerTextPosition: BannerTextPosition;
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  mobileBannerImage?: Maybe<UploadedFileWithPreview>;
  module: Module;
  permissions: Array<Maybe<Scalars['String']['output']>>;
  versioning: SimpleVersioning;
};

export enum BannerAsset {
  ConfiguratorBanner = 'ConfiguratorBanner',
  ConfiguratorMobileBanner = 'ConfiguratorMobileBanner'
}

export type BannerFilteringRule = {
  bannerText?: InputMaybe<Scalars['String']['input']>;
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
};

export type BannerInput = {
  bannerText: TranslatedStringInput;
  bannerTextPosition: BannerTextPosition;
  isActive: Scalars['Boolean']['input'];
};

export enum BannerSortingField {
  BannerText = 'BannerText',
  Company = 'Company',
  Identifier = 'Identifier',
  ModuleName = 'ModuleName'
}

export type BannerSortingRule = {
  field: BannerSortingField;
  order: SortingOrder;
};

export enum BannerTextPosition {
  Centre = 'Centre',
  Left = 'Left',
  Right = 'Right'
}

export type BasicLayout = {
  __typename: 'BasicLayout';
  withAdminButton: Scalars['Boolean']['output'];
};

export type BasicProLayout = {
  __typename: 'BasicProLayout';
  /** Layout mode (side or mix) */
  layoutMode: Scalars['String']['output'];
  /** Navigation Theme (light or dark) */
  navigationTheme: Scalars['String']['output'];
  /** Display a sign in button when user is not authenticated */
  withSignInButton: Scalars['Boolean']['output'];
};

export type BasicProLayoutSettings = {
  /** Layout mode (side or mix) */
  layoutMode: Scalars['String']['input'];
  /** Navigation Theme (light or dark) */
  navigationTheme: Scalars['String']['input'];
  /** Display a sign in button when user is not authenticated */
  withSignInButton: Scalars['Boolean']['input'];
};

export type BasicRouterSettings = {
  /** Display admin button on layout */
  withAdminButton: Scalars['Boolean']['input'];
};

export type BasicSigningModule = Module & {
  __typename: 'BasicSigningModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** OTP Life time in minutes */
  lifeTime: Scalars['Int']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Transport Protocol */
  transportProtocol: TransportProtocolType;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type BasicSigningModuleSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
  /** OTP Life time in minutes */
  lifeTime: Scalars['Int']['input'];
  /** Transport Protocol */
  transportProtocol: TransportProtocolType;
};

export type BidType = {
  __typename: 'BidType';
  bidTimeStamp?: Maybe<Scalars['String']['output']>;
  dealerId?: Maybe<Scalars['String']['output']>;
  dealerName?: Maybe<Scalars['String']['output']>;
  offerValue?: Maybe<Scalars['Float']['output']>;
};

export type Block = {
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  type: BlockType;
};

export type BlockInput = {
  colorBlockInput?: InputMaybe<ColorBlockInput>;
  optionsBlockInput?: InputMaybe<OptionsBlockInput>;
  packageBlockInput?: InputMaybe<PackageBlockInput>;
  trimBlockInput?: InputMaybe<TrimBlockInput>;
  type: BlockType;
};

export enum BlockType {
  Color = 'Color',
  Options = 'Options',
  Package = 'Package',
  Trim = 'Trim'
}

export type BmwApplication = Application & {
  __typename: 'BmwApplication';
  /** Local Applicant */
  applicant: Customer;
  /** Local Applicant ID */
  applicantId: Scalars['ObjectID']['output'];
  appointmentStage?: Maybe<AppointmentStage>;
  /** assignees this application can be assigned to */
  availableAssignees: Array<User>;
  /** Bank */
  bank?: Maybe<SystemBank>;
  /** Bank ID */
  bankId?: Maybe<Scalars['ObjectID']['output']>;
  bmwCustomer: BmwCustomer;
  bmwDocuments: Array<BmwDocument>;
  bmwFinancing: BmwFinance;
  bmwVehicle: BmwVehicle;
  companyCode: Scalars['String']['output'];
  financingStage?: Maybe<FinancingStage>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  insuranceStage?: Maybe<InsuranceStage>;
  languageId?: Maybe<Scalars['ObjectID']['output']>;
  latestStage?: Maybe<ApplicationStageDetails>;
  leadStage?: Maybe<LeadStage>;
  /** Local Vehicle */
  localVehicle?: Maybe<Vehicle>;
  mobilityStage?: Maybe<MobilityStage>;
  /** Module */
  module: Module;
  /** ModuleId */
  moduleId: Scalars['ObjectID']['output'];
  permissions: Array<Maybe<Scalars['String']['output']>>;
  remark?: Maybe<Scalars['String']['output']>;
  remarks: Scalars['String']['output'];
  reservationStage?: Maybe<ReservationStage>;
  /** Sales Name */
  salesName: Scalars['String']['output'];
  salesRef: Scalars['String']['output'];
  stages: Array<ApplicationStage>;
  /** Local Vehicle ID */
  vehicleId?: Maybe<Scalars['ObjectID']['output']>;
  /** AdvancedVersioning */
  versioning: AdvancedVersioning;
};

export type BmwCustomer = {
  __typename: 'BmwCustomer';
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Full Name */
  fullName: Scalars['String']['output'];
  /** Customer ID */
  id: Scalars['String']['output'];
  /** Local Customer ID */
  localCustomerId: Scalars['ObjectID']['output'];
  /** Mobile */
  mobile: Scalars['String']['output'];
  /** NRIC */
  nric: Scalars['String']['output'];
};

export type BmwDbsNewCarFinance = BmwFinance & {
  __typename: 'BmwDBSNewCarFinance';
  bank: Scalars['String']['output'];
  discountPrice?: Maybe<Scalars['Float']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Float']['output'];
  type: BmwFinanceType;
};

export type BmwDbsUsedCarFinance = BmwFinance & {
  __typename: 'BmwDBSUsedCarFinance';
  bank: Scalars['String']['output'];
  discountPrice?: Maybe<Scalars['Float']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Float']['output'];
  type: BmwFinanceType;
};

export type BmwDocument = {
  __typename: 'BmwDocument';
  name: Scalars['String']['output'];
  type: BmwDocumentType;
};

export enum BmwDocumentType {
  FinPassBack = 'FINPassBack',
  FinPassFront = 'FINPassFront',
  IncomeDocument = 'IncomeDocument',
  LogCard = 'LogCard',
  MyIdentityCardBack = 'MYIdentityCardBack',
  MyIdentityCardFront = 'MYIdentityCardFront',
  Passport = 'Passport',
  SgIdentityCardBack = 'SGIdentityCardBack',
  SgIdentityCardFront = 'SGIdentityCardFront',
  VehicleSalesAgreement = 'VehicleSalesAgreement'
}

export type BmwFinance = {
  bank: Scalars['String']['output'];
  discountPrice?: Maybe<Scalars['Float']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Float']['output'];
  type: BmwFinanceType;
};

export enum BmwFinanceType {
  DbsNew = 'DBSNew',
  DbsUsed = 'DBSUsed'
}

export type BmwFsBankIntegration = BankIntegration & {
  __typename: 'BmwFsBankIntegration';
  accessKey: Scalars['String']['output'];
  dealerCode?: Maybe<Scalars['String']['output']>;
  host: Scalars['String']['output'];
  provider: BankIntegrationProvider;
};

export type BmwFsBankIntegrationSettings = {
  accessKey: Scalars['String']['input'];
  dealerCode?: InputMaybe<Scalars['String']['input']>;
  host: Scalars['String']['input'];
  secretKey: Scalars['String']['input'];
};

export type BmwFsBankIntegrationUpdateSettings = {
  accessKey: Scalars['String']['input'];
  dealerCode?: InputMaybe<Scalars['String']['input']>;
  host: Scalars['String']['input'];
  secretKey?: InputMaybe<Scalars['String']['input']>;
};

export type BmwModule = Module & {
  __typename: 'BmwModule';
  /** Bank */
  bank: Bank;
  /** Bank ID */
  bankId: Scalars['ObjectID']['output'];
  /** Bank Module */
  bankModule?: Maybe<Module>;
  /** Bank Module ID */
  bankModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** BMW Setting */
  bmwSetting: BmwSetting;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Customer Module */
  customerModule: Module;
  /** Customer Module ID */
  customerModuleId: Scalars['ObjectID']['output'];
  /** Dealer */
  dealer: Dealer;
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['output'];
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Vehicle management module */
  vehicleModule?: Maybe<Module>;
  /** Vehicle management module ID */
  vehicleModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type BmwModuleSettings = {
  /** Bank ID */
  bankId: Scalars['ObjectID']['input'];
  /** Bank module ID */
  bankModuleId: Scalars['ObjectID']['input'];
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['input'];
  /** Dealer Id */
  dealerId: Scalars['ObjectID']['input'];
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** SDM access key */
  sdmAccessKey: Scalars['String']['input'];
  /** SDM host */
  sdmHost: Scalars['String']['input'];
  /** SDM secret key */
  sdmSecretKey: Scalars['String']['input'];
  /** Vehicle management module ID */
  vehicleModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type BmwModuleUpdateSettings = {
  /** Bank ID */
  bankId: Scalars['ObjectID']['input'];
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['input'];
  /** Dealer Id */
  dealerId: Scalars['ObjectID']['input'];
  /** SDM access key */
  sdmAccessKey: Scalars['String']['input'];
  /** SDM callback url */
  sdmHost: Scalars['String']['input'];
  /** SDM secret key */
  sdmSecretKey?: InputMaybe<Scalars['String']['input']>;
  /** Vehicle management module ID */
  vehicleModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type BmwNewVehicle = BmwVehicle & {
  __typename: 'BmwNewVehicle';
  accessories?: Maybe<Scalars['String']['output']>;
  condition: BmwVehicleCondition;
  engineType: SdmEngineType;
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  ownerIdType: Scalars['String']['output'];
  parallelImport: Scalars['Boolean']['output'];
  scheme: BmwVehicleScheme;
};

export type BmwSetting = {
  __typename: 'BmwSetting';
  /** Module ID */
  authorization: Authorization;
  /** ID */
  id: Scalars['ObjectID']['output'];
  /** SDM access key */
  sdmAccessKey: Scalars['String']['output'];
  /** SDM callback url */
  sdmHost: Scalars['String']['output'];
};

export type BmwUsedVehicle = BmwVehicle & {
  __typename: 'BmwUsedVehicle';
  accessories?: Maybe<Scalars['String']['output']>;
  condition: BmwVehicleCondition;
  engineType: SdmEngineType;
  inspected: Scalars['Boolean']['output'];
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  ownerIdType: Scalars['String']['output'];
  parallelImport: Scalars['Boolean']['output'];
  scheme: BmwVehicleScheme;
};

export type BmwVehicle = {
  accessories?: Maybe<Scalars['String']['output']>;
  condition: BmwVehicleCondition;
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  ownerIdType: Scalars['String']['output'];
  parallelImport: Scalars['Boolean']['output'];
  scheme: BmwVehicleScheme;
};

export enum BmwVehicleCondition {
  New = 'New',
  Used = 'Used'
}

export enum BmwVehicleScheme {
  Normal = 'Normal',
  Opc = 'OPC'
}

export enum BodyType {
  Convertible = 'Convertible',
  Coupe = 'Coupe',
  Hatchback = 'Hatchback',
  Mpv = 'Mpv',
  Sedan = 'Sedan',
  Suv = 'Suv',
  Van = 'Van',
  Wagon = 'Wagon'
}

export enum BooleanWithEmpty {
  None = 'None',
  Off = 'Off',
  On = 'On'
}

export type CtsFinderRedirectionLink = {
  __typename: 'CTSFinderRedirectionLink';
  applicationJourney: ApplicationJourney;
  ctsSetting: CtsSetting;
  endpoint: Endpoint;
  router: Router;
  type: Scalars['String']['output'];
  vehicleId: Scalars['String']['output'];
};

export enum CalculationMode {
  Effective = 'Effective',
  Flat = 'Flat'
}

export type CalculatorDeferredPrincipalResult = {
  __typename: 'CalculatorDeferredPrincipalResult';
  downPayment: CompoundValue;
  loan: CompoundValue;
  monthlyInstalments: Array<Scalars['Float']['output']>;
};

export type CalculatorHirePurchaseResult = {
  __typename: 'CalculatorHirePurchaseResult';
  downPayment: CompoundValue;
  loan: CompoundValue;
  monthlyInstalment: Scalars['Float']['output'];
};

export type CalculatorHirePurchaseWithBalloonGfvResult = {
  __typename: 'CalculatorHirePurchaseWithBalloonGFVResult';
  downPayment: CompoundValue;
  loan: CompoundValue;
  monthlyInstalments: Array<Scalars['Float']['output']>;
};

export type CalculatorHirePurchaseWithBalloonResult = {
  __typename: 'CalculatorHirePurchaseWithBalloonResult';
  downPayment: CompoundValue;
  loan: CompoundValue;
  monthlyInstalment: Scalars['Float']['output'];
};

export type CalculatorLeasePurchaseResult = {
  __typename: 'CalculatorLeasePurchaseResult';
  downPayment: CompoundValue;
  loan: CompoundValue;
  monthlyInstalment: Scalars['Float']['output'];
};

export type CalculatorLeaseResult = {
  __typename: 'CalculatorLeaseResult';
  monthlyInstalment: Scalars['Float']['output'];
};

export type CalculatorPayload = {
  /** Assured Resale Value */
  assuredResaleValue?: InputMaybe<CompoundValuePayload>;
  /** Balloon payment */
  balloonPayment?: InputMaybe<CompoundValuePayload>;
  /** Car Price */
  carPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Commission (%) */
  commission?: InputMaybe<Scalars['Float']['input']>;
  /** Deposit Payment */
  deposit?: InputMaybe<CompoundValuePayload>;
  /** Displacement (cc) */
  displacement?: InputMaybe<Scalars['Int']['input']>;
  /** Down Payment */
  downPayment?: InputMaybe<CompoundValuePayload>;
  /** Estimated Surplus After Assured Resale Value */
  estimatedSurplusBalloon?: InputMaybe<Scalars['Float']['input']>;
  /** Restricted value on Finder */
  finderRestrictedValue?: InputMaybe<FinderRestrictedValuePayload>;
  /** Insurance Fee */
  insuranceFee?: InputMaybe<CompoundValuePayload>;
  /** Interest Rate */
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  /** License and fuel tax */
  licenseAndFuelTax?: InputMaybe<Scalars['Float']['input']>;
  /** License plate fee */
  licensePlateFee?: InputMaybe<Scalars['Float']['input']>;
  /** Loan */
  loan?: InputMaybe<CompoundValuePayload>;
  /** Mileage Value */
  mileage?: InputMaybe<Scalars['Float']['input']>;
  /** Payment Mode */
  paymentMode?: InputMaybe<PaymentMode>;
  /** Residual Value */
  residualValue?: InputMaybe<Scalars['Float']['input']>;
  /** Tax Loss */
  taxLoss?: InputMaybe<Scalars['Float']['input']>;
  /** Number of Terms */
  term: Scalars['Int']['input'];
  /** Total Price */
  totalPrice: Scalars['Float']['input'];
  /** Variant Suite Id */
  variantSuiteId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type CalculatorResult = CalculatorDeferredPrincipalResult | CalculatorHirePurchaseResult | CalculatorHirePurchaseWithBalloonGfvResult | CalculatorHirePurchaseWithBalloonResult | CalculatorLeasePurchaseResult | CalculatorLeaseResult | CalculatorUcclLeasingResult;

export type CalculatorUcclLeasingResult = {
  __typename: 'CalculatorUcclLeasingResult';
  downPayment: CompoundValue;
  loan: CompoundValue;
  monthlyInstalment: Scalars['Float']['output'];
  monthlyPaymentFixedInterestRate: Scalars['Float']['output'];
};

export type CancelMobilityApplicationAccess = {
  __typename: 'CancelMobilityApplicationAccess';
  url?: Maybe<Scalars['String']['output']>;
};

export type CapData = {
  __typename: 'CapData';
  customerFields: Array<LocalCustomerField>;
};

export type CapModule = Module & {
  __typename: 'CapModule';
  /** C@P Setting */
  capSetting?: Maybe<CapSetting>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type CapModuleSettings = {
  /** C@P Integration Setting */
  capSetting?: InputMaybe<CapSettingInput>;
  /** Display Name */
  displayName: Scalars['String']['input'];
};

export type CapSetting = {
  __typename: 'CapSetting';
  app2appClient?: Maybe<Scalars['String']['output']>;
  app2appHost?: Maybe<Scalars['String']['output']>;
  app2appResource?: Maybe<Scalars['String']['output']>;
  app2appSecret?: Maybe<Scalars['String']['output']>;
  capAuthGroup?: Maybe<Scalars['String']['output']>;
  capBaseUrl?: Maybe<Scalars['String']['output']>;
  capEndpointEnv?: Maybe<Scalars['String']['output']>;
  capGroup?: Maybe<Scalars['String']['output']>;
  capLanguage?: Maybe<Scalars['String']['output']>;
  capPagImporterId?: Maybe<Scalars['String']['output']>;
  capRegion?: Maybe<Scalars['String']['output']>;
  capSource?: Maybe<Scalars['String']['output']>;
  /** For C@P Authorization */
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
};

export type CapSettingInput = {
  app2appClient?: InputMaybe<Scalars['String']['input']>;
  app2appHost?: InputMaybe<Scalars['String']['input']>;
  app2appResource?: InputMaybe<Scalars['String']['input']>;
  app2appSecret?: InputMaybe<Scalars['String']['input']>;
  capAuthGroup?: InputMaybe<Scalars['String']['input']>;
  capBaseUrl?: InputMaybe<Scalars['String']['input']>;
  capEndpointEnv?: InputMaybe<Scalars['String']['input']>;
  capGroup?: InputMaybe<Scalars['String']['input']>;
  capLanguage?: InputMaybe<Scalars['String']['input']>;
  capPagImporterId?: InputMaybe<Scalars['String']['input']>;
  capRegion?: InputMaybe<Scalars['String']['input']>;
  capSource?: InputMaybe<Scalars['String']['input']>;
  /** For C@P Authorization */
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
};

export type CapValuesOnApplication = {
  __typename: 'CapValuesOnApplication';
  activityGuid?: Maybe<Scalars['String']['output']>;
  businessPartnerGuid?: Maybe<Scalars['String']['output']>;
  businessPartnerId?: Maybe<Scalars['String']['output']>;
  campaignGuid?: Maybe<Scalars['String']['output']>;
  consentGuid?: Maybe<Scalars['String']['output']>;
  dealerGuid?: Maybe<Scalars['String']['output']>;
  leadGuid?: Maybe<Scalars['String']['output']>;
  leadId?: Maybe<Scalars['String']['output']>;
  salespersonGuid?: Maybe<Scalars['String']['output']>;
};

export type CheckboxApplicationAgreement = ApplicationAgreement & {
  __typename: 'CheckboxApplicationAgreement';
  /** Conditions */
  conditions?: Maybe<Array<Condition>>;
  /** Data field */
  dataField: DataField;
  /** Description */
  description?: Maybe<TranslatedString>;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** Has legal markup */
  hasLegalMarkup?: Maybe<Scalars['Boolean']['output']>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is agreed by the customer */
  isAgreed: Scalars['Boolean']['output'];
  /** Mandatory */
  isMandatory: Scalars['Boolean']['output'];
  /** Legal Markup */
  legalMarkup?: Maybe<TranslatedString>;
  /** Legal Text Position */
  legalTextPosition?: Maybe<LegalTextPosition>;
  /** Order Number */
  orderNumber: Scalars['Int']['output'];
  /** Purpose */
  purpose: Array<ConsentsAndDeclarationsPurpose>;
  /** Title */
  title?: Maybe<TranslatedString>;
  /** C&D type */
  type: ConsentsAndDeclarationsType;
};

export type CheckboxConsentsAndDeclarations = ConsentsAndDeclarations & {
  __typename: 'CheckboxConsentsAndDeclarations';
  /** Conditions */
  conditions?: Maybe<Array<Condition>>;
  /** Data field */
  dataField: DataField;
  /** Description */
  description?: Maybe<TranslatedString>;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** Feature Purpose */
  featurePurpose: ConsentFeaturePurpose;
  /** Has legal markup */
  hasLegalMarkup?: Maybe<Scalars['Boolean']['output']>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is active */
  isActive: Scalars['Boolean']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Mandatory */
  isMandatory: Scalars['Boolean']['output'];
  /** Legal Markup */
  legalMarkup?: Maybe<TranslatedString>;
  /** Legal Text Position */
  legalTextPosition?: Maybe<LegalTextPosition>;
  /** Module */
  module: Module;
  /** Module ID */
  moduleId: Scalars['ObjectID']['output'];
  /** Order Number */
  orderNumber: Scalars['Int']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Purpose */
  purpose: Array<ConsentsAndDeclarationsPurpose>;
  /** Title */
  title?: Maybe<TranslatedString>;
  /** C&D type */
  type: ConsentsAndDeclarationsType;
  /** Versioning */
  versioning: AdvancedVersioning;
};

export type CheckboxConsentsAndDeclarationsSettings = {
  /** Data field */
  dataField: DataField;
  /** Description */
  description?: InputMaybe<TranslatedStringInput>;
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** Has legal markup */
  hasLegalMarkup?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is active */
  isActive: Scalars['Boolean']['input'];
  /** Mandatory */
  isMandatory: Scalars['Boolean']['input'];
  /** Legal Markup */
  legalMarkup?: InputMaybe<TranslatedStringInput>;
  /** Legal Text Position */
  legalTextPosition?: InputMaybe<LegalTextPosition>;
  /** Order Number */
  orderNumber: Scalars['Int']['input'];
  /** Purpose */
  purpose: Array<ConsentsAndDeclarationsPurpose>;
  /** Title */
  title?: InputMaybe<TranslatedStringInput>;
};

export type ColorAndTrimSettings = {
  __typename: 'ColorAndTrimSettings';
  /** Color or trim code */
  code?: Maybe<Scalars['String']['output']>;
  /** Hex */
  hex: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Color or trim image */
  image?: Maybe<UploadedFileWithPreview>;
  /** Color or trim name */
  name: TranslatedString;
  /** Price */
  price?: Maybe<Scalars['Float']['output']>;
};

export type ColorAndTrimSettingsInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  hex: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  name: TranslatedStringInput;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type ColorBlock = Block & {
  __typename: 'ColorBlock';
  /** Color settings */
  colorSettings: Array<ColorAndTrimSettings>;
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Section title */
  sectionTitle: TranslatedString;
  type: BlockType;
};

export type ColorBlockInput = {
  colorSettings: Array<ColorAndTrimSettingsInput>;
  isActive: Scalars['Boolean']['input'];
  sectionTitle: TranslatedStringInput;
};

export type ColumnBlock = {
  __typename: 'ColumnBlock';
  description?: Maybe<TranslatedString>;
  id: Scalars['ObjectID']['output'];
  image?: Maybe<UploadedFileWithPreview>;
  title?: Maybe<TranslatedString>;
};

export type ColumnBlockInput = {
  description?: InputMaybe<TranslatedStringInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  title?: InputMaybe<TranslatedStringInput>;
};

export type ColumnWebPageBlock = WebPageBlock & {
  __typename: 'ColumnWebPageBlock';
  columns: Array<ColumnBlock>;
  id: Scalars['ObjectID']['output'];
  title?: Maybe<TranslatedString>;
  type: WebPageBlockType;
};

export type ColumnWebPageBlockInput = {
  columns: Array<ColumnBlockInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  title?: InputMaybe<TranslatedStringInput>;
  type: WebPageBlockType;
};

export type ComboOption = {
  __typename: 'ComboOption';
  /** Character limit */
  charLimit?: Maybe<Scalars['Int']['output']>;
  /** Combo type */
  comboType: ComboType;
  /** Descriptions for drop down */
  descriptions?: Maybe<Array<TranslatedString>>;
  id: Scalars['ObjectID']['output'];
  /** Label */
  label: TranslatedString;
  /** Placeholder */
  placeholder?: Maybe<Scalars['String']['output']>;
};

export type ComboOptionInput = {
  charLimit?: InputMaybe<Scalars['Int']['input']>;
  descriptions?: InputMaybe<Array<TranslatedStringInput>>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  label: TranslatedStringInput;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  type: ComboType;
};

export type ComboOptionSettings = {
  __typename: 'ComboOptionSettings';
  kind?: Maybe<OptionKind>;
  options: Array<ComboOption>;
  price: Scalars['Float']['output'];
};

export type ComboOptionSettingsInput = {
  options: Array<ComboOptionInput>;
  price: Scalars['Float']['input'];
};

export enum ComboType {
  Dropdown = 'Dropdown',
  TextField = 'TextField'
}

export type CommissionSettingPayload = {
  default: Scalars['Float']['input'];
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
};

export type CommissionSettings = {
  __typename: 'CommissionSettings';
  default: Scalars['Float']['output'];
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
};

export type Company = {
  __typename: 'Company';
  /** Active maintenance */
  activeMaintenanceModule?: Maybe<MaintenanceModule>;
  /** Company address */
  address?: Maybe<Scalars['String']['output']>;
  /** Autoplay settings */
  autoplaySettings: Array<AutoplaySetting>;
  /** Available dealers */
  availableDealers?: Maybe<Array<Dealer>>;
  availableModules: AvailableModules;
  /** COE */
  coe: Scalars['Float']['output'];
  /** Company primary color */
  color: Scalars['String']['output'];
  /** Company name */
  companyName: TranslatedString;
  /** Company copyright */
  copyright: TranslatedString;
  /** Country code */
  countryCode: Scalars['String']['output'];
  /** Currency (symbol) */
  currency: Scalars['String']['output'];
  /** Data Purge After ( in years ) */
  dataPurgeAfter?: Maybe<Scalars['Int']['output']>;
  /** Company description */
  description?: Maybe<TranslatedString>;
  /** Company display name */
  displayName: Scalars['String']['output'];
  /** EDM Email Footer */
  edmEmailFooter: EdmEmailFooter;
  /** Company email address */
  email: Scalars['String']['output'];
  /** Company email settings */
  emailSettings: EmailSettings;
  enableContentRefinement: Scalars['Boolean']['output'];
  /** Dealer Establishment Fee */
  estFee: Scalars['Float']['output'];
  /** Company favicon */
  favicon?: Maybe<UploadedFileWithPreview>;
  /** Company font */
  font?: Maybe<UploadedFile>;
  /** Company font bold */
  fontBold?: Maybe<UploadedFile>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Active state */
  isActive: Scalars['Boolean']['output'];
  /** Data Purge Enabled */
  isDataPurgeEnabled: Scalars['Boolean']['output'];
  /** Deletion state */
  isDeleted: Scalars['Boolean']['output'];
  /** Is Instant Approval Stats Enabled */
  isInstantApprovalStatsEnabled: Scalars['Boolean']['output'];
  /** Languages */
  languages: Array<LanguagePack>;
  /** Company legal name */
  legalName: TranslatedString;
  /** Live chat settings */
  liveChatSettings: Array<LiveChatSetting>;
  /** Company logo */
  logo?: Maybe<UploadedFileWithPreview>;
  /** Market Code */
  marketCode?: Maybe<Scalars['String']['output']>;
  /** Mask settings */
  mask: MaskSettings;
  /** Multi Factor Authentication Settings */
  mfaSettings?: Maybe<MfaSettings>;
  /** Modules */
  modules: Array<Module>;
  /** Password configuration */
  passwordConfiguration: PasswordConfiguration;
  /** Payment Settings */
  paymentSettings: Array<PaymentSetting>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Company phone number */
  phone?: Maybe<Phone>;
  /** PPSR Fee */
  ppsr: Scalars['Float']['output'];
  /** Company Roles */
  roles: Array<Role>;
  /** Company rounding settings */
  roundings: Roundings;
  /** Session Timeout */
  sessionTimeout: Scalars['Int']['output'];
  /** Company sms settings */
  smsSettings: SmsSettings;
  /** Company theme */
  theme: CompanyTheme;
  /** Time zone */
  timeZone: Scalars['String']['output'];
  /** Company User Groups */
  userGroups: Array<UserGroup>;
  /** Company VAT rate setting */
  vatRateSettings?: Maybe<VatRateSettings>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export enum CompanyAsset {
  EdmEmailArrowIcon = 'EdmEmailArrowIcon',
  EdmEmailIcon = 'EdmEmailIcon',
  EdmEmailPhoneIcon = 'EdmEmailPhoneIcon',
  Favicon = 'Favicon',
  Font = 'Font',
  FontBold = 'FontBold',
  Icon = 'Icon',
  Logo = 'Logo'
}

export enum CompanyFilterListCollection {
  Banners = 'Banners',
  Configurators = 'Configurators',
  ConsentsAndDeclarations = 'ConsentsAndDeclarations',
  Events = 'Events',
  FinanceProducts = 'FinanceProducts',
  FinderVehicles = 'FinderVehicles',
  InsuranceProducts = 'InsuranceProducts',
  Inventories = 'Inventories',
  Labels = 'Labels',
  LocalMakes = 'LocalMakes',
  LocalModels = 'LocalModels',
  LocalSubmodels = 'LocalSubmodels',
  LocalVariants = 'LocalVariants',
  Mobilities = 'Mobilities',
  PromoCodes = 'PromoCodes',
  WebPages = 'WebPages'
}

export type CompanyFilterListRule = {
  collection: CompanyFilterListCollection;
  dealerIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export type CompanyFilteringRule = {
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by Currency */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Filter by company display name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter by companies on which the user can create modules */
  withModuleCreation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by companies on which the user can create routers */
  withRouterCreation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyOptions = {
  __typename: 'CompanyOptions';
  availableModules?: Maybe<AvailableModules>;
  /** Country code */
  countryCode: Scalars['String']['output'];
  /** Company display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
};

export type CompanySettings = {
  address?: InputMaybe<Scalars['String']['input']>;
  coe: Scalars['Float']['input'];
  color: Scalars['String']['input'];
  companyName: TranslatedStringInput;
  copyright: TranslatedStringInput;
  countryCode: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  dataMask: MaskSettingsPayload;
  dataPurgeAfter?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<TranslatedStringInput>;
  displayName: Scalars['String']['input'];
  edmEmailFooter: EdmEmailFooterPayload;
  email: Scalars['String']['input'];
  emailSettings: EmailSettingsPayload;
  enableContentRefinement: Scalars['Boolean']['input'];
  estFee: Scalars['Float']['input'];
  isActive: Scalars['Boolean']['input'];
  isDataPurgeEnabled: Scalars['Boolean']['input'];
  isInstantApprovalStatsEnabled: Scalars['Boolean']['input'];
  languages: Array<Scalars['ObjectID']['input']>;
  legalName: TranslatedStringInput;
  marketCode?: InputMaybe<Scalars['String']['input']>;
  mfaSettings?: InputMaybe<MfaSettingsPayload>;
  passwordConfiguration: PasswordConfiguration;
  phone?: InputMaybe<PhonePayload>;
  ppsr: Scalars['Float']['input'];
  roundings: RoundingsPayload;
  sessionTimeout: Scalars['Int']['input'];
  smsSettings: SmsSettingsPayload;
  theme: CompanyTheme;
  timeZone: Scalars['String']['input'];
  vatRateSettings?: InputMaybe<VatRateSettingsInput>;
};

export enum CompanySortingField {
  /** Sort by Currency */
  Currency = 'Currency',
  /** Sort by Company display name */
  Name = 'Name'
}

export type CompanySortingRule = {
  /** Field on which apply the sorting */
  field: CompanySortingField;
  /** Sorting order */
  order: SortingOrder;
};

export enum CompanyTheme {
  Admin = 'Admin',
  Cupra = 'Cupra',
  Default = 'Default',
  Porsche = 'Porsche',
  PorscheV3 = 'PorscheV3',
  Skoda = 'Skoda',
  Volkswagen = 'Volkswagen'
}

export type CompoundValue = {
  __typename: 'CompoundValue';
  amount?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type CompoundValuePayload = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type Condition = {
  type: ConditionType;
};

export type ConditionSettings = {
  applicationModuleConditionSettings?: InputMaybe<ApplicationModuleConditionSettings>;
  bankConditionSettings?: InputMaybe<BankConditionSettings>;
  contextualConditionSettings?: InputMaybe<ContextualConditionSettings>;
  dealerConditionsSettings?: InputMaybe<DealerConditionsSettings>;
  giftVoucherConditionSettings?: InputMaybe<GiftVoucherConditionSettings>;
  insurerConditionSettings?: InputMaybe<InsurerConditionsSettings>;
  locationConditionSettings?: InputMaybe<LocationConditionSettings>;
  logicConditionSettings?: InputMaybe<LogicConditionSettings>;
  type: ConditionType;
};

export enum ConditionType {
  And = 'And',
  IsApplicant = 'IsApplicant',
  IsApplicationModule = 'IsApplicationModule',
  IsApplyingForFinancing = 'IsApplyingForFinancing',
  IsApplyingForInsurance = 'IsApplyingForInsurance',
  IsBank = 'IsBank',
  IsCorporate = 'IsCorporate',
  IsDealer = 'IsDealer',
  IsGiftVoucher = 'IsGiftVoucher',
  IsGuarantor = 'IsGuarantor',
  IsInsurer = 'IsInsurer',
  IsTestDrive = 'IsTestDrive',
  IsTestDriveProcess = 'IsTestDriveProcess',
  IsTradeIn = 'IsTradeIn',
  Or = 'Or',
  WithMyinfo = 'WithMyinfo',
  WithoutMyinfo = 'WithoutMyinfo',
  IsLocation = 'isLocation'
}

export type Configurator = ModelConfigurator | VariantConfigurator;

export type ConfiguratorApplication = Application & {
  __typename: 'ConfiguratorApplication';
  /** Applicant */
  applicant: Customer;
  /** Agreements for the applicant */
  applicantAgreements: Array<ApplicationAgreement>;
  /** Applicant ID */
  applicantId: Scalars['ObjectID']['output'];
  /** KYC fields for the applicant */
  applicantKYC: Array<KycField>;
  appointmentStage?: Maybe<AppointmentStage>;
  /** assignees this application can be assigned to */
  availableAssignees: Array<User>;
  /** Bank */
  bank?: Maybe<SystemBank>;
  /** Bank ID */
  bankId?: Maybe<Scalars['ObjectID']['output']>;
  capValues?: Maybe<CapValuesOnApplication>;
  commentsToInsurer?: Maybe<Scalars['String']['output']>;
  /** Configurator Application Configuration */
  configuration: ConfiguratorApplicationConfiguration;
  /** Variant Configurator */
  configurator: VariantConfigurator;
  /** Configurator Blocks */
  configuratorBlocks: Array<ApplicationConfiguratorBlock>;
  /** Variant Configurator Id */
  configuratorId: Scalars['ObjectID']['output'];
  /** Agreements for the corporate */
  corporateAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the corporate */
  corporateKYC: Array<KycField>;
  /** Dealer data */
  dealer: Dealer;
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['output'];
  /** Application Deposit */
  deposit?: Maybe<ApplicationDeposit>;
  /** Application Document */
  documents: Array<ApplicationDocument>;
  /** Drafting flow */
  draftFlow: StandardApplicationDraftFlow;
  /** Endpoint */
  endpoint?: Maybe<Endpoint>;
  /** Expired Time */
  expireAt?: Maybe<Scalars['DateTime']['output']>;
  /** Financial Product */
  financeProduct?: Maybe<FinanceProduct>;
  /** Application Finance */
  financing?: Maybe<ApplicationFinancing>;
  financingStage?: Maybe<FinancingStage>;
  /**
   * Guarantor
   * currently only have 1 Guarantor
   * might have more guarantor in future
   */
  guarantor?: Maybe<Customer>;
  /** Agreements for the guarantor */
  guarantorAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the guarantor */
  guarantorKYC: Array<KycField>;
  /** Guarantor Application Signing */
  guarantorSigning?: Maybe<ApplicationSigning>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Insurance Product */
  insuranceProduct?: Maybe<InsuranceProduct>;
  /** Insurance application signing */
  insuranceSigning?: Maybe<ApplicationSigning>;
  insuranceStage?: Maybe<InsuranceStage>;
  /** Application insurancing */
  insurancing?: Maybe<ApplicationInsurancing>;
  /** Insurer */
  insurer?: Maybe<Insurer>;
  /** Submitted To Bank Before */
  isSubmittedToBank: Scalars['Boolean']['output'];
  /** Journey Steps Identifiers */
  journeySteps: Array<Scalars['String']['output']>;
  /** Language ID to determine what language user chose in journey */
  languageId?: Maybe<Scalars['ObjectID']['output']>;
  latestStage?: Maybe<ApplicationStageDetails>;
  leadStage?: Maybe<LeadStage>;
  mobilityStage?: Maybe<MobilityStage>;
  /** Module */
  module: Module;
  /** ModuleId */
  moduleId: Scalars['ObjectID']['output'];
  /** Other Vehicle Information */
  otherVehicleInformation?: Maybe<OtherVehicleInformation>;
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Promo Code data */
  promoCode?: Maybe<PromoCode>;
  /** Promo Code ID */
  promoCodeId?: Maybe<Scalars['ObjectID']['output']>;
  /** Quotation */
  quotation?: Maybe<ApplicationQuotation>;
  /** Finance application suite id */
  referenceApplicationSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Finance application suite id */
  referenceApplications: Array<Application>;
  remarks: Scalars['String']['output'];
  reservationStage?: Maybe<ReservationStage>;
  /** Router */
  router?: Maybe<Router>;
  /** Router ID */
  routerId?: Maybe<Scalars['ObjectID']['output']>;
  /** Application Signing */
  signing?: Maybe<ApplicationSigning>;
  stages: Array<ApplicationStage>;
  /** Agreements for the test drive */
  testDriveAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the test drive */
  testDriveKYC: Array<KycField>;
  /** Redirect Url */
  testDriveRedirectUrl?: Maybe<Scalars['String']['output']>;
  /** Test Drive Signing */
  testDriveSigning?: Maybe<ApplicationSigning>;
  /** TradeIn Vehicle */
  tradeInVehicle: Array<TradeInVehicle>;
  /** As a flag whether user has use myinfo on kyc or no */
  useMyinfo?: Maybe<Scalars['Boolean']['output']>;
  /** Vehicle */
  vehicle: Vehicle;
  /** Vehicle ID */
  vehicleId: Scalars['ObjectID']['output'];
  /** Vehicle Image */
  vehicleImage?: Maybe<UploadedFileWithPreview>;
  /** Versioning */
  versioning: AdvancedVersioning;
  /** Application is proceeding with customer device */
  withCustomerDevice: Scalars['Boolean']['output'];
};

export type ConfiguratorApplicationConfiguration = {
  __typename: 'ConfiguratorApplicationConfiguration';
  isAffinAutoFinanceCentreRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Request for financing
   *
   * When user ask for request financial,
   * True: Financing Preference value is "Request" or Calculator visibility is "Optional"
   *       and user checked the checkbox in CI.
   *       Show financing summary in reservation/insurance/lead details and email
   */
  requestForFinancing: Scalars['Boolean']['output'];
  testDrive: Scalars['Boolean']['output'];
  tradeIn: Scalars['Boolean']['output'];
  withFinancing: Scalars['Boolean']['output'];
  withInsurance: Scalars['Boolean']['output'];
};

export type ConfiguratorApplicationConfigurationPayload = {
  isAffinAutoFinanceCentreRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Request for financing
   *
   * When user ask for request financial,
   * True: Financing Preference value is "Request" or Calculator visibility is "Optional"
   *       and user checked the checkbox in CI.
   *       Show financing summary in reservation/insurance/lead details and email
   */
  requestForFinancing: Scalars['Boolean']['input'];
  testDrive: Scalars['Boolean']['input'];
  tradeIn: Scalars['Boolean']['input'];
  withFinancing: Scalars['Boolean']['input'];
  withInsurance: Scalars['Boolean']['input'];
};

export type ConfiguratorApplicationEntrypoint = Endpoint & {
  __typename: 'ConfiguratorApplicationEntrypoint';
  /** Application Stage */
  applicationStage: ApplicationStage;
  /** Configurator Application Module */
  configuratorApplicationModule: ConfiguratorModule;
  /** Configurator Application Module ID */
  configuratorApplicationModuleId: Scalars['ObjectID']['output'];
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Pathname */
  pathname: Scalars['String']['output'];
};

export type ConfiguratorApplicationEntrypointSettings = {
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** Pathname */
  pathname: Scalars['String']['input'];
};

export type ConfiguratorApplicationLink = {
  __typename: 'ConfiguratorApplicationLink';
  applicationJourney: ApplicationJourney;
  endpoint: Endpoint;
  modelConfiguratorId: Scalars['ObjectID']['output'];
  router: Router;
  urlIdentifier: Scalars['String']['output'];
  variantConfiguratorId: Scalars['ObjectID']['output'];
};

export type ConfiguratorBlockPayload = {
  /** Configurator Block Id */
  blockId: Scalars['ObjectID']['input'];
  /** Configurator Values for Combo */
  combo: Array<ConfiguratorComboPayload>;
  /** Configurator IDs can be one or more depending on block type */
  ids: Array<Scalars['ObjectID']['input']>;
};

/** One of the Configurator Combo should have a value */
export type ConfiguratorComboPayload = {
  /** Combo Option Id */
  id: Scalars['ObjectID']['input'];
  /** Value selected in the dropdown or typed by the user */
  value: Scalars['String']['input'];
};

export type ConfiguratorInventory = Inventory & {
  __typename: 'ConfiguratorInventory';
  /** Assigned VIN Count */
  assignedVinCount?: Maybe<Scalars['Int']['output']>;
  /** Computed Stock for new configurator application */
  availableStock: Scalars['Int']['output'];
  /** Snapshot of Color setting, it's okay to use this since image optional */
  colorSetting: ColorAndTrimSettings;
  /** Variant configurator */
  configurator: VariantConfigurator;
  /** Variant configurator ID */
  configuratorId: Scalars['ObjectID']['output'];
  /** Dealer */
  dealer: Dealer;
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Inventory Identifier */
  identifier: Scalars['String']['output'];
  /** Is active flag */
  isActive: Scalars['Boolean']['output'];
  /** Soft deletion flag */
  isDeleted: Scalars['Boolean']['output'];
  /** Kind of inventory */
  kind: InventoryKind;
  /** Model */
  model: LocalModel;
  /** Configurator module */
  module: ConfiguratorModule;
  /** Assigned module */
  moduleId: Scalars['ObjectID']['output'];
  /** Snapshot of Package setting (optional), it's okay to use this since section image optional */
  packageSetting?: Maybe<PackageSettings>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Price, combination price */
  price: Scalars['Float']['output'];
  /** Computed Remaining stock */
  remainingStock: Scalars['Int']['output'];
  /** Computed Reserved stock */
  reservedStock: Scalars['Int']['output'];
  /** Stocks */
  stocks: Array<StockInventory>;
  /** Sub Model (optional) */
  subModel?: Maybe<LocalModel>;
  /** Snapshot of Trim setting, it's okay to use this since image optional */
  trimSetting: ColorAndTrimSettings;
  /** Variant */
  variant: LocalVariant;
  /** Simple versioning */
  versioning: SimpleVersioning;
};

export type ConfiguratorModule = Module & {
  __typename: 'ConfiguratorModule';
  /** Agreements module */
  agreementsModule: Module;
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['output'];
  /** Counter for applications */
  applicationCounter: CounterSettings;
  /** Counter for reservations */
  appointmentCounter: CounterSettings;
  /** Appointment Module */
  appointmentModule?: Maybe<AppointmentModule>;
  /** Appointment Module ID */
  appointmentModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Sale person */
  assignee: DealershipPublicSalesPerson;
  /** Determine when to show Bank in Calculator */
  bankDisplayPreference: DisplayPreference;
  /** Bank IDs */
  bankIds: Array<Scalars['ObjectID']['output']>;
  /** Bank module */
  bankModule?: Maybe<Module>;
  /** Bank module ID */
  bankModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Banks */
  banks: Array<Bank>;
  /** C@P Module ID */
  capModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: Maybe<Scalars['Boolean']['output']>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Customer module */
  customerModule: Module;
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['output'];
  /** Dealer Finance Products */
  dealerFinanceProducts: Array<DealerFinanceProducts>;
  /** Dealer Insurance Products */
  dealerInsuranceProducts: Array<DealerInsuranceProducts>;
  /** Dealer Vehicles */
  dealerVehicles: Array<DealerVehicles>;
  /** Deposit Amount ( changed the naming due to type conflict with standard application module ) */
  depositPrice?: Maybe<Scalars['Float']['output']>;
  displayAppointmentDatepicker: Scalars['Boolean']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Email contents */
  emailContents: ConfiguratorModuleEmailContents;
  /** External URL */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** Financing preference */
  financingPreference: FinancingPreferenceValue;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Counter for insurance */
  insuranceCounter: CounterSettings;
  insuranceModule?: Maybe<Module>;
  insuranceModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Determine when to show Insurer in Calculator */
  insurerDisplayPreference: DisplayPreference;
  /** Insurer IDs */
  insurerIds: Array<Scalars['ObjectID']['output']>;
  /** Insurers */
  insurers: Array<Insurer>;
  /** Is Insurance Optional */
  isInsuranceOptional: Scalars['Boolean']['output'];
  /** Is inventory enabled */
  isInventoryEnabled: Scalars['Boolean']['output'];
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['output'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: Maybe<Scalars['Boolean']['output']>;
  isTradeInAmountVisible?: Maybe<Scalars['Boolean']['output']>;
  /** KYC presets */
  kycPresets: Array<KycPreset>;
  /** Defining the campaign ID for C@P lead submission */
  leadCampaignId?: Maybe<Scalars['String']['output']>;
  /** Counter for leads */
  leadCounter: CounterSettings;
  /** Defining the lead medium for C@P lead submission */
  leadMedium?: Maybe<EventMediumType>;
  /** Defining the lead origin for C@P lead submission */
  leadOrigin?: Maybe<EventLeadOriginType>;
  /** Live chat setting */
  liveChatSetting?: Maybe<LiveChatSetting>;
  /** Live chat setting id */
  liveChatSettingId?: Maybe<Scalars['ObjectID']['output']>;
  /** Market */
  market: ApplicationMarket;
  /** Market Type */
  marketType: ApplicationMarketType;
  /** MyInfo Setting */
  myInfoSetting?: Maybe<MyInfoSetting>;
  /** MyInfo Setting ID */
  myInfoSettingId?: Maybe<Scalars['ObjectID']['output']>;
  /** Payment Settings */
  paymentSettings?: Maybe<PaymentSetting>;
  /** Payment Settings ID */
  paymentSettingsId?: Maybe<Scalars['ObjectID']['output']>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Price Disclaimer */
  priceDisclaimer: DealerDisclaimersConfigurator;
  /** Promo code module */
  promoCodeModule?: Maybe<Module>;
  /** Promo code module id */
  promoCodeModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Counter for reservations */
  reservationCounter: CounterSettings;
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show Finance Calculator */
  showFinanceCalculator: Scalars['Boolean']['output'];
  /** Show From Value on Vehicle Details in Calculator */
  showFromValueOnVehicleDetails: Scalars['Boolean']['output'];
  /** Show Insurance Calculator */
  showInsuranceCalculator: Scalars['Boolean']['output'];
  /** Show Remote Flow Button in Login Access KYC page */
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['output'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['output'];
  /** Skip for Deposit in Payment page */
  skipForDeposit: Scalars['Boolean']['output'];
  /** Terms and Conditions text */
  termsText: DealerTranslatedStringSetting;
  /** Terms and Conditions title */
  termsTitle: DealerTranslatedStringSetting;
  /** Test Drive */
  testDrive: Scalars['Boolean']['output'];
  /** Trade In */
  tradeIn: Scalars['Boolean']['output'];
  /** Vehicle management module */
  vehicleModule: Module;
  /** Vehicle management module ID */
  vehicleModuleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: SimpleVersioning;
};

export enum ConfiguratorModuleAsset {
  SaveOrderBanner = 'SaveOrderBanner',
  SaveOrderIntro = 'SaveOrderIntro',
  SubmitOrderIntro = 'SubmitOrderIntro'
}

export type ConfiguratorModuleEmailContents = {
  __typename: 'ConfiguratorModuleEmailContents';
  saveOrder: ConfiguratorSaveOrderContent;
  submitOrder: ConfiguratorSubmitOrderContent;
};

export type ConfiguratorModuleEmailContentsSetting = {
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentUpdateType: EmailContentUpdateType;
  saveOrder: ConfiguratorSaveOrderInput;
  submitOrder: ConfiguratorSubmitOrderInput;
};

export type ConfiguratorModuleInitialSettings = {
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['input'];
  /** Counter for applications */
  applicationCounter: CounterPayload;
  /** Counter for appointment */
  appointmentCounter: CounterPayload;
  /** Appointment module ID */
  appointmentModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Sale person */
  assignee: DealershipSettingInput;
  /** Determine when to show Bank in Calculator */
  bankDisplayPreference: DisplayPreference;
  /** Banks */
  bankIds: Array<Scalars['ObjectID']['input']>;
  /** Bank module ID */
  bankModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** C@P Module ID */
  capModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['input'];
  /** Deposit Amount ( changed the naming due to type conflict with standard application module ) */
  depositPrice?: InputMaybe<Scalars['Float']['input']>;
  displayAppointmentDatepicker: Scalars['Boolean']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Email contents */
  emailContents: ConfiguratorModuleEmailContentsSetting;
  /** External URL */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** Financing preference */
  financingPreference: FinancingPreferenceValue;
  /** Counter for insurance */
  insuranceCounter: CounterPayload;
  /** Insurance Module ID */
  insuranceModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Determine when to show Insurer in Calculator */
  insurerDisplayPreference: DisplayPreference;
  /** Insurers */
  insurerIds: Array<Scalars['ObjectID']['input']>;
  /** Is Insurance Optional */
  isInsuranceOptional: Scalars['Boolean']['input'];
  /** Is inventory enabled */
  isInventoryEnabled: Scalars['Boolean']['input'];
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['input'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: InputMaybe<Scalars['Boolean']['input']>;
  isTradeInAmountVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defining the campaign ID for C@P lead submission */
  leadCampaignId?: InputMaybe<Scalars['String']['input']>;
  /** Counter for leads */
  leadCounter: CounterPayload;
  /** Defining the lead medium for C@P lead submission */
  leadMedium?: InputMaybe<EventMediumType>;
  /** Defining the lead origin for C@P lead submission */
  leadOrigin?: InputMaybe<EventLeadOriginType>;
  /** Live chat settings */
  liveChatSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Market */
  market?: InputMaybe<ApplicationMarket>;
  /** Market Type Input */
  marketType?: InputMaybe<ApplicationModuleMarketTypeInput>;
  /** MyInfo Setting ID */
  myInfoSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Payment settings ID */
  paymentSettingsId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Price Disclaimer */
  priceDisclaimer: DealerDisclaimersConfiguratorInput;
  /** Promo code module id */
  promoCodeModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Counter for reservations */
  reservationCounter: CounterPayload;
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show Finance Calculator */
  showFinanceCalculator: Scalars['Boolean']['input'];
  /** Show From Value on Vehicle Details in Calculator */
  showFromValueOnVehicleDetails: Scalars['Boolean']['input'];
  /** Show Insurance Calculator */
  showInsuranceCalculator: Scalars['Boolean']['input'];
  /** Show Remote Flow Button in Login Access KYC page */
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['input'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['input'];
  /** Skip for Deposit in Payment page */
  skipForDeposit: Scalars['Boolean']['input'];
  /** Terms text */
  termsText: DealerTranslatedStringSettingInput;
  /** Terms title */
  termsTitle: DealerTranslatedStringSettingInput;
  /** Test Drive */
  testDrive: Scalars['Boolean']['input'];
  /** Trade In */
  tradeIn: Scalars['Boolean']['input'];
  /** Vehicle management module ID */
  vehicleModuleId: Scalars['ObjectID']['input'];
};

export type ConfiguratorModuleUpdateSettings = {
  /** Appointment module ID */
  appointmentModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Sale person */
  assignee: DealershipSettingInput;
  /** Determine when to show Bank in Calculator */
  bankDisplayPreference: DisplayPreference;
  /** Banks */
  bankIds: Array<Scalars['ObjectID']['input']>;
  /** Bank module id */
  bankModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** C@P Module ID */
  capModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deposit Amount ( changed the naming due to type conflict with standard application module ) */
  depositPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Display appointment datepicker */
  displayAppointmentDatepicker: Scalars['Boolean']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** External URL */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** Financing preference */
  financingPreference: FinancingPreferenceValue;
  /** Insurance Module ID */
  insuranceModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Determine when to show Insurer in Calculator */
  insurerDisplayPreference: DisplayPreference;
  /** Insurers */
  insurerIds: Array<Scalars['ObjectID']['input']>;
  /** Is Insurance Optional */
  isInsuranceOptional: Scalars['Boolean']['input'];
  /** Is inventory enabled */
  isInventoryEnabled: Scalars['Boolean']['input'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: InputMaybe<Scalars['Boolean']['input']>;
  isTradeInAmountVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defining the campaign ID for C@P lead submission */
  leadCampaignId?: InputMaybe<Scalars['String']['input']>;
  /** Defining the lead medium for C@P lead submission */
  leadMedium?: InputMaybe<EventMediumType>;
  /** Defining the lead origin for C@P lead submission */
  leadOrigin?: InputMaybe<EventLeadOriginType>;
  /** Live chat settings */
  liveChatSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Market */
  market: ApplicationMarket;
  /** Market Type Input */
  marketType?: InputMaybe<ApplicationModuleMarketTypeInput>;
  /** MyInfo Setting ID */
  myInfoSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Payment Setting ID */
  paymentSettingsId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Price Disclaimer */
  priceDisclaimer: DealerDisclaimersConfiguratorInput;
  /** Promo code module id */
  promoCodeModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show Finance Calculator */
  showFinanceCalculator: Scalars['Boolean']['input'];
  /** Show From Value on Vehicle Details in Calculator */
  showFromValueOnVehicleDetails: Scalars['Boolean']['input'];
  /** Show Insurance Calculator */
  showInsuranceCalculator: Scalars['Boolean']['input'];
  /** Show Remote Flow Button in Login Access KYC page */
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['input'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['input'];
  /** Skip for Deposit in Payment page */
  skipForDeposit: Scalars['Boolean']['input'];
  /** Terms text */
  termsText: DealerTranslatedStringSettingInput;
  /** Terms title */
  termsTitle: DealerTranslatedStringSettingInput;
  /** Test Drive */
  testDrive: Scalars['Boolean']['input'];
  /** Trade In */
  tradeIn: Scalars['Boolean']['input'];
};

export type ConfiguratorSaveOrderContent = {
  __typename: 'ConfiguratorSaveOrderContent';
  bannerImage?: Maybe<UploadedFileWithPreview>;
  contentText: DealerTranslationText;
  introImage?: Maybe<UploadedFileWithPreview>;
  introTitle: DealerTranslationText;
  subject: DealerTranslationText;
};

export type ConfiguratorSaveOrderInput = {
  contentText: DealerTranslationTextInput;
  introTitle: DealerTranslationTextInput;
  subject: DealerTranslationTextInput;
};

export type ConfiguratorStockInventory = StockInventory & {
  __typename: 'ConfiguratorStockInventory';
  /** Configurator Application */
  application?: Maybe<ConfiguratorApplication>;
  /** Application Suite ID */
  applicationId?: Maybe<Scalars['ObjectID']['output']>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Stock Inventory Indentifier */
  identifier: Scalars['String']['output'];
  /** Inventory */
  inventory: Inventory;
  /** Inventory Id */
  inventoryId: Scalars['ObjectID']['output'];
  /** Kind of stock */
  kind: StockInventoryKind;
  /** Reservation expiration date (if applicable) */
  reservationExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Reservation status */
  reservationStatus: ReservationStockStatus;
  /** Registered Vin */
  vin: Scalars['String']['output'];
};

export type ConfiguratorSubmitOrderContent = {
  __typename: 'ConfiguratorSubmitOrderContent';
  contentText: DealerTranslationText;
  introImage?: Maybe<UploadedFileWithPreview>;
  introTitle: DealerTranslationText;
  isPaymentSectionShown: Scalars['Boolean']['output'];
  subject: DealerTranslationText;
};

export type ConfiguratorSubmitOrderInput = {
  contentText: DealerTranslationTextInput;
  introTitle: DealerTranslationTextInput;
  isPaymentSectionShown: Scalars['Boolean']['input'];
  subject: DealerTranslationTextInput;
};

export type ConsentFeaturePurpose = {
  __typename: 'ConsentFeaturePurpose';
  featureId: Scalars['ObjectID']['output'];
  type: ConsentFeatureType;
};

export type ConsentFeaturePurposeInput = {
  featureId?: InputMaybe<Scalars['ObjectID']['input']>;
  type: ConsentFeatureType;
};

export enum ConsentFeatureType {
  Event = 'Event',
  Module = 'Module'
}

export type ConsentsAndDeclarations = {
  /** Conditions */
  conditions?: Maybe<Array<Condition>>;
  /** Data field */
  dataField: DataField;
  /** Description */
  description?: Maybe<TranslatedString>;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** Feature Purpose */
  featurePurpose: ConsentFeaturePurpose;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is active */
  isActive: Scalars['Boolean']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Module */
  module: Module;
  /** Module ID */
  moduleId: Scalars['ObjectID']['output'];
  /** Order Number */
  orderNumber: Scalars['Int']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Purpose */
  purpose: Array<ConsentsAndDeclarationsPurpose>;
  /** Title */
  title?: Maybe<TranslatedString>;
  /** C&D type */
  type: ConsentsAndDeclarationsType;
  /** Versioning */
  versioning: AdvancedVersioning;
};

export type ConsentsAndDeclarationsFilteringRule = {
  /** Filter by multiple company IDs */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Query for Lead Gen Form
   * by default should be false
   */
  eventId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Consent Feature Purpose */
  featurePurpose?: InputMaybe<ConsentFeaturePurposeInput>;
  /** Is Additional Consents */
  isAdditionalConsents?: InputMaybe<Scalars['Boolean']['input']>;
  /** Event Test Drive */
  isAllowTestDrive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Event Trade In */
  isAllowTradeIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by module id */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type ConsentsAndDeclarationsModule = Module & {
  __typename: 'ConsentsAndDeclarationsModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** List of consents and declarations */
  consentsAndDeclarations: Array<ConsentsAndDeclarations>;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type ConsentsAndDeclarationsModuleSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
};

export enum ConsentsAndDeclarationsPurpose {
  Kyc = 'KYC',
  Payment = 'Payment',
  Share = 'Share'
}

export enum ConsentsAndDeclarationsSortingField {
  /** Sort by Active */
  Active = 'Active',
  /** Sort by company */
  Company = 'Company',
  /** Sort by displayName */
  DisplayName = 'DisplayName',
  /** Sort by Mandatory */
  Mandatory = 'Mandatory',
  /** Sort by order number */
  OrderNumber = 'OrderNumber',
  /** Sort by type */
  Type = 'Type'
}

export type ConsentsAndDeclarationsSortingRule = {
  /** Field on which apply the sorting */
  field: ConsentsAndDeclarationsSortingField;
  /** Sorting Order */
  order: SortingOrder;
};

export enum ConsentsAndDeclarationsType {
  Checkbox = 'Checkbox',
  Marketing = 'Marketing',
  Text = 'Text'
}

export type ConsumptionEmission = {
  __typename: 'ConsumptionEmission';
  co2EmissionsWithLabel?: Maybe<LocalizedLabeledValue>;
  electricityConsumptionWithLabel?: Maybe<LocalizedLabeledValue>;
  fuelConsumptionWithLabel?: Maybe<LocalizedLabeledValue>;
};

export enum ContentRefinementSourceAction {
  Add = 'Add',
  Update = 'Update'
}

export enum ContentRefinementSourceKind {
  Configurator = 'Configurator',
  Event = 'Event',
  Module = 'Module'
}

export type ContentRefinementSourceType = {
  action: ContentRefinementSourceAction;
  identifier?: InputMaybe<Scalars['String']['input']>;
  kind: ContentRefinementSourceKind;
};

export type ContextualCondition = Condition & {
  __typename: 'ContextualCondition';
  type: ConditionType;
};

export type ContextualConditionSettings = {
  context: ConditionType;
};

export type CorporateCustomer = {
  __typename: 'CorporateCustomer';
  /** Applications */
  applications: Array<Application>;
  /** Email */
  email: Scalars['String']['output'];
  /** Local Customer Fields Array */
  fields: Array<LocalCustomerField>;
  /**
   * Customer full name
   * mainly used in application list and application detail
   */
  fullName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Masking */
  isMaskingCustomerData?: Maybe<Scalars['Boolean']['output']>;
  /** Customer kind */
  kind: CustomerKind;
  /** KYC Presets */
  kycPresets: Array<KycField>;
  /** Latest application */
  latestApplication: Application;
  /**
   * Latest customer full name,
   * mainly used in customer list and customer detail
   */
  latestFullName: Scalars['String']['output'];
  /** Module */
  module: Module;
  /** Module Id */
  moduleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: AdvancedVersioning;
};

export enum CounterMethod {
  /** Counter is never reset */
  Global = 'Global',
  /** Counter is reset every month */
  Monthly = 'Monthly',
  /** Counter is reset every quarter of the year */
  Quarter = 'Quarter',
  /** Counter is reset every year */
  Yearly = 'Yearly'
}

export type CounterPayload = {
  /** Counter method */
  method: CounterMethod;
  /** Padding (number of leading zeros) */
  padding: Scalars['Int']['input'];
  /** Counter prefix */
  prefix: Scalars['String']['input'];
};

export type CounterSettings = {
  __typename: 'CounterSettings';
  /** Counter method */
  method: CounterMethod;
  /** Padding (number of leading zeros) */
  padding: Scalars['Int']['output'];
  /** Counter prefix */
  prefix: Scalars['String']['output'];
};

export type CreateNewUserLink = {
  __typename: 'CreateNewUserLink';
  /** Token to use with mutation `changePasswordFromToken` */
  token: Scalars['String']['output'];
  /** Verified status */
  verified: Scalars['Boolean']['output'];
};

export type CreateWebsiteModulePayload = {
  displayName: Scalars['String']['input'];
};

export type CtsModule = Module & {
  __typename: 'CtsModule';
  /** Authorization settings for CTS */
  authorization?: Maybe<Authorization>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** CTS Settings */
  ctsSettings: Array<CtsSetting>;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type CtsModuleInitialSettings = {
  /** Display name (for module) */
  displayName: Scalars['String']['input'];
};

export type CtsModuleUpdateSettings = {
  /** Display name (for module) */
  displayName: Scalars['String']['input'];
};

export type CtsSetting = {
  __typename: 'CtsSetting';
  /** Financing module */
  bankModule?: Maybe<BankModule>;
  /** Financing module ID */
  bankModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Dealer Price Disclaimer */
  dealerPriceDisclaimer?: Maybe<DealerPriceDisclaimer>;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** Finance product suite IDs */
  financeProductSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Finance products */
  financeProducts: Array<FinanceProduct>;
  /** Finder Module Ids */
  finderModuleIds: Array<Scalars['ObjectID']['output']>;
  /** Finder Modules */
  finderModules: Array<Module>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Identifier */
  identifier: Scalars['String']['output'];
  /** Insurance module */
  insuranceModule?: Maybe<InsuranceModule>;
  /** Insurance module ID */
  insuranceModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Insurance product suite IDs */
  insuranceProductSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Insurance products */
  insuranceProducts: Array<InsuranceProduct>;
  /** Setting Active */
  isActive: Scalars['Boolean']['output'];
  /** Market */
  market: ApplicationMarket;
  /** Market setting */
  marketType: ApplicationMarketType;
  /** Dealer for Preowned Price Disclaimer */
  preownedDealerPriceDisclaimer?: Maybe<DealerPriceDisclaimer>;
  /** Vehicle module IDs, can be Simple Vehicle Management or Finder Vehicle Management */
  vehicleModuleIds: Array<Scalars['ObjectID']['output']>;
  /** Vehicle modules, can be Simple Vehicle Management or Finder Vehicle Management */
  vehicleModules: Array<Module>;
};

export type CtsSettingInitialInput = {
  /** Bank module ID */
  bankModuleId: Scalars['ObjectID']['input'];
  /** Display name (for setting) */
  displayName: Scalars['String']['input'];
  /** Finder Module Ids */
  finderModuleIds: Array<Scalars['ObjectID']['input']>;
  /** Identifier */
  identifier: Scalars['String']['input'];
  /** Insurance module ID */
  insuranceModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Setting Active */
  isActive: Scalars['Boolean']['input'];
  /** Market specific inputs */
  market?: InputMaybe<ApplicationMarket>;
  marketType?: InputMaybe<ApplicationModuleMarketTypeInput>;
  /** Preowned Disclaimer */
  preownedPriceDisclaimer?: InputMaybe<DealerPriceDisclaimerInput>;
  /** Disclaimer */
  priceDisclaimer?: InputMaybe<DealerPriceDisclaimerInput>;
  /** Vehicle Module Ids */
  vehicleModuleIds: Array<Scalars['ObjectID']['input']>;
};

export type CtsSettingUpdateInput = {
  /** Display name (for setting) */
  displayName: Scalars['String']['input'];
  /** Finder Module Ids */
  finderModuleIds: Array<Scalars['ObjectID']['input']>;
  /** Identifier */
  identifier: Scalars['String']['input'];
  /** Insurance module ID */
  insuranceModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Setting Active */
  isActive: Scalars['Boolean']['input'];
  /** Market specific inputs */
  market?: InputMaybe<ApplicationMarket>;
  marketType?: InputMaybe<ApplicationModuleMarketTypeInput>;
  /** Preowned Disclaimer */
  preownedPriceDisclaimer?: InputMaybe<DealerPriceDisclaimerInput>;
  /** Disclaimer */
  priceDisclaimer?: InputMaybe<DealerPriceDisclaimerInput>;
};

export type Currency = ICurrencyType & {
  __typename: 'Currency';
  currencyCode: Scalars['String']['output'];
  localize: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};


export type CurrencyLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type CustomWebPageBlock = WebPageBlock & {
  __typename: 'CustomWebPageBlock';
  id: Scalars['ObjectID']['output'];
  markdownString?: Maybe<TranslatedString>;
  title?: Maybe<TranslatedString>;
  type: WebPageBlockType;
};

export type CustomWebPageBlockInput = {
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  markdownString?: InputMaybe<TranslatedStringInput>;
  title?: InputMaybe<TranslatedStringInput>;
  type: WebPageBlockType;
};

export type Customer = CorporateCustomer | Guarantor | LocalCustomer;

export type CustomerFilter = {
  __typename: 'CustomerFilter';
  applicationStatus: Array<ApplicationStatus>;
  companies: Array<Company>;
  dealers: Array<Dealer>;
  modules: Array<Module>;
};

export type CustomerFilteringRule = {
  /** Filter by application dealerIds */
  applicationDealerIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by application identifier */
  applicationIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Filter by application module ids */
  applicationModuleIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by application module ids */
  applicationModuleName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by application status */
  applicationStatuses?: InputMaybe<Array<ApplicationStatus>>;
  /** Filter by application assignee name */
  assigneeName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by company ID */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Customer Creation Date */
  creationDate?: InputMaybe<PeriodPayload>;
  /** Filter by customer full name */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by search keyword, fields affected by this keyword is predefined */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Filter by last activity */
  lastActivity?: InputMaybe<PeriodPayload>;
};

export enum CustomerKind {
  Corporate = 'Corporate',
  Guarantor = 'Guarantor',
  Local = 'Local'
}

export type CustomerListEndpoint = Endpoint & {
  __typename: 'CustomerListEndpoint';
  /** Application module IDs */
  applicationModuleIds: Array<Scalars['ObjectID']['output']>;
  /** Application modules */
  applicationModules: Array<Module>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Pathname */
  pathname: Scalars['String']['output'];
  /** Endpoint Listing Title */
  title: Scalars['String']['output'];
};

export type CustomerListEndpointSettings = {
  /** Application module IDs */
  applicationModuleIds: Array<Scalars['ObjectID']['input']>;
  /** Pathname */
  pathname: Scalars['String']['input'];
  /** Endpoint Listing Title */
  title: Scalars['String']['input'];
};

export enum CustomerSortingField {
  ApplicationIdentifier = 'ApplicationIdentifier',
  ApplicationModule = 'ApplicationModule',
  ApplicationModuleName = 'ApplicationModuleName',
  ApplicationStatus = 'ApplicationStatus',
  AssigneeName = 'AssigneeName',
  Company = 'Company',
  CreationDate = 'CreationDate',
  Dealer = 'Dealer',
  FullName = 'FullName',
  LastActivity = 'LastActivity'
}

export type CustomerSortingRule = {
  field: CustomerSortingField;
  order: SortingOrder;
};

export type CustomizedField = {
  __typename: 'CustomizedField';
  /** Input Character Limit */
  characterLimit: Scalars['Int']['output'];
  /** Display Name */
  displayName: TranslatedString;
  /** ID */
  id: Scalars['ObjectID']['output'];
  /** Mandatory */
  isMandatory: Scalars['Boolean']['output'];
  /** Order */
  order: Scalars['Int']['output'];
};

export type CustomizedFieldInput = {
  /** Input Character Limit */
  characterLimit: Scalars['Int']['input'];
  /** Display Name */
  displayName: TranslatedStringInput;
  /** ID */
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Mandatory */
  isMandatory: Scalars['Boolean']['input'];
  /** Order */
  order: Scalars['Int']['input'];
};

export type DbsNewCarFinance = SdmFinancing & {
  __typename: 'DBSNewCarFinance';
  bank: Scalars['String']['output'];
  discountPrice?: Maybe<Scalars['Float']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  type: FinanceType;
};

export type DbsUsedCarFinance = SdmFinancing & {
  __typename: 'DBSUsedCarFinance';
  bank: Scalars['String']['output'];
  discountPrice?: Maybe<Scalars['Float']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  type: FinanceType;
};

export enum DataField {
  DataProcessing = 'DataProcessing',
  None = 'None'
}

export enum DateTimeUnit {
  Days = 'Days',
  Hours = 'Hours'
}

export type DateUnit = {
  __typename: 'DateUnit';
  unit: DateTimeUnit;
  value: Scalars['Float']['output'];
};

export type DateUnitInput = {
  unit: DateTimeUnit;
  value: Scalars['Float']['input'];
};

export enum DayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type DbsBankIntegration = BankIntegration & {
  __typename: 'DbsBankIntegration';
  allowedIps: Scalars['String']['output'];
  apiKey: Scalars['String']['output'];
  certCA?: Maybe<Scalars['String']['output']>;
  dealerCode?: Maybe<Scalars['String']['output']>;
  host: Scalars['String']['output'];
  mappings: Array<DbsBankIntegrationMapping>;
  orgId: Scalars['String']['output'];
  payloadScheme: DbsPayloadScheme;
  privateKey: Scalars['String']['output'];
  provider: BankIntegrationProvider;
  publicCert: Scalars['String']['output'];
};

export type DbsBankIntegrationMapping = {
  __typename: 'DbsBankIntegrationMapping';
  appliedInterestRate: Scalars['Float']['output'];
  packageCode: Scalars['String']['output'];
  schemeCode: Scalars['String']['output'];
};

export type DbsBankIntegrationMappingSettings = {
  appliedInterestRate: Scalars['Float']['input'];
  packageCode: Scalars['String']['input'];
  schemeCode: Scalars['String']['input'];
};

export type DbsBankIntegrationSettings = {
  allowedIps: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  certCA?: InputMaybe<Scalars['String']['input']>;
  dealerCode?: InputMaybe<Scalars['String']['input']>;
  host: Scalars['String']['input'];
  mappings: Array<DbsBankIntegrationMappingSettings>;
  orgId: Scalars['String']['input'];
  payloadScheme: DbsPayloadScheme;
  privateKey: Scalars['String']['input'];
  publicCert: Scalars['String']['input'];
};

export enum DbsPayloadScheme {
  V1 = 'v1',
  V2 = 'v2'
}

export type Dealer = {
  __typename: 'Dealer';
  /** COE */
  coe: Scalars['Float']['output'];
  /** Company */
  company: Company;
  /** Dealer Contact */
  contact: DealerContact;
  /** Dealer Disclaimers */
  disclaimers: DealerDisclaimers;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** Dealer Establishment Fee */
  estFee: Scalars['Float']['output'];
  /** ID */
  id: Scalars['ObjectID']['output'];
  /** Dealer Integration Details */
  integrationDetails: DealerIntegrationDetails;
  /** Active Status */
  isActive: Scalars['Boolean']['output'];
  /** Deletion state */
  isDeleted: Scalars['Boolean']['output'];
  /** Legal Name */
  legalName: TranslatedString;
  /** Module Featured */
  modulesInDealer: Array<PaginatedModulesInDealer>;
  /** Permissions for the current user on this dealer */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** PPSR Fee */
  ppsr: Scalars['Float']['output'];
  /** User IDs in dealer */
  userIds: Array<Scalars['ObjectID']['output']>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type DealerApplicationMarketTypeInput = {
  bankEstFeeEditable?: InputMaybe<Scalars['Boolean']['input']>;
  coeEditable?: InputMaybe<Scalars['Boolean']['input']>;
  dealerId: Scalars['ObjectID']['input'];
  estFeeEditable?: InputMaybe<Scalars['Boolean']['input']>;
  nzFeesViewable?: InputMaybe<Scalars['Boolean']['input']>;
  ppsrEditable?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DealerAsset {
  Icon = 'Icon'
}

export type DealerAutoplay = {
  __typename: 'DealerAutoplay';
  /** Autoplay Dealer ID */
  dealerId: Scalars['Int']['output'];
  /** Autoplay Yard ID */
  yardId: Scalars['Int']['output'];
};

export type DealerAutoplayInput = {
  dealerId: Scalars['Int']['input'];
  yardId: Scalars['Int']['input'];
};

export type DealerBookingCodeSetting = {
  __typename: 'DealerBookingCodeSetting';
  defaultValue: Scalars['String']['output'];
  overrides: Array<DealerBookingCodeSettingOverride>;
  viewable: Scalars['Boolean']['output'];
};

export type DealerBookingCodeSettingInput = {
  defaultValue: Scalars['String']['input'];
  overrides: Array<DealerBookingCodeSettingOverrideInput>;
  viewable: Scalars['Boolean']['input'];
};

export type DealerBookingCodeSettingOverride = {
  __typename: 'DealerBookingCodeSettingOverride';
  dealerId: Scalars['ObjectID']['output'];
  value: Scalars['String']['output'];
  viewable: Scalars['Boolean']['output'];
};

export type DealerBookingCodeSettingOverrideInput = {
  dealerId: Scalars['ObjectID']['input'];
  value: Scalars['String']['input'];
  viewable: Scalars['Boolean']['input'];
};

export type DealerCondition = Condition & {
  __typename: 'DealerCondition';
  dealer: Dealer;
  dealerId: Scalars['ObjectID']['output'];
  type: ConditionType;
};

export type DealerConditionsSettings = {
  dealerId: Scalars['ObjectID']['input'];
};

export type DealerContact = {
  __typename: 'DealerContact';
  /** Dealer Additional Information */
  additionalInfo?: Maybe<TranslatedString>;
  /** Dealer Address */
  address?: Maybe<TranslatedString>;
  /** Dealer Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Dealer Additional Social Media List */
  socialMedia: Array<DealerSocialMedia>;
  /** Dealer Telephone */
  telephone?: Maybe<OptionalPhone>;
};

export type DealerContactInput = {
  additionalInfo?: InputMaybe<TranslatedStringInput>;
  address?: InputMaybe<TranslatedStringInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<OptionalPhonePayload>;
};

export type DealerDisclaimers = {
  __typename: 'DealerDisclaimers';
  financingDisclaimer: Array<DealerFinancingDisclaimer>;
  insuranceDisclaimer: Array<DealerInsuranceDisclaimer>;
};

export type DealerDisclaimersConfigurator = {
  __typename: 'DealerDisclaimersConfigurator';
  defaultValue: Array<Maybe<TranslatedString>>;
  overrides: Array<DealerDisclaimersOverridesConfigurator>;
};

export type DealerDisclaimersConfiguratorInput = {
  /** Default Value */
  defaultValue: Array<TranslatedStringInput>;
  /** Overrides */
  overrides: Array<DealerDisclaimersOverridesConfiguratorInput>;
};

export type DealerDisclaimersInput = {
  financingDisclaimer: Array<DealerFinancingDisclaimerInput>;
  insuranceDisclaimer: Array<DealerInsuranceDisclaimerInput>;
};

export type DealerDisclaimersOverridesConfigurator = {
  __typename: 'DealerDisclaimersOverridesConfigurator';
  dealerId: Scalars['ObjectID']['output'];
  value: Array<TranslatedString>;
};

export type DealerDisclaimersOverridesConfiguratorInput = {
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['input'];
  /** Value */
  value: Array<TranslatedStringInput>;
};

export type DealerFilteringRule = {
  /** Check configurator stock */
  checkConfiguratorStock?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by dealer ID */
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Production Only */
  productionOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DealerFinanceProducts = {
  __typename: 'DealerFinanceProducts';
  dealer: Dealer;
  dealerId: Scalars['ObjectID']['output'];
  financeProductSuiteIds: Array<Scalars['ObjectID']['output']>;
  financeProducts: Array<FinanceProduct>;
};

export type DealerFinanceProductsPayload = {
  dealerId: Scalars['ObjectID']['input'];
  financeProductSuiteIds: Array<Scalars['ObjectID']['input']>;
};

export type DealerFinancingDisclaimer = {
  __typename: 'DealerFinancingDisclaimer';
  bankId: Scalars['ObjectID']['output'];
  bankName: Scalars['String']['output'];
  financingDisclaimer: TranslatedString;
};

export type DealerFinancingDisclaimerInput = {
  bankId: Scalars['ObjectID']['input'];
  bankName: Scalars['String']['input'];
  financingDisclaimer: TranslatedStringInput;
};

export type DealerInput = {
  coe: Scalars['Float']['input'];
  contact: DealerContactInput;
  disclaimers: DealerDisclaimersInput;
  displayName: Scalars['String']['input'];
  estFee: Scalars['Float']['input'];
  integrationDetails: DealerIntegrationDetailsInput;
  isActive: Scalars['Boolean']['input'];
  legalName: TranslatedStringInput;
  ppsr: Scalars['Float']['input'];
};

export type DealerInsuranceDisclaimer = {
  __typename: 'DealerInsuranceDisclaimer';
  insuranceDisclaimer: TranslatedString;
  insurerId: Scalars['ObjectID']['output'];
  insurerName: Scalars['String']['output'];
};

export type DealerInsuranceDisclaimerInput = {
  insuranceDisclaimer: TranslatedStringInput;
  insurerId: Scalars['ObjectID']['input'];
  insurerName: Scalars['String']['input'];
};

export type DealerInsuranceProducts = {
  __typename: 'DealerInsuranceProducts';
  dealer: Dealer;
  dealerId: Scalars['ObjectID']['output'];
  insuranceProductSuiteIds: Array<Scalars['ObjectID']['output']>;
  insuranceProducts: Array<InsuranceProduct>;
};

export type DealerInsuranceProductsPayload = {
  dealerId: Scalars['ObjectID']['input'];
  insuranceProductSuiteIds: Array<Scalars['ObjectID']['input']>;
};

export type DealerIntegrationDetails = {
  __typename: 'DealerIntegrationDetails';
  /** Additional Parameter for integration */
  additionalParameter: Array<AdditionalIntegrationParameter>;
  /** Assortment */
  assortment?: Maybe<Scalars['String']['output']>;
  /** Autoplay dealer integration */
  autoplay?: Maybe<DealerAutoplay>;
  /** Dealer Code */
  dealerCode?: Maybe<Scalars['String']['output']>;
  /** Partner Number */
  partnerNumber?: Maybe<Scalars['String']['output']>;
};

export type DealerIntegrationDetailsInput = {
  additionalParameter: Array<AdditionalIntegrationParameterInput>;
  assortment?: InputMaybe<Scalars['String']['input']>;
  autoplay?: InputMaybe<DealerAutoplayInput>;
  dealerCode?: InputMaybe<Scalars['String']['input']>;
  partnerNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DealerOption = {
  __typename: 'DealerOption';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
};

export type DealerOptionPayload = {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
};

export type DealerPermissions = {
  __typename: 'DealerPermissions';
  /** User may delete dealer */
  delete: Scalars['Boolean']['output'];
  /** User may update the dealer, except updating dealer integrations */
  update: Scalars['Boolean']['output'];
  /** User may update dealer integrations */
  updateIntegration: Scalars['Boolean']['output'];
};

export type DealerPriceDisclaimer = {
  __typename: 'DealerPriceDisclaimer';
  defaultValue: TranslatedString;
  overrides: Array<DealerPriceDisclaimerOverride>;
};

export type DealerPriceDisclaimerInput = {
  /** Default Value */
  defaultValue: TranslatedStringInput;
  /** Overrides */
  overrides: Array<DealerPriceDisclaimerOverridesInput>;
};

export type DealerPriceDisclaimerOverride = {
  __typename: 'DealerPriceDisclaimerOverride';
  dealerId: Scalars['ObjectID']['output'];
  value: TranslatedString;
};

export type DealerPriceDisclaimerOverridesInput = {
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['input'];
  /** Value */
  value: TranslatedStringInput;
};

export type DealerSocialMedia = {
  __typename: 'DealerSocialMedia';
  content: Scalars['String']['output'];
  icon?: Maybe<UploadedFileWithPreview>;
  id: Scalars['ObjectID']['output'];
  title: TranslatedString;
};

export type DealerSocialMediaInput = {
  content: Scalars['String']['input'];
  title: TranslatedStringInput;
};

export enum DealerSortingField {
  /** Sort by display name */
  DisplayName = 'DisplayName',
  /** Sort by user count */
  UserCount = 'UserCount'
}

export type DealerSortingRule = {
  /** Field on which to apply the sorting */
  field: DealerSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type DealerTranslatedStringSetting = {
  __typename: 'DealerTranslatedStringSetting';
  defaultValue: TranslatedString;
  overrides: Array<DealerTranslatedStringSettingOverride>;
};

export type DealerTranslatedStringSettingInput = {
  /** Default Value */
  defaultValue: TranslatedStringInput;
  /** Overrides */
  overrides: Array<DealerTranslatedStringSettingOverridesInput>;
};

export type DealerTranslatedStringSettingOverride = {
  __typename: 'DealerTranslatedStringSettingOverride';
  dealerId: Scalars['ObjectID']['output'];
  value: TranslatedString;
};

export type DealerTranslatedStringSettingOverridesInput = {
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['input'];
  /** Value */
  value: TranslatedStringInput;
};

export type DealerTranslationText = {
  __typename: 'DealerTranslationText';
  defaultValue: TranslatedString;
  overrides: Array<DealerTranslationTextOverride>;
};

export type DealerTranslationTextInput = {
  /** Default Value */
  defaultValue: TranslatedStringInput;
  /** Overrides */
  overrides: Array<DealerTranslationTextOverridesInput>;
};

export type DealerTranslationTextOverride = {
  __typename: 'DealerTranslationTextOverride';
  dealerId: Scalars['ObjectID']['output'];
  value: TranslatedString;
};

export type DealerTranslationTextOverridesInput = {
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['input'];
  /** Value */
  value: TranslatedStringInput;
};

export type DealerVehicles = {
  __typename: 'DealerVehicles';
  dealer: Dealer;
  dealerId: Scalars['ObjectID']['output'];
  vehicleSuiteIds: Array<Scalars['ObjectID']['output']>;
  vehicles: Array<Vehicle>;
};

export type DealerVehiclesPayload = {
  dealerId: Scalars['ObjectID']['input'];
  vehicleSuiteIds: Array<Scalars['ObjectID']['input']>;
};

export type DealershipDepositAmountInput = {
  /** Default Value */
  defaultValue: Scalars['Float']['input'];
  /** Overrides */
  overrides: Array<DealershipDepositAmountOverridesInput>;
};

export type DealershipDepositAmountOverridesInput = {
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['input'];
  /** Value */
  value: Scalars['Float']['input'];
};

export type DealershipMarket = {
  __typename: 'DealershipMarket';
  defaultValue: Scalars['Float']['output'];
  editable: Scalars['Boolean']['output'];
  overrides: Array<DealershipMarketOverride>;
};

export type DealershipMarketInput = {
  /** Default Value */
  defaultValue: Scalars['Float']['input'];
  /** Editable */
  editable: Scalars['Boolean']['input'];
  /** Overrides */
  overrides: Array<DealershipMarketOverridesInput>;
};

export type DealershipMarketOverride = {
  __typename: 'DealershipMarketOverride';
  dealer: Dealer;
  dealerId: Scalars['ObjectID']['output'];
  editable: Scalars['Boolean']['output'];
  value: Scalars['Float']['output'];
};

export type DealershipMarketOverridesInput = {
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['input'];
  /** Editable */
  editable: Scalars['Boolean']['input'];
  /** Value */
  value: Scalars['Float']['input'];
};

export type DealershipMyInfoSetting = {
  __typename: 'DealershipMyInfoSetting';
  defaultId: Scalars['ObjectID']['output'];
  defaultMyInfoSetting: MyInfoSetting;
  overrides: Array<DealershipMyInfoSettingOverride>;
};

export type DealershipMyInfoSettingOverride = {
  __typename: 'DealershipMyInfoSettingOverride';
  dealer: Dealer;
  dealerId: Scalars['ObjectID']['output'];
  myInfoSetting?: Maybe<MyInfoSetting>;
  relatedId?: Maybe<Scalars['ObjectID']['output']>;
};

export type DealershipPaymentSetting = {
  __typename: 'DealershipPaymentSetting';
  defaultId: Scalars['ObjectID']['output'];
  defaultPaymentSetting: PaymentSetting;
  overrides: Array<DealershipPaymentSettingOverride>;
};

export type DealershipPaymentSettingOverride = {
  __typename: 'DealershipPaymentSettingOverride';
  dealer: Dealer;
  dealerId: Scalars['ObjectID']['output'];
  paymentSetting?: Maybe<PaymentSetting>;
  relatedId?: Maybe<Scalars['ObjectID']['output']>;
};

export type DealershipPublicSalesPerson = {
  __typename: 'DealershipPublicSalesPerson';
  defaultId: Scalars['ObjectID']['output'];
  defaultSalesPerson: User;
  overrides: Array<DealershipPublicSalesPersonOverride>;
};

export type DealershipPublicSalesPersonOverride = {
  __typename: 'DealershipPublicSalesPersonOverride';
  dealer: Dealer;
  dealerId: Scalars['ObjectID']['output'];
  relatedId?: Maybe<Scalars['ObjectID']['output']>;
  salesPerson?: Maybe<User>;
};

export type DealershipSetting = DealershipMyInfoSetting | DealershipPaymentSetting | DealershipPublicSalesPerson;

export type DealershipSettingInput = {
  /** Default Id */
  defaultId: Scalars['ObjectID']['input'];
  /** Overrides */
  overrides: Array<DealershipSettingOverridesInput>;
};

export type DealershipSettingOverridesInput = {
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['input'];
  /** Id */
  relatedId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum DealershipSettingType {
  MyInfoSetting = 'MyInfoSetting',
  PaymentSetting = 'PaymentSetting',
  PublicSalesPerson = 'PublicSalesPerson'
}

/** Default finance settings for applications. */
export type DefaultApplicationFinanceSettings = {
  /** Assured Resale Value (HP with Balloon GFV) */
  assuredResaleValue?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Balloon Payment (HP with Balloon) */
  balloonPayment?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Starting price */
  carPrice: Scalars['Float']['input'];
  /** Remaining Cash After Trade In (Currently in porsche finder) */
  cashAfterTradeIn?: InputMaybe<Scalars['Float']['input']>;
  /** Commission (UCCL) */
  commission?: InputMaybe<Scalars['Float']['input']>;
  /** Dealer Options */
  dealerOptions?: InputMaybe<Array<DealerOptionPayload>>;
  /** Deposit Payment */
  deposit?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Discount */
  discount?: InputMaybe<DiscountInput>;
  /** Displacement (UCCL) */
  displacement?: InputMaybe<Scalars['Int']['input']>;
  /** Down Payment */
  downPayment?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Down payment with additional */
  downPaymentWithAdditional?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Estimated Surplus After Assured Resale Value (HP with Balloon GFV) */
  estimatedSurplusBalloon?: InputMaybe<Scalars['Float']['input']>;
  /** Extra Amount */
  extraAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Extra Financed Amount */
  extraFinancedAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Finance product ID */
  financeProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Total Financing Price Application */
  financedAmount: Scalars['Float']['input'];
  /** Insurance Fee (UCCL) */
  insuranceFee?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Interest Rate */
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  /** License and Fuel Tax (UCCL) */
  licenseAndFuelTax?: InputMaybe<Scalars['Float']['input']>;
  /** License plate fee (UCCL) */
  licensePlateFee?: InputMaybe<Scalars['Float']['input']>;
  /** Loan */
  loan?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Mileage Value */
  mileage?: InputMaybe<Scalars['Float']['input']>;
  /** Monthly instalment */
  monthlyInstalment?: InputMaybe<Array<ApplicationMonthlyInstalmentPayload>>;
  /** Monthly payment fixed interest rate (UCCL) */
  monthlyPaymentFixedInterestRate?: InputMaybe<Scalars['Float']['input']>;
  /** Payment Mode */
  paymentMode?: InputMaybe<PaymentMode>;
  /** Promo Code Value */
  promoCodeValue?: InputMaybe<Scalars['Float']['input']>;
  /** Residual Value */
  residualValue?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Tax Loss (UCCL) */
  taxLoss?: InputMaybe<Scalars['Float']['input']>;
  /** Number of Terms */
  term?: InputMaybe<Scalars['Int']['input']>;
  /** Total Price */
  totalPrice: Scalars['Float']['input'];
  /** Trade In Amount (Currently in porsche finder) */
  tradeInAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type DefaultApplicationFinancing = ApplicationFinancing & {
  __typename: 'DefaultApplicationFinancing';
  /** Affin Auto Finance Centre */
  affinAutoFinanceCentre?: Maybe<AffinAutoFinanceCentre>;
  /** Assured Resale Value */
  assuredResaleValue?: Maybe<ApplicationValueSetting>;
  /** Balloon Payment (HP with Balloon) */
  balloonPayment?: Maybe<ApplicationValueSetting>;
  /** Starting price */
  carPrice: Scalars['Float']['output'];
  /** Remaining Cash After Trade In */
  cashAfterTradeIn?: Maybe<Scalars['Float']['output']>;
  /** Commission */
  commission?: Maybe<Scalars['Float']['output']>;
  /** Dealer Options */
  dealerOptions?: Maybe<Array<DealerOption>>;
  /** Deposit */
  deposit?: Maybe<ApplicationValueSetting>;
  /** Discount */
  discount?: Maybe<Discount>;
  /** Displacement */
  displacement?: Maybe<Scalars['Int']['output']>;
  /** Down Payment */
  downPayment?: Maybe<ApplicationValueSetting>;
  /** Down payment with additional */
  downPaymentWithAdditional?: Maybe<ApplicationValueSetting>;
  /** Estimated Surplus After Assured Resale Value */
  estimatedSurplusBalloon?: Maybe<Scalars['Float']['output']>;
  /** Extra Amount */
  extraAmount?: Maybe<Scalars['Float']['output']>;
  /** Extra Financed Amount */
  extraFinancedAmount?: Maybe<Scalars['Float']['output']>;
  /** Finance Product ID */
  financeProductId?: Maybe<Scalars['ObjectID']['output']>;
  /** Total Financing Price Application */
  financedAmount: Scalars['Float']['output'];
  /** Insurance Fee */
  insuranceFee?: Maybe<ApplicationValueSetting>;
  /** Interest Rate */
  interestRate?: Maybe<Scalars['Float']['output']>;
  /** License and Fuel Tax */
  licenseAndFuelTax?: Maybe<Scalars['Float']['output']>;
  /** License plate fee */
  licensePlateFee?: Maybe<Scalars['Float']['output']>;
  /** Loan */
  loan?: Maybe<ApplicationValueSetting>;
  /** Market */
  market: ApplicationMarket;
  /** Mileage Value */
  mileage?: Maybe<Scalars['Float']['output']>;
  /** Monthly Installment */
  monthlyInstalment?: Maybe<Array<ApplicationMonthlyInstalment>>;
  /** Monthly payment fixed interest rate */
  monthlyPaymentFixedInterestRate?: Maybe<Scalars['Float']['output']>;
  /** Payment Mode */
  paymentMode?: Maybe<PaymentMode>;
  /** Promo Code Value */
  promoCodeValue?: Maybe<Scalars['Float']['output']>;
  /** Residual Value */
  residualValue?: Maybe<ApplicationValueSetting>;
  /** Tax Loss */
  taxLoss?: Maybe<Scalars['Float']['output']>;
  /** Term */
  term?: Maybe<Scalars['Int']['output']>;
  /** Total Price Application */
  totalPrice: Scalars['Float']['output'];
  /** Trade in amount */
  tradeInAmount?: Maybe<Scalars['Float']['output']>;
};

/** Default insurance settings for applications */
export type DefaultApplicationInsuranceSettings = {
  /** Car Price */
  carPrice: Scalars['Float']['input'];
  /** Customer date of birth */
  dateOfBirth: Scalars['DateTime']['input'];
  /** Vehicle date of registration */
  dateOfRegistration: Scalars['DateTime']['input'];
  /** Insurance premium amount */
  insurancePremium?: InputMaybe<Scalars['Float']['input']>;
  /** Insurance Product ID */
  insuranceProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Insurer ID */
  insurerId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** No claim discount */
  ncd: Scalars['Float']['input'];
  /** Total Price */
  totalPrice: Scalars['Float']['input'];
  /** Customer years of driving */
  yearsOfDriving: Scalars['Int']['input'];
};

export type DefaultApplicationInsurancing = ApplicationInsurancing & {
  __typename: 'DefaultApplicationInsurancing';
  /** Car Price */
  carPrice: Scalars['Float']['output'];
  /** Customer date of birth */
  dateOfBirth: Scalars['DateTime']['output'];
  /** Vehicle date of registration */
  dateOfRegistration: Scalars['DateTime']['output'];
  /** Insurance premium amount */
  insurancePremium?: Maybe<Scalars['Float']['output']>;
  /** Insurance Product ID */
  insuranceProductId: Scalars['ObjectID']['output'];
  /** Insurer ID */
  insurerId: Scalars['ObjectID']['output'];
  /** Market */
  market: ApplicationMarket;
  /** No claim discount */
  ncd: Scalars['Float']['output'];
  /** Total Price */
  totalPrice: Scalars['Float']['output'];
  /** Customer years of driving */
  yearsOfDriving: Scalars['Int']['output'];
};

export type DefaultApplicationMarket = ApplicationMarketType & {
  __typename: 'DefaultApplicationMarket';
  type: ApplicationMarket;
};

export type DeferredPrincipalTermSettings = TermSettings & {
  __typename: 'DeferredPrincipalTermSettings';
  default: Scalars['Int']['output'];
  interestOnly: Scalars['Int']['output'];
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  step: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type DepositAmount = {
  __typename: 'DepositAmount';
  defaultValue: Scalars['Float']['output'];
  overrides: Array<DepositAmountOverride>;
};

export type DepositAmountInput = {
  /** Default Id */
  defaultValue: Scalars['Float']['input'];
  /** Overrides */
  overrides: Array<DepositAmountOverridesInput>;
};

export type DepositAmountOverride = {
  __typename: 'DepositAmountOverride';
  dealerId: Scalars['ObjectID']['output'];
  value: Scalars['Float']['output'];
};

export type DepositAmountOverridesInput = {
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['input'];
  /** Id */
  value: Scalars['Float']['input'];
};

export type DepositRangeSettings = DepositSettings & {
  __typename: 'DepositRangeSettings';
  default: Scalars['Float']['output'];
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  step: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  unit: AmountUnit;
};

export type DepositSettings = {
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type DepositSettingsPayload = {
  default?: InputMaybe<Scalars['Float']['input']>;
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  step?: InputMaybe<Scalars['Float']['input']>;
  table?: InputMaybe<Array<DepositTableCellPayload>>;
  type: Scalars['String']['input'];
  unit?: InputMaybe<AmountUnit>;
};

export type DepositTableCell = {
  __typename: 'DepositTableCell';
  term: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type DepositTableCellPayload = {
  term: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};

export type DepositTableSettings = DepositSettings & {
  __typename: 'DepositTableSettings';
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  table: Array<DepositTableCell>;
  type: Scalars['String']['output'];
};

export enum DeriveMethod {
  Formula = 'Formula',
  LookupTable = 'LookupTable'
}

export type Discount = {
  __typename: 'Discount';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  percentage: Scalars['Float']['output'];
  type: AmountUnit;
};

export type DiscountCode = GiftVoucher | PromoCode;

export type DiscountInput = {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  percentage: Scalars['Float']['input'];
  type: AmountUnit;
};

export type DiscountPromoType = PromoType & {
  __typename: 'DiscountPromoType';
  amount: Scalars['Float']['output'];
  deductFromFinancing: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  discountType: DiscountType;
  type: PromoTypeEnum;
};

export type DiscountPromoTypeInput = {
  amount: Scalars['Int']['input'];
  deductFromFinancing: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  discountType: DiscountType;
};

export enum DiscountType {
  Percentage = 'Percentage',
  Value = 'Value'
}

export type Displacement = {
  __typename: 'Displacement';
  cubicCentimeter: NumberUnit;
  liter: NumberUnit;
};

export type DisplacementSettingPayload = {
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
};

export type DisplacementSettings = {
  __typename: 'DisplacementSettings';
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
};

export enum DisplayPreference {
  /** Always shown */
  AlwaysShown = 'AlwaysShown',
  /** Hidden */
  Hidden = 'Hidden',
  /** Shown when more than one (default) */
  ShownWhenMoreThanOne = 'ShownWhenMoreThanOne'
}

export type DownPayment = ICurrencyType & {
  __typename: 'DownPayment';
  currencyCode: Scalars['String']['output'];
  localize: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};


export type DownPaymentLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type DownPaymentRangeSettings = DownPaymentSettings & {
  __typename: 'DownPaymentRangeSettings';
  default: Scalars['Float']['output'];
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  max: Scalars['Float']['output'];
  maxUnit?: Maybe<AmountUnit>;
  min: Scalars['Float']['output'];
  minUnit?: Maybe<AmountUnit>;
  step: Scalars['Float']['output'];
  stepUnit?: Maybe<AmountUnit>;
  type: Scalars['String']['output'];
  unit: AmountUnit;
};

export type DownPaymentSettings = {
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type DownPaymentSettingsPayload = {
  default?: InputMaybe<Scalars['Float']['input']>;
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
  max?: InputMaybe<Scalars['Float']['input']>;
  maxUnit?: InputMaybe<AmountUnit>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minUnit?: InputMaybe<AmountUnit>;
  step?: InputMaybe<Scalars['Float']['input']>;
  stepUnit?: InputMaybe<AmountUnit>;
  table?: InputMaybe<Array<DownPaymentTableCellPayload>>;
  type: Scalars['String']['input'];
  unit?: InputMaybe<AmountUnit>;
};

export type DownPaymentTableCell = {
  __typename: 'DownPaymentTableCell';
  term: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type DownPaymentTableCellPayload = {
  term: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};

export type DownPaymentTableSettings = DownPaymentSettings & {
  __typename: 'DownPaymentTableSettings';
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  table: Array<DownPaymentTableCell>;
  type: Scalars['String']['output'];
  unit: AmountUnit;
};

export type Download = {
  __typename: 'Download';
  /** Encryption details */
  encryption?: Maybe<DownloadEncryption>;
  /** Actual link used for downloading */
  link: Scalars['String']['output'];
};

export type DownloadEncryption = {
  __typename: 'DownloadEncryption';
  enabled: Scalars['Boolean']['output'];
  /** Hint for showing to users. e.g. password pattern */
  hint?: Maybe<Scalars['String']['output']>;
  /** Password */
  password: Scalars['String']['output'];
};

export type DraftGiftVoucherSettings = {
  customer: ApplicationCustomerDraft;
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  endpointId?: InputMaybe<Scalars['ObjectID']['input']>;
  inventoryId?: InputMaybe<Scalars['ObjectID']['input']>;
  languageId?: InputMaybe<Scalars['ObjectID']['input']>;
  mobilityModuleId: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
  numberOfBookingReferenceDays?: InputMaybe<Scalars['Int']['input']>;
  stockId?: InputMaybe<Scalars['ObjectID']['input']>;
  vehicle: ApplicationVehicleDraft;
};

export type DrivingLicense = {
  __typename: 'DrivingLicense';
  class?: Maybe<Scalars['String']['output']>;
  emiratesId?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  isUAEResident?: Maybe<Scalars['Boolean']['output']>;
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  issuedCountry?: Maybe<Scalars['String']['output']>;
  passport?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DrivingLicenseType>;
  validity?: Maybe<Scalars['String']['output']>;
};

export type DrivingLicensePayload = {
  class?: InputMaybe<Scalars['String']['input']>;
  emiratesId?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  isUAEResident?: InputMaybe<Scalars['Boolean']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  issuedCountry?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DrivingLicenseType>;
  uploadDLCopy?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  uploadEIDPassportCopy?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  validity?: InputMaybe<Scalars['String']['input']>;
};

export enum DrivingLicenseType {
  Foreigner = 'Foreigner',
  NotApplicable = 'NotApplicable',
  NotHolding = 'NotHolding',
  Qualified = 'Qualified',
  Uae = 'UAE'
}

export type DropdownOptionSettings = {
  __typename: 'DropdownOptionSettings';
  kind?: Maybe<OptionKind>;
  options: Array<Option>;
};

export type DropdownOptionSettingsInput = {
  options: Array<OptionInput>;
};

export type DummyPrivatePageEndpoint = Endpoint & {
  __typename: 'DummyPrivatePageEndpoint';
  /** Body content */
  body: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Pathname */
  pathname: Scalars['String']['output'];
};

export type DummyPrivatePageSettings = {
  /** Body to display */
  body: Scalars['String']['input'];
  /** Pathname */
  pathname: Scalars['String']['input'];
};

export type DummyWelcomePageEndpoint = Endpoint & {
  __typename: 'DummyWelcomePageEndpoint';
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Pathname */
  pathname: Scalars['String']['output'];
};

export type DummyWelcomePageSettings = {
  /** Pathname */
  pathname: Scalars['String']['input'];
};

export type EazyInsurerIntegration = InsurerIntegration & {
  __typename: 'EazyInsurerIntegration';
  apiUrl: Scalars['String']['output'];
  certCA?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  privateKey?: Maybe<Scalars['String']['output']>;
  provider: InsurerIntegrationProvider;
  sftpHost?: Maybe<Scalars['String']['output']>;
  sftpPort?: Maybe<Scalars['Int']['output']>;
  sftpUser?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type EazyInsurerIntegrationSettings = {
  apiUrl: Scalars['String']['input'];
  certCA?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  privateKey?: InputMaybe<Scalars['String']['input']>;
  sftpHost?: InputMaybe<Scalars['String']['input']>;
  sftpPort?: InputMaybe<Scalars['Int']['input']>;
  sftpUser?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type EdmEmailFooter = {
  __typename: 'EdmEmailFooter';
  arrowIcon?: Maybe<UploadedFileWithPreview>;
  connectText: TranslatedString;
  copyRight: TranslatedString;
  disclaimerText: TranslatedString;
  emailIcon?: Maybe<UploadedFileWithPreview>;
  legalNoticeUrl?: Maybe<Scalars['String']['output']>;
  phoneIcon?: Maybe<UploadedFileWithPreview>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  socialMedia: Array<EdmEmailSocialMedia>;
};

export type EdmEmailFooterPayload = {
  connectText: TranslatedStringInput;
  copyRight: TranslatedStringInput;
  disclaimerText: TranslatedStringInput;
  legalNoticeUrl?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EdmEmailSocialMedia = {
  __typename: 'EdmEmailSocialMedia';
  altText?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<UploadedFileWithPreview>;
  id: Scalars['ObjectID']['output'];
  url: Scalars['String']['output'];
};

export type EdmEmailSocialMediaPayload = {
  altText?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export enum Education {
  Bachelor = 'Bachelor',
  Doctorate = 'Doctorate',
  Master = 'Master',
  Preparatory = 'Preparatory',
  Primary = 'Primary',
  Secondary = 'Secondary',
  TechnicalSecondarySchool = 'TechnicalSecondarySchool'
}

export type EfficiencyClassFranceType = {
  __typename: 'EfficiencyClassFranceType';
  /** The Crit'Air label for this car. */
  critAir?: Maybe<LocalizedValue>;
  energyEfficiencyClass?: Maybe<Scalars['String']['output']>;
  energyEfficiencyClassLabel?: Maybe<Scalars['String']['output']>;
};

export type EfficiencyClassGermanyLabel = {
  __typename: 'EfficiencyClassGermanyLabel';
  co2Emissions: Scalars['String']['output'];
  electricityConsumption: Scalars['String']['output'];
  electricityCostPerUnit: Scalars['String']['output'];
  fuelConsumptionCombined: Scalars['String']['output'];
  fuelConsumptionExtraUrban: Scalars['String']['output'];
  fuelConsumptionUrban: Scalars['String']['output'];
  fuelCostPerUnit: Scalars['String']['output'];
  fuelType: Scalars['String']['output'];
  model: Scalars['String']['output'];
  otherEnergyTypes: Scalars['String']['output'];
  power: Scalars['String']['output'];
  powerLabel: Scalars['String']['output'];
  transmission: Scalars['String']['output'];
  unladenWeight: Scalars['String']['output'];
  yearlyElectricityCostNEDC: Scalars['String']['output'];
  yearlyFuelCostNEDC: Scalars['String']['output'];
  yearlyKilometers: Scalars['String']['output'];
  yearlyTax: Scalars['String']['output'];
};

export type EfficiencyClassGermanyType = {
  __typename: 'EfficiencyClassGermanyType';
  co2class?: Maybe<Scalars['String']['output']>;
  co2classWithDischargedBattery?: Maybe<Scalars['String']['output']>;
};

export type EfficiencyClassSwitzerlandType = {
  __typename: 'EfficiencyClassSwitzerlandType';
  co2Emissions?: Maybe<LocalizedLabeledValue>;
  electricityConsumption?: Maybe<LocalizedLabeledValue>;
  energyEfficiencyClass: Scalars['String']['output'];
  energyEfficiencyClassLabel?: Maybe<LocalizedString>;
  fuelConsumption?: Maybe<LocalizedLabeledValue>;
};

export type EmailBankIntegration = BankIntegration & {
  __typename: 'EmailBankIntegration';
  email: Scalars['String']['output'];
  provider: BankIntegrationProvider;
};

export type EmailBankIntegrationSettings = {
  email: Scalars['String']['input'];
};

export enum EmailContentUpdateType {
  Dealer = 'Dealer',
  Module = 'Module'
}

export type EmailInsurerIntegration = InsurerIntegration & {
  __typename: 'EmailInsurerIntegration';
  email: Scalars['String']['output'];
  provider: InsurerIntegrationProvider;
};

export type EmailInsurerIntegrationSettings = {
  email: Scalars['String']['input'];
};

export enum EmailProvider {
  Smtp = 'Smtp',
  System = 'System'
}

export type EmailSettings = {
  /** Email provider type */
  provider: EmailProvider;
};

export type EmailSettingsPayload = {
  /** SMTP Certificate, required only if the SMTP server is using self-signed certificate */
  certificate?: InputMaybe<Scalars['String']['input']>;
  /** Email sender */
  from?: InputMaybe<Scalars['String']['input']>;
  /** SMTP Host */
  host?: InputMaybe<Scalars['String']['input']>;
  /** SMTP requires authentication */
  isAuthenticationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** SMTP SSL */
  isSslEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** SMTP password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** SMTP Port */
  port?: InputMaybe<Scalars['Int']['input']>;
  /** Email provider type */
  provider: EmailProvider;
  /** SMTP username */
  user?: InputMaybe<Scalars['String']['input']>;
};

export enum Emirate {
  AbuDhabi = 'AbuDhabi',
  Ajman = 'Ajman',
  Dubai = 'Dubai',
  Fujairah = 'Fujairah',
  RasAlKhaimah = 'RasAlKhaimah',
  Sharjah = 'Sharjah'
}

export enum EmploymentStatus {
  BetweenJobs = 'BetweenJobs',
  Contract = 'Contract',
  FullTime = 'FullTime',
  PartTime = 'PartTime',
  SelfEmployed = 'SelfEmployed',
  Unemployed = 'Unemployed'
}

export type EnbdApplicationQuotation = ApplicationQuotation & {
  __typename: 'EnbdApplicationQuotation';
  /** Applicant full name */
  applicantName: Scalars['String']['output'];
  /** Chassis Number */
  chassisNumber: Scalars['String']['output'];
  /** Commission number */
  commissionNumber: Scalars['String']['output'];
  /** Company name */
  companyName: Scalars['String']['output'];
  /** Downpayment target */
  downPaymentTo?: Maybe<ApplicationQuotationDownPaymentTarget>;
  /** Engine Number */
  engineNumber: Scalars['String']['output'];
  /** Exterior Color */
  exteriorColor: Scalars['String']['output'];
  /** F&I manager name */
  financeManagerName: Scalars['String']['output'];
  /** Dealer options with VAT */
  options: Array<ApplicationQuotationOption>;
  /** Quotation Source */
  source: ApplicationQuotationSource;
  /** VAT rate */
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type EnbdApplicationQuotationSettings = {
  applicantName: Scalars['String']['input'];
  chassisNumber: Scalars['String']['input'];
  commissionNumber: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  downPaymentTo?: InputMaybe<ApplicationQuotationDownPaymentTarget>;
  engineNumber: Scalars['String']['input'];
  exteriorColor: Scalars['String']['input'];
  financeManagerName: Scalars['String']['input'];
  options: Array<ApplicationQuotationOptionSetting>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
};

export type EnbdBankIntegration = BankIntegration & {
  __typename: 'EnbdBankIntegration';
  /** Company Name */
  companyName: Scalars['String']['output'];
  dealerCode?: Maybe<Scalars['String']['output']>;
  /** F&I Manager */
  financeManager: EnbdFinanceManager;
  provider: BankIntegrationProvider;
  /** Stamp on the bottom side of quotation PDF page */
  stampBottom?: Maybe<UploadedFileWithPreview>;
  /** Stamp on the right side of quotation PDF page */
  stampRight?: Maybe<UploadedFileWithPreview>;
};

export type EnbdBankIntegrationSettings = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  dealerCode?: InputMaybe<Scalars['String']['input']>;
  financeManager?: InputMaybe<EnbdFinanceManagerSettings>;
};

export type EnbdFinanceManager = {
  __typename: 'EnbdFinanceManager';
  /** F&I Manager email */
  email: Scalars['String']['output'];
  /** F&I Manager name */
  name: Scalars['String']['output'];
};

export type EnbdFinanceManagerSettings = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Endpoint = {
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Pathname */
  pathname: Scalars['String']['output'];
};

export type EnergyConsumption = {
  __typename: 'EnergyConsumption';
  /** The unit of consumption */
  unit: EnergyUnit;
  /** The consumption value */
  value: Scalars['Float']['output'];
};

export type EnergyConsumptionInput = {
  /** The unit of consumption */
  unit: EnergyUnit;
  /** The consumption value */
  value: Scalars['Float']['input'];
};

export type EnergyEfficiency = {
  __typename: 'EnergyEfficiency';
  france?: Maybe<EfficiencyClassFranceType>;
  germany?: Maybe<EfficiencyClassGermanyType>;
  switzerland?: Maybe<EfficiencyClassSwitzerlandType>;
};

export enum EnergyUnit {
  Kwh = 'Kwh',
  Liters = 'Liters'
}

export enum EngineType {
  Diesel = 'Diesel',
  Electric = 'Electric',
  Hybrid = 'Hybrid',
  Petrol = 'Petrol'
}

export enum Environment {
  Live = 'Live',
  PreProduction = 'PreProduction',
  Production = 'Production',
  Test = 'Test'
}

export type Equipment = {
  __typename: 'Equipment';
  category?: Maybe<EquipmentCategory>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<LocalizedString>;
  images?: Maybe<Array<Scalars['String']['output']>>;
  name: LocalizedString;
  packageInformation?: Maybe<PackageInformation>;
};

export type EquipmentCategory = {
  __typename: 'EquipmentCategory';
  sortIndex: Scalars['Int']['output'];
  value: LocalizedValue;
};

export type Event = {
  __typename: 'Event';
  /** Campaign ID */
  campaignId?: Maybe<Scalars['String']['output']>;
  /** C@P Module ID */
  capModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: Maybe<Scalars['Boolean']['output']>;
  /** Customized Fields */
  customizedFields: Array<CustomizedField>;
  /** Dealer IDs */
  dealerIds: Array<Scalars['ObjectID']['output']>;
  /** Dealer Vehicles */
  dealerVehicles: Array<DealerVehicles>;
  /** Dealers */
  dealers: Array<Dealer>;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** Email contents */
  emailContents?: Maybe<EventApplicationModuleEmailContents>;
  /** First router path to the event, if any */
  firstRouterPath?: Maybe<Scalars['String']['output']>;
  /** Has customisable email settings for event level */
  hasCustomiseEmail: Scalars['Boolean']['output'];
  /** scenarios is include payment */
  hasPayment: Scalars['Boolean']['output'];
  /** Event ID */
  id: Scalars['ObjectID']['output'];
  /** Identifier */
  identifier: Scalars['String']['output'];
  /** Is Event active */
  isActive: Scalars['Boolean']['output'];
  /** Allow Test Drive */
  isAllowTestDrive: Scalars['Boolean']['output'];
  /** Allow Trade In */
  isAllowTradeIn: Scalars['Boolean']['output'];
  /** is Deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: Maybe<Scalars['Boolean']['output']>;
  /**
   * KYC Presets; This will act as KYC field in this Event Journey
   * Special condition check will be applied to this KYC Preset
   * i.e. Trade in and test drive switch
   */
  kycPresets: Array<KycPreset>;
  /** Lead Origin */
  leadOrigin: EventLeadOriginType;
  /** Medium */
  medium: EventMediumType;
  /** Module */
  module: Module;
  /** Module Id */
  moduleId: Scalars['ObjectID']['output'];
  /** MyInfo setting */
  myInfoSetting?: Maybe<DealershipSetting>;
  /** Event Name */
  name: TranslatedString;
  /** Payment Setting */
  paymentSetting?: Maybe<DealershipSetting>;
  /** Start Date and End Date */
  period: Period;
  /** Permissions for current user on this event */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Public / Private access */
  privateAccess: Scalars['Boolean']['output'];
  /** Sales Person */
  publicSalesPerson?: Maybe<DealershipSetting>;
  /** Event Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show Dealership */
  showDealership: Scalars['Boolean']['output'];
  /** Show Live Chat */
  showLiveChat: Scalars['Boolean']['output'];
  /** Show Remote Flow Button in Login Access KYC page */
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['output'];
  /** Skip for Deposit in Payment page */
  skipForDeposit: Scalars['Boolean']['output'];
  /** URL Slug */
  urlSlug: Scalars['String']['output'];
  /** Advanced Versioning */
  versioning: SimpleVersioning;
};

export type EventApplication = Application & {
  __typename: 'EventApplication';
  /** Applicant */
  applicant: Customer;
  /** Agreements for the applicant */
  applicantAgreements: Array<ApplicationAgreement>;
  /** Applicant ID */
  applicantId: Scalars['ObjectID']['output'];
  /** KYC fields for the applicant */
  applicantKYC: Array<KycField>;
  appointmentStage?: Maybe<AppointmentStage>;
  /** assignees this application can be assigned to */
  availableAssignees: Array<User>;
  /** Bank */
  bank?: Maybe<SystemBank>;
  /** Bank ID */
  bankId?: Maybe<Scalars['ObjectID']['output']>;
  capValues?: Maybe<CapValuesOnApplication>;
  /** Event Application Configuration */
  configuration: EventApplicationConfiguration;
  /** Agreements for the corporate */
  corporateAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the corporate */
  corporateKYC: Array<KycField>;
  /** Customized Fields in Event */
  customizedFields: Array<EventCustomizedField>;
  /** Dealer data */
  dealer: Dealer;
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['output'];
  /** Application Deposit */
  deposit?: Maybe<ApplicationDeposit>;
  /** Application Document */
  documents: Array<ApplicationDocument>;
  /** Drafting flow */
  draftFlow: StandardApplicationDraftFlow;
  /** Endpoint */
  endpoint?: Maybe<Endpoint>;
  /** Event */
  event: Event;
  /** EventId */
  eventId: Scalars['ObjectID']['output'];
  /** Expired Time */
  expireAt?: Maybe<Scalars['DateTime']['output']>;
  /** Financial Product */
  financeProduct?: Maybe<FinanceProduct>;
  /** Application Finance */
  financing?: Maybe<ApplicationFinancing>;
  financingStage?: Maybe<FinancingStage>;
  /**
   * Guarantor
   * currently only have 1 Guarantor
   * might have more guarantor in future
   */
  guarantor?: Maybe<Customer>;
  /** Agreements for the guarantor */
  guarantorAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the guarantor */
  guarantorKYC: Array<KycField>;
  /** Guarantor Application Signing */
  guarantorSigning?: Maybe<ApplicationSigning>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  insuranceStage?: Maybe<InsuranceStage>;
  /** Journey Steps Identifiers */
  journeySteps: Array<Scalars['String']['output']>;
  /** Language ID to determine what language user chose in journey */
  languageId?: Maybe<Scalars['ObjectID']['output']>;
  latestStage?: Maybe<ApplicationStageDetails>;
  leadStage?: Maybe<LeadStage>;
  mobilityStage?: Maybe<MobilityStage>;
  /** Module */
  module: Module;
  /** ModuleId */
  moduleId: Scalars['ObjectID']['output'];
  /** Other Vehicle Information */
  otherVehicleInformation?: Maybe<OtherVehicleInformation>;
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Promo Code data */
  promoCode?: Maybe<PromoCode>;
  /** Finance application suite id */
  referenceApplicationSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Finance application suite id */
  referenceApplications: Array<Application>;
  remarks: Scalars['String']['output'];
  reservationStage?: Maybe<ReservationStage>;
  /** Router */
  router?: Maybe<Router>;
  /** Router ID */
  routerId?: Maybe<Scalars['ObjectID']['output']>;
  /** Application Signing */
  signing?: Maybe<ApplicationSigning>;
  stages: Array<ApplicationStage>;
  /** Agreements for the test drive */
  testDriveAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the test drive */
  testDriveKYC: Array<KycField>;
  /** Redirect Url */
  testDriveRedirectUrl?: Maybe<Scalars['String']['output']>;
  /** Test Drive Signing */
  testDriveSigning?: Maybe<ApplicationSigning>;
  /** TradeIn Vehicle */
  tradeInVehicle: Array<TradeInVehicle>;
  /** URL Slug */
  urlSlug: Scalars['String']['output'];
  /** Vehicle */
  vehicle: Vehicle;
  /** Vehicle ID */
  vehicleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: AdvancedVersioning;
  /** Application is proceeding with customer device */
  withCustomerDevice: Scalars['Boolean']['output'];
};

export type EventApplicationConfiguration = {
  __typename: 'EventApplicationConfiguration';
  assetCondition: AssetCondition;
  testDrive: Scalars['Boolean']['output'];
  tradeIn: Scalars['Boolean']['output'];
};

export type EventApplicationConfigurationPayload = {
  assetCondition: AssetCondition;
  testDrive: Scalars['Boolean']['input'];
  tradeIn: Scalars['Boolean']['input'];
};

export type EventApplicationEntrypoint = Endpoint & {
  __typename: 'EventApplicationEntrypoint';
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** Application Module */
  eventApplicationModule: EventApplicationModule;
  /** Application Module ID */
  eventApplicationModuleId: Scalars['ObjectID']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  pathScripts: Array<PathScript>;
  /** Pathname */
  pathname: Scalars['String']['output'];
};

export type EventApplicationEntrypointSettings = {
  /** Display Name */
  displayName: Scalars['String']['input'];
  pathScripts: Array<PathScriptSettings>;
  /** Pathname */
  pathname: Scalars['String']['input'];
};

export type EventApplicationLink = {
  __typename: 'EventApplicationLink';
  applicationJourney: ApplicationJourney;
  endpoint: Endpoint;
  router: Router;
};

export type EventApplicationModule = Module & {
  __typename: 'EventApplicationModule';
  /** Agreements module */
  agreementsModule: Module;
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['output'];
  /** Counter for applications */
  applicationCounter: CounterSettings;
  /** Counter for reservations */
  appointmentCounter: CounterSettings;
  /** Appointment Module */
  appointmentModule?: Maybe<Module>;
  /** Appointment Module ID */
  appointmentModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Customer module */
  customerModule: Module;
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['output'];
  /** Dealer Finance Products */
  dealerFinanceProducts: Array<DealerFinanceProducts>;
  /** Dealer Vehicles */
  dealerVehicles: Array<DealerVehicles>;
  displayAppointmentDatepicker: Scalars['Boolean']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Email contents */
  emailContents: EventApplicationModuleEmailContents;
  /** Counter for events */
  eventCounter: CounterSettings;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** C@P Module switch */
  isCapEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['output'];
  /** KYC presets */
  kycPresets: Array<KycPreset>;
  /** Counter for leads */
  leadCounter: CounterSettings;
  /** Live chat setting */
  liveChatSetting?: Maybe<LiveChatSetting>;
  /** Live chat setting id */
  liveChatSettingId?: Maybe<Scalars['ObjectID']['output']>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Counter for reservations */
  reservationCounter: CounterSettings;
  /** Show Remote Flow Button in Login Access KYC page */
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['output'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['output'];
  /** Vehicle management module */
  vehicleModule: Module;
  /** Vehicle management module ID */
  vehicleModuleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: SimpleVersioning;
};

export type EventApplicationModuleEmailContents = {
  __typename: 'EventApplicationModuleEmailContents';
  submitOrder: EventApplicationModuleSubmitOrderContent;
};

export type EventApplicationModuleEmailContentsSetting = {
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentUpdateType: EmailContentUpdateType;
  submitOrder: EventApplicationModuleEmailSubmitOrderInput;
};

export type EventApplicationModuleEmailSubmitOrderInput = {
  contentText: DealerTranslationTextInput;
  introTitle: DealerTranslationTextInput;
  subject: DealerTranslationTextInput;
};

export type EventApplicationModuleInitialSettings = {
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['input'];
  applicationCounter: CounterPayload;
  /** Counter for appointment */
  appointmentCounter: CounterPayload;
  /** Appointment module ID */
  appointmentModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['input'];
  displayAppointmentDatepicker: Scalars['Boolean']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Email contents */
  emailContents: EventApplicationModuleEmailContentsSetting;
  /** Counters */
  eventCounter: CounterPayload;
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['input'];
  leadCounter: CounterPayload;
  /** Live chat settings */
  liveChatSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  reservationCounter: CounterPayload;
  /** Show Remote Flow Button in Login Access KYC page */
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['input'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['input'];
  /** Vehicle management module ID */
  vehicleModuleId: Scalars['ObjectID']['input'];
};

export type EventApplicationModuleSettings = {
  /** Dealer vehicles */
  dealerVehicles: Array<DealerVehiclesPayload>;
};

export type EventApplicationModuleSubmitOrderContent = {
  __typename: 'EventApplicationModuleSubmitOrderContent';
  contentText: DealerTranslationText;
  introImage?: Maybe<UploadedFileWithPreview>;
  introTitle: DealerTranslationText;
  subject: DealerTranslationText;
};

export type EventApplicationModuleUpdateSettings = {
  /** Appointment module ID */
  appointmentModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  displayAppointmentDatepicker: Scalars['Boolean']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** C@P Module switch */
  isCapEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['input'];
  /** Live chat settings */
  liveChatSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['input'];
};

export type EventCustomizedField = {
  __typename: 'EventCustomizedField';
  /** Input characters limit */
  characterLimit: Scalars['Int']['output'];
  /** Display name */
  displayName: TranslatedString;
  /** Is Field mandatory */
  isMandatory: Scalars['Boolean']['output'];
  /**
   * User inputted value
   *
   * since it's depends on isMandatory, it can be null
   */
  value?: Maybe<Scalars['String']['output']>;
};

export type EventCustomizedFieldInput = {
  /** Input Character Limit */
  characterLimit: Scalars['Int']['input'];
  /** Display Name */
  displayName: TranslatedStringInput;
  /** Mandatory */
  isMandatory: Scalars['Boolean']['input'];
  /** User Customized Field value */
  value: Scalars['String']['input'];
};

export type EventEmailContents = {
  __typename: 'EventEmailContents';
  submitOrder: EventSubmitOrder;
};

export type EventFilteringRule = {
  /** Filter by active */
  actives?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Filter by even public sales person */
  assigned?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by multiple company IDs */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by dealer ids */
  dealerIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by even display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by end Date */
  endDate?: InputMaybe<PeriodPayload>;
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by event module display name */
  moduleName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by access ( Public / Private access) */
  privateAccesses?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Production Only */
  productionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by start Date */
  startDate?: InputMaybe<PeriodPayload>;
};

export type EventFilters = {
  __typename: 'EventFilters';
  /** Medium */
  mediums: Array<EventMediumType>;
  /** Event Modules */
  moduleCount: Scalars['Int']['output'];
  /** Public / Private access */
  privateAccesses: Array<Scalars['Boolean']['output']>;
  /** Event Scenario */
  scenarios: Array<ApplicationScenario>;
};

export type EventInput = {
  /** Campaign ID */
  campaignId?: InputMaybe<Scalars['String']['input']>;
  /** C@P Module ID */
  capModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Customized fields for event */
  customizedFields: Array<CustomizedFieldInput>;
  /** Dealer IDs */
  dealerIds: Array<Scalars['ObjectID']['input']>;
  /** Dealer vehicles */
  dealerVehicles: Array<DealerVehiclesPayload>;
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** Email settings for the event level */
  eventLevelEmailSettings?: InputMaybe<EventApplicationModuleEmailContentsSetting>;
  /** Has customisable email settings for event level */
  hasCustomiseEmail: Scalars['Boolean']['input'];
  /** Is Event active */
  isActive: Scalars['Boolean']['input'];
  /** Allow Test Drive */
  isAllowTestDrive: Scalars['Boolean']['input'];
  /** Allow Trade In */
  isAllowTradeIn: Scalars['Boolean']['input'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lead Origin */
  leadOrigin: EventLeadOriginType;
  /** Medium */
  medium: EventMediumType;
  /** MyInfo setting */
  myInfoSetting?: InputMaybe<DealershipSettingInput>;
  /** Event Name */
  name: TranslatedStringInput;
  /** Payment Setting */
  paymentSetting?: InputMaybe<DealershipSettingInput>;
  /** Start Date and End Date */
  period: PeriodPayload;
  /** Public / Private access */
  privateAccess: Scalars['Boolean']['input'];
  /** Sales Person */
  publicSalesPerson?: InputMaybe<DealershipSettingInput>;
  /** Event Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show Dealership */
  showDealership: Scalars['Boolean']['input'];
  /** Show Live Chat */
  showLiveChat: Scalars['Boolean']['input'];
  /** Skip for Deposit in Payment page */
  skipForDeposit: Scalars['Boolean']['input'];
  /** URL Slug */
  urlSlug: Scalars['String']['input'];
};

export type EventKycPresetInput = {
  conditions: Array<ConditionSettings>;
  fields: Array<KycFieldSettings>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  settings: KycPresetSettings;
};

export enum EventLeadOriginType {
  Dealer = 'Dealer',
  Internet = 'Internet'
}

export enum EventMediumType {
  Event = 'Event',
  Internet = 'Internet',
  Walkin = 'Walkin'
}

export enum EventModuleAsset {
  ArrowIcon = 'ArrowIcon',
  EmailIcon = 'EmailIcon',
  PhoneIcon = 'PhoneIcon',
  SubmitOrderIntro = 'SubmitOrderIntro'
}

export enum EventSortingField {
  /** Sort by Assigned */
  Assigned = 'Assigned',
  /** Sort by Company */
  Company = 'Company',
  /** Sort by EventId */
  EventId = 'EventId',
  /** Sort by EventName */
  EventName = 'EventName',
  /** Sort by Event Module Name */
  ModuleName = 'ModuleName',
  /** Sort by Payment */
  Payment = 'Payment'
}

export type EventSortingRule = {
  field: EventSortingField;
  order: SortingOrder;
};

export type EventSubmitOrder = {
  __typename: 'EventSubmitOrder';
  contentText: TranslatedString;
  introImage?: Maybe<UploadedFileWithPreview>;
  introTitle: TranslatedString;
  subject: TranslatedString;
};

export type ExteriorColor = {
  __typename: 'ExteriorColor';
  colorGroup?: Maybe<LocalizedColorGroup>;
  metallic?: Maybe<Scalars['Boolean']['output']>;
  name: LocalizedString;
  value: Scalars['String']['output'];
};

export type ExternalBank = Bank & {
  __typename: 'ExternalBank';
  dealerCode: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  identifier: Scalars['String']['output'];
  integration: BankIntegration;
  kind: BankKind;
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
};

export type ExternalBankSettings = {
  dealerCode: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};

export type ExternalLink = AdyenRedirectionLink | ApplyNewRedirectionLink | CtsFinderRedirectionLink | ConfiguratorApplicationLink | CreateNewUserLink | EventApplicationLink | FinderApplicationLink | FiservPaymentRedirectionLink | GiftVoucherAdyenRedirectionLink | GiftVoucherFiservPaymentRedirectionLink | GiftVoucherPayGatePaymentRedirectionLink | GiftVoucherPorschePaymentRedirectionLink | GiftVoucherTtbPaymentRedirectionLink | MobilityApplicationAmendmentLink | MobilityApplicationCancellationLink | MyInfoCallbackLink | NamirialSigningLink | PayGatePaymentRedirectionLink | PorschePaymentRedirectionLink | ProceedWithCustomerLink | ResetPasswordLink | StandardApplicationLink | TestDriveProcessRedirectionLink | TtbPaymentRedirectionLink | VerifyEmailUpdateLink;

export type ExternalReference = {
  __typename: 'ExternalReference';
  id: Scalars['String']['output'];
  system: Scalars['String']['output'];
};

export type ExternalSystemReference = {
  id: Scalars['String']['input'];
  system: Scalars['String']['input'];
};

export enum FieldDisplaySetting {
  Hide = 'Hide',
  Popup = 'Popup',
  Show = 'Show'
}

export enum FilterRuleType {
  LocalMakeFilteringRule = 'LocalMakeFilteringRule',
  LocalModelFilteringRule = 'LocalModelFilteringRule',
  LocalVariantFilteringRule = 'LocalVariantFilteringRule'
}

export type FilterVehicleFilteringRule = {
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by multiple company IDs */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /**
   * Filter by condition
   *
   * Refer to: listing/vehicle/condition/value & listing/warranty/porscheApproved
   */
  conditions?: InputMaybe<Array<InputMaybe<FinderVehicleCondition>>>;
  /**
   * Filter by dealer name
   *
   * Refer to: listing/seller/name/localize
   */
  dealerName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by engine type */
  engineType?: InputMaybe<Array<EngineType>>;
  /**
   * Filter by exterior color
   *
   * Refer to: listing/vehicle/exteriorColor/name/localize
   */
  exteriorColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by functionalities
   *
   * Refer to: setting/functionality
   */
  functionalities?: InputMaybe<Array<InputMaybe<FinderVehicleFunctionality>>>;
  /**
   * Filter by has lta data
   *
   * Refer to: lta
   */
  hasLta?: InputMaybe<Array<InputMaybe<BooleanWithEmpty>>>;
  /**
   * Filter by inspected
   *
   * Refer to: setting/isInspected
   */
  inspected?: InputMaybe<Array<InputMaybe<BooleanWithEmpty>>>;
  /**
   * Filter by inventory ID
   *
   * Refer to: listing/id
   */
  inventoryId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by is state hidden
   *
   * Refer to: setting/isStateHidden
   */
  isStateHidden?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  /** Filter by mileage */
  mileage?: InputMaybe<OptionalRangeValuePayload>;
  /**
   * Filter by model category
   *
   * Refer to: listing/vehicle/modelCategory/localize
   */
  modelCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by Model Year */
  modelYear?: InputMaybe<OptionalRangeValuePayload>;
  /** Filter by module ID */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /**
   * Filter by name
   *
   * Refer to: name/defaultValue
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by partner number
   *
   * Refer to: listing/seller/porschePartnerNumber
   */
  partnerNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by price
   *
   * Refer to: listing/price/value
   */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** dealerId & applicationModuleIds are required to generate range monthly instalment filters. */
  purpose?: InputMaybe<Purpose>;
  /**
   * Filter by range monthly instalments
   * dealerId and applicationModuleIds are required to filter by range monthly instalments.
   */
  rangeMonthlyInstalments?: InputMaybe<Array<RangeAmountPayload>>;
  /**
   * Filter by statuses
   *
   * Refer to: status
   */
  statuses?: InputMaybe<Array<InputMaybe<FinderVehicleStatus>>>;
  /**
   * Filter by vehicle ID
   *
   * Refer to: listing/vehicle/orderTypeCode
   */
  vehicleId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by specific vehicle IDs
   *
   * Refer to: listing/vehicle/orderTypeCode
   */
  vehicleIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FinanceProduct = LocalDeferredPrincipal | LocalHirePurchase | LocalHirePurchaseWithBalloon | LocalHirePurchaseWithBalloonGfv | LocalLease | LocalLeasePurchase | LocalUcclLeasing;

export enum FinanceProductBasedOn {
  DownPayment = 'DownPayment',
  Loan = 'Loan'
}

export type FinanceProductFilteringRule = {
  /** Filter by Application module ID */
  applicationModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by bank name */
  bankName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by multiple company IDs */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by dealer IDs from module */
  dealerIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by finance product display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by identifier */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Module ID, which is Bank/Financing Module */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter Purpose */
  purpose?: InputMaybe<Purpose>;
  /** Filter by variant suite IDs from module */
  variantSuiteIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export enum FinanceProductKind {
  Local = 'Local'
}

export type FinanceProductSettings = {
  balloon?: InputMaybe<BalloonSettingsPayload>;
  balloonGfv?: InputMaybe<BalloonGfvSettingsPayload>;
  bankId: Scalars['ObjectID']['input'];
  bankReferenceIdentifier?: InputMaybe<Scalars['String']['input']>;
  basedOn?: InputMaybe<FinanceProductBasedOn>;
  calculationMode?: InputMaybe<CalculationMode>;
  commission?: InputMaybe<CommissionSettingPayload>;
  deposit?: InputMaybe<DepositSettingsPayload>;
  deriveMethod: DeriveMethod;
  description?: InputMaybe<TranslatedStringInput>;
  displacement?: InputMaybe<DisplacementSettingPayload>;
  displayName: Scalars['String']['input'];
  downPayment?: InputMaybe<DownPaymentSettingsPayload>;
  identifier: Scalars['String']['input'];
  insuranceFee?: InputMaybe<InsuranceFeeSettingPayload>;
  interestRate?: InputMaybe<InterestRateSettingsPayload>;
  isActive: Scalars['Boolean']['input'];
  lease?: InputMaybe<LeaseSettingsPayload>;
  legalName: TranslatedStringInput;
  licenseAndFuelTax?: InputMaybe<LicenseAndFuelTaxSettingPayload>;
  licensePlateFee?: InputMaybe<LicensePlateFeeSettingPayload>;
  loan?: InputMaybe<LoanSettingsPayload>;
  monthlyPaymentFixedInterestRate?: InputMaybe<MonthlyPaymentFixedInterestRateSettingPayload>;
  order: Scalars['Int']['input'];
  payment?: InputMaybe<PaymentSettingsPayload>;
  period: PeriodPayload;
  residualValue?: InputMaybe<ResidualValueSettingsPayload>;
  taxLoss?: InputMaybe<TaxLossSettingPayload>;
  term: TermSettingsPayload;
  type: FinanceProductType;
  variantSuiteIds: Array<Scalars['ObjectID']['input']>;
  vehicleReferenceParameters: VehicleReferenceParametersPayload;
  webCalcSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum FinanceProductSortingField {
  Bank = 'Bank',
  Company = 'Company',
  DisplayName = 'DisplayName',
  EndDate = 'EndDate',
  FinanceProductType = 'FinanceProductType',
  Identifier = 'Identifier',
  Order = 'Order',
  StartDate = 'StartDate'
}

export type FinanceProductSortingRule = {
  /** Field on which apply the sorting */
  field: FinanceProductSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export enum FinanceProductType {
  DeferredPrincipal = 'DeferredPrincipal',
  HirePurchase = 'HirePurchase',
  HirePurchaseWithBalloon = 'HirePurchaseWithBalloon',
  HirePurchaseWithBalloonGfv = 'HirePurchaseWithBalloonGFV',
  Lease = 'Lease',
  LeasePurchase = 'LeasePurchase',
  UcclLeasing = 'UCCLLeasing'
}

export type FinanceProductVehicleFilteringRule = {
  engineType?: InputMaybe<Array<EngineType>>;
  mileage?: InputMaybe<OptionalRangeValuePayload>;
  modelYear?: InputMaybe<OptionalRangeValuePayload>;
  variants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum FinanceType {
  /** DBS New Car */
  DbsNew = 'DBSNew',
  /** DBS Used Car */
  DbsUsed = 'DBSUsed',
  /** HLF New Car */
  HlfNew = 'HLFNew',
  /** HLF Used Car */
  HlfUsed = 'HLFUsed',
  /** Maybank New Car */
  MaybankNew = 'MaybankNew',
  /** Maybank Used Car */
  MaybankUsed = 'MaybankUsed',
  /** UOB New Car */
  UobNew = 'UOBNew',
  /** UOB Used Car */
  UobUsed = 'UOBUsed'
}

export type Financing = {
  __typename: 'Financing';
  productTypes: Array<Scalars['String']['output']>;
  products: Array<FinancingProduct>;
};


export type FinancingProductsArgs = {
  financingProductTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum FinancingPreferenceValue {
  /** Will submit the application to bank, as financing, without control in the CI side */
  Mandatory = 'Mandatory',
  /**
   * User can control it in the CI side. When CI checkbox is checked,
   * submit application to bank as financing.
   */
  Optional = 'Optional',
  /**
   * User can control it in the CI side. When CI checkbox is checked,
   * no submission application to bank, as non-financing
   */
  Request = 'Request'
}

export type FinancingProduct = {
  __typename: 'FinancingProduct';
  rate?: Maybe<Rate>;
  type: Scalars['String']['output'];
};

export type FinancingStage = ApplicationStageDetails & {
  __typename: 'FinancingStage';
  assignee?: Maybe<User>;
  /** Assignee */
  assigneeId?: Maybe<Scalars['ObjectID']['output']>;
  /** Identifier */
  identifier: Scalars['String']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Current status */
  status: ApplicationStatus;
};

export type FinderApplication = Application & {
  __typename: 'FinderApplication';
  /** Applicant */
  applicant: Customer;
  /** Agreements for the applicant */
  applicantAgreements: Array<ApplicationAgreement>;
  /** Applicant ID */
  applicantId: Scalars['ObjectID']['output'];
  /** KYC fields for the applicant */
  applicantKYC: Array<KycField>;
  appointmentStage?: Maybe<AppointmentStage>;
  /** assignees this application can be assigned to */
  availableAssignees: Array<User>;
  /** Bank */
  bank?: Maybe<SystemBank>;
  /** Bank ID */
  bankId?: Maybe<Scalars['ObjectID']['output']>;
  capValues?: Maybe<CapValuesOnApplication>;
  commentsToInsurer?: Maybe<Scalars['String']['output']>;
  /** Application Configuration */
  configuration: FinderApplicationConfiguration;
  /** Agreements for the corporate */
  corporateAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the corporate */
  corporateKYC: Array<KycField>;
  ctsSetting?: Maybe<CtsSetting>;
  /** Dealer data */
  dealer: Dealer;
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['output'];
  /** Application Deposit */
  deposit?: Maybe<ApplicationDeposit>;
  /** Application Document */
  documents: Array<ApplicationDocument>;
  /** Drafting flow */
  draftFlow: StandardApplicationDraftFlow;
  /** Endpoint */
  endpoint?: Maybe<Endpoint>;
  /**
   * Expiration time
   *
   * Only filled when application is in draft stage
   * After expiration time application will be unset
   */
  expireAt?: Maybe<Scalars['DateTime']['output']>;
  /** Financial Product */
  financeProduct?: Maybe<FinanceProduct>;
  /** Application Finance */
  financing?: Maybe<ApplicationFinancing>;
  financingStage?: Maybe<FinancingStage>;
  /**
   * Guarantor
   * currently only have 1 Guarantor
   * might have more guarantor in future
   */
  guarantor?: Maybe<Customer>;
  /** Agreements for the guarantor */
  guarantorAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the guarantor */
  guarantorKYC: Array<KycField>;
  /** Guarantor Application Signing */
  guarantorSigning?: Maybe<ApplicationSigning>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Insurance Product */
  insuranceProduct?: Maybe<InsuranceProduct>;
  /** Insurance application signing */
  insuranceSigning?: Maybe<ApplicationSigning>;
  insuranceStage?: Maybe<InsuranceStage>;
  /** Application insurancing */
  insurancing?: Maybe<ApplicationInsurancing>;
  /** Insurer */
  insurer?: Maybe<Insurer>;
  /** Journey Steps Identifiers */
  journeySteps: Array<Scalars['String']['output']>;
  /** Language ID to determine what language user chose in journey */
  languageId?: Maybe<Scalars['ObjectID']['output']>;
  latestStage?: Maybe<ApplicationStageDetails>;
  leadStage?: Maybe<LeadStage>;
  /** Market */
  market: ApplicationMarket;
  mobilityStage?: Maybe<MobilityStage>;
  /** Module */
  module: Module;
  /** ModuleId */
  moduleId: Scalars['ObjectID']['output'];
  /** Other Vehicle Information */
  otherVehicleInformation?: Maybe<OtherVehicleInformation>;
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Promo Code data */
  promoCode?: Maybe<PromoCode>;
  /** Promo Code ID */
  promoCodeId?: Maybe<Scalars['ObjectID']['output']>;
  /** Quotation */
  quotation?: Maybe<ApplicationQuotation>;
  /** Finance application suite id */
  referenceApplicationSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Finance application suite id */
  referenceApplications: Array<Application>;
  remarks: Scalars['String']['output'];
  reservationStage?: Maybe<ReservationStage>;
  /** Router */
  router?: Maybe<Router>;
  /** Router ID */
  routerId?: Maybe<Scalars['ObjectID']['output']>;
  /** Application Signing */
  signing?: Maybe<ApplicationSigning>;
  stages: Array<ApplicationStage>;
  /** Agreements for the test drive */
  testDriveAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the test drive */
  testDriveKYC: Array<KycField>;
  /** Redirect Url */
  testDriveRedirectUrl?: Maybe<Scalars['String']['output']>;
  /** Test Drive Signing */
  testDriveSigning?: Maybe<ApplicationSigning>;
  /** TradeIn Vehicle */
  tradeInVehicle: Array<TradeInVehicle>;
  /** As a flag whether user has use myinfo on kyc or no */
  useMyinfo?: Maybe<Scalars['Boolean']['output']>;
  /** Vehicle */
  vehicle: Vehicle;
  /** Vehicle ID */
  vehicleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: AdvancedVersioning;
  /** Application is proceeding with customer device */
  withCustomerDevice: Scalars['Boolean']['output'];
};

export type FinderApplicationConfiguration = {
  __typename: 'FinderApplicationConfiguration';
  isAffinAutoFinanceCentreRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Request for financing
   *
   * When user ask for request financial,
   * True: Financing Preference value is "Request" or Calculator visibility is "Optional"
   *       and user checked the checkbox in CI.
   *       Show financing summary in reservation/insurance/lead details and email
   */
  requestForFinancing: Scalars['Boolean']['output'];
  testDrive: Scalars['Boolean']['output'];
  tradeIn: Scalars['Boolean']['output'];
  withFinancing: Scalars['Boolean']['output'];
  withInsurance: Scalars['Boolean']['output'];
};

export type FinderApplicationConfigurationPayload = {
  isAffinAutoFinanceCentreRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Request for financing
   *
   * When user ask for request financial,
   * True: Financing Preference value is "Request" or Calculator visibility is "Optional"
   *       and user checked the checkbox in CI.
   *       Show financing summary in reservation/insurance/lead details and email
   */
  requestForFinancing: Scalars['Boolean']['input'];
  testDrive: Scalars['Boolean']['input'];
  tradeIn: Scalars['Boolean']['input'];
  withFinancing: Scalars['Boolean']['input'];
  withInsurance: Scalars['Boolean']['input'];
};

export type FinderApplicationEntrypoint = Endpoint & {
  __typename: 'FinderApplicationEntrypoint';
  /** Application Stage */
  applicationStage: ApplicationStage;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** Finder Application Module ID */
  finderApplicationModuleIds: Array<Scalars['ObjectID']['output']>;
  /** Finder Application Module */
  finderApplicationModules: Array<FinderApplicationPrivateModule>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Pathname */
  pathname: Scalars['String']['output'];
};

export type FinderApplicationEntrypointSettings = {
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** Pathname */
  pathname: Scalars['String']['input'];
};

export type FinderApplicationLink = {
  __typename: 'FinderApplicationLink';
  applicationJourney: ApplicationJourney;
  endpoint: Endpoint;
  router: Router;
};

export enum FinderApplicationModuleAsset {
  ReminderEmailIntro = 'ReminderEmailIntro',
  SubmitOrderIntro = 'SubmitOrderIntro'
}

export type FinderApplicationModuleEmailContents = {
  __typename: 'FinderApplicationModuleEmailContents';
  reminderEmail: FinderApplicationModuleReminderEmailContent;
  submitOrder: FinderApplicationModuleSubmitOrderContent;
};

export type FinderApplicationModuleEmailContentsSetting = {
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentUpdateType: EmailContentUpdateType;
  reminderEmail: FinderApplicationModuleReminderEmailInput;
  submitOrder: FinderApplicationModuleSubmitOrderInput;
};

export type FinderApplicationModuleInitialSettings = {
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['input'];
  /** Counter for applications */
  applicationCounter: CounterPayload;
  /** Counter for appointment */
  appointmentCounter: CounterPayload;
  /** Appointment module ID */
  appointmentModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Sale person */
  assignee: DealershipSettingInput;
  /** Determine when to show Bank in Calculator */
  bankDisplayPreference: DisplayPreference;
  /** Banks */
  bankIds: Array<Scalars['ObjectID']['input']>;
  /** Bank module ID */
  bankModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** C@P Module ID */
  capModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['input'];
  /** Deposit Amount ( changed the naming due to type conflict with standard application module ) */
  depositPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Display appointment datepicker */
  displayAppointmentDatepicker: Scalars['Boolean']['input'];
  /** Show Finance Calculator */
  displayFinanceCalculator: PreferenceValue;
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Email contents */
  emailContents: FinderApplicationModuleEmailContentsSetting;
  /** Finance Disclaimer */
  financingDisclaimer?: InputMaybe<DealerDisclaimersConfiguratorInput>;
  /** Financing preference */
  financingPreference: FinancingPreferenceValue;
  finderVehicleConditions: Array<FinderVehicleCondition>;
  /** Counter for insurance */
  insuranceCounter: CounterPayload;
  /** Insurance Module ID */
  insuranceModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Determine when to show Insurer in Calculator */
  insurerDisplayPreference: DisplayPreference;
  /** Insurers */
  insurerIds: Array<Scalars['ObjectID']['input']>;
  /** Is Insurance Optional */
  isInsuranceOptional: Scalars['Boolean']['input'];
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['input'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Trade In Amount visibility */
  isTradeInAmountVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defining the campaign ID for C@P lead submission */
  leadCampaignId?: InputMaybe<Scalars['String']['input']>;
  /** Counter for leads */
  leadCounter: CounterPayload;
  /** Defining the lead medium for C@P lead submission */
  leadMedium?: InputMaybe<EventMediumType>;
  /** Defining the lead origin for C@P lead submission */
  leadOrigin?: InputMaybe<EventLeadOriginType>;
  /** Live chat settings */
  liveChatSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Market */
  market?: InputMaybe<ApplicationMarket>;
  /** Market Type Input */
  marketType?: InputMaybe<ApplicationModuleMarketTypeInput>;
  /** Model Page URL */
  modelPageUrl?: InputMaybe<Scalars['String']['input']>;
  /** MyInfo Setting ID */
  myInfoSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Payment settings ID */
  paymentSettingsId?: InputMaybe<Scalars['ObjectID']['input']>;
  porscheApprovedInfo: TranslatedStringInput;
  /** Price Disclaimer */
  priceDisclaimer: DealerDisclaimersConfiguratorInput;
  /** Promo code module id */
  promoCodeModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Counter for reservations */
  reservationCounter: CounterPayload;
  /** reservationInstructions */
  reservationInstructions?: InputMaybe<DealerTranslatedStringSettingInput>;
  /** Reservation period */
  reservationPeriod: Scalars['Int']['input'];
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show From Value on Vehicle Details in Calculator */
  showFromValueOnVehicleDetails: Scalars['Boolean']['input'];
  /** Show Insurance Calculator */
  showInsuranceCalculator: Scalars['Boolean']['input'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['input'];
  /** Show Visit Model Page */
  showVisitModelPageButton: Scalars['Boolean']['input'];
  /** Skip for Deposit when continuing application */
  skipForDeposit: Scalars['Boolean']['input'];
  /** Test Drive */
  testDrive: Scalars['Boolean']['input'];
  /** Trade In */
  tradeIn: Scalars['Boolean']['input'];
  /** Finder Vehicle management module ID */
  vehicleModuleId: Scalars['ObjectID']['input'];
};

export type FinderApplicationModuleReminderEmailContent = {
  __typename: 'FinderApplicationModuleReminderEmailContent';
  active: Scalars['Boolean']['output'];
  contentText: DealerTranslationText;
  introImage?: Maybe<UploadedFileWithPreview>;
  introTitle: DealerTranslationText;
  sendingTime: Scalars['DateTime']['output'];
  subject: DealerTranslationText;
};

export type FinderApplicationModuleReminderEmailInput = {
  active: Scalars['Boolean']['input'];
  contentText: DealerTranslationTextInput;
  introTitle: DealerTranslationTextInput;
  sendingTime: Scalars['DateTime']['input'];
  subject: DealerTranslationTextInput;
};

export type FinderApplicationModuleSubmitOrderContent = {
  __typename: 'FinderApplicationModuleSubmitOrderContent';
  contentText: DealerTranslationText;
  introImage?: Maybe<UploadedFileWithPreview>;
  introTitle: DealerTranslationText;
  isSummaryVehicleVisible: Scalars['Boolean']['output'];
  subject: DealerTranslationText;
};

export type FinderApplicationModuleSubmitOrderInput = {
  contentText: DealerTranslationTextInput;
  introTitle: DealerTranslationTextInput;
  isSummaryVehicleVisible: Scalars['Boolean']['input'];
  subject: DealerTranslationTextInput;
};

export type FinderApplicationModuleUpdateSettings = {
  /** Appointment module ID */
  appointmentModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Sale person */
  assignee: DealershipSettingInput;
  /** Determine when to show Bank in Calculator */
  bankDisplayPreference: DisplayPreference;
  /** Banks */
  bankIds: Array<Scalars['ObjectID']['input']>;
  /** Bank module id */
  bankModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** C@P Module ID */
  capModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deposit Amount ( changed the naming due to type conflict with standard application module ) */
  depositPrice?: InputMaybe<Scalars['Float']['input']>;
  displayAppointmentDatepicker: Scalars['Boolean']['input'];
  /** Show Finance Calculator */
  displayFinanceCalculator: PreferenceValue;
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Financing preference */
  financingPreference: FinancingPreferenceValue;
  finderVehicleConditions: Array<FinderVehicleCondition>;
  /** Insurance Module ID */
  insuranceModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Determine when to show Insurer in Calculator */
  insurerDisplayPreference: DisplayPreference;
  /** Insurers */
  insurerIds: Array<Scalars['ObjectID']['input']>;
  /** Is Insurance Optional */
  isInsuranceOptional: Scalars['Boolean']['input'];
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['input'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Trade In Amount visibility */
  isTradeInAmountVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defining the campaign ID for C@P lead submission */
  leadCampaignId?: InputMaybe<Scalars['String']['input']>;
  /** Defining the lead medium for C@P lead submission */
  leadMedium?: InputMaybe<EventMediumType>;
  /** Defining the lead origin for C@P lead submission */
  leadOrigin?: InputMaybe<EventLeadOriginType>;
  /** Live chat settings */
  liveChatSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Market */
  market: ApplicationMarket;
  /** Market Type Input */
  marketType?: InputMaybe<ApplicationModuleMarketTypeInput>;
  /** Model Page URL */
  modelPageUrl?: InputMaybe<Scalars['String']['input']>;
  /** MyInfo Setting ID */
  myInfoSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Payment Setting ID */
  paymentSettingsId?: InputMaybe<Scalars['ObjectID']['input']>;
  porscheApprovedInfo: TranslatedStringInput;
  /** Price Disclaimer */
  priceDisclaimer: DealerDisclaimersConfiguratorInput;
  /** Promo code module id */
  promoCodeModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** reservationInstructions */
  reservationInstructions?: InputMaybe<DealerTranslatedStringSettingInput>;
  /** Reservation period */
  reservationPeriod: Scalars['Int']['input'];
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show From Value on Vehicle Details in Calculator */
  showFromValueOnVehicleDetails: Scalars['Boolean']['input'];
  /** Show Insurance Calculator */
  showInsuranceCalculator: Scalars['Boolean']['input'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['input'];
  /** Show Visit Model Page */
  showVisitModelPageButton: Scalars['Boolean']['input'];
  /** Skip for Deposit when continuing application */
  skipForDeposit: Scalars['Boolean']['input'];
  /** Test Drive */
  testDrive: Scalars['Boolean']['input'];
  /** Trade In */
  tradeIn: Scalars['Boolean']['input'];
};

export type FinderApplicationPrivateModule = Module & {
  __typename: 'FinderApplicationPrivateModule';
  /** Agreements module */
  agreementsModule: Module;
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['output'];
  /** Counter for applications */
  applicationCounter: CounterSettings;
  /** Counter for reservations */
  appointmentCounter: CounterSettings;
  /** Appointment Module */
  appointmentModule?: Maybe<Module>;
  /** Appointment Module ID */
  appointmentModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Determine when to show Bank in Calculator */
  bankDisplayPreference: DisplayPreference;
  /** Bank IDs */
  bankIds: Array<Scalars['ObjectID']['output']>;
  /** Bank module */
  bankModule?: Maybe<Module>;
  /** Bank module ID */
  bankModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Banks */
  banks: Array<Bank>;
  /** C@P Module ID */
  capModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: Maybe<Scalars['Boolean']['output']>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Customer module */
  customerModule: Module;
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['output'];
  /** Dealer Finance Products */
  dealerFinanceProducts: Array<DealerFinanceProducts>;
  /** Dealer Insurance Products */
  dealerInsuranceProducts: Array<DealerInsuranceProducts>;
  /** Dealer Vehicles */
  dealerVehicles: Array<DealerVehicles>;
  /** Deposit Amount ( changed the naming due to type conflict with standard application module ) */
  depositPrice?: Maybe<Scalars['Float']['output']>;
  displayAppointmentDatepicker: Scalars['Boolean']['output'];
  /** Show Finance Calculator */
  displayFinanceCalculator: PreferenceValue;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Email contents */
  emailContents: FinderApplicationModuleEmailContents;
  /** Finance Disclaimer */
  financingDisclaimer?: Maybe<DealerDisclaimersConfigurator>;
  /** Financing preference */
  financingPreference: FinancingPreferenceValue;
  finderVehicleConditions: Array<FinderVehicleCondition>;
  /** Flexible Discount */
  flexibleDiscount: FlexibleDiscount;
  /** Has Dealer Options */
  hasDealerOptions: Scalars['Boolean']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /**
   * Include dealer option for financing
   *
   * Only applicable if hasDealerOptions is true
   * When true, dealer option will be included in finance amount
   * When false, dealer option will be included as downpayment and not included in finance amount
   *
   * When hasDealerOptions is false, revert this value to true
   */
  includeDealerOptionsForFinancing: Scalars['Boolean']['output'];
  /** Counter for insurance */
  insuranceCounter: CounterSettings;
  insuranceModule?: Maybe<Module>;
  insuranceModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Determine when to show Insurer in Calculator */
  insurerDisplayPreference: DisplayPreference;
  /** Insurer IDs */
  insurerIds: Array<Scalars['ObjectID']['output']>;
  /** Insurers */
  insurers: Array<Insurer>;
  /** Is Insurance Optional */
  isInsuranceOptional: Scalars['Boolean']['output'];
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['output'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: Maybe<Scalars['Boolean']['output']>;
  /** Trade In Amount visibility */
  isTradeInAmountVisible?: Maybe<Scalars['Boolean']['output']>;
  /** KYC presets */
  kycPresets: Array<KycPreset>;
  /** Defining the campaign ID for C@P lead submission */
  leadCampaignId?: Maybe<Scalars['String']['output']>;
  /** Counter for leads */
  leadCounter: CounterSettings;
  /** Defining the lead medium for C@P lead submission */
  leadMedium?: Maybe<EventMediumType>;
  /** Defining the lead origin for C@P lead submission */
  leadOrigin?: Maybe<EventLeadOriginType>;
  /** Live chat setting */
  liveChatSetting?: Maybe<LiveChatSetting>;
  /** Live chat setting id */
  liveChatSettingId?: Maybe<Scalars['ObjectID']['output']>;
  /** Market */
  market: ApplicationMarket;
  /** Market Type */
  marketType: ApplicationMarketType;
  /** Model Page URL */
  modelPageUrl?: Maybe<Scalars['String']['output']>;
  /** MyInfo Setting */
  myInfoSetting?: Maybe<MyInfoSetting>;
  /** MyInfo Setting ID */
  myInfoSettingId?: Maybe<Scalars['ObjectID']['output']>;
  /** Payment Settings */
  paymentSettings?: Maybe<PaymentSetting>;
  /** Payment Settings ID */
  paymentSettingsId?: Maybe<Scalars['ObjectID']['output']>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  porscheApprovedInfo: TranslatedString;
  /** Price Disclaimer */
  priceDisclaimer: DealerDisclaimersConfigurator;
  /** Promo code module */
  promoCodeModule?: Maybe<Module>;
  /** Promo code module id */
  promoCodeModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Counter for reservations */
  reservationCounter: CounterSettings;
  /** Reservation Instructions */
  reservationInstructions?: Maybe<DealerTranslatedStringSetting>;
  /** Reservation period */
  reservationPeriod: Scalars['Int']['output'];
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show From Value on Vehicle Details in Calculator */
  showFromValueOnVehicleDetails: Scalars['Boolean']['output'];
  /** Show Insurance Calculator */
  showInsuranceCalculator: Scalars['Boolean']['output'];
  /** Show Remote Flow Button in Login Access KYC page */
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['output'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['output'];
  /** Show Visit Model Page */
  showVisitModelPageButton: Scalars['Boolean']['output'];
  /** Skip for Deposit in KYC page */
  skipForDeposit: Scalars['Boolean']['output'];
  /** Test Drive */
  testDrive: Scalars['Boolean']['output'];
  /** Trade In */
  tradeIn: Scalars['Boolean']['output'];
  /** Finder Vehicle management module */
  vehicleModule: Module;
  /** Finder Vehicle management module ID */
  vehicleModuleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: SimpleVersioning;
};

export type FinderApplicationPrivateModuleInitialSettings = {
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['input'];
  /** Counter for applications */
  applicationCounter: CounterPayload;
  /** Counter for appointment */
  appointmentCounter: CounterPayload;
  /** Appointment module ID */
  appointmentModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Determine when to show Bank in Calculator */
  bankDisplayPreference: DisplayPreference;
  /** Banks */
  bankIds: Array<Scalars['ObjectID']['input']>;
  /** Bank module ID */
  bankModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** C@P Module ID */
  capModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['input'];
  /** Deposit Amount ( changed the naming due to type conflict with standard application module ) */
  depositPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Display appointment datepicker */
  displayAppointmentDatepicker: Scalars['Boolean']['input'];
  /** Show Finance Calculator */
  displayFinanceCalculator: PreferenceValue;
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Email contents */
  emailContents: FinderApplicationModuleEmailContentsSetting;
  /** Finance Disclaimer */
  financingDisclaimer?: InputMaybe<DealerDisclaimersConfiguratorInput>;
  /** Financing preference */
  financingPreference: FinancingPreferenceValue;
  finderVehicleConditions: Array<FinderVehicleCondition>;
  /** Flexible Discount */
  flexibleDiscount: FlexibleDiscountInput;
  /** Has Dealer Options */
  hasDealerOptions: Scalars['Boolean']['input'];
  /**
   * Include dealer option for financing
   *
   * Only applicable if hasDealerOptions is true
   * When true, dealer option will be included in finance amount
   * When false, dealer option will be included as downpayment and not included in finance amount
   *
   * When hasDealerOptions is false, revert this value to true
   */
  includeDealerOptionsForFinancing: Scalars['Boolean']['input'];
  /** Counter for insurance */
  insuranceCounter: CounterPayload;
  /** Insurance Module ID */
  insuranceModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Determine when to show Insurer in Calculator */
  insurerDisplayPreference: DisplayPreference;
  /** Insurers */
  insurerIds: Array<Scalars['ObjectID']['input']>;
  /** Is Insurance Optional */
  isInsuranceOptional: Scalars['Boolean']['input'];
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['input'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Trade In Amount visibility */
  isTradeInAmountVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defining the campaign ID for C@P lead submission */
  leadCampaignId?: InputMaybe<Scalars['String']['input']>;
  /** Counter for leads */
  leadCounter: CounterPayload;
  /** Defining the lead medium for C@P lead submission */
  leadMedium?: InputMaybe<EventMediumType>;
  /** Defining the lead origin for C@P lead submission */
  leadOrigin?: InputMaybe<EventLeadOriginType>;
  /** Live chat settings */
  liveChatSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Market */
  market?: InputMaybe<ApplicationMarket>;
  /** Market Type Input */
  marketType?: InputMaybe<ApplicationModuleMarketTypeInput>;
  /** Model Page URL */
  modelPageUrl?: InputMaybe<Scalars['String']['input']>;
  /** MyInfo Setting ID */
  myInfoSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Payment settings ID */
  paymentSettingsId?: InputMaybe<Scalars['ObjectID']['input']>;
  porscheApprovedInfo: TranslatedStringInput;
  /** Price Disclaimer */
  priceDisclaimer: DealerDisclaimersConfiguratorInput;
  /** Promo code module id */
  promoCodeModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Counter for reservations */
  reservationCounter: CounterPayload;
  /** reservationInstructions */
  reservationInstructions?: InputMaybe<DealerTranslatedStringSettingInput>;
  /** Reservation period */
  reservationPeriod: Scalars['Int']['input'];
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show From Value on Vehicle Details in Calculator */
  showFromValueOnVehicleDetails: Scalars['Boolean']['input'];
  /** Show Insurance Calculator */
  showInsuranceCalculator: Scalars['Boolean']['input'];
  /** Show Remote Flow Button in Login Access KYC page */
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['input'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['input'];
  /** Show Visit Model Page */
  showVisitModelPageButton: Scalars['Boolean']['input'];
  /** Skip for Deposit in KYC page */
  skipForDeposit: Scalars['Boolean']['input'];
  /** Test Drive */
  testDrive: Scalars['Boolean']['input'];
  /** Trade In */
  tradeIn: Scalars['Boolean']['input'];
  /** Finder Vehicle management module ID */
  vehicleModuleId: Scalars['ObjectID']['input'];
};

export type FinderApplicationPrivateModuleUpdateSettings = {
  /** Appointment module ID */
  appointmentModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Determine when to show Bank in Calculator */
  bankDisplayPreference: DisplayPreference;
  /** Banks */
  bankIds: Array<Scalars['ObjectID']['input']>;
  /** Bank module id */
  bankModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** C@P Module ID */
  capModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deposit Amount ( changed the naming due to type conflict with standard application module ) */
  depositPrice?: InputMaybe<Scalars['Float']['input']>;
  displayAppointmentDatepicker: Scalars['Boolean']['input'];
  /** Show Finance Calculator */
  displayFinanceCalculator: PreferenceValue;
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Financing preference */
  financingPreference: FinancingPreferenceValue;
  finderVehicleConditions: Array<FinderVehicleCondition>;
  /** Flexible Discount */
  flexibleDiscount: FlexibleDiscountInput;
  /** Has Dealer Options */
  hasDealerOptions: Scalars['Boolean']['input'];
  /**
   * Include dealer option for financing
   *
   * Only applicable if hasDealerOptions is true
   * When true, dealer option will be included in finance amount
   * When false, dealer option will be included as downpayment and not included in finance amount
   *
   * When hasDealerOptions is false, revert this value to true
   */
  includeDealerOptionsForFinancing: Scalars['Boolean']['input'];
  /** Insurance Module ID */
  insuranceModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Determine when to show Insurer in Calculator */
  insurerDisplayPreference: DisplayPreference;
  /** Insurers */
  insurerIds: Array<Scalars['ObjectID']['input']>;
  /** Is Insurance Optional */
  isInsuranceOptional: Scalars['Boolean']['input'];
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['input'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: InputMaybe<Scalars['Boolean']['input']>;
  /** Trade In Amount visibility */
  isTradeInAmountVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defining the campaign ID for C@P lead submission */
  leadCampaignId?: InputMaybe<Scalars['String']['input']>;
  /** Defining the lead medium for C@P lead submission */
  leadMedium?: InputMaybe<EventMediumType>;
  /** Defining the lead origin for C@P lead submission */
  leadOrigin?: InputMaybe<EventLeadOriginType>;
  /** Live chat settings */
  liveChatSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Market */
  market: ApplicationMarket;
  /** Market Type Input */
  marketType?: InputMaybe<ApplicationModuleMarketTypeInput>;
  /** Model Page URL */
  modelPageUrl?: InputMaybe<Scalars['String']['input']>;
  /** MyInfo Setting ID */
  myInfoSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Payment Setting ID */
  paymentSettingsId?: InputMaybe<Scalars['ObjectID']['input']>;
  porscheApprovedInfo: TranslatedStringInput;
  /** Price Disclaimer */
  priceDisclaimer: DealerDisclaimersConfiguratorInput;
  /** Promo code module id */
  promoCodeModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** reservationInstructions */
  reservationInstructions?: InputMaybe<DealerTranslatedStringSettingInput>;
  /** Reservation period */
  reservationPeriod: Scalars['Int']['input'];
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show From Value on Vehicle Details in Calculator */
  showFromValueOnVehicleDetails: Scalars['Boolean']['input'];
  /** Show Insurance Calculator */
  showInsuranceCalculator: Scalars['Boolean']['input'];
  /** Show Remote Flow Button in Login Access KYC page */
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['input'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['input'];
  /** Show Visit Model Page */
  showVisitModelPageButton: Scalars['Boolean']['input'];
  /** Skip for Deposit in KYC page */
  skipForDeposit: Scalars['Boolean']['input'];
  /** Test Drive */
  testDrive: Scalars['Boolean']['input'];
  /** Trade In */
  tradeIn: Scalars['Boolean']['input'];
};

export type FinderApplicationPublicAccessEntrypoint = Endpoint & {
  __typename: 'FinderApplicationPublicAccessEntrypoint';
  /** Application Stage */
  applicationStage: ApplicationStage;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** Finder Application Module ID */
  finderApplicationModuleIds: Array<Scalars['ObjectID']['output']>;
  /** Finder Application Module */
  finderApplicationModules: Array<FinderApplicationPublicModule>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Pathname */
  pathname: Scalars['String']['output'];
};

export type FinderApplicationPublicAccessEntrypointSettings = {
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** Pathname */
  pathname: Scalars['String']['input'];
};

export type FinderApplicationPublicModule = Module & {
  __typename: 'FinderApplicationPublicModule';
  /** Agreements module */
  agreementsModule: Module;
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['output'];
  /** Counter for applications */
  applicationCounter: CounterSettings;
  /** Counter for reservations */
  appointmentCounter: CounterSettings;
  /** Appointment Module */
  appointmentModule?: Maybe<Module>;
  /** Appointment Module ID */
  appointmentModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Sale person */
  assignee: DealershipPublicSalesPerson;
  /** Determine when to show Bank in Calculator */
  bankDisplayPreference: DisplayPreference;
  /** Bank IDs */
  bankIds: Array<Scalars['ObjectID']['output']>;
  /** Bank module */
  bankModule?: Maybe<Module>;
  /** Bank module ID */
  bankModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Banks */
  banks: Array<Bank>;
  /** C@P Module ID */
  capModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: Maybe<Scalars['Boolean']['output']>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Customer module */
  customerModule: Module;
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['output'];
  /** Dealer Finance Products */
  dealerFinanceProducts: Array<DealerFinanceProducts>;
  /** Dealer Insurance Products */
  dealerInsuranceProducts: Array<DealerInsuranceProducts>;
  /** Dealer Vehicles */
  dealerVehicles: Array<DealerVehicles>;
  /** Deposit Amount ( changed the naming due to type conflict with standard application module ) */
  depositPrice?: Maybe<Scalars['Float']['output']>;
  displayAppointmentDatepicker: Scalars['Boolean']['output'];
  /** Show Finance Calculator */
  displayFinanceCalculator: PreferenceValue;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Email contents */
  emailContents: FinderApplicationModuleEmailContents;
  /** Finance Disclaimer */
  financingDisclaimer?: Maybe<DealerDisclaimersConfigurator>;
  /** Financing preference */
  financingPreference: FinancingPreferenceValue;
  finderVehicleConditions: Array<FinderVehicleCondition>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Counter for insurance */
  insuranceCounter: CounterSettings;
  insuranceModule?: Maybe<Module>;
  insuranceModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Determine when to show Insurer in Calculator */
  insurerDisplayPreference: DisplayPreference;
  /** Insurer IDs */
  insurerIds: Array<Scalars['ObjectID']['output']>;
  /** Insurers */
  insurers: Array<Insurer>;
  /** Is Insurance Optional */
  isInsuranceOptional: Scalars['Boolean']['output'];
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['output'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: Maybe<Scalars['Boolean']['output']>;
  /** Trade In Amount visibility */
  isTradeInAmountVisible?: Maybe<Scalars['Boolean']['output']>;
  /** KYC presets */
  kycPresets: Array<KycPreset>;
  /** Defining the campaign ID for C@P lead submission */
  leadCampaignId?: Maybe<Scalars['String']['output']>;
  /** Counter for leads */
  leadCounter: CounterSettings;
  /** Defining the lead medium for C@P lead submission */
  leadMedium?: Maybe<EventMediumType>;
  /** Defining the lead origin for C@P lead submission */
  leadOrigin?: Maybe<EventLeadOriginType>;
  /** Live chat setting */
  liveChatSetting?: Maybe<LiveChatSetting>;
  /** Live chat setting id */
  liveChatSettingId?: Maybe<Scalars['ObjectID']['output']>;
  /** Market */
  market: ApplicationMarket;
  /** Market Type */
  marketType: ApplicationMarketType;
  /** Model Page URL */
  modelPageUrl?: Maybe<Scalars['String']['output']>;
  /** MyInfo Setting */
  myInfoSetting?: Maybe<MyInfoSetting>;
  /** MyInfo Setting ID */
  myInfoSettingId?: Maybe<Scalars['ObjectID']['output']>;
  /** Payment Settings */
  paymentSettings?: Maybe<PaymentSetting>;
  /** Payment Settings ID */
  paymentSettingsId?: Maybe<Scalars['ObjectID']['output']>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  porscheApprovedInfo: TranslatedString;
  /** Price Disclaimer */
  priceDisclaimer: DealerDisclaimersConfigurator;
  /** Promo code module */
  promoCodeModule?: Maybe<Module>;
  /** Promo code module id */
  promoCodeModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Counter for reservations */
  reservationCounter: CounterSettings;
  /** Reservation Instructions */
  reservationInstructions?: Maybe<DealerTranslatedStringSetting>;
  /** Reservation period */
  reservationPeriod: Scalars['Int']['output'];
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show From Value on Vehicle Details in Calculator */
  showFromValueOnVehicleDetails: Scalars['Boolean']['output'];
  /** Show Insurance Calculator */
  showInsuranceCalculator: Scalars['Boolean']['output'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['output'];
  /** Show Visit Model Page */
  showVisitModelPageButton: Scalars['Boolean']['output'];
  /** Skip for Deposit when continuing application */
  skipForDeposit: Scalars['Boolean']['output'];
  /** Test Drive */
  testDrive: Scalars['Boolean']['output'];
  /** Trade In */
  tradeIn: Scalars['Boolean']['output'];
  /** Finder Vehicle management module */
  vehicleModule: Module;
  /** Finder Vehicle management module ID */
  vehicleModuleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: SimpleVersioning;
};

export type FinderRestrictedValuePayload = {
  maxTerm: Scalars['Int']['input'];
};

export type FinderVehicle = Vehicle & {
  __typename: 'FinderVehicle';
  /** Finder Vehicle autoplay */
  autoplay?: Maybe<FinderVehicleAutoplay>;
  /** Finance Product Suite Ids assigned to this Finder Vehicle */
  financeProductSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Finance Products assigned to this Finder Vehicle */
  financeProducts: Array<FinanceProduct>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /**
   * Identifier
   *
   * Point to finder inventory ID: listing/id
   */
  identifier: Scalars['String']['output'];
  /**
   * Is active
   *
   * Will point to status = Available, other status return false
   */
  isActive: Scalars['Boolean']['output'];
  /**
   * Is deletable
   *
   * Resolver will return false, as it's synchronized with finder service
   */
  isDeletable: Scalars['Boolean']['output'];
  /**
   * Is deleted
   *
   * Soft deletion
   */
  isDeleted: Scalars['Boolean']['output'];
  /** Is LTA Uploaded */
  isLTAUploaded?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Finder vehicle listing
   * Is remote determines whether to get listing data from remote or locally
   */
  listing: Listing;
  /** LTA data */
  lta?: Maybe<LtaIntegration>;
  /**
   * Module details
   *
   * Resolver from module ID
   */
  module: Module;
  /**
   * Module ID
   *
   * Which should point to Finder Vehicle Management
   */
  moduleId: Scalars['ObjectID']['output'];
  /** Monthly Payment */
  monthlyInstalment?: Maybe<Scalars['Float']['output']>;
  /**
   * Name
   *
   * Resolver to listing/vehicle/name/localize
   */
  name: TranslatedString;
  /**
   * Order number
   *
   * Resolver to constant value, just to match Vehicle Interface
   */
  order: Scalars['Int']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Finder vehicle configurable setting */
  setting: FinderVehicleSetting;
  /** Availability status */
  status: FinderVehicleStatus;
  /** URL of porsche finder */
  url: Scalars['String']['output'];
  /** Versioning */
  versioning: AdvancedVersioning;
};


export type FinderVehicleListingArgs = {
  isRemote?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinderVehicleMonthlyInstalmentArgs = {
  applicationModuleIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  bankModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FinderVehicleAutoplay = {
  __typename: 'FinderVehicleAutoplay';
  /**
   * Last updated synchronization
   *
   * If it's different with _versioning.updatedAt, then Autoplay API will be called
   * and `lastUpdated` will be set the same with `_versioning.updatedAt
   */
  lastUpdated: Scalars['DateTime']['output'];
  /** Listing id from autoplay API response, optional so when it being removed, it will be set to undefined */
  listingId?: Maybe<Scalars['Int']['output']>;
};

export enum FinderVehicleCondition {
  /** Specific to new vehicle conditions in Finder */
  New = 'New',
  /** Specific to Porsche Approved vehicle conditions in Finder */
  PorscheApproved = 'PorscheApproved',
  /** Specific to Preowned vehicle conditions in Finder */
  Preowned = 'Preowned'
}

export type FinderVehicleFilters = {
  __typename: 'FinderVehicleFilters';
  /** Car Conditions */
  conditions?: Maybe<Array<Maybe<FinderVehicleCondition>>>;
  /** Car Model Categories */
  modelCategories: Array<Scalars['String']['output']>;
  /** Monthly Instalments */
  monthlyInstalments: Array<RangeAmount>;
};

export enum FinderVehicleFunctionality {
  /** Only for one time flow, unless it got resetted later on */
  OneTime = 'OneTime',
  /** Vehicle become permanently available, even after several flow submission */
  Permanent = 'Permanent'
}

export type FinderVehicleLtaIntegrationPayload = {
  arf: Scalars['Float']['input'];
  chassisNumber?: InputMaybe<Scalars['String']['input']>;
  coe?: InputMaybe<Scalars['Float']['input']>;
  coeCategory?: InputMaybe<LtaCoeCategory>;
  coeExpiryDate: Scalars['DateTime']['input'];
  coePeriod?: InputMaybe<Scalars['Float']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  engineNumber?: InputMaybe<Scalars['String']['input']>;
  firstRegistrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  omv: Scalars['Float']['input'];
  originalRegistrationDate: Scalars['DateTime']['input'];
  ownerId: Scalars['String']['input'];
  ownerIdType: LtaPreOwnerIdType;
  parfEligibilityExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  parfRebateAmount?: InputMaybe<Scalars['Float']['input']>;
  power?: InputMaybe<Scalars['Float']['input']>;
  pqp?: InputMaybe<Scalars['Float']['input']>;
  registrationNumber: Scalars['String']['input'];
  transfers?: InputMaybe<Scalars['Int']['input']>;
  yearOfManufacture?: InputMaybe<Scalars['String']['input']>;
};

export type FinderVehicleManagementModule = Module & {
  __typename: 'FinderVehicleManagementModule';
  /** Autoplay Setting ID */
  autoplaySettingId?: Maybe<Scalars['ObjectID']['output']>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Settings */
  setting: FinderVehicleManagementSetting;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type FinderVehicleManagementModuleSetting = {
  /** Allow LTA */
  allowLTA: Scalars['Boolean']['input'];
  /** Autoplay setting ID */
  autoplaySettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Secrets data */
  secrets: FinderVehicleManagementModuleSettingSecret;
};

export type FinderVehicleManagementModuleSettingSecret = {
  /** API Endpoint */
  apiEndpoint: Scalars['String']['input'];
  /** API Key */
  apiKey: Scalars['String']['input'];
  /** Finder URL */
  finderUrl: Scalars['String']['input'];
  /** Login endpoint */
  loginEndpoint: Scalars['String']['input'];
  /** Secret key */
  secretKey: Scalars['String']['input'];
};

export type FinderVehicleManagementSecret = {
  __typename: 'FinderVehicleManagementSecret';
  /** API Endpoint */
  apiEndpoint: Scalars['String']['output'];
  /** API Key */
  apiKey: Scalars['String']['output'];
  /** Finder URL */
  finderUrl: Scalars['String']['output'];
  /** Login endpoint */
  loginEndpoint: Scalars['String']['output'];
  /** Secret key */
  secretKey: Scalars['String']['output'];
};

export type FinderVehicleManagementSetting = {
  __typename: 'FinderVehicleManagementSetting';
  /** Allow LTA */
  allowLTA: Scalars['Boolean']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Reference to finder vehicle management */
  moduleId: Scalars['ObjectID']['output'];
  /** Secrets */
  secrets: FinderVehicleManagementSecret;
};

export type FinderVehiclePayload = {
  isLTAUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  lta?: InputMaybe<FinderVehicleLtaIntegrationPayload>;
  setting: FinderVehicleSettings;
};

export type FinderVehicleReferenceParameters = {
  __typename: 'FinderVehicleReferenceParameters';
  conditions: Array<FinderVehicleCondition>;
  engineType: Array<EngineType>;
  isAddOnSpecificVehicles: Scalars['Boolean']['output'];
  mileage?: Maybe<OptionalRangeValue>;
  modelYear?: Maybe<OptionalRangeValue>;
  variants?: Maybe<Array<Scalars['String']['output']>>;
};

export type FinderVehicleReferenceParametersPayload = {
  conditions: Array<FinderVehicleCondition>;
  engineType: Array<EngineType>;
  isAddOnSpecificVehicles: Scalars['Boolean']['input'];
  mileage?: InputMaybe<OptionalRangeValuePayload>;
  modelYear?: InputMaybe<OptionalRangeValuePayload>;
  variants?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FinderVehicleSetting = {
  __typename: 'FinderVehicleSetting';
  /** Button function */
  functionality: FinderVehicleFunctionality;
  /** Is inspected by dealer */
  isInspected: Scalars['Boolean']['output'];
  /**
   * Button state
   *
   * One factors to determine "Reserved Now" button is "hidden" in porsche finder page or not
   */
  isStateHidden: Scalars['Boolean']['output'];
  /** Is Test Drive Button */
  isTestDriveButtonHidden: Scalars['Boolean']['output'];
};

export type FinderVehicleSettings = {
  functionality: FinderVehicleFunctionality;
  isInspected: Scalars['Boolean']['input'];
  isStateHidden: Scalars['Boolean']['input'];
  isTestDriveButtonHidden: Scalars['Boolean']['input'];
};

export enum FinderVehicleSortingField {
  Company = 'Company',
  Condition = 'Condition',
  DealerName = 'DealerName',
  ExteriorColor = 'ExteriorColor',
  Functionality = 'Functionality',
  HasLta = 'HasLta',
  InventoryId = 'InventoryId',
  IsInspected = 'IsInspected',
  IsStateHidden = 'IsStateHidden',
  Name = 'Name',
  Price = 'Price',
  Status = 'Status',
  VehicleId = 'VehicleId'
}

export type FinderVehicleSortingRule = {
  /** Field on which apply the sorting */
  field: FinderVehicleSortingField;
  /** Sorting order */
  order: SortingOrder;
};

/** Should be match with porsche finder service availability status */
export enum FinderVehicleStatus {
  Available = 'Available',
  Reserved = 'Reserved',
  Submitted = 'Submitted'
}

export enum FinderVehicleSyncStatus {
  /** Currently there is no synchronization in-process */
  Idle = 'Idle',
  /** There is synchronization in-process */
  Running = 'Running'
}

export type FiservPaymentModule = Module & {
  __typename: 'FiservPaymentModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Payment Settings */
  paymentSettings: Array<FiservPaymentSetting>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type FiservPaymentModuleSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
};

export type FiservPaymentRedirectionLink = {
  __typename: 'FiservPaymentRedirectionLink';
  path: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type FiservPaymentSetting = PaymentSetting & {
  __typename: 'FiservPaymentSetting';
  /** Amount */
  amount: Scalars['Float']['output'];
  /** Currency */
  currency: Scalars['String']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Payment Endpoint */
  paymentEndpoint: Scalars['String']['output'];
  /** Payment module ID */
  paymentModuleId: Scalars['ObjectID']['output'];
  /** Store Name */
  storeName: Scalars['String']['output'];
};

export type FiservPaymentSettingsInput = {
  /** Amount */
  amount: Scalars['Float']['input'];
  /** Currency */
  currency: Scalars['String']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Payment Endpoint */
  paymentEndpoint: Scalars['String']['input'];
  /** Secret Key */
  secretKey: Scalars['String']['input'];
  /** Store Name */
  storeName: Scalars['String']['input'];
};

export type FiservPaymentUpdateSettingsInput = {
  /** Amount */
  amount: Scalars['Float']['input'];
  /** Currency */
  currency: Scalars['String']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Payment Endpoint */
  paymentEndpoint: Scalars['String']['input'];
  /** Secret Key */
  secretKey?: InputMaybe<Scalars['String']['input']>;
  /** Store Name */
  storeName: Scalars['String']['input'];
};

export type FlexibleDiscount = {
  __typename: 'FlexibleDiscount';
  isEnabled: Scalars['Boolean']['output'];
};

export type FlexibleDiscountInput = {
  isEnabled: Scalars['Boolean']['input'];
};

export type FormattedDate = {
  __typename: 'FormattedDate';
  localize: Scalars['String']['output'];
  value: Scalars['DateTime']['output'];
};


export type FormattedDateLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type GeneratedOtpResult = {
  __typename: 'GeneratedOTPResult';
  expiredAt: Scalars['DateTime']['output'];
};

export type GenericPrincipalTermSettings = TermSettings & {
  __typename: 'GenericPrincipalTermSettings';
  default: Scalars['Int']['output'];
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  step: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type GetFinanceProductsFilteringRule = {
  moduleId: Scalars['ObjectID']['input'];
};

export type GetInsuranceProductsFilteringRule = {
  moduleId: Scalars['ObjectID']['input'];
};

export type GiftPromoType = PromoType & {
  __typename: 'GiftPromoType';
  description: Scalars['String']['output'];
  type: PromoTypeEnum;
};

export type GiftPromoTypeInput = {
  description: Scalars['String']['input'];
};

export type GiftVoucher = {
  __typename: 'GiftVoucher';
  application?: Maybe<MobilityApplication>;
  dealer?: Maybe<Dealer>;
  /** Deposit */
  deposit?: Maybe<ApplicationDeposit>;
  /** Application Document */
  documents: Array<ApplicationDocument>;
  draftFlow: GiftVoucherDraftFlow;
  /** Journey expiration time */
  expireAt?: Maybe<Scalars['DateTime']['output']>;
  giftCode: Scalars['String']['output'];
  giftee?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  mobilityModule: Module;
  mobilityModuleId: Scalars['ObjectID']['output'];
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  numberOfBookingReferenceDays?: Maybe<Scalars['Int']['output']>;
  purchasedDate?: Maybe<Scalars['DateTime']['output']>;
  purchaser?: Maybe<Customer>;
  purchaserAgreements: Array<ApplicationAgreement>;
  purchaserFullName?: Maybe<Scalars['String']['output']>;
  purchaserId?: Maybe<Scalars['ObjectID']['output']>;
  purchaserKYC: Array<KycField>;
  status: GiftVoucherStatus;
  stock?: Maybe<StockInventory>;
  value: Scalars['Float']['output'];
  vehicle: Vehicle;
  vehicleId: Scalars['ObjectID']['output'];
  versioning: AdvancedVersioning;
};

export type GiftVoucherAdyenRedirectionLink = {
  __typename: 'GiftVoucherAdyenRedirectionLink';
  path: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type GiftVoucherCondition = Condition & {
  __typename: 'GiftVoucherCondition';
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  type: ConditionType;
};

export type GiftVoucherConditionSettings = {
  moduleId: Scalars['ObjectID']['input'];
};

export type GiftVoucherDraftFlow = {
  __typename: 'GiftVoucherDraftFlow';
  /** Is the purchaser agreements completed */
  areAgreementsCompleted: Scalars['Boolean']['output'];
  /** Is the purchaser KYCs completed */
  areKYCsCompleted: Scalars['Boolean']['output'];
  /** Is the purchaser payment agreements completed */
  arePaymentAgreementsCompleted: Scalars['Boolean']['output'];
  /** Is the purchaser payment deposit completed */
  isDepositCompleted?: Maybe<Scalars['Boolean']['output']>;
  isReceived: Scalars['Boolean']['output'];
};

export type GiftVoucherFilter = {
  __typename: 'GiftVoucherFilter';
  /** Filter by gift voucher company */
  companies?: Maybe<Array<Company>>;
  /** Filter by gift voucher module */
  modules?: Maybe<Array<Module>>;
  /** Filter by gift voucher status */
  statuses: Array<GiftVoucherStatus>;
};

export type GiftVoucherFilteringRule = {
  /** Filter by multiple company IDs */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by gift code */
  giftCode?: InputMaybe<Scalars['String']['input']>;
  /** Filter by giftee name */
  gifteeName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by purchaser name */
  purchaserName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by statuses */
  status?: InputMaybe<Array<InputMaybe<GiftVoucherStatus>>>;
};

export type GiftVoucherFiservPaymentRedirectionLink = {
  __typename: 'GiftVoucherFiservPaymentRedirectionLink';
  path: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type GiftVoucherJourneyContext = {
  __typename: 'GiftVoucherJourneyContext';
  giftVoucher: GiftVoucher;
  token: Scalars['String']['output'];
};

export type GiftVoucherModule = Module & {
  __typename: 'GiftVoucherModule';
  /** Agreements module */
  agreementsModule: Module;
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['output'];
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Customer module */
  customerModule: Module;
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Email Contents */
  emailContents: GiftVoucherModuleEmailContent;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Payment Settings */
  paymentSettings?: Maybe<PaymentSetting>;
  /** Payment Settings ID */
  paymentSettingsId?: Maybe<Scalars['ObjectID']['output']>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export enum GiftVoucherModuleAsset {
  CustomerConfirmation = 'CustomerConfirmation'
}

export type GiftVoucherModuleCustomerEmail = {
  __typename: 'GiftVoucherModuleCustomerEmail';
  confirmation?: Maybe<GiftVoucherModuleEmailContext>;
};

export type GiftVoucherModuleEmailContent = {
  __typename: 'GiftVoucherModuleEmailContent';
  customer: GiftVoucherModuleCustomerEmail;
  salesPerson: GiftVoucherModuleSalespersonEmail;
};

export type GiftVoucherModuleEmailContentCustomerInput = {
  confirmation: GiftVoucherModuleEmailContentInput;
};

export type GiftVoucherModuleEmailContentInput = {
  contentText: DealerTranslatedStringSettingInput;
  introTitle: DealerTranslatedStringSettingInput;
  subject: DealerTranslatedStringSettingInput;
};

export type GiftVoucherModuleEmailContentSalesPersonInput = {
  confirmation: GiftVoucherModuleEmailContentInput;
};

export type GiftVoucherModuleEmailContentsInput = {
  customer: GiftVoucherModuleEmailContentCustomerInput;
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentUpdateType: EmailContentUpdateType;
};

export type GiftVoucherModuleEmailContext = {
  __typename: 'GiftVoucherModuleEmailContext';
  contentText: DealerTranslatedStringSetting;
  introImage?: Maybe<UploadedFileWithPreview>;
  introTitle: DealerTranslatedStringSetting;
  subject: DealerTranslatedStringSetting;
};

export type GiftVoucherModuleInitialSettings = {
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['input'];
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Payment settings ID */
  paymentSettingsId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type GiftVoucherModuleSalespersonEmail = {
  __typename: 'GiftVoucherModuleSalespersonEmail';
  confirmation?: Maybe<GiftVoucherModuleEmailContext>;
};

export type GiftVoucherModuleUpdateSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Payment settings ID */
  paymentSettingsId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type GiftVoucherPayGatePaymentRedirectionLink = {
  __typename: 'GiftVoucherPayGatePaymentRedirectionLink';
  path: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type GiftVoucherPorschePaymentRedirectionLink = {
  __typename: 'GiftVoucherPorschePaymentRedirectionLink';
  path: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export enum GiftVoucherSortingField {
  Company = 'Company',
  GiftCode = 'GiftCode',
  GiftVoucherStatus = 'GiftVoucherStatus',
  Giftee = 'Giftee',
  PurchasedDate = 'PurchasedDate',
  Purchaser = 'Purchaser',
  Value = 'Value'
}

export type GiftVoucherSortingRule = {
  /** Field on which apply the sorting */
  field: GiftVoucherSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export enum GiftVoucherStatus {
  ApplicantDetailsReceived = 'ApplicantDetailsReceived',
  Expired = 'Expired',
  PaymentCompleted = 'PaymentCompleted',
  PaymentFailed = 'PaymentFailed',
  PaymentPending = 'PaymentPending',
  PaymentReceived = 'PaymentReceived',
  PaymentTimeout = 'PaymentTimeout',
  Unused = 'Unused',
  Used = 'Used'
}

export type GiftVoucherTtbPaymentRedirectionLink = {
  __typename: 'GiftVoucherTtbPaymentRedirectionLink';
  path: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type Guarantor = {
  __typename: 'Guarantor';
  /** Email */
  email: Scalars['String']['output'];
  /** Local Customer Fields Array */
  fields: Array<LocalCustomerField>;
  /** Full Name */
  fullName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Masking */
  isMaskingCustomerData?: Maybe<Scalars['Boolean']['output']>;
  /** Customer kind */
  kind: CustomerKind;
  /** KYC Presets */
  kycPresets: Array<KycField>;
  /** Latest application */
  latestApplication: Application;
  /** Module */
  module: Module;
  /** Module Id */
  moduleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: AdvancedVersioning;
};

export type HlfNewCarFinance = SdmFinancing & {
  __typename: 'HLFNewCarFinance';
  bank: Scalars['String']['output'];
  downPayment?: Maybe<Scalars['Float']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  tenure: Scalars['Int']['output'];
  type: FinanceType;
};

export type HlfUsedCarFinance = SdmFinancing & {
  __typename: 'HLFUsedCarFinance';
  bank: Scalars['String']['output'];
  coeExpiryDate: Scalars['DateTime']['output'];
  downPayment?: Maybe<Scalars['Float']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  tenure: Scalars['Int']['output'];
  type: FinanceType;
};

export type Hitcount = {
  __typename: 'Hitcount';
  key: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Hitcounts = {
  __typename: 'Hitcounts';
  accidentFree: Array<Hitcount>;
  audioCommunicationEquipment: Array<Hitcount>;
  bodyType: Array<Hitcount>;
  comfortAssistanceEquipment: Array<Hitcount>;
  driveSide: Array<Hitcount>;
  drivetrain: Array<Hitcount>;
  ePerformanceEquipment: Array<Hitcount>;
  engineType: Array<Hitcount>;
  exteriorColorGroup: Array<Hitcount>;
  exteriorEquipment: Array<Hitcount>;
  financingProductType: Array<Hitcount>;
  firstRegistrationDate: Array<Hitcount>;
  interiorColorGroup: Array<Hitcount>;
  interiorEquipment: Array<Hitcount>;
  interiorMaterial: Array<Hitcount>;
  maximumPowerHP: Array<Hitcount>;
  maximumPowerKW: Array<Hitcount>;
  mileage: Array<Hitcount>;
  minimumPowerHP: Array<Hitcount>;
  minimumPowerKW: Array<Hitcount>;
  modelCategory: Array<Hitcount>;
  modelGeneration: Array<Hitcount>;
  modelSeries: Array<Hitcount>;
  modelYear: Array<Hitcount>;
  numberOfPreviousOwners: Array<Hitcount>;
  optionPackage: Array<Hitcount>;
  performanceEquipment: Array<Hitcount>;
  radius: Array<Hitcount>;
  rooftopColorGroup: Array<Hitcount>;
  sales: Array<Hitcount>;
  salesIncentives: Array<Hitcount>;
  seller: Array<Hitcount>;
  transmission: Array<Hitcount>;
  vatDeductible: Array<Hitcount>;
  vehicleType: Array<Hitcount>;
  video: Array<Hitcount>;
  wheelSizeEquipment: Array<Hitcount>;
};

export type HlfBankIntegration = BankIntegration & {
  __typename: 'HlfBankIntegration';
  allowedIps: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  cancellationPartial: Scalars['String']['output'];
  dealerCode?: Maybe<Scalars['String']['output']>;
  editionPartial: Scalars['String']['output'];
  privateKey: Scalars['String']['output'];
  provider: BankIntegrationProvider;
  publicCert: Scalars['String']['output'];
  reassignPartial: Scalars['String']['output'];
  submissionPartial: Scalars['String']['output'];
};

export type HlfBankIntegrationSettings = {
  allowedIps: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  cancellationPartial: Scalars['String']['input'];
  dealerCode?: InputMaybe<Scalars['String']['input']>;
  editionPartial: Scalars['String']['input'];
  privateKey: Scalars['String']['input'];
  publicCert: Scalars['String']['input'];
  reassignPartial: Scalars['String']['input'];
  submissionPartial: Scalars['String']['input'];
};

export type HlfBankV2Integration = BankIntegration & {
  __typename: 'HlfBankV2Integration';
  allowedIps: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  cancellationPartial: Scalars['String']['output'];
  dealerCode?: Maybe<Scalars['String']['output']>;
  editionPartial: Scalars['String']['output'];
  privateKey: Scalars['String']['output'];
  provider: BankIntegrationProvider;
  publicCert: Scalars['String']['output'];
  reassignPartial: Scalars['String']['output'];
  submissionPartial: Scalars['String']['output'];
};

export type HlfBankV2IntegrationSettings = {
  allowedIps: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
  cancellationPartial: Scalars['String']['input'];
  dealerCode: Scalars['String']['input'];
  editionPartial: Scalars['String']['input'];
  privateKey: Scalars['String']['input'];
  publicCert: Scalars['String']['input'];
  reassignPartial: Scalars['String']['input'];
  submissionPartial: Scalars['String']['input'];
};

export type HomeDeliveryFilteringRule = {
  agreementModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  customerModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum HomeDeliverySortingField {
  Name = 'Name'
}

export type HomeDeliverySortingRule = {
  /** Field on which apply the sorting */
  field: LocationSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type ICurrencyType = {
  currencyCode?: Maybe<Scalars['String']['output']>;
  localize?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};


export type ICurrencyTypeLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type ILocalizedValue = {
  localize?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};


export type ILocalizedValueLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type ImageDescription = {
  __typename: 'ImageDescription';
  description?: Maybe<TranslatedString>;
  icon?: Maybe<UploadedFileWithPreview>;
  id: Scalars['ObjectID']['output'];
  title?: Maybe<TranslatedString>;
};

export type ImageDescriptionWebPageBlockInput = {
  description?: InputMaybe<TranslatedStringInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  title?: InputMaybe<TranslatedStringInput>;
};

export type ImageWebPageBlock = WebPageBlock & {
  __typename: 'ImageWebPageBlock';
  button?: Maybe<WebPageButton>;
  descriptions: Array<ImageDescription>;
  id: Scalars['ObjectID']['output'];
  image?: Maybe<UploadedFileWithPreview>;
  title?: Maybe<TranslatedString>;
  type: WebPageBlockType;
};

export type ImageWebPageBlockInput = {
  button?: InputMaybe<WebPageButtonInput>;
  descriptions: Array<ImageDescriptionWebPageBlockInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  title?: InputMaybe<TranslatedStringInput>;
  type: WebPageBlockType;
};

export type ImportAudiFinancingSalesPersonCodeMappingsResponse = {
  __typename: 'ImportAudiFinancingSalesPersonCodeMappingsResponse';
  current: Array<SalesPersonCodeMapping>;
  duplicateIds: Array<Scalars['String']['output']>;
  updateCount: Scalars['Int']['output'];
};

export type ImportExcel = {
  __typename: 'ImportExcel';
  duplicateIds: Array<Scalars['String']['output']>;
  templateList: Array<Template>;
  updateCount: Scalars['Int']['output'];
  vehicleModules: Array<SimpleVehicleManagementModule>;
};

export type ImportInventoryFail = {
  __typename: 'ImportInventoryFail';
  message: Scalars['String']['output'];
};

export type ImportInventoryResponse = ImportInventoryFail | ImportInventorySuccess;

export type ImportInventorySuccess = {
  __typename: 'ImportInventorySuccess';
  updatedCount: Scalars['Int']['output'];
};

export type ImportSdmSalesPersonCodeMappingsResponse = {
  __typename: 'ImportSdmSalesPersonCodeMappingsResponse';
  current: Array<SalesPersonCodeMapping>;
  duplicateIds: Array<Scalars['String']['output']>;
  updateCount: Scalars['Int']['output'];
};

export enum ImportStatus {
  Fail = 'Fail',
  Success = 'Success'
}

/** Generic import excel response */
export type ImportedExcel = {
  __typename: 'ImportedExcel';
  message?: Maybe<Scalars['String']['output']>;
  status: ImportStatus;
  updatedCount: Scalars['Int']['output'];
};

export enum IncomeType {
  Salaried = 'Salaried',
  SelfEmployed = 'SelfEmployed'
}

export type InstantApprovalStatisticFilterPayload = {
  /** Filter for companyId */
  companyId: Scalars['ObjectID']['input'];
};

export type InsuranceFeeSettingPayload = {
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
  table: Array<InsuranceFeeTableValuesPayload>;
  vehicleFilterParameterTable: Array<InsuranceFeeTableValuesForVehicleParameterPayload>;
};

export type InsuranceFeeSettings = {
  __typename: 'InsuranceFeeSettings';
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  table: Array<InsuranceFeeTableValues>;
  vehicleFilterParameterTable: Array<InsuranceFeeTableValuesForVehicleParameterFilter>;
};

export type InsuranceFeeTableValues = {
  __typename: 'InsuranceFeeTableValues';
  value: Scalars['Float']['output'];
  variantSuiteId: Scalars['ObjectID']['output'];
};

export type InsuranceFeeTableValuesForVehicleParameterFilter = {
  __typename: 'InsuranceFeeTableValuesForVehicleParameterFilter';
  type: VehicleKind;
  value: Scalars['Float']['output'];
};

export type InsuranceFeeTableValuesForVehicleParameterPayload = {
  type: VehicleKind;
  value: Scalars['Float']['input'];
};

export type InsuranceFeeTableValuesPayload = {
  value: Scalars['Float']['input'];
  variantSuiteId: Scalars['ObjectID']['input'];
};

export type InsuranceModule = Module & {
  __typename: 'InsuranceModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type InsuranceModuleSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
};

export type InsurancePremiumPayload = {
  /** Total price */
  carPrice: Scalars['Float']['input'];
  /** Customer date of birth */
  dateOfBirth: Scalars['DateTime']['input'];
  /**
   * Customer driving experience
   *
   * The value should be chosen from selected options presets
   */
  drivingExperience: Scalars['Int']['input'];
  /** Which insurer id used for calculator */
  insurerId: Scalars['ObjectID']['input'];
  /** Vehicle Model name */
  modelName: Scalars['String']['input'];
  /** Customer No claim discount, in percentage */
  ncd: Scalars['Int']['input'];
  /** Vehicle Original registration date */
  originalRegistrationDate: Scalars['DateTime']['input'];
};

export type InsuranceProduct = {
  __typename: 'InsuranceProduct';
  /** Combined suite ids from variantSuiteIds and vehicleReferenceParameters */
  allVariantSuiteIds: Array<Scalars['ObjectID']['output']>;
  description?: Maybe<TranslatedString>;
  displayName: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  identifier: Scalars['String']['output'];
  insurer: Insurer;
  insurerId: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  kind: InsuranceProductKind;
  legalName: TranslatedString;
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  order: Scalars['Int']['output'];
  period: Period;
  permissions: Array<Maybe<Scalars['String']['output']>>;
  type: InsuranceProductType;
  /** Variant Suite Ids assigned */
  variantSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Variants/Finder Vehicles retrieved from variantSuiteIds and vehicleReferenceParameters */
  variants: Array<Vehicle>;
  /** Vehicle Parameters assignment */
  vehicleReferenceParameters: VehicleReferenceParameters;
  versioning: AdvancedVersioning;
};

export type InsuranceProductFilteringRule = {
  /** Filter by Application module ID */
  applicationModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by multiple company IDs */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by dealer IDs from module */
  dealerIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Insurance Product Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Filter by finance product display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by identifier */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Filter by insurer name */
  insurerName?: InputMaybe<Scalars['String']['input']>;
  /** is the Insurance Product Active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Insurance Product Legal Name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Module ID, Insurance Module */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Period */
  period?: InputMaybe<PeriodPayload>;
  /** Filter Purpose */
  purpose?: InputMaybe<Purpose>;
  /** Filter by variant suite IDs from module */
  variantSuiteIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export enum InsuranceProductKind {
  Local = 'Local'
}

export type InsuranceProductSettings = {
  description?: InputMaybe<TranslatedStringInput>;
  displayName: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  insurerId: Scalars['ObjectID']['input'];
  isActive: Scalars['Boolean']['input'];
  kind: InsuranceProductKind;
  legalName: TranslatedStringInput;
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  order: Scalars['Int']['input'];
  period: PeriodPayload;
  type?: InputMaybe<InsuranceProductType>;
  variantSuiteIds: Array<Scalars['ObjectID']['input']>;
  vehicleReferenceParameters: VehicleReferenceParametersPayload;
};

export enum InsuranceProductSortingField {
  Company = 'Company',
  Description = 'Description',
  DisplayName = 'DisplayName',
  EndDate = 'EndDate',
  Identifier = 'Identifier',
  Insurer = 'Insurer',
  IsActive = 'IsActive',
  LegalName = 'LegalName',
  Order = 'Order',
  Period = 'Period',
  StartDate = 'StartDate',
  Type = 'Type'
}

export type InsuranceProductSortingRule = {
  /** Field on which apply the sorting */
  field: InsuranceProductSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export enum InsuranceProductType {
  Eazy = 'Eazy'
}

export type InsuranceStage = ApplicationStageDetails & {
  __typename: 'InsuranceStage';
  assignee?: Maybe<User>;
  /** Assignee */
  assigneeId?: Maybe<Scalars['ObjectID']['output']>;
  /** Identifier */
  identifier: Scalars['String']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Current status */
  status: ApplicationStatus;
};

export type Insurer = {
  __typename: 'Insurer';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  insuranceDisclaimer?: Maybe<DealerDisclaimersConfigurator>;
  insuranceProductTypes: Array<InsuranceProductType>;
  insuranceProducts: Array<InsuranceProduct>;
  integration: InsurerIntegration;
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  legalName: TranslatedString;
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  order: Scalars['Int']['output'];
  permissions: Array<Maybe<Scalars['String']['output']>>;
  reSubmissionApprovalModule?: Maybe<Module>;
  reSubmissionApprovalModuleId?: Maybe<Scalars['ObjectID']['output']>;
  sendEmailToCustomer: Scalars['Boolean']['output'];
  sendPDFToCustomer: Scalars['Boolean']['output'];
  showCommentsField?: Maybe<Scalars['Boolean']['output']>;
  submissionApprovalModule?: Maybe<Module>;
  submissionApprovalModuleId?: Maybe<Scalars['ObjectID']['output']>;
  versioning: SimpleVersioning;
};

export type InsurerCondition = Condition & {
  __typename: 'InsurerCondition';
  insurer: Insurer;
  insurerId: Scalars['ObjectID']['output'];
  type: ConditionType;
};

export type InsurerConditionsSettings = {
  insurerId: Scalars['ObjectID']['input'];
};

export type InsurerFilteringRule = {
  /** Filter by company display name */
  companyDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by insurer display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by insurer integration providers */
  insurerIntegrationProviders?: InputMaybe<Array<InsurerIntegrationProvider>>;
  /** Filter by module ID */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type InsurerIntegration = {
  provider: InsurerIntegrationProvider;
};

export enum InsurerIntegrationProvider {
  Eazy = 'Eazy',
  Email = 'Email'
}

export type InsurerIntegrationSettings = {
  eazy?: InputMaybe<EazyInsurerIntegrationSettings>;
  email?: InputMaybe<EmailInsurerIntegrationSettings>;
};

export type InsurerSettings = {
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  insuranceDisclaimer?: InputMaybe<DealerDisclaimersConfiguratorInput>;
  insuranceProductTypes: Array<InsuranceProductType>;
  isActive: Scalars['Boolean']['input'];
  legalName: TranslatedStringInput;
  moduleId: Scalars['ObjectID']['input'];
  order: Scalars['Int']['input'];
  reSubmissionApprovalModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  sendEmailToCustomer: Scalars['Boolean']['input'];
  /** Have the option to exclude agreement pdf from email sending to customer */
  sendPDFToCustomer: Scalars['Boolean']['input'];
  showCommentsField?: InputMaybe<Scalars['Boolean']['input']>;
  submissionApprovalModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum InsurerSortingField {
  CompanyDisplayName = 'CompanyDisplayName',
  DisplayName = 'DisplayName',
  Order = 'Order'
}

export type InsurerSortingRule = {
  /** Field on which apply the sorting */
  field: InsurerSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type InterestRateFixedSettings = InterestRateSettings & {
  __typename: 'InterestRateFixedSettings';
  default: Scalars['Float']['output'];
  displayTotalInterestPayable: FieldDisplaySetting;
  isViewable: FieldDisplaySetting;
  type: Scalars['String']['output'];
};

export type InterestRateRangeSettings = InterestRateSettings & {
  __typename: 'InterestRateRangeSettings';
  default: Scalars['Float']['output'];
  displayTotalInterestPayable: FieldDisplaySetting;
  isViewable: FieldDisplaySetting;
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  step: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type InterestRateSettings = {
  displayTotalInterestPayable: FieldDisplaySetting;
  isViewable: FieldDisplaySetting;
  type: Scalars['String']['output'];
};

export type InterestRateSettingsPayload = {
  basedOn?: InputMaybe<InterestRateTableBasedOn>;
  default?: InputMaybe<Scalars['Float']['input']>;
  displayTotalInterestPayable: FieldDisplaySetting;
  isGenerateStepsInTable?: InputMaybe<Scalars['Boolean']['input']>;
  isViewable: FieldDisplaySetting;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  step?: InputMaybe<Scalars['Float']['input']>;
  table?: InputMaybe<Array<InterestRateTableCellPayload>>;
  type: Scalars['String']['input'];
  unit?: InputMaybe<AmountUnit>;
};

export enum InterestRateTableBasedOn {
  DownPayment = 'DownPayment',
  Loan = 'Loan'
}

export type InterestRateTableCell = {
  __typename: 'InterestRateTableCell';
  base: Scalars['Float']['output'];
  term: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type InterestRateTableCellPayload = {
  base: Scalars['Float']['input'];
  term: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
};

export type InterestRateTableSettings = InterestRateSettings & {
  __typename: 'InterestRateTableSettings';
  basedOn: InterestRateTableBasedOn;
  displayTotalInterestPayable: FieldDisplaySetting;
  isGenerateStepsInTable?: Maybe<Scalars['Boolean']['output']>;
  isViewable: FieldDisplaySetting;
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  step: Scalars['Float']['output'];
  table: Array<InterestRateTableCell>;
  type: Scalars['String']['output'];
  unit: AmountUnit;
};

export type Interior = {
  __typename: 'Interior';
  color?: Maybe<InteriorColorAttributes>;
  description?: Maybe<LocalizedString>;
  imageKeys?: Maybe<Array<Scalars['String']['output']>>;
  material?: Maybe<LocalizedValue>;
  name: LocalizedString;
};

export type InteriorColorAttributes = {
  __typename: 'InteriorColorAttributes';
  cockpitColorHexCode: Scalars['String']['output'];
  cockpitStitchingColorHexCode?: Maybe<Scalars['String']['output']>;
  colorGroup?: Maybe<LocalizedInteriorColorGroup>;
  seatColorHexCode: Scalars['String']['output'];
  seatStitchingColorHexCode?: Maybe<Scalars['String']['output']>;
};

export type Inventory = {
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is active flag */
  isActive: Scalars['Boolean']['output'];
  /** Soft deletion flag */
  isDeleted: Scalars['Boolean']['output'];
  /** Kind of inventory */
  kind: InventoryKind;
  /** Model */
  model: LocalModel;
  /** Assigned module */
  moduleId: Scalars['ObjectID']['output'];
  /** Price, combination price */
  price: Scalars['Float']['output'];
  /** Stocks */
  stocks: Array<StockInventory>;
  /** Sub Model (optional) */
  subModel?: Maybe<LocalModel>;
  /** Variant */
  variant: LocalVariant;
  /** Simple versioning */
  versioning: SimpleVersioning;
};

export type InventoryFilteringRule = {
  /** Filter by active */
  actives?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Filter by color setting name */
  colorSettingName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by multiple company IDs */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by configurator ID */
  configuratorId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by dealer IDs */
  dealerIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by model IDs */
  modelIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by display name */
  modelName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by module ID */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by module name */
  moduleName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter by package setting name */
  packageSettingName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter by identifier */
  subModelName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by submodel IDs */
  submodelIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by trim setting name */
  trimSettingName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter by Module ID, configurator module */
  variantName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter by vin */
  vin?: InputMaybe<Scalars['String']['input']>;
};

export enum InventoryKind {
  ConfiguratorInventory = 'ConfiguratorInventory',
  MobilityInventory = 'MobilityInventory'
}

export type InventoryModelOption = {
  __typename: 'InventoryModelOption';
  label: Scalars['String']['output'];
  subModels?: Maybe<Array<InventorySubModelOption>>;
  value: Scalars['ObjectID']['output'];
  variants?: Maybe<Array<InventoryVariantOption>>;
};

export type InventoryModuleOption = {
  __typename: 'InventoryModuleOption';
  label: Scalars['String']['output'];
  models?: Maybe<Array<InventoryModelOption>>;
  type: ModuleType;
  value: Scalars['ObjectID']['output'];
};

export type InventoryOptionItem = {
  __typename: 'InventoryOptionItem';
  modules?: Maybe<Array<InventoryModuleOption>>;
};

export type InventoryOptions = {
  __typename: 'InventoryOptions';
  create: InventoryOptionItem;
  delete: InventoryOptionItem;
};

export type InventoryOptionsFilteringRule = {
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by dealer IDs */
  dealerIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export type InventorySettings = {
  dealerId: Scalars['ObjectID']['input'];
  /** Model suite ids */
  modelIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  moduleId: Scalars['ObjectID']['input'];
  /** Submodel suite ids */
  subModelIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Variant suite ids */
  variantIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export enum InventorySortingField {
  AssignedVinCount = 'AssignedVinCount',
  Company = 'Company',
  ConfiguratorColorName = 'ConfiguratorColorName',
  ConfiguratorPackageName = 'ConfiguratorPackageName',
  ConfiguratorTrimName = 'ConfiguratorTrimName',
  Id = 'ID',
  ModelName = 'ModelName',
  ModuleName = 'ModuleName',
  Stock = 'Stock',
  SubModelName = 'SubModelName',
  VariantName = 'VariantName',
  Vin = 'Vin'
}

export type InventorySortingRule = {
  /** Field on which apply the sorting */
  field: InventorySortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type InventorySubModelOption = {
  __typename: 'InventorySubModelOption';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['ObjectID']['output']>;
  variants?: Maybe<Array<InventoryVariantOption>>;
};

export type InventoryUpdationSettings = {
  isActive: Scalars['Boolean']['input'];
  period?: InputMaybe<PeriodPayload>;
};

export type InventoryVariantOption = {
  __typename: 'InventoryVariantOption';
  label: Scalars['String']['output'];
  value: Scalars['ObjectID']['output'];
};

export enum JobTitle {
  AssistantManager = 'AssistantManager',
  Director = 'Director',
  Manager = 'Manager',
  Others = 'Others',
  President = 'President',
  Staff = 'Staff',
  Supervisor = 'Supervisor',
  VicePresident = 'VicePresident'
}

export enum JobTitleTh {
  BusinessOwner = 'BusinessOwner',
  Director = 'Director',
  Employee = 'Employee',
  Manager = 'Manager',
  Others = 'Others',
  PresidentOrCeo = 'PresidentOrCeo',
  Student = 'Student'
}

export type KycField = {
  __typename: 'KYCField';
  isRequired: Scalars['Boolean']['output'];
  key: LocalCustomerFieldKey;
  purpose: Array<KycFieldPurpose>;
};

export type KycFieldSettings = {
  isRequired: Scalars['Boolean']['input'];
  key: LocalCustomerFieldKey;
  purpose: Array<KycFieldPurpose>;
};

export type KycPreset = {
  __typename: 'KYCPreset';
  conditions?: Maybe<Array<Condition>>;
  displayName: Scalars['String']['output'];
  fields: Array<KycField>;
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type KycPresetFilteringRule = {
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type KycPresetSettings = {
  displayName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export enum KycFieldPurpose {
  Kyc = 'KYC',
  Share = 'Share'
}

export enum LtaCoeCategory {
  CatA = 'CatA',
  CatB = 'CatB',
  CatC = 'CatC',
  CatE = 'CatE'
}

export type LtaIntegration = {
  __typename: 'LTAIntegration';
  arf: Scalars['Float']['output'];
  chassisNumber?: Maybe<Scalars['String']['output']>;
  coe?: Maybe<Scalars['Float']['output']>;
  coeCategory?: Maybe<LtaCoeCategory>;
  coeExpiryDate: Scalars['DateTime']['output'];
  coePeriod?: Maybe<Scalars['Float']['output']>;
  colour?: Maybe<Scalars['String']['output']>;
  engineNumber?: Maybe<Scalars['String']['output']>;
  firstRegistrationDate?: Maybe<Scalars['DateTime']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  omv: Scalars['Float']['output'];
  originalRegistrationDate: Scalars['DateTime']['output'];
  ownerId: Scalars['String']['output'];
  ownerIdType: LtaPreOwnerIdType;
  parfEligibilityExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  parfRebateAmount?: Maybe<Scalars['Float']['output']>;
  power?: Maybe<Scalars['Float']['output']>;
  pqp?: Maybe<Scalars['Float']['output']>;
  registrationNumber: Scalars['String']['output'];
  transfers?: Maybe<Scalars['Int']['output']>;
  yearOfManufacture?: Maybe<Scalars['String']['output']>;
};

export enum LtaPreOwnerIdType {
  Business = 'Business',
  ClubOrAssociationOrOrganization = 'ClubOrAssociationOrOrganization',
  Company = 'Company',
  ForeignCompany = 'ForeignCompany',
  ForeignIdentificationNumber = 'ForeignIdentificationNumber',
  ForeignPassport = 'ForeignPassport',
  Government = 'Government',
  LimitedLiabilityPartnership = 'LimitedLiabilityPartnership',
  LimitedPartnership = 'LimitedPartnership',
  MalaysiaNric = 'MalaysiaNric',
  Professional = 'Professional',
  SingaporeNric = 'SingaporeNric',
  StatutoryBoard = 'StatutoryBoard'
}

export type LtaSettings = {
  arf: Scalars['Float']['input'];
  chassisNumber?: InputMaybe<Scalars['String']['input']>;
  coe?: InputMaybe<Scalars['Float']['input']>;
  coeCategory?: InputMaybe<LtaCoeCategory>;
  coeExpiryDate: Scalars['DateTime']['input'];
  coePeriod?: InputMaybe<Scalars['Float']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  engineNumber?: InputMaybe<Scalars['String']['input']>;
  firstRegistrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  omv: Scalars['Float']['input'];
  originalRegistrationDate: Scalars['DateTime']['input'];
  ownerId: Scalars['String']['input'];
  ownerIdType: LtaPreOwnerIdType;
  parfEligibilityExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  parfRebateAmount?: InputMaybe<Scalars['Float']['input']>;
  power?: InputMaybe<Scalars['Float']['input']>;
  pqp?: InputMaybe<Scalars['Float']['input']>;
  registrationNumber: Scalars['String']['input'];
  transfers?: InputMaybe<Scalars['Int']['input']>;
  yearOfManufacture?: InputMaybe<Scalars['String']['input']>;
};

export type LabeledValue = {
  __typename: 'LabeledValue';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Labels = {
  __typename: 'Labels';
  /** Background Color */
  backgroundColor: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** isActive */
  isActive: Scalars['Boolean']['output'];
  /** Label Module */
  labelModule: Module;
  /** Label Name */
  labelName: TranslatedString;
  /** Module Variant */
  moduleVariants: Array<Maybe<ModuleVariant>>;
  /** Number of Variant Tagged */
  numberOfVariantTagged: Scalars['Int']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Text Color */
  textColor: Scalars['String']['output'];
  /** Versioning */
  versioning: SimpleVersioning;
};

export type LabelsFilteringField = {
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  labelName?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type LabelsInput = {
  /** Background Color */
  backgroundColor: Scalars['String']['input'];
  /** Active */
  isActive: Scalars['Boolean']['input'];
  /** Label Name */
  labelName: TranslatedStringInput;
  /** Module Variant */
  moduleVariants: Array<ModuleVariantInput>;
  /** Text Color */
  textColor: Scalars['String']['input'];
};

export type LabelsModule = Module & {
  __typename: 'LabelsModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type LabelsModuleSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
};

export enum LabelsSortingField {
  Company = 'Company',
  Identifier = 'Identifier',
  LabelName = 'LabelName',
  ModuleName = 'ModuleName',
  TextColor = 'TextColor'
}

export type LabelsSortingRule = {
  field: LabelsSortingField;
  order: SortingOrder;
};

export enum LanguageOrientation {
  /** Left to Right (LTR) */
  LeftToRight = 'LeftToRight',
  /** Right to Left (RTL) */
  RightToLeft = 'RightToLeft'
}

export type LanguagePack = {
  __typename: 'LanguagePack';
  /** International Code */
  code: Scalars['String']['output'];
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Orientation */
  orientation: LanguageOrientation;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Reference Name */
  referenceName: Scalars['String']['output'];
  /** Translations */
  translations: Scalars['JSONObject']['output'];
  /** Versioning */
  versioning: SimpleVersioning;
};

export type LanguagePackFilteringRule = {
  /** Filter for a specific company */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by Display Name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by a specific keyword */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Orientation */
  orientation?: InputMaybe<Array<LanguageOrientation>>;
  /** Filter by Reference Name */
  referenceName?: InputMaybe<Scalars['String']['input']>;
};

export type LanguagePackFilters = {
  __typename: 'LanguagePackFilters';
  orientation: Array<Maybe<LanguageOrientation>>;
};

export type LanguagePackSettings = {
  /** International Code */
  code: Scalars['String']['input'];
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** Orientation */
  orientation: LanguageOrientation;
  /** Display Name */
  referenceName?: InputMaybe<Scalars['String']['input']>;
  /** Translations */
  translations: Scalars['JSONObject']['input'];
};

export enum LanguagePackSortingField {
  DisplayName = 'DisplayName',
  InternationalCode = 'InternationalCode',
  ReferenceName = 'ReferenceName'
}

export type LanguagePackSortingRule = {
  field: LanguagePackSortingField;
  order: SortingOrder;
};

export type Layout = BasicLayout | BasicProLayout;

export type LeadStage = ApplicationStageDetails & {
  __typename: 'LeadStage';
  assignee?: Maybe<User>;
  /** Assignee */
  assigneeId?: Maybe<Scalars['ObjectID']['output']>;
  /** Identifier */
  identifier: Scalars['String']['output'];
  /** Current status */
  status: ApplicationStatus;
};

export type LeaseSettings = {
  __typename: 'LeaseSettings';
  table: Array<LeaseTableCell>;
  type: Scalars['String']['output'];
  vehicleFilterParameterTable: Array<LeaseValueTableCellForVehicleParameterFilter>;
};

export type LeaseSettingsPayload = {
  table: Array<LeaseTableCellPayload>;
  type: Scalars['String']['input'];
  vehicleFilterParameterTable: Array<LeaseValueTableCellForVehicleParameterFilterPayload>;
};

export type LeaseTableCell = {
  __typename: 'LeaseTableCell';
  term: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
  variant: Vehicle;
  variantSuiteId: Scalars['ObjectID']['output'];
};

export type LeaseTableCellPayload = {
  term: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
  variantSuiteId: Scalars['ObjectID']['input'];
};

export type LeaseValueTableCellForVehicleParameterFilter = {
  __typename: 'LeaseValueTableCellForVehicleParameterFilter';
  term: Scalars['Int']['output'];
  type: VehicleKind;
  value: Scalars['Float']['output'];
};

export type LeaseValueTableCellForVehicleParameterFilterPayload = {
  term: Scalars['Int']['input'];
  type: VehicleKind;
  value: Scalars['Float']['input'];
};

export enum LegalTextPosition {
  After = 'After',
  Before = 'Before',
  Modal = 'Modal'
}

export type LicenseAndFuelTaxSettingPayload = {
  fuelTable: Array<LicenseAndFuelTaxTableValuesPayload>;
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
  licenseTable: Array<LicenseAndFuelTaxTableValuesPayload>;
};

export type LicenseAndFuelTaxSettings = {
  __typename: 'LicenseAndFuelTaxSettings';
  fuelTable: Array<LicenseAndFuelTaxTableValues>;
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  licenseTable: Array<LicenseAndFuelTaxTableValues>;
};

export type LicenseAndFuelTaxTableValues = {
  __typename: 'LicenseAndFuelTaxTableValues';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type LicenseAndFuelTaxTableValuesPayload = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
  value: Scalars['Int']['input'];
};

export type LicensePlateFeeSettingPayload = {
  default: Scalars['Float']['input'];
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
  step: Scalars['Float']['input'];
};

export type LicensePlateFeeSettings = {
  __typename: 'LicensePlateFeeSettings';
  default: Scalars['Float']['output'];
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  step: Scalars['Float']['output'];
};

export type ListFinderVehiclesInfo = {
  __typename: 'ListFinderVehiclesInfo';
  /** Number of vehicles matching original query */
  count: Scalars['Int']['output'];
  /** Finder Vehicle Filters for productionOnly */
  filters?: Maybe<FinderVehicleFilters>;
  /** Vehicles on the request page */
  items: Array<FinderVehicle>;
};

export type Listing = {
  __typename: 'Listing';
  additionalCustomerInformationAvailable?: Maybe<Scalars['Boolean']['output']>;
  availableFrom?: Maybe<FormattedDate>;
  description?: Maybe<LocalizedString>;
  externalReference?: Maybe<ExternalReference>;
  financing?: Maybe<Financing>;
  firstVisibleAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  location?: Maybe<Location>;
  marketplaceId?: Maybe<Scalars['String']['output']>;
  onlineOrderableState?: Maybe<OnlineOrderableState>;
  price: Price;
  seller: Seller;
  stockNumber: Scalars['String']['output'];
  subtitle?: Maybe<LocalizedString>;
  title?: Maybe<LocalizedString>;
  updatedAt: Scalars['DateTime']['output'];
  vehicle: PorscheFinderVehicle;
  warranty?: Maybe<Warranty>;
};

export type ListingTypeEdge = {
  __typename: 'ListingTypeEdge';
  cursor: Scalars['String']['output'];
  node: Listing;
};

export type ListingsConnection = {
  __typename: 'ListingsConnection';
  edges: Array<ListingTypeEdge>;
  pageInfo: PaginationInfo;
  totalCount: Scalars['Int']['output'];
};

export type LiveChatSetting = {
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Live Chat Module Id */
  liveChatModuleId: Scalars['ObjectID']['output'];
};

export type LoanSettings = {
  __typename: 'LoanSettings';
  default?: Maybe<Scalars['Float']['output']>;
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  maxUnit?: Maybe<AmountUnit>;
  min?: Maybe<Scalars['Float']['output']>;
  minUnit?: Maybe<AmountUnit>;
  step?: Maybe<Scalars['Float']['output']>;
  stepUnit?: Maybe<AmountUnit>;
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<AmountUnit>;
};

export type LoanSettingsPayload = {
  default?: InputMaybe<Scalars['Float']['input']>;
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
  max?: InputMaybe<Scalars['Float']['input']>;
  maxUnit?: InputMaybe<AmountUnit>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minUnit?: InputMaybe<AmountUnit>;
  step?: InputMaybe<Scalars['Float']['input']>;
  stepUnit?: InputMaybe<AmountUnit>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<AmountUnit>;
};

export type LocalCustomer = {
  __typename: 'LocalCustomer';
  /** Applications */
  applications: Array<Application>;
  /** Email */
  email: Scalars['String']['output'];
  /** Local Customer Fields Array */
  fields: Array<LocalCustomerField>;
  /**
   * Customer full name
   * mainly used in application list and application detail
   */
  fullName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Masking */
  isMaskingCustomerData?: Maybe<Scalars['Boolean']['output']>;
  /** Customer kind */
  kind: CustomerKind;
  /** KYC Presets */
  kycPresets: Array<KycField>;
  /** Latest application */
  latestApplication: Application;
  /**
   * Latest customer full name,
   * mainly used in customer list and customer detail
   */
  latestFullName: Scalars['String']['output'];
  /** Module */
  module: Module;
  /** Module Id */
  moduleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: AdvancedVersioning;
};

export type LocalCustomerDateField = {
  __typename: 'LocalCustomerDateField';
  /** Value for local customer field */
  dateValue: Scalars['DateTime']['output'];
  /** Key string for local customer field */
  key: LocalCustomerFieldKey;
  /** Source for local customer */
  source: LocalCustomerFieldSource;
};

export type LocalCustomerDrivingLicenseField = {
  __typename: 'LocalCustomerDrivingLicenseField';
  /** Value for local customer field */
  drivingLicenseValue: Array<DrivingLicense>;
  /** Key string for local customer field */
  key: LocalCustomerFieldKey;
  /** Source for local customer */
  source: LocalCustomerFieldSource;
};

export type LocalCustomerField = LocalCustomerDateField | LocalCustomerDrivingLicenseField | LocalCustomerNumberField | LocalCustomerPhoneField | LocalCustomerReferenceDetailSetField | LocalCustomerSalaryTransferredBankSetField | LocalCustomerStringDescriptionField | LocalCustomerStringField | LocalCustomerUaeIdentitySetField | LocalCustomerUploadsField;

export enum LocalCustomerFieldKey {
  Address = 'Address',
  AddressType = 'AddressType',
  Birthday = 'Birthday',
  Citizenship = 'Citizenship',
  City = 'City',
  Comments = 'Comments',
  CompanyAddress = 'CompanyAddress',
  CompanyCity = 'CompanyCity',
  CompanyDistrict = 'CompanyDistrict',
  CompanyName = 'CompanyName',
  CompanyPhone = 'CompanyPhone',
  CompanyPhoneExtension = 'CompanyPhoneExtension',
  CorporateAnnualRevenue = 'CorporateAnnualRevenue',
  CorporateIdentityNumber = 'CorporateIdentityNumber',
  CorporateIndustryCategory = 'CorporateIndustryCategory',
  CorporateName = 'CorporateName',
  CorporateNumberOfEmployee = 'CorporateNumberOfEmployee',
  CorporatePhone = 'CorporatePhone',
  CorporateRegisteredCapital = 'CorporateRegisteredCapital',
  CorporateRegistrationDate = 'CorporateRegistrationDate',
  CorrespondenceAddress = 'CorrespondenceAddress',
  CorrespondenceCity = 'CorrespondenceCity',
  CorrespondenceDistrict = 'CorrespondenceDistrict',
  Country = 'Country',
  CreationDate = 'CreationDate',
  DateOfJoining = 'DateOfJoining',
  DeliveryAddress = 'DeliveryAddress',
  District = 'District',
  DriverLicensePassDate = 'DriverLicensePassDate',
  DrivingLicense = 'DrivingLicense',
  DrivingLicenseMy = 'DrivingLicenseMy',
  DrivingLicenseTh = 'DrivingLicenseTh',
  Education = 'Education',
  Email = 'Email',
  Emirate = 'Emirate',
  EmploymentStatus = 'EmploymentStatus',
  FirstName = 'FirstName',
  FirstNameJapan = 'FirstNameJapan',
  FullName = 'FullName',
  Gender = 'Gender',
  IdentityNumber = 'IdentityNumber',
  IncomeType = 'IncomeType',
  JobTitle = 'JobTitle',
  JobTitleTh = 'JobTitleTh',
  LastName = 'LastName',
  LastNameFront = 'LastNameFront',
  LastNameJapan = 'LastNameJapan',
  MaritalStatus = 'MaritalStatus',
  MonthlyIncome = 'MonthlyIncome',
  Nationality = 'Nationality',
  NoClaimDiscount = 'NoClaimDiscount',
  OtherIncome = 'OtherIncome',
  Passport = 'Passport',
  Phone = 'Phone',
  PostalCode = 'PostalCode',
  PreferredFirstPaymentDate = 'PreferredFirstPaymentDate',
  PurchaseIntention = 'PurchaseIntention',
  Race = 'Race',
  ReferenceDetailSet = 'ReferenceDetailSet',
  Region = 'Region',
  RelationshipWithApplicant = 'RelationshipWithApplicant',
  ResidenceType = 'ResidenceType',
  ResidentialStatus = 'ResidentialStatus',
  ResidentialStatusVwfs = 'ResidentialStatusVWFS',
  Road = 'Road',
  SalaryTransferredBankSet = 'SalaryTransferredBankSet',
  Salutation = 'Salutation',
  SalutationBmw = 'SalutationBmw',
  Telephone = 'Telephone',
  TimeOfAddress = 'TimeOfAddress',
  TimeOfEmployment = 'TimeOfEmployment',
  Title = 'Title',
  TradeInVehicles = 'TradeInVehicles',
  UaeDrivingLicense = 'UAEDrivingLicense',
  UaeIdentitySet = 'UAEIdentitySet',
  UnitNumber = 'UnitNumber',
  UploadDrivingLicense = 'UploadDrivingLicense',
  UploadIdentity = 'UploadIdentity',
  UploadOtherDocument = 'UploadOtherDocument',
  UploadPassport = 'UploadPassport',
  VehicleContractEnd = 'VehicleContractEnd'
}

export type LocalCustomerFieldSettings = {
  dateValue?: InputMaybe<Scalars['DateTime']['input']>;
  drivingLicenseValue?: InputMaybe<Array<DrivingLicensePayload>>;
  fileValues?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  key: LocalCustomerFieldKey;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  phoneValue?: InputMaybe<PhonePayload>;
  referenceDetailValue?: InputMaybe<ReferenceDetailPayload>;
  salaryTransferredBankValue?: InputMaybe<SalaryTransferredBankPayload>;
  source: LocalCustomerFieldSource;
  stringDescriptionValue?: InputMaybe<StringDescriptionPayload>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  uaeIdentityValue?: InputMaybe<UaeIdentityPayload>;
};

export enum LocalCustomerFieldSource {
  Bmw = 'Bmw',
  MyInfo = 'MyInfo',
  UserInput = 'UserInput'
}

export type LocalCustomerManagementModule = Module & {
  __typename: 'LocalCustomerManagementModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** KYC Fields */
  kycFields: Array<LocalCustomerManagementModuleKycField>;
  /** KYC Presets */
  kycPresets: Array<KycPreset>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type LocalCustomerManagementModuleKycField = {
  __typename: 'LocalCustomerManagementModuleKycField';
  /** Field */
  field: LocalCustomerFieldKey;
  /** Order */
  order: Scalars['Int']['output'];
};

export type LocalCustomerManagementModuleKycFieldSettings = {
  /** Field */
  field: LocalCustomerFieldKey;
  /** Active */
  isActive: Scalars['Boolean']['input'];
  /** Order */
  order: Scalars['Int']['input'];
};

export type LocalCustomerManagementSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
};

export type LocalCustomerNumberField = {
  __typename: 'LocalCustomerNumberField';
  /** Key string for local customer field */
  key: LocalCustomerFieldKey;
  /** Value for local customer field */
  numberValue: Scalars['Float']['output'];
  /** Source for local customer */
  source: LocalCustomerFieldSource;
};

export type LocalCustomerPhoneField = {
  __typename: 'LocalCustomerPhoneField';
  /** Key string for local customer field */
  key: LocalCustomerFieldKey;
  /** Value for local customer field */
  phoneValue: Phone;
  /** Source for local customer */
  source: LocalCustomerFieldSource;
};

export type LocalCustomerReferenceDetailSetField = {
  __typename: 'LocalCustomerReferenceDetailSetField';
  /** Key string for local customer field */
  key: LocalCustomerFieldKey;
  /** Value for local customer field */
  referenceDetailValue: ReferenceDetailSet;
  /** Source for local customer */
  source: LocalCustomerFieldSource;
};

export type LocalCustomerSalaryTransferredBankSetField = {
  __typename: 'LocalCustomerSalaryTransferredBankSetField';
  /** Key string for local customer field */
  key: LocalCustomerFieldKey;
  /** Value for local customer field */
  salaryTransferredBankValue: SalaryTransferredBankSet;
  /** Source for local customer */
  source: LocalCustomerFieldSource;
};

export type LocalCustomerStringDescriptionField = {
  __typename: 'LocalCustomerStringDescriptionField';
  /** Key string for local customer field */
  key: LocalCustomerFieldKey;
  /** Source for local customer */
  source: LocalCustomerFieldSource;
  /** Value for local customer field */
  stringDescriptionValue: StringDescription;
};

export type LocalCustomerStringField = {
  __typename: 'LocalCustomerStringField';
  /** Key string for local customer field */
  key: LocalCustomerFieldKey;
  /** Source for local customer */
  source: LocalCustomerFieldSource;
  /** Value for local customer field */
  stringValue: Scalars['String']['output'];
};

export type LocalCustomerUaeIdentitySetField = {
  __typename: 'LocalCustomerUAEIdentitySetField';
  /** Key string for local customer field */
  key: LocalCustomerFieldKey;
  /** Source for local customer */
  source: LocalCustomerFieldSource;
  /** Value for local customer field */
  uaeIdentityValue: UaeIdentitySet;
};

export type LocalCustomerUploadsField = {
  __typename: 'LocalCustomerUploadsField';
  /** Key string for local customer field */
  key: LocalCustomerFieldKey;
  /** Source for local customer */
  source: LocalCustomerFieldSource;
  /** Value for local customer field */
  uploads: Array<UploadedFileWithPreview>;
};

export type LocalDeferredPrincipal = {
  __typename: 'LocalDeferredPrincipal';
  /** Combined suite ids from variantSuiteIds and vehicleReferenceParameters */
  allVariantSuiteIds: Array<Scalars['ObjectID']['output']>;
  bank: SystemBank;
  bankId: Scalars['ObjectID']['output'];
  bankReferenceIdentifier?: Maybe<Scalars['String']['output']>;
  basedOn: FinanceProductBasedOn;
  calculationMode: CalculationMode;
  deriveMethod: DeriveMethod;
  description?: Maybe<TranslatedString>;
  displayName: Scalars['String']['output'];
  downPayment: DownPaymentSettings;
  id: Scalars['ObjectID']['output'];
  identifier: Scalars['String']['output'];
  interestRate: InterestRateSettings;
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  kind: FinanceProductKind;
  legalName: TranslatedString;
  loan?: Maybe<LoanSettings>;
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  order: Scalars['Int']['output'];
  payment: PaymentSettings;
  period: Period;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  term: DeferredPrincipalTermSettings;
  type: FinanceProductType;
  /** Variant Suite Ids assigned */
  variantSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Variants/Finder Vehicles retrieved from variantSuiteIds and vehicleReferenceParameters */
  variants: Array<Vehicle>;
  /** Vehicle Parameters assignment */
  vehicleReferenceParameters: VehicleReferenceParameters;
  versioning: AdvancedVersioning;
  webCalcSettingId?: Maybe<Scalars['ObjectID']['output']>;
};

export type LocalHirePurchase = {
  __typename: 'LocalHirePurchase';
  /** Combined suite ids from variantSuiteIds and vehicleReferenceParameters */
  allVariantSuiteIds: Array<Scalars['ObjectID']['output']>;
  bank: SystemBank;
  bankId: Scalars['ObjectID']['output'];
  bankReferenceIdentifier?: Maybe<Scalars['String']['output']>;
  basedOn: FinanceProductBasedOn;
  calculationMode: CalculationMode;
  deriveMethod: DeriveMethod;
  description?: Maybe<TranslatedString>;
  displayName: Scalars['String']['output'];
  downPayment: DownPaymentSettings;
  id: Scalars['ObjectID']['output'];
  identifier: Scalars['String']['output'];
  interestRate: InterestRateSettings;
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  kind: FinanceProductKind;
  legalName: TranslatedString;
  loan?: Maybe<LoanSettings>;
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  order: Scalars['Int']['output'];
  payment: PaymentSettings;
  period: Period;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  term: GenericPrincipalTermSettings;
  type: FinanceProductType;
  /** Variant Suite Ids assigned */
  variantSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Variants/Finder Vehicles retrieved from variantSuiteIds and vehicleReferenceParameters */
  variants: Array<Vehicle>;
  /** Vehicle Parameters assignment */
  vehicleReferenceParameters: VehicleReferenceParameters;
  versioning: AdvancedVersioning;
  webCalcSettingId?: Maybe<Scalars['ObjectID']['output']>;
};

export type LocalHirePurchaseWithBalloon = {
  __typename: 'LocalHirePurchaseWithBalloon';
  /** Combined suite ids from variantSuiteIds and vehicleReferenceParameters */
  allVariantSuiteIds: Array<Scalars['ObjectID']['output']>;
  balloon: BalloonSettings;
  bank: SystemBank;
  bankId: Scalars['ObjectID']['output'];
  bankReferenceIdentifier?: Maybe<Scalars['String']['output']>;
  basedOn: FinanceProductBasedOn;
  calculationMode: CalculationMode;
  deriveMethod: DeriveMethod;
  description?: Maybe<TranslatedString>;
  displayName: Scalars['String']['output'];
  downPayment: DownPaymentSettings;
  id: Scalars['ObjectID']['output'];
  identifier: Scalars['String']['output'];
  interestRate: InterestRateSettings;
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  kind: FinanceProductKind;
  legalName: TranslatedString;
  loan?: Maybe<LoanSettings>;
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  order: Scalars['Int']['output'];
  payment: PaymentSettings;
  period: Period;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  term: GenericPrincipalTermSettings;
  type: FinanceProductType;
  /** Variant Suite Ids assigned */
  variantSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Variants/Finder Vehicles retrieved from variantSuiteIds and vehicleReferenceParameters */
  variants: Array<Vehicle>;
  /** Vehicle Parameters assignment */
  vehicleReferenceParameters: VehicleReferenceParameters;
  versioning: AdvancedVersioning;
  webCalcSettingId?: Maybe<Scalars['ObjectID']['output']>;
};

export type LocalHirePurchaseWithBalloonGfv = {
  __typename: 'LocalHirePurchaseWithBalloonGFV';
  /** Combined suite ids from variantSuiteIds and vehicleReferenceParameters */
  allVariantSuiteIds: Array<Scalars['ObjectID']['output']>;
  balloon: BalloonGfvSettings;
  bank: SystemBank;
  bankId: Scalars['ObjectID']['output'];
  bankReferenceIdentifier?: Maybe<Scalars['String']['output']>;
  basedOn: FinanceProductBasedOn;
  calculationMode: CalculationMode;
  deriveMethod: DeriveMethod;
  description?: Maybe<TranslatedString>;
  displayName: Scalars['String']['output'];
  downPayment: DownPaymentSettings;
  id: Scalars['ObjectID']['output'];
  identifier: Scalars['String']['output'];
  interestRate: InterestRateSettings;
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  kind: FinanceProductKind;
  legalName: TranslatedString;
  loan?: Maybe<LoanSettings>;
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  order: Scalars['Int']['output'];
  payment: PaymentSettings;
  period: Period;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  term: GenericPrincipalTermSettings;
  type: FinanceProductType;
  /** Variant Suite Ids assigned */
  variantSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Variants/Finder Vehicles retrieved from variantSuiteIds and vehicleReferenceParameters */
  variants: Array<Vehicle>;
  /** Vehicle Parameters assignment */
  vehicleReferenceParameters: VehicleReferenceParameters;
  versioning: AdvancedVersioning;
  webCalcSettingId?: Maybe<Scalars['ObjectID']['output']>;
};

export type LocalLease = {
  __typename: 'LocalLease';
  /** Combined suite ids from variantSuiteIds and vehicleReferenceParameters */
  allVariantSuiteIds: Array<Scalars['ObjectID']['output']>;
  bank: SystemBank;
  bankId: Scalars['ObjectID']['output'];
  bankReferenceIdentifier?: Maybe<Scalars['String']['output']>;
  deposit: DepositSettings;
  deriveMethod: DeriveMethod;
  description?: Maybe<TranslatedString>;
  displayName: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  identifier: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  kind: FinanceProductKind;
  lease: LeaseSettings;
  legalName: TranslatedString;
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  order: Scalars['Int']['output'];
  period: Period;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  term: GenericPrincipalTermSettings;
  type: FinanceProductType;
  /** Variant Suite Ids assigned */
  variantSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Variants/Finder Vehicles retrieved from variantSuiteIds and vehicleReferenceParameters */
  variants: Array<Vehicle>;
  /** Vehicle Parameters assignment */
  vehicleReferenceParameters: VehicleReferenceParameters;
  versioning: AdvancedVersioning;
  webCalcSettingId?: Maybe<Scalars['ObjectID']['output']>;
};

export type LocalLeasePurchase = {
  __typename: 'LocalLeasePurchase';
  /** Combined suite ids from variantSuiteIds and vehicleReferenceParameters */
  allVariantSuiteIds: Array<Scalars['ObjectID']['output']>;
  bank: SystemBank;
  bankId: Scalars['ObjectID']['output'];
  bankReferenceIdentifier?: Maybe<Scalars['String']['output']>;
  basedOn: FinanceProductBasedOn;
  calculationMode: CalculationMode;
  deriveMethod: DeriveMethod;
  description?: Maybe<TranslatedString>;
  displayName: Scalars['String']['output'];
  downPayment: DownPaymentSettings;
  id: Scalars['ObjectID']['output'];
  identifier: Scalars['String']['output'];
  interestRate: InterestRateSettings;
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  kind: FinanceProductKind;
  legalName: TranslatedString;
  loan?: Maybe<LoanSettings>;
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  order: Scalars['Int']['output'];
  payment: PaymentSettings;
  period: Period;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  residualValue: ResidualValueSettings;
  term: GenericPrincipalTermSettings;
  type: FinanceProductType;
  /** Variant Suite Ids assigned */
  variantSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Variants/Finder Vehicles retrieved from variantSuiteIds and vehicleReferenceParameters */
  variants: Array<Vehicle>;
  /** Vehicle Parameters assignment */
  vehicleReferenceParameters: VehicleReferenceParameters;
  versioning: AdvancedVersioning;
  webCalcSettingId?: Maybe<Scalars['ObjectID']['output']>;
};

export type LocalMake = Vehicle & {
  __typename: 'LocalMake';
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Make ID */
  identifier: Scalars['String']['output'];
  /** Is active */
  isActive: Scalars['Boolean']['output'];
  /** Is deletable */
  isDeletable: Scalars['Boolean']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Number of models */
  models: PaginatedLocalModels;
  /** Module */
  module: Module;
  /** Module ID */
  moduleId: Scalars['ObjectID']['output'];
  /** Make name */
  name: TranslatedString;
  /** Order Number */
  order: Scalars['Int']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: AdvancedVersioning;
};

export type LocalMakeFilteringRule = {
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by multiple company IDs */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by make ID */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Filter by make name */
  name?: InputMaybe<TranslatedStringInput>;
};

export type LocalMakeSettings = {
  /** Make ID */
  identifier: Scalars['String']['input'];
  /** Is active */
  isActive: Scalars['Boolean']['input'];
  /** Make name */
  name: TranslatedStringInput;
  /** Order number */
  order: Scalars['Int']['input'];
};

export enum LocalMakeSortingField {
  /** Sort by company */
  Company = 'Company',
  /** Sort by make ID */
  Identifier = 'Identifier',
  /** Sort by is active */
  IsActive = 'IsActive',
  /** Sort by make name */
  Name = 'Name',
  /** Sort by order number */
  Order = 'Order'
}

export type LocalMakeSortingRule = {
  /** Field on which apply the sorting */
  field: LocalMakeSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type LocalModel = Vehicle & {
  __typename: 'LocalModel';
  /** Body Type */
  bodyType: BodyType;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Model ID / Identifier */
  identifier: Scalars['String']['output'];
  /** Is active */
  isActive: Scalars['Boolean']['output'];
  /** Is deletable */
  isDeletable: Scalars['Boolean']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Local Make */
  make: LocalMake;
  /** Local Make ID */
  makeId: Scalars['ObjectID']['output'];
  /** Module */
  module: Module;
  /** Module ID */
  moduleId: Scalars['ObjectID']['output'];
  /** Model name */
  name: TranslatedString;
  /** Order number */
  order: Scalars['Int']['output'];
  /** Parent model for submodels */
  parentModel?: Maybe<LocalModel>;
  /** Parent ID for submodels */
  parentModelId?: Maybe<Scalars['ObjectID']['output']>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Number of submodels */
  submodels: PaginatedLocalModels;
  /** Number of variants */
  variants: PaginatedLocalVariants;
  /** Versioning */
  versioning: AdvancedVersioning;
};

export type LocalModelFilteringRule = {
  /** Filter by body type */
  bodyType?: InputMaybe<Array<BodyType>>;
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by multiple company IDs */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by Model ID */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Filter by make names */
  makeName?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by module ID */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by model name */
  name?: InputMaybe<TranslatedStringInput>;
  /** Filter by parent model names */
  parentModels?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by submodel, or model */
  submodel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalModelSettings = {
  /** Body Type */
  bodyType: BodyType;
  /** Model ID */
  identifier: Scalars['String']['input'];
  /** Is active */
  isActive: Scalars['Boolean']['input'];
  /** Make object ID */
  makeId: Scalars['ObjectID']['input'];
  /** Model name */
  name: TranslatedStringInput;
  /** Order Number */
  order: Scalars['Int']['input'];
  /** Local model parent object ID */
  parentModelId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum LocalModelSortingField {
  /** Sort by body type */
  BodyType = 'BodyType',
  /** Sort by company */
  Company = 'Company',
  /** Sort by model ID */
  Identifier = 'Identifier',
  /** Sort by is active */
  IsActive = 'IsActive',
  /** Sort by make name */
  MakeName = 'MakeName',
  /** Sort by model name */
  Name = 'Name',
  /** Sort by order number */
  Order = 'Order',
  /** Sort by parent model name */
  ParentModelName = 'ParentModelName',
  /** Sort by number of submodels */
  Submodels = 'Submodels',
  /** Sort by number of variants */
  Variants = 'Variants'
}

export type LocalModelSortingRule = {
  /** Field on which apply the sorting */
  field: LocalModelSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type LocalSubmodelSettings = {
  /** Body Type */
  bodyType: BodyType;
  /** Submodel ID */
  identifier: Scalars['String']['input'];
  /** Is active */
  isActive: Scalars['Boolean']['input'];
  /** Submodel name */
  name: TranslatedStringInput;
  /** Order Number */
  order: Scalars['Int']['input'];
  /** Local model parent object ID */
  parentModelId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type LocalUcclLeasing = {
  __typename: 'LocalUcclLeasing';
  /** Combined suite ids from variantSuiteIds and vehicleReferenceParameters */
  allVariantSuiteIds: Array<Scalars['ObjectID']['output']>;
  bank: SystemBank;
  bankId: Scalars['ObjectID']['output'];
  bankReferenceIdentifier?: Maybe<Scalars['String']['output']>;
  basedOn: FinanceProductBasedOn;
  calculationMode: CalculationMode;
  /** Commission settings */
  commission: CommissionSettings;
  deriveMethod: DeriveMethod;
  description?: Maybe<TranslatedString>;
  /** Displacement settings */
  displacement: DisplacementSettings;
  displayName: Scalars['String']['output'];
  downPayment: DownPaymentSettings;
  id: Scalars['ObjectID']['output'];
  identifier: Scalars['String']['output'];
  /** Insurance fee settings */
  insuranceFee: InsuranceFeeSettings;
  interestRate: InterestRateSettings;
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  kind: FinanceProductKind;
  legalName: TranslatedString;
  /** License and fuel tax settings */
  licenseAndFuelTax: LicenseAndFuelTaxSettings;
  /** License plate fee settings */
  licensePlateFee: LicensePlateFeeSettings;
  loan?: Maybe<LoanSettings>;
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  /** Monthly payment (Fixed Interest Rate) settings */
  monthlyPaymentFixedInterestRate: MonthlyPaymentFixedInterestRateSettings;
  order: Scalars['Int']['output'];
  payment: PaymentSettings;
  period: Period;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Tax loss settings */
  taxLoss: TaxLossSettings;
  term: GenericPrincipalTermSettings;
  type: FinanceProductType;
  /** Variant Suite Ids assigned */
  variantSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Variants/Finder Vehicles retrieved from variantSuiteIds and vehicleReferenceParameters */
  variants: Array<Vehicle>;
  /** Vehicle Parameters assignment */
  vehicleReferenceParameters: VehicleReferenceParameters;
  versioning: AdvancedVersioning;
  webCalcSettingId?: Maybe<Scalars['ObjectID']['output']>;
};

export type LocalVariant = Vehicle & {
  __typename: 'LocalVariant';
  /** Apple Car Play */
  appleCarPlay?: Maybe<Scalars['Boolean']['output']>;
  /** Bank Code Mapping */
  bankCodeMappings: Array<VariantBankCodeMapping>;
  /** Body Type */
  bodyType: BodyType;
  /** Brochure */
  brochure?: Maybe<UploadedFileWithPreview>;
  /** Company */
  company: Company;
  /** Description */
  description: TranslatedString;
  /** Energy consumption */
  energyConsumption?: Maybe<EnergyConsumption>;
  /** Engine */
  engine: TranslatedString;
  /**
   * Engine displacement (in cc)
   *
   * UCCL Leasing will look for this field
   */
  engineDisplacement?: Maybe<Scalars['Int']['output']>;
  /** Engine Type */
  engineType: EngineType;
  /** Features */
  features: TranslatedString;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Vehicle ID/ Identifier */
  identifier: Scalars['String']['output'];
  /** Variant upload images */
  images?: Maybe<Array<Maybe<UploadedFileWithPreview>>>;
  /** Is Active */
  isActive: Scalars['Boolean']['output'];
  /** Is deletable */
  isDeletable: Scalars['Boolean']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Local Model */
  model: LocalModel;
  /** Local Model ID */
  modelId: Scalars['ObjectID']['output'];
  /** Model Year */
  modelYear?: Maybe<Scalars['Int']['output']>;
  /** Module */
  module: Module;
  /** Module ID */
  moduleId: Scalars['ObjectID']['output'];
  /** Monthly Payment */
  monthlyInstalment?: Maybe<Scalars['Float']['output']>;
  /** Variant Name */
  name: TranslatedString;
  /** Order Number */
  order: Scalars['Int']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Power output */
  powerOutput?: Maybe<Scalars['Float']['output']>;
  /** Seats */
  seats?: Maybe<Scalars['Int']['output']>;
  /** Submodel */
  submodel?: Maybe<LocalModel>;
  /** Submodel ID */
  submodelId?: Maybe<Scalars['ObjectID']['output']>;
  /** Top speed */
  topSpeed?: Maybe<Scalars['Float']['output']>;
  /** Transmission */
  transmission?: Maybe<TransmissionKind>;
  /** Vehicle Price */
  vehiclePrice: Scalars['Float']['output'];
  /** Versioning */
  versioning: AdvancedVersioning;
};


export type LocalVariantMonthlyInstalmentArgs = {
  applicationModuleIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  bankModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type LocalVariantFilteringRule = {
  /** Filter by application module id */
  applicationModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by multiple company IDs */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by Dealer ID in application module */
  dealerIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by Engine Type */
  engineType?: InputMaybe<Array<EngineType>>;
  /** Filter by vehicle ID */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Filter by model IDs */
  modelIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Module ID (mandatory with production only), which is vehicle module */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by local variant display name */
  name?: InputMaybe<TranslatedStringInput>;
  purpose?: InputMaybe<Purpose>;
  /** Filter by submodel IDs */
  submodelIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export type LocalVariantSettings = {
  /** Apple Car Play */
  appleCarPlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bank Code Mappings */
  bankCodeMappings?: InputMaybe<Array<InputMaybe<VariantBankCodeMappingInput>>>;
  /** Body Type */
  bodyType: BodyType;
  /** Description */
  description: TranslatedStringInput;
  /** Energy consumption */
  energyConsumption?: InputMaybe<EnergyConsumptionInput>;
  /** Engine */
  engine: TranslatedStringInput;
  /** Engine Displacement (cc) */
  engineDisplacement?: InputMaybe<Scalars['Int']['input']>;
  /** Engine Type */
  engineType: EngineType;
  /** Features */
  features: TranslatedStringInput;
  /** Vehicle ID */
  identifier: Scalars['String']['input'];
  /** Is active */
  isActive: Scalars['Boolean']['input'];
  /** Model object ID */
  modelId: Scalars['ObjectID']['input'];
  /** Model Year */
  modelYear?: InputMaybe<Scalars['Int']['input']>;
  /** Variant name */
  name: TranslatedStringInput;
  /** Order Number */
  order: Scalars['Int']['input'];
  /** Power output */
  powerOutput?: InputMaybe<Scalars['Float']['input']>;
  /** Seats */
  seats?: InputMaybe<Scalars['Int']['input']>;
  /** Submodel object ID */
  submodelId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Top speed */
  topSpeed?: InputMaybe<Scalars['Float']['input']>;
  /** Transmission */
  transmission?: InputMaybe<TransmissionKind>;
  /** Vehicle Price */
  vehiclePrice: Scalars['Float']['input'];
};

export enum LocalVariantSortingField {
  /** Sort by company */
  Company = 'Company',
  /** Sort by identifier */
  Identifier = 'Identifier',
  /** Sort by is active */
  IsActive = 'IsActive',
  /** Sort by model ID */
  ModelId = 'ModelId',
  /** Sort by model name */
  ModelName = 'ModelName',
  /** Sort by model order then variant order */
  ModelOrderAndVariantOrder = 'ModelOrderAndVariantOrder',
  /** Sort by variant name */
  Name = 'Name',
  /** Sort by order number */
  Order = 'Order',
  /** Sort by price */
  Price = 'Price',
  /** Sort by submodel name */
  SubmodelName = 'SubmodelName'
}

export type LocalVariantSortingRule = {
  /** Field on which apply the sorting */
  field: LocalVariantSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type LocalizedColorGroup = ILocalizedValue & {
  __typename: 'LocalizedColorGroup';
  hexCode?: Maybe<Scalars['String']['output']>;
  localize?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};


export type LocalizedColorGroupLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedInteriorColorGroup = ILocalizedValue & {
  __typename: 'LocalizedInteriorColorGroup';
  hexCode: Scalars['String']['output'];
  localize?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};


export type LocalizedInteriorColorGroupLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedLabeledValue = {
  __typename: 'LocalizedLabeledValue';
  localize?: Maybe<LabeledValue>;
};


export type LocalizedLabeledValueLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedModelCategory = ILocalizedValue & {
  __typename: 'LocalizedModelCategory';
  localize?: Maybe<Scalars['String']['output']>;
  modelSeries: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


export type LocalizedModelCategoryLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedModelGeneration = ILocalizedValue & {
  __typename: 'LocalizedModelGeneration';
  localize?: Maybe<Scalars['String']['output']>;
  modelSeries: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


export type LocalizedModelGenerationLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedSalesFilter = {
  __typename: 'LocalizedSalesFilter';
  localize: Scalars['String']['output'];
  value: SalesFilter;
};


export type LocalizedSalesFilterLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedSortOption = {
  __typename: 'LocalizedSortOption';
  localize: Scalars['String']['output'];
  value: SortOption;
};


export type LocalizedSortOptionLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedStandardEquipment = {
  __typename: 'LocalizedStandardEquipment';
  localize?: Maybe<Array<StandardEquipmentCategory>>;
};


export type LocalizedStandardEquipmentLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedString = {
  __typename: 'LocalizedString';
  localize?: Maybe<Scalars['String']['output']>;
};


export type LocalizedStringLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedTechnicalData = {
  __typename: 'LocalizedTechnicalData';
  localize?: Maybe<Array<TechnicalDataCategory>>;
};


export type LocalizedTechnicalDataLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedValue = ILocalizedValue & {
  __typename: 'LocalizedValue';
  localize?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};


export type LocalizedValueLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedVehicleType = {
  __typename: 'LocalizedVehicleType';
  localize: Scalars['String']['output'];
  value: VehicleType;
};


export type LocalizedVehicleTypeLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type Location = {
  __typename: 'Location';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type LocationCondition = Condition & {
  __typename: 'LocationCondition';
  isHomeDelivery: Scalars['Boolean']['output'];
  location?: Maybe<MobilityLocation>;
  locationId?: Maybe<Scalars['ObjectID']['output']>;
  type: ConditionType;
};

export type LocationConditionSettings = {
  isHomeDelivery: Scalars['Boolean']['input'];
  locationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type LocationFilteringRule = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum LocationSortingField {
  Name = 'Name'
}

export type LocationSortingRule = {
  /** Field on which apply the sorting */
  field: LocationSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type LogicCondition = Condition & {
  __typename: 'LogicCondition';
  children: Array<Condition>;
  type: ConditionType;
};

export type LogicConditionSettings = {
  children: Array<ConditionSettings>;
};

export type LowestMonthlyInstalmentPayload = {
  /** Application Module Id */
  applicationModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Assigned Only - If it is true, only finance product which has the variant assigned will be considered */
  assignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bank Module Id */
  bankModuleId: Scalars['ObjectID']['input'];
  /** Car Price */
  carPrice: Scalars['Float']['input'];
  /** Dealer Id */
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Total Price */
  totalPrice: Scalars['Float']['input'];
  /** Variant Suite Id */
  variantSuiteId: Scalars['ObjectID']['input'];
};

export type MfaSettings = {
  __typename: 'MFASettings';
  enabledOn: Scalars['DateTime']['output'];
  type: MfaSettingsType;
};

export type MfaSettingsPayload = {
  type: MfaSettingsType;
};

export enum MfaSettingsType {
  SmsOtp = 'SmsOTP'
}

export type MaintenanceDetailsSettings = {
  /** Is Active */
  isActive: Scalars['Boolean']['input'];
  /** Page content */
  pageContent?: InputMaybe<TranslatedStringInput>;
  /** Page title */
  pageTitle: TranslatedStringInput;
  /** Period */
  period: PeriodPayload;
  /** Warning Before */
  warningBefore?: InputMaybe<Scalars['Int']['input']>;
};

export type MaintenanceModule = Module & {
  __typename: 'MaintenanceModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Image */
  image?: Maybe<UploadedFileWithPreview>;
  /** Is Active */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Page content */
  pageContent?: Maybe<TranslatedString>;
  /** Page title */
  pageTitle?: Maybe<TranslatedString>;
  /** Period */
  period?: Maybe<Period>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
  /** Warning Before */
  warningBefore?: Maybe<Scalars['Int']['output']>;
};

export type MaintenanceModuleSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
};

export type MaintenanceUpdate = {
  __typename: 'MaintenanceUpdate';
  /** Company */
  company: Company;
  /** Company Id */
  companyId: Scalars['ObjectID']['output'];
  /** Time when the update is released */
  date: Scalars['DateTime']['output'];
  /** Image */
  image?: Maybe<UploadedFileWithPreview>;
  /** Activeness */
  isActive: Scalars['Boolean']['output'];
  /** Page content */
  pageContent?: Maybe<TranslatedString>;
  /** Page title */
  pageTitle: TranslatedString;
  /** Period */
  period: Period;
  /** Warning Before */
  warningBefore?: Maybe<Scalars['Int']['output']>;
};

export type MandatoryCompoundValuePayload = {
  amount: Scalars['Float']['input'];
  percentage: Scalars['Float']['input'];
};

export type MarketingApplicationAgreement = ApplicationAgreement & {
  __typename: 'MarketingApplicationAgreement';
  /** Conditions */
  conditions?: Maybe<Array<Condition>>;
  /** Data field */
  dataField: DataField;
  /** Default Checked */
  defaultChecked: Scalars['Boolean']['output'];
  /** Description */
  description?: Maybe<TranslatedString>;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is agreed by the customer */
  isAgreed: Scalars['Boolean']['output'];
  /** Mandatory */
  isMandatory: Scalars['Boolean']['output'];
  /** Order Number */
  orderNumber: Scalars['Int']['output'];
  /** Platform */
  platform: MarketingPlatform;
  /** Platforms agreed */
  platformsAgreed: MarketingPlatformsAgreed;
  /** Purpose */
  purpose: Array<ConsentsAndDeclarationsPurpose>;
  /** Title */
  title?: Maybe<TranslatedString>;
  /** C&D type */
  type: ConsentsAndDeclarationsType;
};

export type MarketingConsentsAndDeclarations = ConsentsAndDeclarations & {
  __typename: 'MarketingConsentsAndDeclarations';
  /** Conditions */
  conditions?: Maybe<Array<Condition>>;
  /** Data field */
  dataField: DataField;
  /** Default Checked for channels */
  defaultChecked: Scalars['Boolean']['output'];
  /** Description */
  description?: Maybe<TranslatedString>;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** Feature Purpose */
  featurePurpose: ConsentFeaturePurpose;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is active */
  isActive: Scalars['Boolean']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Mandatory */
  isMandatory: Scalars['Boolean']['output'];
  /** Module */
  module: Module;
  /** Module ID */
  moduleId: Scalars['ObjectID']['output'];
  /** Order Number */
  orderNumber: Scalars['Int']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Platform */
  platform: MarketingPlatform;
  /** Purpose */
  purpose: Array<ConsentsAndDeclarationsPurpose>;
  /** Title */
  title?: Maybe<TranslatedString>;
  /** C&D type */
  type: ConsentsAndDeclarationsType;
  /** Versioning */
  versioning: AdvancedVersioning;
};

export type MarketingConsentsAndDeclarationsSettings = {
  /** Data field */
  dataField: DataField;
  /** Default Checked for channels */
  defaultChecked: Scalars['Boolean']['input'];
  /** Description */
  description?: InputMaybe<TranslatedStringInput>;
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** Is active */
  isActive: Scalars['Boolean']['input'];
  /** Mandatory */
  isMandatory: Scalars['Boolean']['input'];
  /** Order Number */
  orderNumber: Scalars['Int']['input'];
  /** Plaform */
  platform: MarketingPlatformInput;
  /** Purpose */
  purpose: Array<ConsentsAndDeclarationsPurpose>;
  /** Title */
  title?: InputMaybe<TranslatedStringInput>;
};

export type MarketingPlatform = {
  __typename: 'MarketingPlatform';
  email: Scalars['Boolean']['output'];
  fax: Scalars['Boolean']['output'];
  mail: Scalars['Boolean']['output'];
  phone: Scalars['Boolean']['output'];
  sms: Scalars['Boolean']['output'];
};

export type MarketingPlatformInput = {
  email: Scalars['Boolean']['input'];
  fax: Scalars['Boolean']['input'];
  mail: Scalars['Boolean']['input'];
  phone: Scalars['Boolean']['input'];
  sms: Scalars['Boolean']['input'];
};

export type MarketingPlatformsAgreed = {
  __typename: 'MarketingPlatformsAgreed';
  email: Scalars['Boolean']['output'];
  fax: Scalars['Boolean']['output'];
  mail: Scalars['Boolean']['output'];
  phone: Scalars['Boolean']['output'];
  sms: Scalars['Boolean']['output'];
};

export type MarketingPlatformsAgreedInput = {
  email: Scalars['Boolean']['input'];
  fax: Scalars['Boolean']['input'];
  mail: Scalars['Boolean']['input'];
  phone: Scalars['Boolean']['input'];
  sms: Scalars['Boolean']['input'];
};

export enum MaskDirection {
  Back = 'Back',
  Front = 'Front',
  None = 'None'
}

export type MaskSettings = {
  __typename: 'MaskSettings';
  /** Mask Count */
  count: Scalars['Int']['output'];
  /** Mask Direction */
  direction: MaskDirection;
};

export type MaskSettingsPayload = {
  count: Scalars['Int']['input'];
  direction: MaskDirection;
};

export type Matrix = {
  __typename: 'Matrix';
  /** Color setting */
  color?: Maybe<ColorAndTrimSettings>;
  /** Color hex */
  colorId: Scalars['ObjectID']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Trim setting */
  trim?: Maybe<ColorAndTrimSettings>;
  /** Trim Hex */
  trimId: Scalars['ObjectID']['output'];
  /** Variant Color Image */
  variantColorImage?: Maybe<UploadedFileWithPreview>;
  /** Variant Trim Image */
  variantTrimImage?: Maybe<UploadedFileWithPreview>;
};

export enum MatrixAsset {
  ColorImage = 'ColorImage',
  TrimImage = 'TrimImage'
}

export enum MaybankEnvironment {
  Production = 'Production',
  Sit = 'SIT',
  Staging = 'Staging',
  Uat = 'UAT'
}

export type MaybankIntegration = BankIntegration & {
  __typename: 'MaybankIntegration';
  allowedIps: Scalars['String']['output'];
  apiKey: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  dealerCode?: Maybe<Scalars['String']['output']>;
  dealerId?: Maybe<Scalars['String']['output']>;
  encryptionPrivateKey: Scalars['String']['output'];
  encryptionPublicCert: Scalars['String']['output'];
  environment: MaybankEnvironment;
  generatedId: Scalars['String']['output'];
  generatedSecrets: Scalars['String']['output'];
  host: Scalars['String']['output'];
  provider: BankIntegrationProvider;
  signaturePrivateKey: Scalars['String']['output'];
  signaturePublicCert: Scalars['String']['output'];
};

export type MaybankIntegrationSettings = {
  allowedIps: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  dealerCode?: InputMaybe<Scalars['String']['input']>;
  dealerId?: InputMaybe<Scalars['String']['input']>;
  encryptionPrivateKey: Scalars['String']['input'];
  encryptionPublicCert: Scalars['String']['input'];
  environment: MaybankEnvironment;
  host: Scalars['String']['input'];
  signaturePrivateKey: Scalars['String']['input'];
  signaturePublicCert: Scalars['String']['input'];
};

export type MaybankIntegrationUpdateSettings = {
  allowedIps: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  dealerCode?: InputMaybe<Scalars['String']['input']>;
  dealerId?: InputMaybe<Scalars['String']['input']>;
  encryptionPrivateKey?: InputMaybe<Scalars['String']['input']>;
  encryptionPublicCert: Scalars['String']['input'];
  environment: MaybankEnvironment;
  host: Scalars['String']['input'];
  signaturePrivateKey?: InputMaybe<Scalars['String']['input']>;
  signaturePublicCert: Scalars['String']['input'];
};

export type MaybankNewCarFinance = SdmFinancing & {
  __typename: 'MaybankNewCarFinance';
  bank: Scalars['String']['output'];
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  type: FinanceType;
};

export type MaybankUsedCarFinance = SdmFinancing & {
  __typename: 'MaybankUsedCarFinance';
  bank: Scalars['String']['output'];
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  type: FinanceType;
};

export type MenuCustomPathItem = MenuItem & {
  __typename: 'MenuCustomPathItem';
  /** Icon */
  icon?: Maybe<Scalars['String']['output']>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Label */
  label: TranslatedString;
  /** Pathname */
  pathname: Scalars['String']['output'];
};

export type MenuCustomPathItemSettings = {
  /** Icon */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Label */
  label: TranslatedStringInput;
  /** Pathname */
  pathname: Scalars['String']['input'];
};

export type MenuEndpointItem = MenuItem & {
  __typename: 'MenuEndpointItem';
  /** Endpoint */
  endpoint: Endpoint;
  /** Endpoint ID */
  endpointId: Scalars['ObjectID']['output'];
  /** Icon */
  icon?: Maybe<Scalars['String']['output']>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Label */
  label: TranslatedString;
};

export type MenuEndpointItemSettings = {
  /** Endpoint ID */
  endpointId: Scalars['ObjectID']['input'];
  /** Icon */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Label */
  label: TranslatedStringInput;
};

export type MenuItem = {
  /** Icon */
  icon?: Maybe<Scalars['String']['output']>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Label */
  label: TranslatedString;
};

export type MenuItemSettings = {
  customPathItem?: InputMaybe<MenuCustomPathItemSettings>;
  endpointItem?: InputMaybe<MenuEndpointItemSettings>;
  logoutActionItem?: InputMaybe<MenuLogoutActionItemSettings>;
};

export type MenuLogoutActionItem = MenuItem & {
  __typename: 'MenuLogoutActionItem';
  /** Icon */
  icon?: Maybe<Scalars['String']['output']>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Label */
  label: TranslatedString;
};

export type MenuLogoutActionItemSettings = {
  /** Icon */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Label */
  label: TranslatedStringInput;
};

export type MessageNotice = {
  __typename: 'MessageNotice';
  date: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
};

export enum MileageUnit {
  Kilometer = 'kilometer',
  Mile = 'mile'
}

export type Mobility = MobilityAdditionalInfo | MobilityAddon;

export type MobilityAdditionalInfo = {
  __typename: 'MobilityAdditionalInfo';
  /** Detail */
  detail: Array<MobilityDetail>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is active */
  isActive: Scalars['Boolean']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Mobility Kind */
  kind: MobilityKind;
  /** Module */
  module: Module;
  /** ModuleId */
  moduleId: Scalars['ObjectID']['output'];
  /** Order Number */
  order: Scalars['Int']['output'];
  /** StockIds */
  stockIds: Array<Scalars['ObjectID']['output']>;
  /** Title */
  title: TranslatedString;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type MobilityAdditionalInfoSetting = {
  /** Detail */
  detail: Array<MobilityDetailPayload>;
  /** Is active */
  isActive: Scalars['Boolean']['input'];
  /** Order Number */
  order: Scalars['Int']['input'];
  /** StockIds */
  stockIds: Array<Scalars['ObjectID']['input']>;
  /** Title */
  title: TranslatedStringInput;
};

export type MobilityAdditionalInfoSnapshot = MobilitySnapshot & {
  __typename: 'MobilityAdditionalInfoSnapshot';
  detail: Array<MobilityDetail>;
  mobilityId: Scalars['ObjectID']['output'];
  title: TranslatedString;
};

export type MobilityAddon = {
  __typename: 'MobilityAddon';
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is active */
  isActive: Scalars['Boolean']['output'];
  /** Is Chargeable */
  isChargeable: Scalars['Boolean']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Mobility Kind */
  kind: MobilityKind;
  /** Module */
  module: Module;
  /** ModuleId */
  moduleId: Scalars['ObjectID']['output'];
  /** Mobility Options */
  options: Array<MobilityOption>;
  /** Order Number */
  order: Scalars['Int']['output'];
  /** Reference name */
  referenceName: Scalars['String']['output'];
  /** StockIds */
  stockIds: Array<Scalars['ObjectID']['output']>;
  /** Title */
  title: TranslatedString;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type MobilityAddonSetting = {
  /** Is active */
  isActive: Scalars['Boolean']['input'];
  /** Is Chargeable */
  isChargeable: Scalars['Boolean']['input'];
  /** Mobility Options */
  options: Array<MobilityOptionPayload>;
  /** Order Number */
  order: Scalars['Int']['input'];
  /** Reference name */
  referenceName: Scalars['String']['input'];
  /** StockIds */
  stockIds: Array<Scalars['ObjectID']['input']>;
  /** Title */
  title: TranslatedStringInput;
};

export type MobilityAddonSnapshot = MobilitySnapshot & {
  __typename: 'MobilityAddonSnapshot';
  mobilityId: Scalars['ObjectID']['output'];
  option: MobilityOption;
  title: TranslatedString;
};

export type MobilityApplication = Application & {
  __typename: 'MobilityApplication';
  /** List of previous versions of the application */
  amendments?: Maybe<Array<MobilityApplication>>;
  /** Applicant */
  applicant: Customer;
  /** Agreements for the applicant */
  applicantAgreements: Array<ApplicationAgreement>;
  /** Applicant ID */
  applicantId: Scalars['ObjectID']['output'];
  /** KYC fields for the applicant */
  applicantKYC: Array<KycField>;
  appointmentStage?: Maybe<AppointmentStage>;
  /** assignees this application can be assigned to */
  availableAssignees: Array<User>;
  /** Agreements for the corporate */
  corporateAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the corporate */
  corporateKYC: Array<KycField>;
  /** Dealer data */
  dealer: Dealer;
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['output'];
  /** Application Deposit */
  deposit?: Maybe<ApplicationDeposit>;
  /** Application Document */
  documents: Array<ApplicationDocument>;
  /** Drafting flow */
  draftFlow: StandardApplicationDraftFlow;
  /** Endpoint */
  endpoint?: Maybe<Endpoint>;
  /** Expired Time */
  expireAt?: Maybe<Scalars['DateTime']['output']>;
  financingStage?: Maybe<FinancingStage>;
  /** Promo Code data */
  giftVoucher?: Maybe<GiftVoucher>;
  /** Promo Code ID */
  giftVoucherSuiteId?: Maybe<Scalars['ObjectID']['output']>;
  /**
   * Guarantor
   * currently only have 1 Guarantor
   * might have more guarantor in future
   */
  guarantor?: Maybe<Customer>;
  /** Agreements for the guarantor */
  guarantorAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the guarantor */
  guarantorKYC: Array<KycField>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  insuranceStage?: Maybe<InsuranceStage>;
  /** Journey Steps Identifiers */
  journeySteps: Array<Scalars['String']['output']>;
  /** Language ID to determine what language user chose in journey */
  languageId?: Maybe<Scalars['ObjectID']['output']>;
  latestStage?: Maybe<ApplicationStageDetails>;
  leadStage?: Maybe<LeadStage>;
  /** Mobility booking details */
  mobilityBookingDetails: MobilityBookingDetails;
  /** Mobility snapshots */
  mobilitySnapshots: Array<MobilitySnapshot>;
  mobilityStage?: Maybe<MobilityStage>;
  /** Module */
  module: Module;
  /** ModuleId */
  moduleId: Scalars['ObjectID']['output'];
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Promo Code data */
  promoCode?: Maybe<PromoCode>;
  /** Promo Code Amount */
  promoCodeAmount?: Maybe<Scalars['Float']['output']>;
  /** Promo Code ID */
  promoCodeId?: Maybe<Scalars['ObjectID']['output']>;
  remarks: Scalars['String']['output'];
  reservationStage?: Maybe<ReservationStage>;
  /** Router */
  router?: Maybe<Router>;
  /** Router ID */
  routerId?: Maybe<Scalars['ObjectID']['output']>;
  scenarios: Array<ApplicationScenario>;
  /** Application Signing */
  signing?: Maybe<ApplicationSigning>;
  stages: Array<ApplicationStage>;
  /** Vehicle */
  vehicle: Vehicle;
  /** Vehicle ID */
  vehicleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: AdvancedVersioning;
  /** stock vin */
  vin?: Maybe<Scalars['String']['output']>;
};

export type MobilityApplicationAmendmentLink = {
  __typename: 'MobilityApplicationAmendmentLink';
  application: Application;
  path: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type MobilityApplicationCancellationLink = {
  __typename: 'MobilityApplicationCancellationLink';
  application: Application;
  endpoint: Endpoint;
  path: Scalars['String']['output'];
  router: Router;
  token: Scalars['String']['output'];
};

export type MobilityApplicationEntrypoint = Endpoint & {
  __typename: 'MobilityApplicationEntrypoint';
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Mobility Application Module */
  mobilityApplicationModule: MobilityModule;
  /** Mobility Application Module ID */
  mobilityApplicationModuleId: Scalars['ObjectID']['output'];
  /** Pathname */
  pathname: Scalars['String']['output'];
};

export type MobilityApplicationEntrypointSettings = {
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** Pathname */
  pathname: Scalars['String']['input'];
};

export enum MobilityAsset {
  BookingAmendment = 'BookingAmendment',
  BookingCancellation = 'BookingCancellation',
  BookingCheckedIn = 'BookingCheckedIn',
  BookingComplete = 'BookingComplete',
  BookingConfirmation = 'BookingConfirmation',
  BookingReminder = 'BookingReminder'
}

export type MobilityBookingDetails = {
  __typename: 'MobilityBookingDetails';
  bookingCode?: Maybe<Scalars['String']['output']>;
  inventoryStock: StockInventory;
  inventoryStockId: Scalars['ObjectID']['output'];
  inventoryStockPrice: Scalars['Float']['output'];
  location: MobilityBookingLocation;
  period: Period;
};

export type MobilityBookingDetailsPayload = {
  bookingCode?: InputMaybe<Scalars['String']['input']>;
  inventoryStockId: Scalars['ObjectID']['input'];
  location: MobilityBookingLocationPayload;
  period: PeriodPayload;
};

export type MobilityBookingLocation = MobilityBookingLocationHome | MobilityBookingLocationPickup;

export type MobilityBookingLocationHome = {
  __typename: 'MobilityBookingLocationHome';
  id?: Maybe<Scalars['ObjectID']['output']>;
  type: MobilityBookingLocationType;
};

export type MobilityBookingLocationHomeDeliveryPayload = {
  id?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type MobilityBookingLocationPayload = {
  homeDelivery?: InputMaybe<MobilityBookingLocationHomeDeliveryPayload>;
  isHomeDelivery: Scalars['Boolean']['input'];
  pickup?: InputMaybe<MobilityBookingLocationPickupPayload>;
};

export type MobilityBookingLocationPickup = {
  __typename: 'MobilityBookingLocationPickup';
  address: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id?: Maybe<Scalars['ObjectID']['output']>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  type: MobilityBookingLocationType;
  url: Scalars['String']['output'];
};

export type MobilityBookingLocationPickupPayload = {
  address: Scalars['String']['input'];
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export enum MobilityBookingLocationType {
  Home = 'Home',
  Pickup = 'Pickup'
}

export type MobilityCustomerEmailContent = {
  __typename: 'MobilityCustomerEmailContent';
  bookingAmendment: MobilityEmailContent;
  bookingCancellation: MobilityEmailContent;
  bookingCheckedIn: MobilityEmailContent;
  bookingComplete: MobilityEmailContent;
  bookingConfirmation: MobilityEmailContent;
  bookingReminder: MobilityEmailContent;
};

export type MobilityCustomerEmailContentInput = {
  bookingAmendment?: InputMaybe<MobilityEmailContentInput>;
  bookingCancellation?: InputMaybe<MobilityEmailContentInput>;
  bookingCheckedIn?: InputMaybe<MobilityEmailContentInput>;
  bookingComplete?: InputMaybe<MobilityEmailContentInput>;
  bookingConfirmation?: InputMaybe<MobilityEmailContentInput>;
  bookingReminder?: InputMaybe<MobilityEmailContentInput>;
};

export type MobilityDetail = {
  __typename: 'MobilityDetail';
  description: TranslatedString;
  subTitle: TranslatedString;
};

export type MobilityDetailPayload = {
  description: TranslatedStringInput;
  subTitle: TranslatedStringInput;
};

export type MobilityDetailsAddonPayload = {
  name: TranslatedStringInput;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type MobilityDetailsPayload = {
  addon?: InputMaybe<MobilityDetailsAddonPayload>;
  id: Scalars['ObjectID']['input'];
  kind: MobilityKind;
};

export enum MobilityEmailAssetType {
  IntroImage = 'IntroImage'
}

export type MobilityEmailContent = {
  __typename: 'MobilityEmailContent';
  contentText: DealerTranslationText;
  introImage?: Maybe<UploadedFileWithPreview>;
  introTitle: DealerTranslationText;
  isEmailEnabled?: Maybe<Scalars['Boolean']['output']>;
  subject: DealerTranslationText;
};

export type MobilityEmailContentInput = {
  contentText: DealerTranslationTextInput;
  introTitle: DealerTranslationTextInput;
  isEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subject: DealerTranslationTextInput;
};

export type MobilityEmailScenarioContent = {
  __typename: 'MobilityEmailScenarioContent';
  customers: MobilityCustomerEmailContent;
  id: Scalars['ObjectID']['output'];
  isHomeDelivery: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['ObjectID']['output']>;
  operators: MobilityOperatorEmailContent;
};

export type MobilityEmailScenarioContentInput = {
  customers?: InputMaybe<MobilityCustomerEmailContentInput>;
  id: Scalars['ObjectID']['input'];
  isHomeDelivery: Scalars['Boolean']['input'];
  locationId?: InputMaybe<Scalars['ObjectID']['input']>;
  operators?: InputMaybe<MobilityOperatorEmailContentInput>;
};

export type MobilityFilteringRule = {
  /** Filter by multiple company IDs */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by kind */
  kind?: InputMaybe<MobilityKind>;
  /** Filter by reference name */
  referenceName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Title */
  title?: InputMaybe<TranslatedStringInput>;
};

export type MobilityHomeDelivery = {
  __typename: 'MobilityHomeDelivery';
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['ObjectID']['output']>;
  id: Scalars['ObjectID']['output'];
  isEnable: Scalars['Boolean']['output'];
};

export type MobilityHomeDeliveryInput = {
  assigneeId?: InputMaybe<Scalars['ObjectID']['input']>;
  isEnable: Scalars['Boolean']['input'];
};

export type MobilityInventory = Inventory & {
  __typename: 'MobilityInventory';
  /** Assigned VIN Count */
  assignedVinCount?: Maybe<Scalars['Int']['output']>;
  /** Computed Stock for new configurator application */
  availableStock: Scalars['Int']['output'];
  /** Dealer data */
  dealer: Dealer;
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Inventory Identifier */
  identifier: Scalars['String']['output'];
  /** Is active flag */
  isActive: Scalars['Boolean']['output'];
  /** Soft deletion flag */
  isDeleted: Scalars['Boolean']['output'];
  /** Kind of inventory */
  kind: InventoryKind;
  /** Model */
  model: LocalModel;
  /** Mobility module */
  module: MobilityModule;
  /** Assigned module */
  moduleId: Scalars['ObjectID']['output'];
  /** Period, within which bookings can be made */
  period?: Maybe<Period>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Price, combination price */
  price: Scalars['Float']['output'];
  /** Computed Remaining stock */
  remainingStock: Scalars['Int']['output'];
  /** Computed Reserved stock */
  reservedStock: Scalars['Int']['output'];
  /** Stocks */
  stocks: Array<StockInventory>;
  /** Sub Model (optional) */
  subModel?: Maybe<LocalModel>;
  /** Variant */
  variant: LocalVariant;
  /** variant suite id */
  variantSuiteId: Scalars['ObjectID']['output'];
  /** Simple versioning */
  versioning: SimpleVersioning;
};

export enum MobilityKind {
  AdditionalInfo = 'AdditionalInfo',
  Addon = 'Addon'
}

export type MobilityLocation = {
  __typename: 'MobilityLocation';
  address: Scalars['String']['output'];
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['ObjectID']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  isHomeDelivery?: Maybe<Scalars['Boolean']['output']>;
  moduleId?: Maybe<Scalars['ObjectID']['output']>;
  moduleName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MobilityLocationInput = {
  address: Scalars['String']['input'];
  assigneeId?: InputMaybe<Scalars['ObjectID']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type MobilityModule = Module & {
  __typename: 'MobilityModule';
  /** Agreements module */
  agreementsModule: Module;
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['output'];
  /** Amendment Cut off */
  amendmentCutOff: Scalars['Int']['output'];
  /**
   * Available Booking Range in Datepicker
   * 0 as default means no booking range
   */
  availableNumberOfBookingRange: DateUnit;
  /** Base Url */
  baseUrl?: Maybe<Scalars['String']['output']>;
  /** Booking Code */
  bookingCode: DealerBookingCodeSetting;
  /** Counter for applications */
  bookingsCounter: CounterSettings;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Customer module */
  customerModule: Module;
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Duration before newxt booking */
  durationBeforeNextBooking: Scalars['Float']['output'];
  /** Email Contents */
  emailContents: Array<MobilityEmailScenarioContent>;
  /** External Model Info */
  externalModelInfo: Scalars['Boolean']['output'];
  /** Gift Voucher module id */
  giftVoucherModule?: Maybe<Module>;
  /** Gift Voucher module id */
  giftVoucherModuleId?: Maybe<Scalars['ObjectID']['output']>;
  homeDelivery: MobilityHomeDelivery;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** KYC presets */
  kycPresets: Array<KycPreset>;
  /** Live chat setting */
  liveChatSetting?: Maybe<LiveChatSetting>;
  /** Live chat settings */
  liveChatSettingId?: Maybe<Scalars['ObjectID']['output']>;
  /** Locations */
  locations: Array<MobilityLocation>;
  /** Minimum advanced booking */
  minimumAdvancedBooking: Scalars['Int']['output'];
  /** Payment Settings */
  paymentSettings?: Maybe<PaymentSetting>;
  /** Payment Settings ID */
  paymentSettingsId?: Maybe<Scalars['ObjectID']['output']>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Persist KYC data for booking journey */
  persistKYCData: Scalars['Boolean']['output'];
  /** Promo code module */
  promoCodeModule?: Maybe<Module>;
  /** Promo code module id */
  promoCodeModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Rental Disclaimer */
  rentalDisclaimer: DealerTranslatedStringSetting;
  /** Rental Requirement */
  rentalRequirement: DealerTranslatedStringSetting;
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  sendEmailToCustomer: Scalars['Boolean']['output'];
  sendPDFToCustomer: Scalars['Boolean']['output'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['output'];
  /** Signing Setting */
  signing: MobilitySigningSetting;
  /** Unavailable Day of Week */
  unavailableDayOfWeek: Array<DayOfWeek>;
  /** Unavailable Time Range */
  unavailableTimeRange: Array<Period>;
  /** Vehicle management module */
  vehicleModule: Module;
  /** Vehicle management module ID */
  vehicleModuleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: SimpleVersioning;
};

export type MobilityModuleInitialSettings = {
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['input'];
  /** Amendment Cut off */
  amendmentCutOff: Scalars['Int']['input'];
  /**
   * Available Booking Range in Datepicker
   * 0 as default means no booking range
   */
  availableNumberOfBookingRange: DateUnitInput;
  /** Base Url */
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  /** Booking Code */
  bookingCode: DealerBookingCodeSettingInput;
  /** Counter for booking */
  bookingsCounter: CounterPayload;
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Duration before newxt booking */
  durationBeforeNextBooking: Scalars['Float']['input'];
  /** External Model Info */
  externalModelInfo: Scalars['Boolean']['input'];
  /** Gift Voucher module id */
  giftVoucherModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  homeDelivery: MobilityHomeDeliveryInput;
  /** Live chat settings */
  liveChatSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Price Disclaimer */
  locations: Array<MobilityLocationInput>;
  /** Minimum advanced booking */
  minimumAdvancedBooking: Scalars['Int']['input'];
  /** Payment settings ID */
  paymentSettingsId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Persist KYC data for booking journey */
  persistKYCData: Scalars['Boolean']['input'];
  /** Promo code module id */
  promoCodeModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Rental Disclaimer */
  rentalDisclaimer: DealerTranslatedStringSettingInput;
  /** Rental Requirement */
  rentalRequirement: DealerTranslatedStringSettingInput;
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  sendEmailToCustomer: Scalars['Boolean']['input'];
  sendPDFToCustomer: Scalars['Boolean']['input'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['input'];
  /** Signing */
  signing: MobilitySigningSettingInput;
  /** Unavailable Day of Week */
  unavailableDayOfWeek: Array<DayOfWeek>;
  /** Unavailable Time Range */
  unavailableTimeRange: Array<PeriodPayload>;
  /** Vehicle management module ID */
  vehicleModuleId: Scalars['ObjectID']['input'];
};

export type MobilityModuleUpdateSettings = {
  /** Amendment Cut off */
  amendmentCutOff: Scalars['Int']['input'];
  /**
   * Available Booking Range in Datepicker
   * 0 as default means no booking range
   */
  availableNumberOfBookingRange: DateUnitInput;
  /** Base Url */
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  /** Booking Code */
  bookingCode: DealerBookingCodeSettingInput;
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Duration before newxt booking */
  durationBeforeNextBooking: Scalars['Float']['input'];
  /** External Model Info */
  externalModelInfo: Scalars['Boolean']['input'];
  /** Gift Voucher module id */
  giftVoucherModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  homeDelivery: MobilityHomeDeliveryInput;
  /** Live chat settings */
  liveChatSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Price Disclaimer */
  locations: Array<MobilityLocationInput>;
  /** Minimum advanced booking */
  minimumAdvancedBooking: Scalars['Int']['input'];
  /** Payment settings ID */
  paymentSettingsId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Persist KYC data for booking journey */
  persistKYCData: Scalars['Boolean']['input'];
  /** Promo code module id */
  promoCodeModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Rental Disclaimer */
  rentalDisclaimer: DealerTranslatedStringSettingInput;
  /** Rental Requirement */
  rentalRequirement: DealerTranslatedStringSettingInput;
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  sendEmailToCustomer: Scalars['Boolean']['input'];
  sendPDFToCustomer: Scalars['Boolean']['input'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['input'];
  /** Signing input */
  signing: MobilitySigningSettingInput;
  /** Unavailable Day of Week */
  unavailableDayOfWeek: Array<DayOfWeek>;
  /** Unavailable Time Range */
  unavailableTimeRange: Array<PeriodPayload>;
};

export type MobilityOperatorEmailContent = {
  __typename: 'MobilityOperatorEmailContent';
  bookingAmendment: MobilityEmailContent;
  bookingCancellation: MobilityEmailContent;
  bookingConfirmation: MobilityEmailContent;
};

export type MobilityOperatorEmailContentInput = {
  bookingAmendment?: InputMaybe<MobilityEmailContentInput>;
  bookingCancellation?: InputMaybe<MobilityEmailContentInput>;
  bookingConfirmation?: InputMaybe<MobilityEmailContentInput>;
};

export type MobilityOption = {
  __typename: 'MobilityOption';
  name: TranslatedString;
  price?: Maybe<Scalars['Float']['output']>;
};

export type MobilityOptionPayload = {
  name: TranslatedStringInput;
  price?: InputMaybe<Scalars['Int']['input']>;
};

export enum MobilityRecipient {
  Customers = 'Customers',
  Operators = 'Operators'
}

export type MobilitySigningSetting = {
  __typename: 'MobilitySigningSetting';
  isEnabled: Scalars['Boolean']['output'];
  module?: Maybe<Module>;
  moduleId?: Maybe<Scalars['ObjectID']['output']>;
};

export type MobilitySigningSettingInput = {
  isEnabled: Scalars['Boolean']['input'];
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type MobilitySnapshot = {
  mobilityId: Scalars['ObjectID']['output'];
};

export enum MobilitySortingField {
  /** Sort by Active */
  Active = 'Active',
  /** Sort by company */
  Company = 'Company',
  /** Sort by mobility kind */
  Kind = 'Kind',
  /** Sort by order number */
  Order = 'Order',
  /** Sort by referenceName */
  ReferenceName = 'ReferenceName',
  /** Sort by title */
  Title = 'Title'
}

export type MobilitySortingRule = {
  field: MobilitySortingField;
  order: SortingOrder;
};

export type MobilityStage = ApplicationStageDetails & {
  __typename: 'MobilityStage';
  assignee?: Maybe<User>;
  /** Assignee */
  assigneeId?: Maybe<Scalars['ObjectID']['output']>;
  /** Identifier */
  identifier: Scalars['String']['output'];
  /** Current status */
  status: ApplicationStatus;
};

export type MobilityStockInventory = StockInventory & {
  __typename: 'MobilityStockInventory';
  /** Blocking Dates */
  blockPeriod: Array<StockBlockingPeriod>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Stock Inventory Indentifier */
  identifier: Scalars['String']['output'];
  /** upload images */
  images?: Maybe<Array<Maybe<UploadedFileWithPreview>>>;
  /** Inventory */
  inventory: Inventory;
  /** Inventory Id */
  inventoryId: Scalars['ObjectID']['output'];
  /** Active Status */
  isActive: Scalars['Boolean']['output'];
  /** Kind of stock */
  kind: StockInventoryKind;
  /** Mileage */
  mileage?: Maybe<Scalars['Float']['output']>;
  /** Mobilities */
  mobilities: Array<Mobility>;
  /**
   * Period, within which bookings can be made
   * Overrides the settings on `MobilityInventory`
   */
  period?: Maybe<Period>;
  /** Price for specific stock */
  price?: Maybe<Scalars['Int']['output']>;
  /** Reservation status */
  reservationStatus: ReservationStockStatus;
  /** Reservations */
  reservations: Array<MobilityStockReservation>;
  /** Registered Vin */
  vin: Scalars['String']['output'];
};

export type MobilityStockReservation = {
  __typename: 'MobilityStockReservation';
  applicationId: Scalars['ObjectID']['output'];
  /** Booking Period */
  bookingPeriod: Period;
  reservationExpiryDate: Scalars['DateTime']['output'];
};

export type MobilityVehicleFilters = {
  __typename: 'MobilityVehicleFilters';
  /** Daily Rates */
  dailyRates: Array<RangeAmount>;
  id: Scalars['ObjectID']['output'];
  /** Models */
  models: Array<TranslatedString>;
  /** SubModels */
  submodels: Array<SubmodelFilter>;
};

export type ModelConfigurator = {
  __typename: 'ModelConfigurator';
  /** Banner image or video */
  banner?: Maybe<UploadedFile>;
  /** Banner text */
  bannerText?: Maybe<TranslatedString>;
  /** Banner text position */
  bannerTextPosition?: Maybe<BannerTextPosition>;
  /** Configurator title */
  configuratorTitle: TranslatedString;
  /** Images for page description */
  descriptionImages: Array<UploadedFileWithPreview>;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** External URL */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is Active */
  isActive: Scalars['Boolean']['output'];
  /** Mobile Banner image or video */
  mobileBanner?: Maybe<UploadedFile>;
  /** Model */
  model: Vehicle;
  /** Model Suite ID */
  modelId: Scalars['ObjectID']['output'];
  /** Configurator Module */
  module: Module;
  /** Configurator Module ID */
  moduleId: Scalars['ObjectID']['output'];
  /** Page description */
  pageDescription: TranslatedString;
  /** Page Subtitle */
  pageSubtitle: TranslatedString;
  /** Page title */
  pageTitle: TranslatedString;
  /** Available permissions for model configurator */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  urlIdentifier: Scalars['String']['output'];
  /** Variant configurators IDs */
  variantConfiguratorIds: Array<Scalars['ObjectID']['output']>;
  /** Variant configurators */
  variantConfigurators: Array<VariantConfigurator>;
  /** Vehicle Module */
  vehicleModule: Module;
  versioning: SimpleVersioning;
};

export enum ModelConfiguratorAsset {
  Banner = 'Banner',
  MobileBanner = 'mobileBanner'
}

export type ModelConfiguratorFilteringRule = {
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by multiple company IDs */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by configurator module display name */
  configuratorModuleDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** Is Active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by module ID */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Production Only */
  productionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by vehicle body types */
  vehicleBodyTypes?: InputMaybe<Array<BodyType>>;
  /** Filter by vehicle engines */
  vehicleEngines?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by vehicle model display name */
  vehicleModelDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by vehicle module display name */
  vehicleModuleDisplayName?: InputMaybe<Scalars['String']['input']>;
};

export type ModelConfiguratorFilters = {
  __typename: 'ModelConfiguratorFilters';
  /** Body Types (to do) */
  bodyTypes: Array<BodyType>;
  /** Engines */
  engines: Array<TranslatedString>;
  id: Scalars['ObjectID']['output'];
};

export type ModelConfiguratorSettings = {
  bannerText?: InputMaybe<TranslatedStringInput>;
  bannerTextPosition?: InputMaybe<BannerTextPosition>;
  configuratorTitle: TranslatedStringInput;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  pageDescription: TranslatedStringInput;
  pageSubtitle: TranslatedStringInput;
  pageTitle: TranslatedStringInput;
  priceDisclaimer: DealerDisclaimersConfiguratorInput;
  urlIdentifier: Scalars['String']['input'];
};

export enum ModelConfiguratorSortingField {
  /** Sort by company */
  Company = 'Company',
  /** Sort by configurator module display name */
  ConfiguratorModuleDisplayName = 'ConfiguratorModuleDisplayName',
  /** Sort by display name */
  DisplayName = 'DisplayName',
  /** Sort by variant configurator count */
  VariantConfiguratorCount = 'VariantConfiguratorCount',
  /** Sort by vehicle module display name */
  VehicleModuleDisplayName = 'VehicleModuleDisplayName',
  /** Sort by vehicle price */
  VehiclePrice = 'VehiclePrice'
}

export type ModelConfiguratorSortingRule = {
  /** Field on which to apply the sorting */
  field: ModelConfiguratorSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type Module = {
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
};

export enum ModuleAsset {
  Image = 'Image'
}

export type ModuleFilteringRule = {
  /** Filter for a specific company */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter for multiple companies */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by company name */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** is Filter for CTS Setting Finder Module */
  isForCTSSettingFinderModule?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter for specific roles */
  moduleRole?: InputMaybe<ModuleRole>;
  /** Filter for specific module class/type */
  moduleType?: InputMaybe<ModuleType>;
  /** Filter for multiple module types */
  moduleTypes?: InputMaybe<Array<ModuleType>>;
};

export type ModuleOption = {
  __typename: 'ModuleOption';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** porscheMasterDataModuleId */
  porscheMasterDataModuleId?: Maybe<Scalars['ObjectID']['output']>;
};

export enum ModuleRole {
  /** Application */
  Application = 'Application',
  /** Banking features */
  Banking = 'Banking',
  /** Event Application */
  EventApplication = 'EventApplication',
  /** Insurance */
  Insurance = 'Insurance',
  /** Mobility */
  Mobility = 'Mobility',
  /** MyInfo */
  MyInfo = 'MyInfo',
  /** Payment features */
  Payment = 'Payment',
  /** Promo Code */
  PromoCode = 'PromoCode',
  /** Signing features (OTP, Namirial, Adobe Sign etc..) */
  Signing = 'Signing',
  /** Trade-In */
  TradeIn = 'TradeIn'
}

export enum ModuleSortingField {
  CompanyName = 'CompanyName',
  DisplayName = 'DisplayName',
  ModuleType = 'ModuleType'
}

export type ModuleSortingRule = {
  /** Field on which apply the sorting */
  field: ModuleSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export enum ModuleType {
  /** Adyen Payment Gateway */
  AdyenPaymentModule = 'AdyenPaymentModule',
  /** Appointment Module */
  AppointmentModule = 'AppointmentModule',
  /** Audi Calculation Module */
  AudiCalculationModule = 'AudiCalculationModule',
  /** Audi Financing Module */
  AudiFinancingModule = 'AudiFinancingModule',
  /** Audi Sales Force Module */
  AudiSalesForceModule = 'AudiSalesForceModule',
  /** Autoplay Module */
  AutoplayModule = 'AutoplayModule',
  /** Legacy banking module */
  BankModule = 'BankModule',
  /** OTP signing */
  BasicSigningModule = 'BasicSigningModule',
  /** BMW Module */
  BmwModule = 'BmwModule',
  /** C@P Module */
  CapModule = 'CapModule',
  /** ConfiguratorModule */
  ConfiguratorModule = 'ConfiguratorModule',
  /** Legacy consent & declarations */
  ConsentsAndDeclarations = 'ConsentsAndDeclarations',
  /** Porsche CTS Module */
  CtsModule = 'CtsModule',
  /** Event Application (AFC Legacy) */
  EventApplicationModule = 'EventApplicationModule',
  /** Finder Application Private Module */
  FinderApplicationPrivateModule = 'FinderApplicationPrivateModule',
  /** Finder Application Public Module */
  FinderApplicationPublicModule = 'FinderApplicationPublicModule',
  /** Finder Vehicle Management Module */
  FinderVehicleManagement = 'FinderVehicleManagement',
  /** Fiserv Payment Module */
  FiservPaymentModule = 'FiservPaymentModule',
  /** Gift Voucher Module */
  GiftVoucherModule = 'GiftVoucherModule',
  /** Insurance Module */
  InsuranceModule = 'InsuranceModule',
  /** Labels Module */
  LabelsModule = 'LabelsModule',
  /** Local customer management */
  LocalCustomerManagement = 'LocalCustomerManagement',
  /** Maintenance Module */
  MaintenanceModule = 'MaintenanceModule',
  /** Mobility Module */
  MobilityModule = 'MobilityModule',
  /** MyInfo */
  MyInfoModule = 'MyInfoModule',
  /** E-Signing with Namirial */
  NamirialSigningModule = 'NamirialSigningModule',
  /** PayGate Payment Module */
  PayGatePaymentModule = 'PayGatePaymentModule',
  /** Porsche Master Data Module */
  PorscheMasterDataModule = 'PorscheMasterDataModule',
  /** Porsche Payment Module */
  PorschePaymentModule = 'PorschePaymentModule',
  /** Promo Code Module */
  PromoCodeModule = 'PromoCodeModule',
  /** SDM Module */
  SdmModule = 'SdmModule',
  /** Simple/local vehicle management */
  SimpleVehicleManagement = 'SimpleVehicleManagement',
  /** Standard Application (AFC Legacy) */
  StandardApplicationModule = 'StandardApplicationModule',
  /** Trade In Module */
  TradeInModule = 'TradeInModule',
  /** TTB Payment Module */
  TtbPaymentModule = 'TtbPaymentModule',
  /** Userlike Chatbot Module */
  UserlikeChatbotModule = 'UserlikeChatbotModule',
  /** Website Module */
  WebsiteModule = 'WebsiteModule',
  /** Whatsapp Live Chat Module */
  WhatsappLiveChatModule = 'WhatsappLiveChatModule'
}

export type ModuleVariant = {
  __typename: 'ModuleVariant';
  /** Added Variants */
  addedVariantSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Added Variants */
  addedVariants: Array<LocalVariant>;
  /** Modules */
  module: Module;
  /** Module */
  moduleId: Scalars['ObjectID']['output'];
};

export type ModuleVariantInput = {
  /** Added Variants */
  addedVariantSuiteIds: Array<Scalars['ObjectID']['input']>;
  /** Module */
  moduleId: Scalars['ObjectID']['input'];
};

export type ModuleWithSalesForceSetting = AudiFinancingModule | SdmModule;

export type MonthlyPaymentFixedInterestRateSettingPayload = {
  isViewable: Scalars['Boolean']['input'];
};

export type MonthlyPaymentFixedInterestRateSettings = {
  __typename: 'MonthlyPaymentFixedInterestRateSettings';
  isViewable: Scalars['Boolean']['output'];
};

export type MultiSelectOptionSettings = {
  __typename: 'MultiSelectOptionSettings';
  kind?: Maybe<OptionKind>;
  options: Array<Option>;
};

export type MultiSelectOptionSettingsInput = {
  options: Array<OptionInput>;
};

export type Mutation = {
  __typename: 'Mutation';
  /** Add Comment to Audit Trail */
  addAuditTrailComment: Scalars['Boolean']['output'];
  /** Add Comment to customer Audit Trail */
  addCustomerAuditTrailComment: Scalars['Boolean']['output'];
  /** Add Comment to Inventory Audit Trail */
  addInventoryAuditTrailComment: Scalars['Boolean']['output'];
  /** Add stock inventory */
  addStockInventory: Inventory;
  /** Add comment to trade-in Audit Trail */
  addTradeInAuditTrailComment: Scalars['Boolean']['output'];
  /** Add LTA data into existing vehicle */
  addVehicleLta: Vehicle;
  /** Amend mobility application */
  amendMobilityApplication?: Maybe<ApplicationJourney>;
  /** Apply basic layout on Router */
  applyBasicLayoutOnRouter?: Maybe<Router>;
  /** Apply Basic pro layout on Router */
  applyBasicProLayoutOnRouter?: Maybe<Router>;
  /** Apply empty layout on Router */
  applyEmptyLayoutOnRouter?: Maybe<Router>;
  /** Request to renew a password */
  applyForPasswordChange: Scalars['Boolean']['output'];
  applyGiftVoucher: Scalars['Boolean']['output'];
  /** Apply new function */
  applyNew: Scalars['String']['output'];
  /** Apply new application for configurator */
  applyNewConfiguratorApplication: ApplicationJourney;
  /** Apply new application for finder */
  applyNewFinderApplication: ApplicationJourney;
  /** Apply new application for showroom */
  applyNewStandardApplication: ApplicationJourney;
  /** Approves an application */
  approveApplication: Scalars['Boolean']['output'];
  /** Attach dealers to User Group */
  attachDealersToUserGroup?: Maybe<UserGroup>;
  /** Attach permissions on an role */
  attachPermissionOnRole?: Maybe<Role>;
  /** Attach superior user groups to user group */
  attachSuperiorGroupsToUserGroup?: Maybe<UserGroup>;
  /** Attach users on role */
  attachUserOnRole?: Maybe<Role>;
  /** Attach users to User Group */
  attachUsersToUserGroup?: Maybe<UserGroup>;
  /** Validate credentials (username/password) and return a Json Web Token */
  authenticate: AuthenticationResponse;
  /** Continue authentication with sms otp */
  authenticateWithSmsOTP: AuthenticationResponse;
  /** Continue authentication with TOTP */
  authenticateWithTOTP: AuthenticationResponse;
  /** Authenticate with a web public key credential */
  authenticateWithWebPublicKeyCredential: AuthenticationResponse;
  /** Provides Calculation based on the parameters passed */
  calculate: CalculatorResult;
  /** Cancels an application */
  cancelApplication: Scalars['Boolean']['output'];
  /** Setting A new password in Profile Setting */
  changePassword: Scalars['Boolean']['output'];
  /** Change password following a successful authentication */
  changePasswordFromAuthentication: AuthenticationResponse;
  /** Change password by using a token */
  changePasswordFromToken: Scalars['Boolean']['output'];
  /** Check In an application (appointment) */
  checkInApplication: Scalars['Boolean']['output'];
  /** Complete an application */
  completeApplication: Scalars['Boolean']['output'];
  /** Complete registration request for a web public key */
  completeWebPublicKeyCredentialRegistration: Scalars['Boolean']['output'];
  /** Concludes the agreement for the finder application */
  concludeAgreementApplication: Scalars['Boolean']['output'];
  /** Confirm test drive appointment booking */
  confirmBookingApplication: Scalars['Boolean']['output'];
  /** Contact the customer */
  contactApplication: Scalars['Boolean']['output'];
  /** Continue application */
  continueApplication?: Maybe<Scalars['String']['output']>;
  copyVariantConfigurator: VariantConfigurator;
  /** Create an additional detail for a pacakge setting */
  createAdditionalDetail?: Maybe<AdditionalDetails>;
  /** Create Adyen payment module */
  createAdyenPaymentModule: Module;
  /** Create Adyen Payment Settings in Adyen Payment Module */
  createAdyenPaymentSettings: AdyenPaymentModule;
  /** Create application list endpoint */
  createApplicationListEndpoint?: Maybe<Router>;
  /** Create Appointment Module */
  createAppointmentModule: Module;
  /** Create  Audi Calculation Module */
  createAudiCalculationModule: Module;
  /** Create Audi Calculation Module setting */
  createAudiCalculationModuleSetting: Module;
  /** Create Authorization for Audi Financing Module */
  createAudiFinancingAuthorization: Module;
  /** Create Audi Financing module */
  createAudiFinancingModule: Module;
  /** Create Audi Sales Force Module */
  createAudiSalesForceModule: Module;
  /** Create Autoplay module */
  createAutoplayModule: Module;
  /** Create Autoplay module setting */
  createAutoplayModuleSetting: Module;
  /** Creates a new bank */
  createBank: SystemBank;
  /** Create bank module */
  createBankModule: Module;
  createBanner: Banner;
  /** Create basic signing module */
  createBasicSigningModule: Module;
  /** Create BMW module */
  createBmwModule: Module;
  /** Create C@P Module */
  createCapModule: Module;
  /** Create a new checkbox consent and declaration */
  createCheckboxConsentsAndDeclarations: ConsentsAndDeclarations;
  /** Create a color block for a variant configurator */
  createColorBlock?: Maybe<VariantConfigurator>;
  /** Creates a new company */
  createCompany: Company;
  /** Create entry point for configurator application module */
  createConfiguratorApplicationEntrypoint?: Maybe<Router>;
  /** Create Configurator Module */
  createConfiguratorModule: Module;
  /** Create consent and declarations module */
  createConsentsAndDeclarationsModule: Module;
  /** Create CTS Module */
  createCtsModule: Module;
  /** Create CTS Module setting */
  createCtsModuleSetting: Module;
  /** Create customer list endpoint */
  createCustomerListEndpoint?: Maybe<Router>;
  createDealer: Dealer;
  createDealerSocialMedia: DealerSocialMedia;
  /** Create dummy private page as endpoint on a router */
  createDummyPrivatePageEndpoint?: Maybe<Router>;
  /** Create dummy welcome page as endpoint on a router */
  createDummyWelcomePageEndpoint?: Maybe<Router>;
  /** Create EDM email social media */
  createEdmEmailSocialMedia: EdmEmailSocialMedia;
  /** Create Event */
  createEvent: Event;
  /** Create entrypoint for event application module */
  createEventApplicationEntrypoint?: Maybe<Router>;
  /** Create event application module */
  createEventApplicationModule: Module;
  /** Create External bank */
  createExternalBank: Module;
  /** Creates a new finance product */
  createFinanceProduct: FinanceProduct;
  /** Create entrypoint for finder application dealer access module */
  createFinderApplicationEntrypoint?: Maybe<Router>;
  /** Create Finder Application Private Module */
  createFinderApplicationPrivateModule: Module;
  /** Create entrypoint for finder application public access module */
  createFinderApplicationPublicAccessEntrypoint?: Maybe<Router>;
  /** Create Finder Application Public Module */
  createFinderApplicationPublicModule: Module;
  /** Create Finder Vehicle Management module */
  createFinderVehicleManagementModule: Module;
  /** Create Fiserv payment module */
  createFiservPaymentModule: Module;
  /** Create Fiserv Payment Settings in Fiserv Payment Module */
  createFiservPaymentSettings: FiservPaymentModule;
  /** Create Gift Voucher Module */
  createGiftVoucherModule: Module;
  /** Create insurance module */
  createInsuranceModule: Module;
  /** Creates a new insurance product */
  createInsuranceProduct: InsuranceProduct;
  /** Creates a new insurer */
  createInsurer: Insurer;
  /** Create an inventory, support bulk creation, returning created inventory count */
  createInventory: Scalars['Int']['output'];
  /** Create KYCPreset in local customer management module */
  createKYCPreset: LocalCustomerManagementModule;
  createLabels: Labels;
  /** Create Labels Module */
  createLabelsModule: Module;
  /** Create a new language pack */
  createLanguagePack: LanguagePack;
  /** Create local customer management module */
  createLocalCustomerManagement: Module;
  /** Create Maintenance Module */
  createMaintenanceModule: Module;
  /** Create a make */
  createMake: LocalMake;
  /** Create a new marketing consent and declaration */
  createMarketingConsentsAndDeclarations: ConsentsAndDeclarations;
  /** Create a new additional info mobility */
  createMobilityAdditionalInfo: Mobility;
  /** Create a new addon mobility */
  createMobilityAddon: Mobility;
  /** Create entry point for mobility application module */
  createMobilityApplicationEntrypoint?: Maybe<Router>;
  /** Create mobility module */
  createMobilityModule: Module;
  /** Create a model */
  createModel: LocalModel;
  /** Creates a model configurator */
  createModelConfigurator: ModelConfigurator;
  /** Create MyInfo Module */
  createMyInfoModule: Module;
  createMyInfoSetting: MyInfoModule;
  /** Create Namirial Signing module */
  createNamirialSigningModule: Module;
  /** Create options blocks for a variant configurator */
  createOptionsBlock?: Maybe<OptionsBlock>;
  /** Create a package block for a variant configurator */
  createPackageBlock?: Maybe<PackageBlock>;
  /** Create a package setting for a package block */
  createPackageSetting?: Maybe<PackageSettings>;
  /** Create PayGate payment module */
  createPayGatePaymentModule: Module;
  /** Create PayGate Payment Settings in PayGate Payment Module */
  createPayGatePaymentSettings: PayGatePaymentModule;
  /** Create Porsche MasterData Module */
  createPorscheMasterDataModule: Module;
  /** Create Porsche payment module */
  createPorschePaymentModule: Module;
  /** Create Porsche Payment Settings in Porsche Payment Module */
  createPorschePaymentSettings: PorschePaymentModule;
  /** Create a promo code */
  createPromoCode: PromoCode;
  /** Create promo code module */
  createPromoCodeModule: Module;
  /** Create role */
  createRole: Role;
  /** Create a new router */
  createRouter: Router;
  /** Create menu items for a router */
  createRouterMenu?: Maybe<Router>;
  /** Create Authorization External Module */
  createSDMAuthorization: Module;
  /** Create SDM module */
  createSdmModule: Module;
  /** Create simple vehicle management module */
  createSimpleVehicleManagementModule: Module;
  /** Create entrypoint for standard application module */
  createStandardApplicationEntrypoint?: Maybe<Router>;
  /** Create standard application module */
  createStandardApplicationModule: Module;
  /** Create entrypoint for standard application public access module */
  createStandardApplicationPublicAccessEntrypoint?: Maybe<Router>;
  /** Create a submodel */
  createSubmodel: LocalModel;
  /** Create a new text consent and declaration */
  createTextConsentsAndDeclarations: ConsentsAndDeclarations;
  /** Create Trade In Module */
  createTradeInModule: Module;
  /** Create a trim block for a variant configurator */
  createTrimBlock?: Maybe<VariantConfigurator>;
  /** Create TTB payment module */
  createTtbPaymentModule: Module;
  /** Create TTB Payment Settings in TTB Payment Module */
  createTtbPaymentSettings: TtbPaymentModule;
  /** Create user */
  createUser: User;
  /** Create User Group */
  createUserGroup: UserGroup;
  /** Create Userlike Chatbot Module */
  createUserlikeChatbotModule: Module;
  /** Create Userlike settings inside module */
  createUserlikeChatbotSettings: UserlikeChatbotModule;
  /** Create a variant */
  createVariant: LocalVariant;
  /** Creates a variant configurator */
  createVariantConfigurator: VariantConfigurator;
  /** Create WebCalc Setting */
  createWebCalcSetting?: Maybe<WebCalcSetting>;
  createWebPage: WebPage;
  /** Create entry point for web page */
  createWebPageEndpoint?: Maybe<Router>;
  /** Create Website Module */
  createWebsiteModule: Module;
  /** Create Website social media */
  createWebsiteSocialMedia: EdmEmailSocialMedia;
  /** Create Whatsapp Live Chat Module */
  createWhatsappLiveChatModule: Module;
  /** Create settings inside module */
  createWhatsappLiveChatSettings: WhatsappLiveChatModule;
  /** Declines an application */
  declineApplication: Scalars['Boolean']['output'];
  /** Delete package block additional setting */
  deleteAdditionalDetail?: Maybe<VariantConfigurator>;
  /** Delete Adyen Payment Settings in Adyen Payment Module */
  deleteAdyenPaymentSettings: AdyenPaymentModule;
  /** Delete application document */
  deleteApplicationDocument?: Maybe<Application>;
  /** Delete Appointment Module Asset */
  deleteAppointmentModuleAsset?: Maybe<Module>;
  /** Delete Audi Calculation Module setting */
  deleteAudiCalculationModuleSetting: Module;
  /** Delete Autoplay module setting */
  deleteAutoplayModuleSetting: Module;
  /** Delete bank */
  deleteBank?: Maybe<SystemBank>;
  /** Delete bank asset */
  deleteBankAsset?: Maybe<SystemBank>;
  deleteBanner: Scalars['Boolean']['output'];
  deleteBannerImage?: Maybe<Banner>;
  /** Delete company */
  deleteCompany: Scalars['Boolean']['output'];
  /** Delete company asset */
  deleteCompanyAsset?: Maybe<Company>;
  /** Delete description image for Model Configurator */
  deleteConfiguratorDescriptionImage?: Maybe<ModelConfigurator>;
  /** Delete Configurator Module Assets */
  deleteConfiguratorModuleAsset?: Maybe<Module>;
  /** Delete a consent and declaration */
  deleteConsentsAndDeclarations: Scalars['Boolean']['output'];
  /** Delete CTS Module setting */
  deleteCtsModuleSetting: Module;
  deleteDealer: Scalars['Boolean']['output'];
  deleteDealerSocialMedia: Scalars['Boolean']['output'];
  deleteDealerSocialMediaAsset?: Maybe<Dealer>;
  /** Delete EDM email social media */
  deleteEdmEmailSocialMedia?: Maybe<Company>;
  /** Delete EDM email social media asset */
  deleteEdmSocialMediaAsset?: Maybe<Company>;
  /** Delete router endpoint from router */
  deleteEndpoint?: Maybe<Router>;
  /** Delete Event */
  deleteEvent: Scalars['Boolean']['output'];
  /** Delete event application module Assets */
  deleteEventApplicationModuleAsset?: Maybe<Module>;
  /** Delete event application module Assets */
  deleteEventLevelAsset?: Maybe<Event>;
  /** Delete External bank */
  deleteExternalBank: Module;
  /** Delete finance product */
  deleteFinanceProduct: Scalars['Boolean']['output'];
  /** Delete Finder Application Module Assets */
  deleteFinderApplicationModuleAsset?: Maybe<Module>;
  /** Delete Fiserv Payment Settings in Fiserv Payment Module */
  deleteFiservPaymentSettings: FiservPaymentModule;
  /** Delete gift voucher document */
  deleteGiftVoucherDocument?: Maybe<GiftVoucher>;
  /** Delete Gift Voucher Module Asset */
  deleteGiftVoucherModuleAsset?: Maybe<Module>;
  /** Delete insurance product */
  deleteInsuranceProduct: Scalars['Boolean']['output'];
  /** Delete Insurer */
  deleteInsurer?: Maybe<Scalars['Boolean']['output']>;
  /** Delete inventories, support bulk deletion, returning deleted inventory count */
  deleteInventories: Scalars['Int']['output'];
  /** Delete KYCPreset in local customer management module */
  deleteKYCPreset?: Maybe<LocalCustomerManagementModule>;
  deleteLabels?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a language pack */
  deleteLanguagePack: Scalars['Boolean']['output'];
  /** Delete MaintenanceModule Asset */
  deleteMaintenanceModuleAsset?: Maybe<Module>;
  /** Delete mobility */
  deleteMobility: Scalars['Boolean']['output'];
  /** delete mobility module email asset */
  deleteMobilityModuleEmailAsset?: Maybe<Module>;
  /** Delete model configurator */
  deleteModelConfigurator: Scalars['Boolean']['output'];
  /** Delete model configurator asset */
  deleteModelConfiguratorAsset?: Maybe<ModelConfigurator>;
  /** Delete module */
  deleteModule: Scalars['Boolean']['output'];
  deleteMyInfoSetting: MyInfoModule;
  /** Delete options block */
  deleteOptionsBlock?: Maybe<VariantConfigurator>;
  /** Delete package block setting */
  deletePackageSetting?: Maybe<VariantConfigurator>;
  /** Delete PayGate Payment Settings in PayGate Payment Module */
  deletePayGatePaymentSettings: PayGatePaymentModule;
  /** Delete Porsche Payment Settings in Porsche Payment Module */
  deletePorschePaymentSettings: PorschePaymentModule;
  /** Delete a promo code */
  deletePromoCode: Scalars['Boolean']['output'];
  /** Delete role */
  deleteRole: Scalars['Boolean']['output'];
  /** Delete router */
  deleteRouter: Scalars['Boolean']['output'];
  /** Delete stock asset */
  deleteStockAsset?: Maybe<Inventory>;
  /** Delete stock inventory */
  deleteStockInventory: Inventory;
  /** Delete TTB Payment Settings in TTB Payment Module */
  deleteTtbPaymentSettings: TtbPaymentModule;
  /** Delete user */
  deleteUser: UserDeletionResult;
  /** Delete user asset */
  deleteUserAsset?: Maybe<User>;
  /** Delete User Group */
  deleteUserGroup: Scalars['Boolean']['output'];
  /** Delete Userlike settings inside module */
  deleteUserlikeChatbotSettings: UserlikeChatbotModule;
  /** Delete variant asset */
  deleteVariantAsset?: Maybe<LocalVariant>;
  /** Delete variant configurator */
  deleteVariantConfigurator: Scalars['Boolean']['output'];
  /** Delete asset in color block setting */
  deleteVariantConfiguratorColorSettingAsset?: Maybe<VariantConfigurator>;
  /** Delete variant configurator asset (color and trim images only) */
  deleteVariantConfiguratorMatrixAsset?: Maybe<VariantConfigurator>;
  /** Delete variant configurator options asset */
  deleteVariantConfiguratorOptionAsset?: Maybe<VariantConfigurator>;
  /** Delete option setting asset */
  deleteVariantConfiguratorOptionSettingAsset?: Maybe<VariantConfigurator>;
  /** Delete variant configurator pacakge additional details asset */
  deleteVariantConfiguratorPackageAdditionalDetailsAsset?: Maybe<VariantConfigurator>;
  /** Delete variant configurator package section image asset */
  deleteVariantConfiguratorPackageSectionImageAsset?: Maybe<VariantConfigurator>;
  /** Delete asset in trim block setting */
  deleteVariantConfiguratorTrimSettingAsset?: Maybe<VariantConfigurator>;
  /** Delete vehicle */
  deleteVehicle: Scalars['Boolean']['output'];
  deleteWebPage: Scalars['Boolean']['output'];
  deleteWebPageBlock: Scalars['Boolean']['output'];
  deleteWebPageImage: WebPage;
  /** Delete Website social media */
  deleteWebsiteSocialMedia?: Maybe<Module>;
  /** Delete Website email social media asset */
  deleteWebsiteSocialMediaAsset?: Maybe<Module>;
  /** Delete settings inside module */
  deleteWhatsappLiveChatSettings: WhatsappLiveChatModule;
  /** Disable 2FA / Authenticator for the signed user */
  disableAuthenticator: User;
  /** Draft a new configurator application */
  draftConfiguratorApplication: ApplicationJourney;
  /** Draft a new event application */
  draftEventApplication: ApplicationJourney;
  /** Draft a new finder application */
  draftFinderApplication: ApplicationJourney;
  draftGiftVoucher: GiftVoucherJourneyContext;
  /** Draft a new mobility application */
  draftMobilityApplication: ApplicationJourney;
  /** Draft a new application */
  draftStandardApplication: ApplicationJourney;
  /** Enable 2FA / Authenticator for the signed user */
  enableAuthenticator: User;
  /** End test drive for appointment */
  endTestDrive: Scalars['Boolean']['output'];
  /** Extend configurator stock expriy */
  extendConfiguratorStockExpiry: ApplicationJourney;
  /** Extend event journey expiry */
  extendEventJourneyExpiry: ApplicationJourney;
  /** Extend finder vehicle expiration time */
  extendFinderVehicleExpiry: ApplicationJourney;
  /** Extend gift voucher expiration journey */
  extendGiftVoucherJourneyExpiry: GiftVoucherJourneyContext;
  /** Extend mobility stock expriy */
  extendMobilityStockExpiry: ApplicationJourney;
  /** Generate amend mobility application access */
  generateAmendMobilityApplicationAccess?: Maybe<AmendMobilityApplicationAccess>;
  /** Generate cancel mobility application access */
  generateCancelMobilityApplicationAccess?: Maybe<CancelMobilityApplicationAccess>;
  /** Generate Passcode for Remote Journey */
  generateRemoteJourneyPasscode: GeneratedOtpResult;
  /** Generate OTP */
  generateSigningOTP: GeneratedOtpResult;
  /** Generate a challenge to authenticate with web credentials */
  generateWebCredentialAuthentication?: Maybe<AuthenticationWithWebPublicKeyCredential>;
  /**
   * Get application agreement and KYC fields from journey
   *
   * This used for retrieving agreements and KYC fields, which configuration is updated inside KYC page
   * Ie: Test drive checkbox and trade in checkbox inside KYC page Standard and Configurator application
   * For event application, it use different handler, since the initial page is KYC page
   */
  getAgreementsAndKycFieldsFromUpdatedConfiguration: Application;
  /** Update AudiFinancing Sales Person Code Mappings With Excel */
  importAudiFinancingModuleSalesPersonCodeMappings: ImportAudiFinancingSalesPersonCodeMappingsResponse;
  /** Import Variant Prices for Model Configurator */
  importConfiguratorVariantPrices: ImportInventoryResponse;
  /** Import LTA vehicles from excel for porsche finder */
  importFinderVehiclesLta: ImportedExcel;
  /** Import Inventories */
  importInventories: ImportInventoryResponse;
  /** Import language pack */
  importLanguagePack: LanguagePack;
  /** Import vehicle make */
  importMake: ImportExcel;
  /** Import vehicle model */
  importModel: ImportExcel;
  /** Update SDM Sales Person Code Mappings With Excel */
  importSdmModuleSalesPersonCodeMappings: ImportSdmSalesPersonCodeMappingsResponse;
  /** Import vehicle submodel */
  importSubModel: ImportExcel;
  /** Import vehicle variant */
  importVariant: ImportExcel;
  /** Import variant images in bulk */
  importVariantImages?: Maybe<Scalars['Int']['output']>;
  /** Send email to customer device to proceed */
  proceedWithCustomerDevice: Scalars['Boolean']['output'];
  /** Qualify the lead application */
  qualifyLeadApplication: Scalars['Boolean']['output'];
  /** Refresh application status */
  refreshApplicationStatus: Scalars['Boolean']['output'];
  /**
   * Take the Json Web Token (JWT) from headers and returns a new one with a renewed lifetime
   *
   * Authentication is required
   */
  refreshCredentials: Scalars['String']['output'];
  /** Release finder vehicle expiration time */
  releaseFinderVehicleExpiry: Scalars['Boolean']['output'];
  /** Release reserved configurator stock */
  releaseReservedConfiguratorStock: Scalars['Boolean']['output'];
  /** Release reserved mobility stock */
  releaseReservedMobilityStock: Scalars['Boolean']['output'];
  /** Remove dealer on user group */
  removeDealerOnUserGroup?: Maybe<UserGroup>;
  /** Remove permission on role */
  removePermissionOnRole?: Maybe<Role>;
  /** Remove user on role */
  removeUserOnRole?: Maybe<Role>;
  /** Remove user on user group */
  removeUserOnUserGroup?: Maybe<UserGroup>;
  /** Remove LTA data from existing vehicle */
  removeVehicleLta: Vehicle;
  /** Request Disbursement */
  requestDisbursement?: Maybe<Application>;
  /** Request Release Letter */
  requestReleaseLetter?: Maybe<Application>;
  /** Create a web public key credential registration request */
  requestWebPublicKeyCredentialRegistration: WebPublicKeyCredentialRegistrationRequest;
  /** Resend SMS OTP for reset password */
  resendSmsOTPForResetPassword: ResetPasswordResponse;
  /** Resend SMS OTP for update email */
  resendSmsOTPForUpdateEmail: UpdateEmailResponse;
  /** Reset finder status */
  resetFinderVehicle: FinderVehicle;
  /** Revoke user session */
  revokeUserSession: Scalars['Boolean']['output'];
  /**
   * Revoke web public key credential
   *
   * Return the key ID revoked
   */
  revokeWebPublicKeyCredential?: Maybe<Scalars['String']['output']>;
  /** Resend activation link to user */
  sendActivationLink?: Maybe<User>;
  /** Share Application */
  shareStandardApplication: Application;
  /**
   * Start test drive for appointment
   *
   * Origin endpoint id is where this action is triggered
   * For CI, it's should be endpoint id of appointment details
   * For Admin, it's null
   */
  startTestDrive: ApplicationJourney;
  /** Submit Payment Application */
  submitAdyenPayment: ApplicationJourney;
  /** Applicant agrees on CnD */
  submitApplicantAgreements: ApplicationJourney;
  /** Applicant set appointment */
  submitApplicantAppointment: ApplicationJourney;
  /** Applicant provides KYC */
  submitApplicantKYC: ApplicationJourney;
  /**
   * Submit application quotation data during journey
   *
   * Applicable to application with financing and ENBD bank integration
   */
  submitApplicationQuotation: ApplicationJourney;
  /** Resubmit Application to all kind of application */
  submitChanges: ApplicationJourney;
  /** Submit Fiserv Payment Application */
  submitFiservPayment: ApplicationJourney;
  /** Submit Payment Application */
  submitGiftVoucherAdyenPayment: GiftVoucherJourneyContext;
  /** Buyer agrees on CnD */
  submitGiftVoucherApplicantAgreements: GiftVoucherJourneyContext;
  /** Buyer provides KYC */
  submitGiftVoucherApplicantKYC: GiftVoucherJourneyContext;
  /** Submit Fiserv Payment Application */
  submitGiftVoucherFiservPayment: GiftVoucherJourneyContext;
  /** Submit PayGate Payment Application */
  submitGiftVoucherPayGatePayment: GiftVoucherJourneyContext;
  /** Submit Porsche Payment Application */
  submitGiftVoucherPorschePayment: GiftVoucherJourneyContext;
  /** Submit TTB Payment Application */
  submitGiftVoucherTtbPayment: GiftVoucherJourneyContext;
  /** Guarantor agrees on CnD */
  submitGuarantorAgreements: ApplicationJourney;
  /** Guarantor provides KYC */
  submitGuarantorKYC: ApplicationJourney;
  /** Submit PayGate Payment Application */
  submitPayGatePayment: ApplicationJourney;
  /** Submit Porsche Payment Application */
  submitPorschePayment: ApplicationJourney;
  /** Validate OTP */
  submitSigningOTP: ApplicationJourney;
  /** Applicant agrees on Test DriveCnD */
  submitTestDriveAgreements: ApplicationJourney;
  /** Applicant provides Test Drive KYC */
  submitTestDriveKYC: ApplicationJourney;
  /** Submit TTB Payment Application */
  submitTtbPayment: ApplicationJourney;
  /** Synchronize porsche finder with our system AFC */
  synchronizeFinderVehicle: FinderVehicleSyncStatus;
  /** Synchronize changes from PCCD with our system */
  synchronizePorscheMasterData: PorscheMasterDataSyncResult;
  /** Take stock inventory by numbers, from latest one */
  takeOutStockInventory: Inventory;
  /** Unqualify the lead application */
  unqualifyLeadApplication: Scalars['Boolean']['output'];
  /**
   * Update an existing account/user
   *
   * Authentication is required
   */
  updateAccount?: Maybe<User>;
  /** Update an additional settings for a package setting */
  updateAdditionalDetail?: Maybe<VariantConfigurator>;
  /** Update Adyen payment module */
  updateAdyenPaymentModule?: Maybe<Module>;
  /** Update Adyen Payment Settings in Adyen Payment Module */
  updateAdyenPaymentSettings: AdyenPaymentModule;
  updateApplication: Application;
  /** Update application module settings by Dealer */
  updateApplicationDealershipAssignmentsByDealer?: Maybe<Module>;
  /** Update Application Fields */
  updateApplicationFields: Scalars['Boolean']['output'];
  /** Update application list endpoint */
  updateApplicationListEndpoint?: Maybe<Router>;
  /**
   * Update solely appointment data
   *
   * This is used, because we don't want to trigger submission changes for appointment data change
   */
  updateAppointmentData: Scalars['Boolean']['output'];
  /** Update Appointment Module */
  updateAppointmentModule?: Maybe<Module>;
  /** Update Appointment Module Email content */
  updateAppointmentModuleEmailContent?: Maybe<Module>;
  /** Update or Assign assignee to Application */
  updateAssigneeOnApplication?: Maybe<Application>;
  /** Update Audi Calculation module FP assignments */
  updateAudiCalculationFinanceProducts?: Maybe<Module>;
  /** Update Audi Calculation module Insurance Product assignments */
  updateAudiCalculationInsuranceProducts?: Maybe<Module>;
  /** Update  Audi Calculation Module */
  updateAudiCalculationModule?: Maybe<Module>;
  /** Update Audi Calculation Module setting */
  updateAudiCalculationModuleSetting: Module;
  /** Update AudiFinancing Sales Person Code Mappings */
  updateAudiFinancingModuleSalesPersonCodeMappings: Module;
  /** Update Audi Sales Force Module */
  updateAudiSalesForceModule?: Maybe<Module>;
  /** Update Autoplay module */
  updateAutoplayModule: Module;
  /** Update Autoplay module setting */
  updateAutoplayModuleSetting: Module;
  /** Updates bank specifications */
  updateBank?: Maybe<SystemBank>;
  /** Updates bank available Finance Product Types */
  updateBankAvailableFinanceProductTypes?: Maybe<SystemBank>;
  /** Update bank module */
  updateBankModule?: Maybe<Module>;
  updateBanner?: Maybe<Banner>;
  /** Update basic signing module */
  updateBasicSigningModule?: Maybe<Module>;
  /** Update BMW FS bank integration setting */
  updateBmwFsBankIntegrationSetting?: Maybe<Bank>;
  /** Update BMW module */
  updateBmwModule?: Maybe<Module>;
  /** Update C@P Module */
  updateCapModule?: Maybe<Module>;
  /** Update a checkbox consent and declaration */
  updateCheckboxConsentsAndDeclarations?: Maybe<ConsentsAndDeclarations>;
  /** Update a color block for a variant configurator */
  updateColorBlock?: Maybe<VariantConfigurator>;
  /** Updates company specifications */
  updateCompany?: Maybe<Company>;
  /** Save the Configurator Order */
  updateConfiguratorApplication: ApplicationJourney;
  /** Update Configurator Application Configuration */
  updateConfiguratorApplicationConfiguration: Scalars['Boolean']['output'];
  /** Update entry point for configurator application module */
  updateConfiguratorApplicationEntrypoint?: Maybe<Router>;
  /** Update Configurator Application Journey */
  updateConfiguratorApplicationJourney: ApplicationJourney;
  /** Update Configurator Module */
  updateConfiguratorModule?: Maybe<Module>;
  /** Update Configurator Module Email Contents */
  updateConfiguratorModuleEmailContents?: Maybe<Module>;
  /** Update Consent Order List */
  updateConsentOrderList: Scalars['Boolean']['output'];
  /** Update consent and declarations module */
  updateConsentsAndDeclarationsModule?: Maybe<Module>;
  /** Update CTS module FP assignments */
  updateCtsFinanceProducts?: Maybe<Module>;
  /** Update CTS module Insurance Product assignments */
  updateCtsInsuranceProducts?: Maybe<Module>;
  /** Update CTS Module */
  updateCtsModule?: Maybe<Module>;
  /** Update CTS Module setting */
  updateCtsModuleSetting: Module;
  /** Update Customer Info */
  updateCustomer?: Maybe<Customer>;
  /** Update customer list endpoint */
  updateCustomerListEndpoint?: Maybe<Router>;
  /** Update DBS bank integration setting */
  updateDbsBankIntegrationSetting?: Maybe<Bank>;
  updateDealer?: Maybe<Dealer>;
  updateDealerSocialMedia?: Maybe<DealerSocialMedia>;
  /**
   * Update the display name for the logged in user
   *
   * Authentication is required
   */
  updateDisplayName: User;
  /** Update dummy private page as endpoint on a router */
  updateDummyPrivatePageEndpoint?: Maybe<Router>;
  /** Update dummy welcome page as endpoint on a router */
  updateDummyWelcomePageEndpoint?: Maybe<Router>;
  /** Update  Eazy Insurer integration setting */
  updateEazyInsurerIntegrationSetting?: Maybe<Insurer>;
  /** Update EDM email social media */
  updateEdmEmailSocialMedia?: Maybe<Company>;
  /** Update Email bank integration setting */
  updateEmailBankIntegrationSetting?: Maybe<Bank>;
  /** Update Email */
  updateEmailFromToken: Scalars['Boolean']['output'];
  /** Update Email Insurer integration setting */
  updateEmailInsurerIntegrationSetting?: Maybe<Insurer>;
  /** Update ENBD bank integration setting */
  updateEnbdBankIntegrationSetting?: Maybe<Bank>;
  /** Update Event */
  updateEvent: Event;
  /** update event application */
  updateEventApplication: ApplicationJourney;
  /** Update entrypoint for event application module */
  updateEventApplicationEntrypoint?: Maybe<Router>;
  /** Update event application finance product assignments */
  updateEventApplicationFinanceProductAssignments?: Maybe<Module>;
  /** Update event application module email contents */
  updateEventApplicationModuleEmailContents?: Maybe<Module>;
  /** Update event application module Main Details */
  updateEventApplicationModuleMainDetails?: Maybe<Module>;
  /** Update event application vehicle assignments */
  updateEventApplicationVehicleAssignments?: Maybe<Module>;
  /** Create External bank */
  updateExternalBank: Module;
  /** Updates finance product specifications */
  updateFinanceProduct?: Maybe<FinanceProduct>;
  /** Update Finder application */
  updateFinderApplication: ApplicationJourney;
  /** update existing finder application draft */
  updateFinderApplicationDraft: ApplicationJourney;
  /** Update entrypoint for finder application dealer access module */
  updateFinderApplicationEntrypoint?: Maybe<Router>;
  /**
   * Update finder application journey
   *
   * For trade in vehicle
   */
  updateFinderApplicationJourney: ApplicationJourney;
  /** Update Finder Application Private Module */
  updateFinderApplicationPrivateModule?: Maybe<Module>;
  /** Update Finder Application Private Module Email Contents */
  updateFinderApplicationPrivateModuleEmailContents?: Maybe<Module>;
  /** Update entrypoint for finder application public access module */
  updateFinderApplicationPublicAccessEntrypoint?: Maybe<Router>;
  /** Update Finder Application Public Module */
  updateFinderApplicationPublicModule?: Maybe<Module>;
  /** Update Finder Application Public Module Email Contents */
  updateFinderApplicationPublicModuleEmailContents?: Maybe<Module>;
  /** Update finder vehicle */
  updateFinderVehicle: FinderVehicle;
  /** Update finder vehicle management module */
  updateFinderVehicleManagementModule?: Maybe<Module>;
  /** Update Fiserv payment module */
  updateFiservPaymentModule?: Maybe<Module>;
  /** Update Fiserv Payment Settings in Fiserv Payment Module */
  updateFiservPaymentSettings: FiservPaymentModule;
  /** update gift voucher */
  updateGiftVoucher: GiftVoucherJourneyContext;
  /** Update Gift Voucher Module */
  updateGiftVoucherModule?: Maybe<Module>;
  /** Update Gift Voucher Module Email content */
  updateGiftVoucherModuleEmailContent?: Maybe<Module>;
  /** Update HLF bank integration setting */
  updateHlfBankIntegrationSetting?: Maybe<Bank>;
  /** Update HLF bank v2 integration setting */
  updateHlfBankV2IntegrationSetting?: Maybe<Bank>;
  /** Update insurance module */
  updateInsuranceModule?: Maybe<Module>;
  /** Updates insurance product specifications */
  updateInsuranceProduct?: Maybe<InsuranceProduct>;
  /** Updates insurer specifications */
  updateInsurer?: Maybe<Insurer>;
  /** Update an inventory */
  updateInventory: Inventory;
  /** Update KYCPresets in local customer management module */
  updateKYCPreset?: Maybe<LocalCustomerManagementModule>;
  updateLabels?: Maybe<Labels>;
  /** Update Labels Module */
  updateLabelsModule?: Maybe<Module>;
  /** Update a language pack */
  updateLanguagePack?: Maybe<LanguagePack>;
  /** Update local customer management module */
  updateLocalCustomerManagement?: Maybe<Module>;
  /** Update Local Customer Management Module KYC Fields */
  updateLocalCustomerManagementKYCFields?: Maybe<Module>;
  /** Update Maintenance Module */
  updateMaintenanceModule?: Maybe<Module>;
  /** Update Maintenance Module Details */
  updateMaintenanceModuleDetails?: Maybe<Module>;
  /** Update make */
  updateMake?: Maybe<LocalMake>;
  /** Update a marketing consent and declaration */
  updateMarketingConsentsAndDeclarations?: Maybe<ConsentsAndDeclarations>;
  /** Update Maybank integration setting */
  updateMaybankIntegrationSetting?: Maybe<Bank>;
  /** Update additional info mobility */
  updateMobilityAdditionalInfo?: Maybe<Mobility>;
  /** Update addon mobility */
  updateMobilityAddon?: Maybe<Mobility>;
  updateMobilityApplication: UpdatedMobilityApplication;
  /** Update curent mobility application draft */
  updateMobilityApplicationDraft: ApplicationJourney;
  /** Update entry point for mobility application module */
  updateMobilityApplicationEntrypoint?: Maybe<Router>;
  /**
   * Updates deposit amount for mobility since promo code allows deduction
   * of payment price in this journey
   */
  updateMobilityDepositAmount: ApplicationJourney;
  /** Update mobility module email content */
  updateMobilityEmailContent?: Maybe<Module>;
  /** Update mobility module */
  updateMobilityModule?: Maybe<Module>;
  /** Update model */
  updateModel?: Maybe<LocalModel>;
  /** Updates model configurator settings */
  updateModelConfigurator?: Maybe<ModelConfigurator>;
  /** Update MyInfo Module */
  updateMyInfoModule?: Maybe<Module>;
  updateMyInfoSetting: MyInfoModule;
  /** Update Namirial Settings in Namirial Module */
  updateNamirialSettings: NamirialSigningModule;
  /** Update Namirial Signing module */
  updateNamirialSigningModule?: Maybe<Module>;
  /** Update Namirial Signing Settings / Secrets */
  updateNamirialSigningSettings: Module;
  /** Update an options block for a variant configurator */
  updateOptionsBlock?: Maybe<VariantConfigurator>;
  /** Update a package block for a variant configurator */
  updatePackageBlock?: Maybe<VariantConfigurator>;
  /** Update a package setting for a package block */
  updatePackageSetting?: Maybe<VariantConfigurator>;
  /** Update PayGate payment module */
  updatePayGatePaymentModule?: Maybe<Module>;
  /** Update PayGate Payment Settings in PayGate Payment Module */
  updatePayGatePaymentSettings: PayGatePaymentModule;
  /** Update Porsche MasterData Module */
  updatePorscheMasterDataModule?: Maybe<Module>;
  /** Update Porsche payment module */
  updatePorschePaymentModule?: Maybe<Module>;
  /** Update Porsche Payment Settings in Porsche Payment Module */
  updatePorschePaymentSettings: PorschePaymentModule;
  /** Update a promo code */
  updatePromoCode?: Maybe<PromoCode>;
  /** Update promo code module */
  updatePromoCodeModule?: Maybe<Module>;
  /** Update role */
  updateRole?: Maybe<Role>;
  /** Update a router specifications */
  updateRouter?: Maybe<Router>;
  /** Update menu items for a router */
  updateRouterMenu?: Maybe<Router>;
  /**
   * Update Sales Force Setting in SDM Module or Audi Financing Module
   * TODO: cater for Audi Financing Module
   */
  updateSalesForceSetting: ModuleWithSalesForceSetting;
  /** Update SDM Sales Person Code Mappings */
  updateSdmModuleSalesPersonCodeMappings: Module;
  /** Update simple vehicle management module */
  updateSimpleVehicleManagementModule?: Maybe<Module>;
  /** Update Standard Application Configuration */
  updateStandardApplicationConfiguration: Scalars['Boolean']['output'];
  /** Update Dealership management for standard application vehicle, and FP assignment */
  updateStandardApplicationDealership?: Maybe<Module>;
  /** update existing application draft */
  updateStandardApplicationDraft: ApplicationJourney;
  /** Update entrypoint for standard application module */
  updateStandardApplicationEntrypoint?: Maybe<Router>;
  /** Update standard application finance product assignments */
  updateStandardApplicationFinanceProductAssignments?: Maybe<Module>;
  /** Update Standard Application Journey */
  updateStandardApplicationJourney: ApplicationJourney;
  /** Update Standard Application Module Main Details */
  updateStandardApplicationModuleMainDetails?: Maybe<Module>;
  /** Update entrypoint for standard application public access module */
  updateStandardApplicationPublicAccessEntrypoint?: Maybe<Router>;
  /** Update standard application vehicle assignments */
  updateStandardApplicationVehicleAssignments?: Maybe<Module>;
  /** Update stock inventory */
  updateStockInventory: Inventory;
  /**
   * Update test drive data for appointment
   *
   * This is used, because we don't want to trigger submission changes for test drive data change
   */
  updateTestDriveData: Scalars['Boolean']['output'];
  /** Update a text consent and declaration */
  updateTextConsentsAndDeclarations?: Maybe<ConsentsAndDeclarations>;
  /** Update Trade In Module */
  updateTradeInModule?: Maybe<Module>;
  /** Update Trade In Setting */
  updateTradeInSetting: TradeInSetting;
  /** Update a trim block for a variant configurator */
  updateTrimBlock?: Maybe<VariantConfigurator>;
  /** Update TTB payment module */
  updateTtbPaymentModule?: Maybe<Module>;
  /** Update TTB Payment Settings in TTB Payment Module */
  updateTtbPaymentSettings: TtbPaymentModule;
  /** Update UOB bank integration setting */
  updateUobBankIntegrationSetting?: Maybe<Bank>;
  /** Update user */
  updateUser: User;
  /** Update user group */
  updateUserGroup?: Maybe<UserGroup>;
  /** Update Userlike Chatbot Module */
  updateUserlikeChatbotModule: Module;
  /** Update Userlike settings inside module */
  updateUserlikeChatbotSettings: UserlikeChatbotModule;
  /** Update variant */
  updateVariant?: Maybe<LocalVariant>;
  /** Update variant configurator */
  updateVariantConfigurator: VariantConfigurator;
  /** Update variant images ordering */
  updateVariantImageOrdering?: Maybe<LocalVariant>;
  updateVariantLabels?: Maybe<Labels>;
  /** Update WebCalc Setting */
  updateWebCalcSetting?: Maybe<WebCalcSetting>;
  updateWebPage: WebPage;
  /** Update entry point for web page */
  updateWebPageEndpoint?: Maybe<Router>;
  /** Update Website Module */
  updateWebsiteModule: Module;
  /** Update Website social media */
  updateWebsiteSocialMedia?: Maybe<Module>;
  /** Update Whatsapp Live Chat Module */
  updateWhatsappLiveChatModule: Module;
  /** Update settings inside module */
  updateWhatsappLiveChatSettings: WhatsappLiveChatModule;
  /** Upload application document */
  uploadApplicationDocument: UploadApplicationDocumentResult;
  /** Upload application document */
  uploadApplicationDocuments?: Maybe<Scalars['Boolean']['output']>;
  /** Upload Appointment Module Asset */
  uploadAppointmentModuleAsset?: Maybe<Module>;
  /** Upload bank asset */
  uploadBankAsset?: Maybe<SystemBank>;
  uploadBannerImage: Banner;
  /** Upload company asset */
  uploadCompanyAsset?: Maybe<Company>;
  /** Upload Description images for Model Configurator */
  uploadConfiguratorDescriptionImage?: Maybe<ModelConfigurator>;
  /** Upload Configurator Module Assets */
  uploadConfiguratorModuleAsset?: Maybe<Module>;
  uploadDealerSocialMediaAsset?: Maybe<Dealer>;
  /** Upload EDM email social media asset */
  uploadEdmSocialMediaAsset?: Maybe<Company>;
  /** Upload event application module Assets */
  uploadEventApplicationModuleAsset?: Maybe<Module>;
  /** Upload event application module Assets */
  uploadEventLevelAsset?: Maybe<Event>;
  /** Upload Finder Application Module Assets */
  uploadFinderApplicationModuleAsset?: Maybe<Module>;
  /** Upload Gift Voucher documents */
  uploadGiftVoucherDocument: UploadGiftVoucherDocumentResult;
  /** Upload Gift Voucher Module Asset */
  uploadGiftVoucherModuleAsset?: Maybe<Module>;
  /** Upload MaintenanceModule Asset */
  uploadMaintenanceModuleAsset?: Maybe<Module>;
  /** Upload mobility module email asset */
  uploadMobilityModuleEmailAsset?: Maybe<Module>;
  /** Upload model configurator asset */
  uploadModelConfiguratorAsset?: Maybe<ModelConfigurator>;
  /** Upload stock asset */
  uploadStockAsset?: Maybe<Inventory>;
  /** Upload user asset */
  uploadUserAsset?: Maybe<User>;
  /** Upload variant asset */
  uploadVariantAsset?: Maybe<UploadedVariantAsset>;
  /** Upload asset to color block setting */
  uploadVariantConfiguratorColorSettingAsset?: Maybe<VariantConfigurator>;
  /** Upload variant configurator asset (color and trim images only) */
  uploadVariantConfiguratorMatrixAsset?: Maybe<VariantConfigurator>;
  /** Upload variant configurator option images asset */
  uploadVariantConfiguratorOptionAsset?: Maybe<VariantConfigurator>;
  /** Upload option setting asset */
  uploadVariantConfiguratorOptionSettingAsset?: Maybe<VariantConfigurator>;
  /** Upload variant configurator package additional details asset */
  uploadVariantConfiguratorPackageAdditionalDetailsAsset?: Maybe<VariantConfigurator>;
  /** Upload variant configurator package section image asset */
  uploadVariantConfiguratorPackageSectionImageAsset?: Maybe<VariantConfigurator>;
  /** Upload asset to trim block setting */
  uploadVariantConfiguratorTrimSettingAsset?: Maybe<VariantConfigurator>;
  uploadWebPageImage?: Maybe<WebPage>;
  /** Upload Website social media asset */
  uploadWebsiteSocialMediaAsset?: Maybe<Module>;
  /** Create or update a KYC preset in event / Lead gen forms */
  upsertKycPresetInEvent: Event;
  /** Validate Passcode for Remote Journey */
  validateRemoteJourneyPasscode: ApplicationJourney;
  /** Validate SMS OTP for reset password */
  validateSmsOTPForResetPassword: ResetPasswordResponse;
  /** Validate SMS OTP for update email */
  validateSmsOTPForUpdateEmail: UpdateEmailResponse;
};


export type MutationAddAuditTrailCommentArgs = {
  applicationId: Scalars['ObjectID']['input'];
  applicationStage: ApplicationStage;
  comment: Scalars['String']['input'];
};


export type MutationAddCustomerAuditTrailCommentArgs = {
  comment: Scalars['String']['input'];
  customerSuiteId: Scalars['ObjectID']['input'];
};


export type MutationAddInventoryAuditTrailCommentArgs = {
  comment: Scalars['String']['input'];
  inventoryId: Scalars['ObjectID']['input'];
};


export type MutationAddStockInventoryArgs = {
  inventoryId: Scalars['ObjectID']['input'];
  value: Scalars['Int']['input'];
};


export type MutationAddTradeInAuditTrailCommentArgs = {
  comment: Scalars['String']['input'];
  tradeInId: Scalars['ObjectID']['input'];
};


export type MutationAddVehicleLtaArgs = {
  id: Scalars['ObjectID']['input'];
  kind: VehicleKind;
  settings: LtaSettings;
};


export type MutationAmendMobilityApplicationArgs = {
  location: MobilityBookingLocationPayload;
  period: PeriodPayload;
  token: Scalars['String']['input'];
};


export type MutationApplyBasicLayoutOnRouterArgs = {
  routerId: Scalars['ObjectID']['input'];
  settings: BasicRouterSettings;
};


export type MutationApplyBasicProLayoutOnRouterArgs = {
  routerId: Scalars['ObjectID']['input'];
  settings: BasicProLayoutSettings;
};


export type MutationApplyEmptyLayoutOnRouterArgs = {
  routerId: Scalars['ObjectID']['input'];
};


export type MutationApplyForPasswordChangeArgs = {
  companyID?: InputMaybe<Scalars['ObjectID']['input']>;
  email: Scalars['String']['input'];
};


export type MutationApplyGiftVoucherArgs = {
  giftCode: Scalars['String']['input'];
};


export type MutationApplyNewArgs = {
  applicationId: Scalars['ObjectID']['input'];
  stage: ApplicationStage;
};


export type MutationApplyNewConfiguratorApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  configuration: ConfiguratorApplicationConfigurationPayload;
  financing: ApplicationFinanceSettings;
  insurancing?: InputMaybe<ApplicationInsuranceSettings>;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationApplyNewFinderApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  configuration: FinderApplicationConfigurationPayload;
  financing: ApplicationFinanceSettings;
  insurancing?: InputMaybe<ApplicationInsuranceSettings>;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationApplyNewStandardApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  configuration: StandardApplicationConfiguration;
  financing: ApplicationFinanceSettings;
  insurancing?: InputMaybe<ApplicationInsuranceSettings>;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationApproveApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  stage: ApplicationStage;
};


export type MutationAttachDealersToUserGroupArgs = {
  dealerIds: Array<Scalars['ObjectID']['input']>;
  userGroupId: Scalars['ObjectID']['input'];
};


export type MutationAttachPermissionOnRoleArgs = {
  permissionIds: Array<Scalars['ObjectID']['input']>;
  roleId: Scalars['ObjectID']['input'];
};


export type MutationAttachSuperiorGroupsToUserGroupArgs = {
  superiorUserGroupIds: Array<Scalars['ObjectID']['input']>;
  userGroupId: Scalars['ObjectID']['input'];
};


export type MutationAttachUserOnRoleArgs = {
  roleId: Scalars['ObjectID']['input'];
  userIds: Array<Scalars['ObjectID']['input']>;
};


export type MutationAttachUsersToUserGroupArgs = {
  userGroupId: Scalars['ObjectID']['input'];
  userIds: Array<Scalars['ObjectID']['input']>;
};


export type MutationAuthenticateArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationAuthenticateWithSmsOtpArgs = {
  code: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationAuthenticateWithTotpArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationAuthenticateWithWebPublicKeyCredentialArgs = {
  response: Scalars['JSONObject']['input'];
  token: Scalars['String']['input'];
};


export type MutationCalculateArgs = {
  data: CalculatorPayload;
  financeProductId: Scalars['ObjectID']['input'];
};


export type MutationCancelApplicationArgs = {
  applicationId?: InputMaybe<Scalars['ObjectID']['input']>;
  stage: ApplicationStage;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  previousPassword: Scalars['String']['input'];
};


export type MutationChangePasswordFromAuthenticationArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationChangePasswordFromTokenArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationCheckInApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  stage: ApplicationStage;
};


export type MutationCompleteApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  stage: ApplicationStage;
};


export type MutationCompleteWebPublicKeyCredentialRegistrationArgs = {
  response: Scalars['JSONObject']['input'];
  token: Scalars['String']['input'];
};


export type MutationConcludeAgreementApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  stage: ApplicationStage;
};


export type MutationConfirmBookingApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type MutationContactApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type MutationContinueApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  continueRequestFinancing?: InputMaybe<Scalars['Boolean']['input']>;
  isProceedWithCustomerDevice?: InputMaybe<Scalars['Boolean']['input']>;
  isSkipDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  stage: ApplicationStage;
};


export type MutationCopyVariantConfiguratorArgs = {
  modelConfiguratorId: Scalars['ObjectID']['input'];
  newVariantConfiguratorId: Scalars['ObjectID']['input'];
  oldVariantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationCreateAdditionalDetailArgs = {
  blockId: Scalars['ObjectID']['input'];
  packageSettingId: Scalars['ObjectID']['input'];
  settings: AdditionalDetailsInput;
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationCreateAdyenPaymentModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: AdyenPaymentModuleSettings;
};


export type MutationCreateAdyenPaymentSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: AdyenPaymentSettingsInput;
};


export type MutationCreateApplicationListEndpointArgs = {
  routerId: Scalars['ObjectID']['input'];
  settings: ApplicationListEndpointSettings;
};


export type MutationCreateAppointmentModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: AppointmentModuleInitialSettings;
};


export type MutationCreateAudiCalculationModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: AudiCalculationModuleInitialSettings;
};


export type MutationCreateAudiCalculationModuleSettingArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: AudiCalculationSettingInitialInput;
};


export type MutationCreateAudiFinancingAuthorizationArgs = {
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationCreateAudiFinancingModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  secrets: SalesForceSettingInput;
  settings: AudiFinancingModuleSettings;
};


export type MutationCreateAudiSalesForceModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: AudiSalesForceModuleSettings;
};


export type MutationCreateAutoplayModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: AutoplayModulePayload;
};


export type MutationCreateAutoplayModuleSettingArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: AutoplaySettingPayload;
};


export type MutationCreateBankArgs = {
  integrationSettings: BankIntegrationSettings;
  settings: BankSettings;
};


export type MutationCreateBankModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: BankModuleSettings;
};


export type MutationCreateBannerArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: BannerInput;
};


export type MutationCreateBasicSigningModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: BasicSigningModuleSettings;
};


export type MutationCreateBmwModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: BmwModuleSettings;
};


export type MutationCreateCapModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: CapModuleSettings;
};


export type MutationCreateCheckboxConsentsAndDeclarationsArgs = {
  conditionSettings?: InputMaybe<Array<ConditionSettings>>;
  eventId?: InputMaybe<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  settings: CheckboxConsentsAndDeclarationsSettings;
};


export type MutationCreateColorBlockArgs = {
  settings: BlockInput;
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationCreateCompanyArgs = {
  settings: CompanySettings;
};


export type MutationCreateConfiguratorApplicationEntrypointArgs = {
  configuratorApplicationModuleId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: ConfiguratorApplicationEntrypointSettings;
};


export type MutationCreateConfiguratorModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: ConfiguratorModuleInitialSettings;
};


export type MutationCreateConsentsAndDeclarationsModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: ConsentsAndDeclarationsModuleSettings;
};


export type MutationCreateCtsModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: CtsModuleInitialSettings;
};


export type MutationCreateCtsModuleSettingArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: CtsSettingInitialInput;
};


export type MutationCreateCustomerListEndpointArgs = {
  routerId: Scalars['ObjectID']['input'];
  settings: CustomerListEndpointSettings;
};


export type MutationCreateDealerArgs = {
  companyId: Scalars['ObjectID']['input'];
  dealerInput: DealerInput;
};


export type MutationCreateDealerSocialMediaArgs = {
  dealerId: Scalars['ObjectID']['input'];
  dealerSocialMediaInput: DealerSocialMediaInput;
};


export type MutationCreateDummyPrivatePageEndpointArgs = {
  routerId: Scalars['ObjectID']['input'];
  settings: DummyPrivatePageSettings;
};


export type MutationCreateDummyWelcomePageEndpointArgs = {
  routerId: Scalars['ObjectID']['input'];
  settings: DummyWelcomePageSettings;
};


export type MutationCreateEdmEmailSocialMediaArgs = {
  companyId: Scalars['ObjectID']['input'];
  socialMediaInput: EdmEmailSocialMediaPayload;
};


export type MutationCreateEventArgs = {
  eventInput: EventInput;
  kycPresets: Array<EventKycPresetInput>;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationCreateEventApplicationEntrypointArgs = {
  eventApplicationModuleId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: EventApplicationEntrypointSettings;
};


export type MutationCreateEventApplicationModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: EventApplicationModuleInitialSettings;
};


export type MutationCreateExternalBankArgs = {
  integrationSettings: BankIntegrationSettings;
  moduleId: Scalars['ObjectID']['input'];
  settings: ExternalBankSettings;
};


export type MutationCreateFinanceProductArgs = {
  kind: FinanceProductKind;
  settings: FinanceProductSettings;
};


export type MutationCreateFinderApplicationEntrypointArgs = {
  finderApplicationModuleIds: Array<Scalars['ObjectID']['input']>;
  routerId: Scalars['ObjectID']['input'];
  settings: FinderApplicationEntrypointSettings;
};


export type MutationCreateFinderApplicationPrivateModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: FinderApplicationPrivateModuleInitialSettings;
};


export type MutationCreateFinderApplicationPublicAccessEntrypointArgs = {
  finderApplicationModuleIds: Array<Scalars['ObjectID']['input']>;
  routerId: Scalars['ObjectID']['input'];
  settings: FinderApplicationPublicAccessEntrypointSettings;
};


export type MutationCreateFinderApplicationPublicModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: FinderApplicationModuleInitialSettings;
};


export type MutationCreateFinderVehicleManagementModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: FinderVehicleManagementModuleSetting;
};


export type MutationCreateFiservPaymentModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: FiservPaymentModuleSettings;
};


export type MutationCreateFiservPaymentSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: FiservPaymentSettingsInput;
};


export type MutationCreateGiftVoucherModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: GiftVoucherModuleInitialSettings;
};


export type MutationCreateInsuranceModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: InsuranceModuleSettings;
};


export type MutationCreateInsuranceProductArgs = {
  kind: InsuranceProductKind;
  settings: InsuranceProductSettings;
};


export type MutationCreateInsurerArgs = {
  integrationSettings: InsurerIntegrationSettings;
  settings: InsurerSettings;
};


export type MutationCreateInventoryArgs = {
  settings: InventorySettings;
};


export type MutationCreateKycPresetArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: KycPresetSettings;
};


export type MutationCreateLabelsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: LabelsInput;
};


export type MutationCreateLabelsModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: LabelsModuleSettings;
};


export type MutationCreateLanguagePackArgs = {
  displayName: Scalars['String']['input'];
  referenceName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateLocalCustomerManagementArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: LocalCustomerManagementSettings;
};


export type MutationCreateMaintenanceModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: MaintenanceModuleSettings;
};


export type MutationCreateMakeArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: LocalMakeSettings;
};


export type MutationCreateMarketingConsentsAndDeclarationsArgs = {
  conditionSettings?: InputMaybe<Array<ConditionSettings>>;
  eventId?: InputMaybe<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  settings: MarketingConsentsAndDeclarationsSettings;
};


export type MutationCreateMobilityAdditionalInfoArgs = {
  moduleId: Scalars['ObjectID']['input'];
  setting: MobilityAdditionalInfoSetting;
};


export type MutationCreateMobilityAddonArgs = {
  moduleId: Scalars['ObjectID']['input'];
  setting: MobilityAddonSetting;
};


export type MutationCreateMobilityApplicationEntrypointArgs = {
  mobilityApplicationModuleId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: MobilityApplicationEntrypointSettings;
};


export type MutationCreateMobilityModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: MobilityModuleInitialSettings;
};


export type MutationCreateModelArgs = {
  settings: LocalModelSettings;
};


export type MutationCreateModelConfiguratorArgs = {
  modelId: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
  settings: ModelConfiguratorSettings;
};


export type MutationCreateMyInfoModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: MyInfoModuleSettings;
};


export type MutationCreateMyInfoSettingArgs = {
  myInfoModuleId: Scalars['ObjectID']['input'];
  secrets: MyInfoSettingInput;
};


export type MutationCreateNamirialSigningModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  secrets?: InputMaybe<NamirialSettingsInput>;
  settings: NamirialSigningModuleSettings;
};


export type MutationCreateOptionsBlockArgs = {
  settings: BlockInput;
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationCreatePackageBlockArgs = {
  settings: BlockInput;
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationCreatePackageSettingArgs = {
  blockId: Scalars['ObjectID']['input'];
  settings: PackageSettingsInput;
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationCreatePayGatePaymentModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: PayGatePaymentModuleSettings;
};


export type MutationCreatePayGatePaymentSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: PayGatePaymentSettingsInput;
};


export type MutationCreatePorscheMasterDataModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: PorscheMasterDataModuleSettings;
};


export type MutationCreatePorschePaymentModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: PorschePaymentModuleSettings;
};


export type MutationCreatePorschePaymentSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: PorschePaymentSettingsInput;
};


export type MutationCreatePromoCodeArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: PromoCodeSettings;
};


export type MutationCreatePromoCodeModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: PromoCodeModuleSettings;
};


export type MutationCreateRoleArgs = {
  companyId: Scalars['ObjectID']['input'];
  displayName: Scalars['String']['input'];
};


export type MutationCreateRouterArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: RouterSettings;
};


export type MutationCreateRouterMenuArgs = {
  menuItem: MenuItemSettings;
  routerId: Scalars['ObjectID']['input'];
};


export type MutationCreateSdmAuthorizationArgs = {
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationCreateSdmModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  secrets: SalesForceSettingInput;
  settings: SdmModuleSettings;
};


export type MutationCreateSimpleVehicleManagementModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: SimpleVehicleManagementSettings;
};


export type MutationCreateStandardApplicationEntrypointArgs = {
  applicationModuleId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: StandardApplicationEntrypointSettings;
};


export type MutationCreateStandardApplicationModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: StandardApplicationModuleInitialSettings;
};


export type MutationCreateStandardApplicationPublicAccessEntrypointArgs = {
  applicationModuleId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: StandardApplicationPublicAccessEntrypointSettings;
};


export type MutationCreateSubmodelArgs = {
  settings: LocalSubmodelSettings;
};


export type MutationCreateTextConsentsAndDeclarationsArgs = {
  conditionSettings?: InputMaybe<Array<ConditionSettings>>;
  eventId?: InputMaybe<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  settings: TextConsentsAndDeclarationsSettings;
};


export type MutationCreateTradeInModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: TradeInModuleSettings;
};


export type MutationCreateTrimBlockArgs = {
  settings: BlockInput;
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationCreateTtbPaymentModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: TtbPaymentModuleSettings;
};


export type MutationCreateTtbPaymentSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: TtbPaymentSettingsInput;
};


export type MutationCreateUserArgs = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  settings: UserSettings;
};


export type MutationCreateUserGroupArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: UserGroupSettings;
};


export type MutationCreateUserlikeChatbotModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: UserlikeChatbotModuleInput;
};


export type MutationCreateUserlikeChatbotSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: UserlikeChatbotSettingsInput;
};


export type MutationCreateVariantArgs = {
  settings: LocalVariantSettings;
};


export type MutationCreateVariantConfiguratorArgs = {
  modelConfiguratorId: Scalars['ObjectID']['input'];
  variantId: Scalars['ObjectID']['input'];
};


export type MutationCreateWebCalcSettingArgs = {
  moduleId: Scalars['ObjectID']['input'];
  setting: WebCalcSettingPayload;
};


export type MutationCreateWebPageArgs = {
  moduleId: Scalars['ObjectID']['input'];
  webPageBlockInput: Array<WebPageBlockInput>;
  webPageInput: WebPageInput;
};


export type MutationCreateWebPageEndpointArgs = {
  routerId: Scalars['ObjectID']['input'];
  settings: WebPageEndpointSettings;
  websiteModuleId: Scalars['ObjectID']['input'];
};


export type MutationCreateWebsiteModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: CreateWebsiteModulePayload;
};


export type MutationCreateWebsiteSocialMediaArgs = {
  moduleId: Scalars['ObjectID']['input'];
  socialMediaInput: EdmEmailSocialMediaPayload;
};


export type MutationCreateWhatsappLiveChatModuleArgs = {
  companyId: Scalars['ObjectID']['input'];
  settings: WhatsappLiveChatModuleInput;
};


export type MutationCreateWhatsappLiveChatSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: WhatsappLiveChatSettingsInput;
};


export type MutationDeclineApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  stage: ApplicationStage;
};


export type MutationDeleteAdditionalDetailArgs = {
  additionalDetailId: Scalars['ObjectID']['input'];
  blockId: Scalars['ObjectID']['input'];
  packageSettingsId: Scalars['ObjectID']['input'];
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationDeleteAdyenPaymentSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationDeleteApplicationDocumentArgs = {
  applicationId?: InputMaybe<Scalars['ObjectID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  uploadId: Scalars['ObjectID']['input'];
};


export type MutationDeleteAppointmentModuleAssetArgs = {
  moduleId: Scalars['ObjectID']['input'];
  type: AppointmentModuleAsset;
};


export type MutationDeleteAudiCalculationModuleSettingArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settingId: Scalars['ObjectID']['input'];
};


export type MutationDeleteAutoplayModuleSettingArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settingId: Scalars['ObjectID']['input'];
};


export type MutationDeleteBankArgs = {
  bankId: Scalars['ObjectID']['input'];
};


export type MutationDeleteBankAssetArgs = {
  bankId: Scalars['ObjectID']['input'];
  type: BankAsset;
};


export type MutationDeleteBannerArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteBannerImageArgs = {
  bannerAsset: BannerAsset;
  id: Scalars['ObjectID']['input'];
  imageId: Scalars['ObjectID']['input'];
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteCompanyAssetArgs = {
  companyId: Scalars['ObjectID']['input'];
  type: CompanyAsset;
};


export type MutationDeleteConfiguratorDescriptionImageArgs = {
  imageId: Scalars['ObjectID']['input'];
  modelConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationDeleteConfiguratorModuleAssetArgs = {
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentUpdateType: EmailContentUpdateType;
  moduleId: Scalars['ObjectID']['input'];
  type: ConfiguratorModuleAsset;
};


export type MutationDeleteConsentsAndDeclarationsArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteCtsModuleSettingArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settingId: Scalars['ObjectID']['input'];
};


export type MutationDeleteDealerArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteDealerSocialMediaArgs = {
  dealerSocialMediaId: Scalars['ObjectID']['input'];
};


export type MutationDeleteDealerSocialMediaAssetArgs = {
  dealerSocialMediaId: Scalars['ObjectID']['input'];
  type: DealerAsset;
};


export type MutationDeleteEdmEmailSocialMediaArgs = {
  socialMediaId: Scalars['ObjectID']['input'];
};


export type MutationDeleteEdmSocialMediaAssetArgs = {
  socialMediaId: Scalars['ObjectID']['input'];
  type: CompanyAsset;
};


export type MutationDeleteEndpointArgs = {
  endpointId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
};


export type MutationDeleteEventArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteEventApplicationModuleAssetArgs = {
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentUpdateType: EmailContentUpdateType;
  id: Scalars['ObjectID']['input'];
  type: EventModuleAsset;
};


export type MutationDeleteEventLevelAssetArgs = {
  id: Scalars['ObjectID']['input'];
  type: EventModuleAsset;
};


export type MutationDeleteExternalBankArgs = {
  bankId: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationDeleteFinanceProductArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteFinderApplicationModuleAssetArgs = {
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentUpdateType: EmailContentUpdateType;
  moduleId: Scalars['ObjectID']['input'];
  type: FinderApplicationModuleAsset;
};


export type MutationDeleteFiservPaymentSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationDeleteGiftVoucherDocumentArgs = {
  giftVoucherId?: InputMaybe<Scalars['ObjectID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  uploadId: Scalars['ObjectID']['input'];
};


export type MutationDeleteGiftVoucherModuleAssetArgs = {
  moduleId: Scalars['ObjectID']['input'];
  type: GiftVoucherModuleAsset;
};


export type MutationDeleteInsuranceProductArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteInsurerArgs = {
  insurerId: Scalars['ObjectID']['input'];
};


export type MutationDeleteInventoriesArgs = {
  settings: InventorySettings;
};


export type MutationDeleteKycPresetArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationDeleteLabelsArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteLanguagePackArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteMaintenanceModuleAssetArgs = {
  moduleId: Scalars['ObjectID']['input'];
  type: ModuleAsset;
};


export type MutationDeleteMobilityArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteMobilityModuleEmailAssetArgs = {
  assetType: MobilityEmailAssetType;
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentId: Scalars['ObjectID']['input'];
  emailContentUpdateType: EmailContentUpdateType;
  mobilityAsset: MobilityAsset;
  mobilityRecipient: MobilityRecipient;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationDeleteModelConfiguratorArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteModelConfiguratorAssetArgs = {
  id: Scalars['ObjectID']['input'];
  type: ModelConfiguratorAsset;
};


export type MutationDeleteModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationDeleteMyInfoSettingArgs = {
  id: Scalars['ObjectID']['input'];
  myInfoModuleId: Scalars['ObjectID']['input'];
};


export type MutationDeleteOptionsBlockArgs = {
  blockId: Scalars['ObjectID']['input'];
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationDeletePackageSettingArgs = {
  blockId: Scalars['ObjectID']['input'];
  packageSettingsId: Scalars['ObjectID']['input'];
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationDeletePayGatePaymentSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationDeletePorschePaymentSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationDeletePromoCodeArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteRoleArgs = {
  roleId: Scalars['ObjectID']['input'];
};


export type MutationDeleteRouterArgs = {
  routerId: Scalars['ObjectID']['input'];
};


export type MutationDeleteStockAssetArgs = {
  stockId: Scalars['ObjectID']['input'];
  uploadId: Scalars['ObjectID']['input'];
};


export type MutationDeleteStockInventoryArgs = {
  id: Scalars['ObjectID']['input'];
  inventoryId: Scalars['ObjectID']['input'];
};


export type MutationDeleteTtbPaymentSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ObjectID']['input'];
  newAssigneeId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type MutationDeleteUserAssetArgs = {
  type: UserAsset;
  userId: Scalars['ObjectID']['input'];
};


export type MutationDeleteUserGroupArgs = {
  userGroupId: Scalars['ObjectID']['input'];
};


export type MutationDeleteUserlikeChatbotSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationDeleteVariantAssetArgs = {
  type: VariantAsset;
  uploadId: Scalars['ObjectID']['input'];
  variantId: Scalars['ObjectID']['input'];
};


export type MutationDeleteVariantConfiguratorArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteVariantConfiguratorColorSettingAssetArgs = {
  blockId: Scalars['ObjectID']['input'];
  colorSettingId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  type: VariantConfiguratorAsset;
};


export type MutationDeleteVariantConfiguratorMatrixAssetArgs = {
  colorId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  trimId: Scalars['ObjectID']['input'];
  type: MatrixAsset;
};


export type MutationDeleteVariantConfiguratorOptionAssetArgs = {
  blockId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  type?: InputMaybe<VariantConfiguratorAsset>;
  uploadId: Scalars['ObjectID']['input'];
};


export type MutationDeleteVariantConfiguratorOptionSettingAssetArgs = {
  blockId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  optionSettingId: Scalars['ObjectID']['input'];
  type: VariantConfiguratorAsset;
};


export type MutationDeleteVariantConfiguratorPackageAdditionalDetailsAssetArgs = {
  additionalDetailsId: Scalars['ObjectID']['input'];
  blockId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  packageSettingId: Scalars['ObjectID']['input'];
  type?: InputMaybe<VariantConfiguratorAsset>;
};


export type MutationDeleteVariantConfiguratorPackageSectionImageAssetArgs = {
  blockId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  packageSettingId: Scalars['ObjectID']['input'];
  type: VariantConfiguratorAsset;
};


export type MutationDeleteVariantConfiguratorTrimSettingAssetArgs = {
  blockId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  trimSettingId: Scalars['ObjectID']['input'];
  type: VariantConfiguratorAsset;
};


export type MutationDeleteVehicleArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteWebPageArgs = {
  webPageId: Scalars['ObjectID']['input'];
};


export type MutationDeleteWebPageBlockArgs = {
  webPageBlockId: Scalars['ObjectID']['input'];
  webPageId: Scalars['ObjectID']['input'];
};


export type MutationDeleteWebPageImageArgs = {
  webPageAsset: WebPageAsset;
  webPageBlockId?: InputMaybe<Scalars['ObjectID']['input']>;
  webPageBlockListId?: InputMaybe<Scalars['ObjectID']['input']>;
  webPageId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type MutationDeleteWebsiteSocialMediaArgs = {
  socialMediaId: Scalars['ObjectID']['input'];
};


export type MutationDeleteWebsiteSocialMediaAssetArgs = {
  socialMediaId: Scalars['ObjectID']['input'];
};


export type MutationDeleteWhatsappLiveChatSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationDraftConfiguratorApplicationArgs = {
  configuration: ConfiguratorApplicationConfigurationPayload;
  configuratorBlocks: Array<ConfiguratorBlockPayload>;
  configuratorId: Scalars['ObjectID']['input'];
  customer: ApplicationCustomerDraft;
  dealerId: Scalars['ObjectID']['input'];
  endpointId?: InputMaybe<Scalars['ObjectID']['input']>;
  financing?: InputMaybe<ApplicationFinanceSettings>;
  insurancing?: InputMaybe<ApplicationInsuranceSettings>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  promoCodeId?: InputMaybe<Scalars['ObjectID']['input']>;
  tradeInVehicle: Array<TradeInVehiclePayload>;
  vehicle: ApplicationVehicleDraft;
};


export type MutationDraftEventApplicationArgs = {
  configuration: EventApplicationConfigurationPayload;
  customer: ApplicationCustomerDraft;
  customerKind: CustomerKind;
  customizedFields: Array<EventCustomizedFieldInput>;
  dealerId: Scalars['ObjectID']['input'];
  endpointId?: InputMaybe<Scalars['ObjectID']['input']>;
  eventId: Scalars['ObjectID']['input'];
  languageId?: InputMaybe<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  tradeInVehicle: Array<TradeInVehiclePayload>;
  vehicle: ApplicationVehicleDraft;
};


export type MutationDraftFinderApplicationArgs = {
  configuration: FinderApplicationConfigurationPayload;
  customer: ApplicationCustomerDraft;
  dealerId: Scalars['ObjectID']['input'];
  endpointId?: InputMaybe<Scalars['ObjectID']['input']>;
  financing?: InputMaybe<ApplicationFinanceSettings>;
  insurancing?: InputMaybe<ApplicationInsuranceSettings>;
  isTestDriveDrafting?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  promoCodeId?: InputMaybe<Scalars['ObjectID']['input']>;
  tradeInVehicle: Array<TradeInVehiclePayload>;
  vehicle: ApplicationVehicleDraft;
};


export type MutationDraftGiftVoucherArgs = {
  setting: DraftGiftVoucherSettings;
};


export type MutationDraftMobilityApplicationArgs = {
  customer: ApplicationCustomerDraft;
  endpointId?: InputMaybe<Scalars['ObjectID']['input']>;
  languageId?: InputMaybe<Scalars['ObjectID']['input']>;
  mobilityBookingDetails: MobilityBookingDetailsPayload;
  mobilityDetails: Array<MobilityDetailsPayload>;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationDraftStandardApplicationArgs = {
  configuration: StandardApplicationConfiguration;
  customer: ApplicationCustomerDraft;
  dealerId: Scalars['ObjectID']['input'];
  endpointId?: InputMaybe<Scalars['ObjectID']['input']>;
  financing: ApplicationFinanceSettings;
  insurancing?: InputMaybe<ApplicationInsuranceSettings>;
  languageId?: InputMaybe<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  promoCodeId?: InputMaybe<Scalars['ObjectID']['input']>;
  tradeInVehicle: Array<TradeInVehiclePayload>;
  vehicle: ApplicationVehicleDraft;
};


export type MutationEnableAuthenticatorArgs = {
  secret: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationEndTestDriveArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type MutationExtendConfiguratorStockExpiryArgs = {
  token: Scalars['String']['input'];
};


export type MutationExtendEventJourneyExpiryArgs = {
  token: Scalars['String']['input'];
};


export type MutationExtendFinderVehicleExpiryArgs = {
  token: Scalars['String']['input'];
};


export type MutationExtendGiftVoucherJourneyExpiryArgs = {
  token: Scalars['String']['input'];
};


export type MutationExtendMobilityStockExpiryArgs = {
  token: Scalars['String']['input'];
};


export type MutationGenerateAmendMobilityApplicationAccessArgs = {
  applicationId: Scalars['ObjectID']['input'];
  period: PeriodPayload;
};


export type MutationGenerateCancelMobilityApplicationAccessArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type MutationGenerateRemoteJourneyPasscodeArgs = {
  secret: Scalars['String']['input'];
};


export type MutationGenerateSigningOtpArgs = {
  purpose: ApplicationSigningPurpose;
  token: Scalars['String']['input'];
};


export type MutationGenerateWebCredentialAuthenticationArgs = {
  username: Scalars['String']['input'];
};


export type MutationGetAgreementsAndKycFieldsFromUpdatedConfigurationArgs = {
  configuration: UpdatedConfigurationSettings;
  token: Scalars['String']['input'];
};


export type MutationImportAudiFinancingModuleSalesPersonCodeMappingsArgs = {
  duplicateIdsToBeUpdated: Array<Scalars['String']['input']>;
  isUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationImportConfiguratorVariantPricesArgs = {
  modelConfiguratorId: Scalars['ObjectID']['input'];
  upload?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationImportFinderVehiclesLtaArgs = {
  moduleId: Scalars['ObjectID']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationImportInventoriesArgs = {
  dealerId: Scalars['ObjectID']['input'];
  upload?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationImportLanguagePackArgs = {
  languagePackId: Scalars['ObjectID']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationImportMakeArgs = {
  companyId: Scalars['String']['input'];
  duplicateIdsToBeUpdated: Array<Scalars['String']['input']>;
  isUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  moduleId: Scalars['String']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationImportModelArgs = {
  companyId: Scalars['String']['input'];
  duplicateIdsToBeUpdated: Array<Scalars['String']['input']>;
  isUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  moduleId: Scalars['String']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationImportSdmModuleSalesPersonCodeMappingsArgs = {
  duplicateIdsToBeUpdated: Array<Scalars['String']['input']>;
  isUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationImportSubModelArgs = {
  companyId: Scalars['String']['input'];
  duplicateIdsToBeUpdated: Array<Scalars['String']['input']>;
  isUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  moduleId: Scalars['String']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationImportVariantArgs = {
  companyId: Scalars['String']['input'];
  duplicateIdsToBeUpdated: Array<Scalars['String']['input']>;
  isUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  moduleId: Scalars['String']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationImportVariantImagesArgs = {
  uploads: Array<InputMaybe<Scalars['Upload']['input']>>;
  vehicleModuleId: Scalars['ObjectID']['input'];
};


export type MutationProceedWithCustomerDeviceArgs = {
  fields: Array<LocalCustomerFieldSettings>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationQualifyLeadApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  stage: ApplicationStage;
};


export type MutationRefreshApplicationStatusArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type MutationReleaseFinderVehicleExpiryArgs = {
  token: Scalars['String']['input'];
};


export type MutationReleaseReservedConfiguratorStockArgs = {
  token: Scalars['String']['input'];
};


export type MutationReleaseReservedMobilityStockArgs = {
  token: Scalars['String']['input'];
};


export type MutationRemoveDealerOnUserGroupArgs = {
  dealerId: Scalars['ObjectID']['input'];
  userGroupId: Scalars['ObjectID']['input'];
};


export type MutationRemovePermissionOnRoleArgs = {
  permissionId?: InputMaybe<Scalars['ObjectID']['input']>;
  roleId: Scalars['ObjectID']['input'];
};


export type MutationRemoveUserOnRoleArgs = {
  roleId: Scalars['ObjectID']['input'];
  userId: Scalars['ObjectID']['input'];
};


export type MutationRemoveUserOnUserGroupArgs = {
  userGroupId: Scalars['ObjectID']['input'];
  userId: Scalars['ObjectID']['input'];
};


export type MutationRemoveVehicleLtaArgs = {
  id: Scalars['ObjectID']['input'];
  kind: VehicleKind;
};


export type MutationRequestDisbursementArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type MutationRequestReleaseLetterArgs = {
  applicationId: Scalars['ObjectID']['input'];
  settings: RequestReleaseLetterSettings;
};


export type MutationResendSmsOtpForResetPasswordArgs = {
  token: Scalars['String']['input'];
};


export type MutationResendSmsOtpForUpdateEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationResetFinderVehicleArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationRevokeUserSessionArgs = {
  displayNotice?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ObjectID']['input'];
};


export type MutationRevokeWebPublicKeyCredentialArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationSendActivationLinkArgs = {
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type MutationShareStandardApplicationArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  configuration: StandardApplicationConfiguration;
  customer: ApplicationCustomerDraft;
  dealerId: Scalars['ObjectID']['input'];
  endpointId: Scalars['ObjectID']['input'];
  financing: Array<ApplicationFinanceSettings>;
  insurancing: Array<ApplicationInsuranceSettings>;
  languageId?: InputMaybe<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  promoCodeId?: InputMaybe<Scalars['ObjectID']['input']>;
  vehicle: Array<ApplicationVehicleDraft>;
};


export type MutationStartTestDriveArgs = {
  applicationId: Scalars['ObjectID']['input'];
  testDriveRedirectUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitAdyenPaymentArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  sessionResult?: InputMaybe<Scalars['String']['input']>;
  skipDeposit: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationSubmitApplicantAgreementsArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  customerKind: CustomerKind;
  hasGuarantor?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
};


export type MutationSubmitApplicantAppointmentArgs = {
  bookingTimeSlot?: InputMaybe<SubmitAppointmentBookingTimeSlot>;
  token: Scalars['String']['input'];
};


export type MutationSubmitApplicantKycArgs = {
  customerKind: CustomerKind;
  fields: Array<LocalCustomerFieldSettings>;
  saveDraft?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
};


export type MutationSubmitApplicationQuotationArgs = {
  quotation: ApplicationQuotationSettings;
  token: Scalars['String']['input'];
};


export type MutationSubmitChangesArgs = {
  applicationId: Scalars['ObjectID']['input'];
  commentsToInsurer?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  stage: ApplicationStage;
  updates?: InputMaybe<Array<ApplicationUpdate>>;
  withRedirectionLink?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSubmitFiservPaymentArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  skipDeposit: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationSubmitGiftVoucherAdyenPaymentArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  sessionResult?: InputMaybe<Scalars['String']['input']>;
  skipDeposit: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationSubmitGiftVoucherApplicantAgreementsArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  customerKind: CustomerKind;
  token: Scalars['String']['input'];
};


export type MutationSubmitGiftVoucherApplicantKycArgs = {
  customerKind: CustomerKind;
  fields: Array<LocalCustomerFieldSettings>;
  saveDraft?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
};


export type MutationSubmitGiftVoucherFiservPaymentArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  skipDeposit: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationSubmitGiftVoucherPayGatePaymentArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  skipDeposit: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationSubmitGiftVoucherPorschePaymentArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  skipDeposit: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationSubmitGiftVoucherTtbPaymentArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  skipDeposit: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationSubmitGuarantorAgreementsArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  token: Scalars['String']['input'];
};


export type MutationSubmitGuarantorKycArgs = {
  fields: Array<LocalCustomerFieldSettings>;
  saveDraft?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
};


export type MutationSubmitPayGatePaymentArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  skipDeposit: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationSubmitPorschePaymentArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  skipDeposit: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationSubmitSigningOtpArgs = {
  code: Scalars['String']['input'];
  purpose: ApplicationSigningPurpose;
  token: Scalars['String']['input'];
};


export type MutationSubmitTestDriveAgreementsArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  token: Scalars['String']['input'];
};


export type MutationSubmitTestDriveKycArgs = {
  fields: Array<LocalCustomerFieldSettings>;
  token: Scalars['String']['input'];
};


export type MutationSubmitTtbPaymentArgs = {
  agreedConsents: Array<ApplicantAgreementSettings>;
  skipDeposit: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationSynchronizeFinderVehicleArgs = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type MutationSynchronizePorscheMasterDataArgs = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type MutationTakeOutStockInventoryArgs = {
  inventoryId: Scalars['ObjectID']['input'];
  value: Scalars['Int']['input'];
};


export type MutationUnqualifyLeadApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  stage: ApplicationStage;
};


export type MutationUpdateAccountArgs = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  data: UpsertUserPayload;
  id: Scalars['ObjectID']['input'];
};


export type MutationUpdateAdditionalDetailArgs = {
  additionalDetailId: Scalars['ObjectID']['input'];
  blockId: Scalars['ObjectID']['input'];
  packageSettingsId: Scalars['ObjectID']['input'];
  settings: AdditionalDetailsInput;
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationUpdateAdyenPaymentModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: AdyenPaymentModuleSettings;
};


export type MutationUpdateAdyenPaymentSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
  settings: AdyenPaymentSettingsInput;
};


export type MutationUpdateApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  commentsToInsurer?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  stage: ApplicationStage;
  updates?: InputMaybe<Array<ApplicationUpdate>>;
};


export type MutationUpdateApplicationDealershipAssignmentsByDealerArgs = {
  dealerAssignee?: InputMaybe<DealershipSettingOverridesInput>;
  dealerBookingCode?: InputMaybe<DealerBookingCodeSettingOverrideInput>;
  dealerFinanceProducts?: InputMaybe<DealerFinanceProductsPayload>;
  dealerFinancingDisclaimer?: InputMaybe<DealerDisclaimersOverridesConfiguratorInput>;
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  dealerInsuranceProducts?: InputMaybe<DealerInsuranceProductsPayload>;
  dealerMarketType?: InputMaybe<DealerApplicationMarketTypeInput>;
  dealerPriceDisclaimer?: InputMaybe<DealerDisclaimersOverridesConfiguratorInput>;
  dealerRentalDisclaimer?: InputMaybe<DealerTranslatedStringSettingOverridesInput>;
  dealerRentalRequirement?: InputMaybe<DealerTranslatedStringSettingOverridesInput>;
  dealerReservationInstructions?: InputMaybe<DealerTranslatedStringSettingOverridesInput>;
  dealerTermsText?: InputMaybe<DealerTranslatedStringSettingOverridesInput>;
  dealerTermsTitle?: InputMaybe<DealerTranslatedStringSettingOverridesInput>;
  dealerVehicles?: InputMaybe<DealerVehiclesPayload>;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationUpdateApplicationFieldsArgs = {
  commentsToInsurer?: InputMaybe<Scalars['String']['input']>;
  remarks: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateApplicationListEndpointArgs = {
  endpointId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: ApplicationListEndpointSettings;
};


export type MutationUpdateAppointmentDataArgs = {
  applicationId: Scalars['ObjectID']['input'];
  appointmentData: ApplicationUpdateAppointmentDateTimeData;
};


export type MutationUpdateAppointmentModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: AppointmentModuleInitialSettings;
};


export type MutationUpdateAppointmentModuleEmailContentArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: AppointmentModuleEmailContentsInput;
};


export type MutationUpdateAssigneeOnApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  assigneeId?: InputMaybe<Scalars['ObjectID']['input']>;
  languageId?: InputMaybe<Scalars['ObjectID']['input']>;
  stage: ApplicationStage;
};


export type MutationUpdateAudiCalculationFinanceProductsArgs = {
  financeProductSuiteIds: Array<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  settingId: Scalars['ObjectID']['input'];
};


export type MutationUpdateAudiCalculationInsuranceProductsArgs = {
  insuranceProductSuiteIds: Array<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  settingId: Scalars['ObjectID']['input'];
};


export type MutationUpdateAudiCalculationModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: AudiCalculationModuleUpdateSettings;
};


export type MutationUpdateAudiCalculationModuleSettingArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settingId: Scalars['ObjectID']['input'];
  settings: AudiCalculationSettingUpdateInput;
};


export type MutationUpdateAudiFinancingModuleSalesPersonCodeMappingsArgs = {
  mappings: Array<AudiFinancingModuleSalesPersonCodeMapping>;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationUpdateAudiSalesForceModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: AudiSalesForceModuleSettings;
};


export type MutationUpdateAutoplayModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: AutoplayModulePayload;
};


export type MutationUpdateAutoplayModuleSettingArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settingId?: InputMaybe<Scalars['ObjectID']['input']>;
  settings: AutoplaySettingPayload;
};


export type MutationUpdateBankArgs = {
  bankId: Scalars['ObjectID']['input'];
  settings: BankSettings;
};


export type MutationUpdateBankAvailableFinanceProductTypesArgs = {
  bankId: Scalars['ObjectID']['input'];
  settings: BankAvailableFinanceProductTypesUpdateSetting;
};


export type MutationUpdateBankModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: BankModuleSettings;
};


export type MutationUpdateBannerArgs = {
  id: Scalars['ObjectID']['input'];
  settings: BannerInput;
};


export type MutationUpdateBasicSigningModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: BasicSigningModuleSettings;
};


export type MutationUpdateBmwFsBankIntegrationSettingArgs = {
  bankId: Scalars['ObjectID']['input'];
  settings: BmwFsBankIntegrationUpdateSettings;
};


export type MutationUpdateBmwModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: BmwModuleUpdateSettings;
};


export type MutationUpdateCapModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: CapModuleSettings;
};


export type MutationUpdateCheckboxConsentsAndDeclarationsArgs = {
  conditionSettings?: InputMaybe<Array<ConditionSettings>>;
  eventId?: InputMaybe<Scalars['ObjectID']['input']>;
  id: Scalars['ObjectID']['input'];
  settings: CheckboxConsentsAndDeclarationsSettings;
};


export type MutationUpdateColorBlockArgs = {
  blockId: Scalars['ObjectID']['input'];
  settings: BlockInput;
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['ObjectID']['input'];
  settings: CompanySettings;
};


export type MutationUpdateConfiguratorApplicationArgs = {
  configuration: ConfiguratorApplicationConfigurationPayload;
  configuratorBlocks?: InputMaybe<Array<ConfiguratorBlockPayload>>;
  customer: ApplicationCustomerDraft;
  dealerId: Scalars['ObjectID']['input'];
  financing?: InputMaybe<ApplicationFinanceSettings>;
  insurancing?: InputMaybe<ApplicationInsuranceSettings>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
  vehicle: ApplicationVehicleDraft;
};


export type MutationUpdateConfiguratorApplicationConfigurationArgs = {
  configuration: ConfiguratorApplicationConfigurationPayload;
  token: Scalars['String']['input'];
};


export type MutationUpdateConfiguratorApplicationEntrypointArgs = {
  endpointId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: ConfiguratorApplicationEntrypointSettings;
};


export type MutationUpdateConfiguratorApplicationJourneyArgs = {
  configuration: ConfiguratorApplicationConfigurationPayload;
  customerKind: CustomerKind;
  financing?: InputMaybe<UpdateApplicationJourneyFinancingSettings>;
  token: Scalars['String']['input'];
  tradeInVehicle: Array<TradeInVehiclePayload>;
};


export type MutationUpdateConfiguratorModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: ConfiguratorModuleUpdateSettings;
};


export type MutationUpdateConfiguratorModuleEmailContentsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: ConfiguratorModuleEmailContentsSetting;
};


export type MutationUpdateConsentOrderListArgs = {
  consentIds: Array<Scalars['ObjectID']['input']>;
  featurePurpose: ConsentFeaturePurposeInput;
};


export type MutationUpdateConsentsAndDeclarationsModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: ConsentsAndDeclarationsModuleSettings;
};


export type MutationUpdateCtsFinanceProductsArgs = {
  financeProductSuiteIds: Array<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  settingId: Scalars['ObjectID']['input'];
};


export type MutationUpdateCtsInsuranceProductsArgs = {
  insuranceProductSuiteIds: Array<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  settingId: Scalars['ObjectID']['input'];
};


export type MutationUpdateCtsModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: CtsModuleUpdateSettings;
};


export type MutationUpdateCtsModuleSettingArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settingId: Scalars['ObjectID']['input'];
  settings: CtsSettingUpdateInput;
};


export type MutationUpdateCustomerArgs = {
  customerId: Scalars['ObjectID']['input'];
  updates?: InputMaybe<Array<LocalCustomerFieldSettings>>;
};


export type MutationUpdateCustomerListEndpointArgs = {
  endpointId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: CustomerListEndpointSettings;
};


export type MutationUpdateDbsBankIntegrationSettingArgs = {
  bankId: Scalars['ObjectID']['input'];
  settings: DbsBankIntegrationSettings;
};


export type MutationUpdateDealerArgs = {
  dealerInput: DealerInput;
  id: Scalars['ObjectID']['input'];
};


export type MutationUpdateDealerSocialMediaArgs = {
  dealerSocialMediaId: Scalars['ObjectID']['input'];
  dealerSocialMediaInput: DealerSocialMediaInput;
};


export type MutationUpdateDisplayNameArgs = {
  displayName: Scalars['String']['input'];
};


export type MutationUpdateDummyPrivatePageEndpointArgs = {
  endpointId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: DummyPrivatePageSettings;
};


export type MutationUpdateDummyWelcomePageEndpointArgs = {
  endpointId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: DummyWelcomePageSettings;
};


export type MutationUpdateEazyInsurerIntegrationSettingArgs = {
  insurerId: Scalars['ObjectID']['input'];
  settings: EazyInsurerIntegrationSettings;
};


export type MutationUpdateEdmEmailSocialMediaArgs = {
  socialMediaId: Scalars['ObjectID']['input'];
  socialMediaInput: EdmEmailSocialMediaPayload;
};


export type MutationUpdateEmailBankIntegrationSettingArgs = {
  bankId: Scalars['ObjectID']['input'];
  settings: EmailBankIntegrationSettings;
};


export type MutationUpdateEmailFromTokenArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationUpdateEmailInsurerIntegrationSettingArgs = {
  insurerId: Scalars['ObjectID']['input'];
  settings: EmailInsurerIntegrationSettings;
};


export type MutationUpdateEnbdBankIntegrationSettingArgs = {
  bankId: Scalars['ObjectID']['input'];
  settings: EnbdBankIntegrationSettings;
};


export type MutationUpdateEventArgs = {
  eventInput: EventInput;
  id: Scalars['ObjectID']['input'];
};


export type MutationUpdateEventApplicationArgs = {
  configuration: EventApplicationConfigurationPayload;
  customerKind: CustomerKind;
  customizedFields: Array<EventCustomizedFieldInput>;
  dealerId: Scalars['ObjectID']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  tradeInVehicle: Array<TradeInVehiclePayload>;
  vehicle: ApplicationVehicleDraft;
};


export type MutationUpdateEventApplicationEntrypointArgs = {
  endpointId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: EventApplicationEntrypointSettings;
};


export type MutationUpdateEventApplicationFinanceProductAssignmentsArgs = {
  dealerFinanceProducts: Array<DealerFinanceProductsPayload>;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationUpdateEventApplicationModuleEmailContentsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: EventApplicationModuleEmailContentsSetting;
};


export type MutationUpdateEventApplicationModuleMainDetailsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: EventApplicationModuleUpdateSettings;
};


export type MutationUpdateEventApplicationVehicleAssignmentsArgs = {
  dealerVehicles: Array<DealerVehiclesPayload>;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationUpdateExternalBankArgs = {
  bankId: Scalars['ObjectID']['input'];
  integrationSettings: BankIntegrationUpdateSettings;
  moduleId: Scalars['ObjectID']['input'];
  settings: ExternalBankSettings;
};


export type MutationUpdateFinanceProductArgs = {
  id: Scalars['ObjectID']['input'];
  settings: FinanceProductSettings;
};


export type MutationUpdateFinderApplicationArgs = {
  configuration: FinderApplicationConfigurationPayload;
  financing?: InputMaybe<ApplicationFinanceSettings>;
  insurancing?: InputMaybe<ApplicationInsuranceSettings>;
  isTestDriveDrafting?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['ObjectID']['input']>;
  promoCodeId?: InputMaybe<Scalars['ObjectID']['input']>;
  token: Scalars['String']['input'];
  tradeInVehicle: Array<TradeInVehiclePayload>;
};


export type MutationUpdateFinderApplicationDraftArgs = {
  configuration: FinderApplicationConfigurationPayload;
  customer: ApplicationCustomerDraft;
  dealerId: Scalars['ObjectID']['input'];
  financing?: InputMaybe<ApplicationFinanceSettings>;
  insurancing?: InputMaybe<ApplicationInsuranceSettings>;
  isTestDriveDrafting?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['ObjectID']['input']>;
  promoCodeId?: InputMaybe<Scalars['ObjectID']['input']>;
  token: Scalars['String']['input'];
  tradeInVehicle: Array<TradeInVehiclePayload>;
};


export type MutationUpdateFinderApplicationEntrypointArgs = {
  endpointId: Scalars['ObjectID']['input'];
  finderApplicationModuleIds: Array<Scalars['ObjectID']['input']>;
  routerId: Scalars['ObjectID']['input'];
  settings: FinderApplicationEntrypointSettings;
};


export type MutationUpdateFinderApplicationJourneyArgs = {
  customerKind: CustomerKind;
  financing?: InputMaybe<UpdateApplicationJourneyFinancingSettings>;
  token: Scalars['String']['input'];
  tradeInVehicle: Array<TradeInVehiclePayload>;
};


export type MutationUpdateFinderApplicationPrivateModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: FinderApplicationPrivateModuleUpdateSettings;
};


export type MutationUpdateFinderApplicationPrivateModuleEmailContentsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: FinderApplicationModuleEmailContentsSetting;
};


export type MutationUpdateFinderApplicationPublicAccessEntrypointArgs = {
  endpointId: Scalars['ObjectID']['input'];
  finderApplicationModuleIds: Array<Scalars['ObjectID']['input']>;
  routerId: Scalars['ObjectID']['input'];
  settings: FinderApplicationPublicAccessEntrypointSettings;
};


export type MutationUpdateFinderApplicationPublicModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: FinderApplicationModuleUpdateSettings;
};


export type MutationUpdateFinderApplicationPublicModuleEmailContentsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: FinderApplicationModuleEmailContentsSetting;
};


export type MutationUpdateFinderVehicleArgs = {
  id: Scalars['ObjectID']['input'];
  payload: FinderVehiclePayload;
};


export type MutationUpdateFinderVehicleManagementModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: FinderVehicleManagementModuleSetting;
};


export type MutationUpdateFiservPaymentModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: FiservPaymentModuleSettings;
};


export type MutationUpdateFiservPaymentSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
  settings: FiservPaymentUpdateSettingsInput;
};


export type MutationUpdateGiftVoucherArgs = {
  numberOfBookingReferenceDays: Scalars['Int']['input'];
  stockId: Scalars['ObjectID']['input'];
  token: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};


export type MutationUpdateGiftVoucherModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: GiftVoucherModuleUpdateSettings;
};


export type MutationUpdateGiftVoucherModuleEmailContentArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: GiftVoucherModuleEmailContentsInput;
};


export type MutationUpdateHlfBankIntegrationSettingArgs = {
  bankId: Scalars['ObjectID']['input'];
  settings: HlfBankIntegrationSettings;
};


export type MutationUpdateHlfBankV2IntegrationSettingArgs = {
  bankId: Scalars['ObjectID']['input'];
  settings: HlfBankV2IntegrationSettings;
};


export type MutationUpdateInsuranceModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: InsuranceModuleSettings;
};


export type MutationUpdateInsuranceProductArgs = {
  id: Scalars['ObjectID']['input'];
  settings: InsuranceProductSettings;
};


export type MutationUpdateInsurerArgs = {
  insurerId: Scalars['ObjectID']['input'];
  settings: InsurerSettings;
};


export type MutationUpdateInventoryArgs = {
  id: Scalars['ObjectID']['input'];
  settings: InventoryUpdationSettings;
};


export type MutationUpdateKycPresetArgs = {
  conditionSettings?: InputMaybe<Array<ConditionSettings>>;
  fields: Array<KycFieldSettings>;
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
  settings: KycPresetSettings;
};


export type MutationUpdateLabelsArgs = {
  id: Scalars['ObjectID']['input'];
  settings: LabelsInput;
};


export type MutationUpdateLabelsModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: LabelsModuleSettings;
};


export type MutationUpdateLanguagePackArgs = {
  id: Scalars['ObjectID']['input'];
  settings: LanguagePackSettings;
};


export type MutationUpdateLocalCustomerManagementArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: LocalCustomerManagementSettings;
};


export type MutationUpdateLocalCustomerManagementKycFieldsArgs = {
  kycFields: Array<LocalCustomerManagementModuleKycFieldSettings>;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationUpdateMaintenanceModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: MaintenanceModuleSettings;
};


export type MutationUpdateMaintenanceModuleDetailsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: MaintenanceDetailsSettings;
};


export type MutationUpdateMakeArgs = {
  id: Scalars['ObjectID']['input'];
  settings: LocalMakeSettings;
};


export type MutationUpdateMarketingConsentsAndDeclarationsArgs = {
  conditionSettings?: InputMaybe<Array<ConditionSettings>>;
  eventId?: InputMaybe<Scalars['ObjectID']['input']>;
  id: Scalars['ObjectID']['input'];
  settings: MarketingConsentsAndDeclarationsSettings;
};


export type MutationUpdateMaybankIntegrationSettingArgs = {
  bankId: Scalars['ObjectID']['input'];
  settings: MaybankIntegrationUpdateSettings;
};


export type MutationUpdateMobilityAdditionalInfoArgs = {
  id: Scalars['ObjectID']['input'];
  setting: MobilityAdditionalInfoSetting;
};


export type MutationUpdateMobilityAddonArgs = {
  id: Scalars['ObjectID']['input'];
  setting: MobilityAddonSetting;
};


export type MutationUpdateMobilityApplicationArgs = {
  applicationId: Scalars['ObjectID']['input'];
  stage: ApplicationStage;
  updates?: InputMaybe<Array<ApplicationUpdate>>;
};


export type MutationUpdateMobilityApplicationDraftArgs = {
  mobilityBookingDetails: MobilityBookingDetailsPayload;
  mobilityDetails: Array<MobilityDetailsPayload>;
  token: Scalars['String']['input'];
};


export type MutationUpdateMobilityApplicationEntrypointArgs = {
  endpointId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: MobilityApplicationEntrypointSettings;
};


export type MutationUpdateMobilityDepositAmountArgs = {
  giftVoucherId?: InputMaybe<Scalars['ObjectID']['input']>;
  promoCodeId?: InputMaybe<Scalars['ObjectID']['input']>;
  token: Scalars['String']['input'];
};


export type MutationUpdateMobilityEmailContentArgs = {
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentUpdateType: EmailContentUpdateType;
  emailContents: Array<MobilityEmailScenarioContentInput>;
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type MutationUpdateMobilityModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: MobilityModuleUpdateSettings;
};


export type MutationUpdateModelArgs = {
  id: Scalars['ObjectID']['input'];
  settings: LocalModelSettings;
};


export type MutationUpdateModelConfiguratorArgs = {
  id: Scalars['ObjectID']['input'];
  settings: ModelConfiguratorSettings;
};


export type MutationUpdateMyInfoModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: MyInfoModuleSettings;
};


export type MutationUpdateMyInfoSettingArgs = {
  id: Scalars['ObjectID']['input'];
  myInfoModuleId: Scalars['ObjectID']['input'];
  secrets: MyInfoSettingInput;
};


export type MutationUpdateNamirialSettingsArgs = {
  namirialModuleId: Scalars['ObjectID']['input'];
  settings: NamirialSettingsInput;
};


export type MutationUpdateNamirialSigningModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: NamirialSigningModuleSettings;
};


export type MutationUpdateNamirialSigningSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: NamirialSettingsInput;
};


export type MutationUpdateOptionsBlockArgs = {
  blockId: Scalars['ObjectID']['input'];
  settings: BlockInput;
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationUpdatePackageBlockArgs = {
  blockId: Scalars['ObjectID']['input'];
  settings: BlockInput;
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationUpdatePackageSettingArgs = {
  blockId: Scalars['ObjectID']['input'];
  packageSettingsId: Scalars['ObjectID']['input'];
  settings: PackageSettingsInput;
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationUpdatePayGatePaymentModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: PayGatePaymentModuleSettings;
};


export type MutationUpdatePayGatePaymentSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
  settings: PayGatePaymentUpdateSettingsInput;
};


export type MutationUpdatePorscheMasterDataModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: PorscheMasterDataModuleSettings;
};


export type MutationUpdatePorschePaymentModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: PorschePaymentModuleSettings;
};


export type MutationUpdatePorschePaymentSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
  settings: PorschePaymentUpdateSettingsInput;
};


export type MutationUpdatePromoCodeArgs = {
  id: Scalars['ObjectID']['input'];
  settings: PromoCodeSettings;
};


export type MutationUpdatePromoCodeModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: PromoCodeModuleSettings;
};


export type MutationUpdateRoleArgs = {
  roleId: Scalars['ObjectID']['input'];
  settings: RoleSettings;
};


export type MutationUpdateRouterArgs = {
  routerId: Scalars['ObjectID']['input'];
  settings: RouterSettings;
};


export type MutationUpdateRouterMenuArgs = {
  menuItems: Array<MenuItemSettings>;
  routerId: Scalars['ObjectID']['input'];
};


export type MutationUpdateSalesForceSettingArgs = {
  financingModuleId: Scalars['ObjectID']['input'];
  settings: SalesForceSettingInput;
};


export type MutationUpdateSdmModuleSalesPersonCodeMappingsArgs = {
  mappings: Array<SdmModuleSalesPersonCodeMapping>;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationUpdateSimpleVehicleManagementModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: SimpleVehicleManagementUpdateSettings;
};


export type MutationUpdateStandardApplicationConfigurationArgs = {
  configuration: StandardApplicationConfiguration;
  token: Scalars['String']['input'];
};


export type MutationUpdateStandardApplicationDealershipArgs = {
  applicationFinanceProducts: Array<StandardApplicationFinanceProductPayload>;
  applicationVehicles: Array<StandardApplicationVehiclePayload>;
  dealerId: Scalars['ObjectID']['input'];
};


export type MutationUpdateStandardApplicationDraftArgs = {
  configuration: StandardApplicationConfiguration;
  customer: ApplicationCustomerDraft;
  financing: ApplicationFinanceSettings;
  insurancing?: InputMaybe<ApplicationInsuranceSettings>;
  languageId?: InputMaybe<Scalars['ObjectID']['input']>;
  promoCodeId?: InputMaybe<Scalars['ObjectID']['input']>;
  token: Scalars['String']['input'];
  tradeInVehicle: Array<TradeInVehiclePayload>;
};


export type MutationUpdateStandardApplicationEntrypointArgs = {
  endpointId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: StandardApplicationEntrypointSettings;
};


export type MutationUpdateStandardApplicationFinanceProductAssignmentsArgs = {
  dealerFinanceProducts: Array<DealerFinanceProductsPayload>;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationUpdateStandardApplicationJourneyArgs = {
  configuration: StandardApplicationConfiguration;
  customerKind: CustomerKind;
  financing?: InputMaybe<UpdateApplicationJourneyFinancingSettings>;
  saveDraft?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
  tradeInVehicle: Array<TradeInVehiclePayload>;
};


export type MutationUpdateStandardApplicationModuleMainDetailsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: StandardApplicationModuleUpdateSettings;
};


export type MutationUpdateStandardApplicationPublicAccessEntrypointArgs = {
  endpointId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: StandardApplicationPublicAccessEntrypointSettings;
};


export type MutationUpdateStandardApplicationVehicleAssignmentsArgs = {
  dealerVehicles: Array<DealerVehiclesPayload>;
  moduleId: Scalars['ObjectID']['input'];
};


export type MutationUpdateStockInventoryArgs = {
  id: Scalars['ObjectID']['input'];
  inventoryId: Scalars['ObjectID']['input'];
  settings: StockInventoryUpdationSettings;
};


export type MutationUpdateTestDriveDataArgs = {
  applicationId: Scalars['ObjectID']['input'];
  testDriveData: ApplicationUpdateTestDriveDetails;
};


export type MutationUpdateTextConsentsAndDeclarationsArgs = {
  conditionSettings?: InputMaybe<Array<ConditionSettings>>;
  eventId?: InputMaybe<Scalars['ObjectID']['input']>;
  id: Scalars['ObjectID']['input'];
  settings: TextConsentsAndDeclarationsSettings;
};


export type MutationUpdateTradeInModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: TradeInModuleSettings;
};


export type MutationUpdateTradeInSettingArgs = {
  settings: TradeInSettingInput;
  tradeInModuleId: Scalars['ObjectID']['input'];
};


export type MutationUpdateTrimBlockArgs = {
  blockId: Scalars['ObjectID']['input'];
  settings: BlockInput;
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type MutationUpdateTtbPaymentModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: TtbPaymentModuleSettings;
};


export type MutationUpdateTtbPaymentSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
  settings: TtbPaymentUpdateSettingsInput;
};


export type MutationUpdateUobBankIntegrationSettingArgs = {
  bankId: Scalars['ObjectID']['input'];
  settings: UobBankIntegrationSettings;
};


export type MutationUpdateUserArgs = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  id: Scalars['ObjectID']['input'];
  settings: UserSettings;
};


export type MutationUpdateUserGroupArgs = {
  settings: UserGroupSettings;
  userGroupId: Scalars['ObjectID']['input'];
};


export type MutationUpdateUserlikeChatbotModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: UserlikeChatbotModuleInput;
};


export type MutationUpdateUserlikeChatbotSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
  settings: UserlikeChatbotSettingsInput;
};


export type MutationUpdateVariantArgs = {
  id: Scalars['ObjectID']['input'];
  settings: LocalVariantSettings;
};


export type MutationUpdateVariantConfiguratorArgs = {
  variantConfiguratorId: Scalars['ObjectID']['input'];
  vehiclePrice: Scalars['Float']['input'];
};


export type MutationUpdateVariantImageOrderingArgs = {
  orderedImageIds: Array<InputMaybe<Scalars['ObjectID']['input']>>;
  variantId: Scalars['ObjectID']['input'];
};


export type MutationUpdateVariantLabelsArgs = {
  addedVariants: Array<Scalars['ObjectID']['input']>;
  id: Scalars['ObjectID']['input'];
};


export type MutationUpdateWebCalcSettingArgs = {
  moduleId: Scalars['ObjectID']['input'];
  setting: WebCalcSettingPayload;
};


export type MutationUpdateWebPageArgs = {
  webPageBlockInput: Array<WebPageBlockInput>;
  webPageId: Scalars['ObjectID']['input'];
  webPageInput: WebPageInput;
};


export type MutationUpdateWebPageEndpointArgs = {
  endpointId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  settings: WebPageEndpointSettings;
};


export type MutationUpdateWebsiteModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: UpdateWebsiteModulePayload;
};


export type MutationUpdateWebsiteSocialMediaArgs = {
  socialMediaId: Scalars['ObjectID']['input'];
  socialMediaInput: EdmEmailSocialMediaPayload;
};


export type MutationUpdateWhatsappLiveChatModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
  settings: WhatsappLiveChatModuleInput;
};


export type MutationUpdateWhatsappLiveChatSettingsArgs = {
  id: Scalars['ObjectID']['input'];
  moduleId: Scalars['ObjectID']['input'];
  settings: WhatsappLiveChatSettingsInput;
};


export type MutationUploadApplicationDocumentArgs = {
  applicationId?: InputMaybe<Scalars['ObjectID']['input']>;
  isTemporary?: InputMaybe<Scalars['Boolean']['input']>;
  kind: ApplicationDocumentKind;
  token?: InputMaybe<Scalars['String']['input']>;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadApplicationDocumentsArgs = {
  payload: Array<ApplicationDocumentPayload>;
  token: Scalars['String']['input'];
};


export type MutationUploadAppointmentModuleAssetArgs = {
  moduleId: Scalars['ObjectID']['input'];
  type: AppointmentModuleAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadBankAssetArgs = {
  bankId: Scalars['ObjectID']['input'];
  type: BankAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadBannerImageArgs = {
  bannerAsset: BannerAsset;
  id: Scalars['ObjectID']['input'];
  uploads: Array<InputMaybe<Scalars['Upload']['input']>>;
};


export type MutationUploadCompanyAssetArgs = {
  companyId: Scalars['ObjectID']['input'];
  type: CompanyAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadConfiguratorDescriptionImageArgs = {
  modelConfiguratorId: Scalars['ObjectID']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationUploadConfiguratorModuleAssetArgs = {
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentUpdateType: EmailContentUpdateType;
  moduleId: Scalars['ObjectID']['input'];
  type: ConfiguratorModuleAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadDealerSocialMediaAssetArgs = {
  dealerSocialMediaId: Scalars['ObjectID']['input'];
  type: DealerAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadEdmSocialMediaAssetArgs = {
  socialMediaId: Scalars['ObjectID']['input'];
  type: CompanyAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadEventApplicationModuleAssetArgs = {
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentUpdateType: EmailContentUpdateType;
  id: Scalars['ObjectID']['input'];
  type: EventModuleAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadEventLevelAssetArgs = {
  id: Scalars['ObjectID']['input'];
  type: EventModuleAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadFinderApplicationModuleAssetArgs = {
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentUpdateType: EmailContentUpdateType;
  moduleId: Scalars['ObjectID']['input'];
  type: FinderApplicationModuleAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadGiftVoucherDocumentArgs = {
  giftVoucherId?: InputMaybe<Scalars['ObjectID']['input']>;
  isTemporary?: InputMaybe<Scalars['Boolean']['input']>;
  kind: ApplicationDocumentKind;
  token?: InputMaybe<Scalars['String']['input']>;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadGiftVoucherModuleAssetArgs = {
  moduleId: Scalars['ObjectID']['input'];
  type: GiftVoucherModuleAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadMaintenanceModuleAssetArgs = {
  moduleId: Scalars['ObjectID']['input'];
  type: ModuleAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadMobilityModuleEmailAssetArgs = {
  assetType: MobilityEmailAssetType;
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  emailContentId: Scalars['ObjectID']['input'];
  emailContentUpdateType: EmailContentUpdateType;
  mobilityAsset: MobilityAsset;
  mobilityRecipient: MobilityRecipient;
  moduleId: Scalars['ObjectID']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationUploadModelConfiguratorAssetArgs = {
  id: Scalars['ObjectID']['input'];
  type: ModelConfiguratorAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadStockAssetArgs = {
  stockId: Scalars['ObjectID']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationUploadUserAssetArgs = {
  type: UserAsset;
  upload: Scalars['Upload']['input'];
  userId: Scalars['ObjectID']['input'];
};


export type MutationUploadVariantAssetArgs = {
  type: VariantAsset;
  upload: Scalars['Upload']['input'];
  variantId: Scalars['ObjectID']['input'];
};


export type MutationUploadVariantConfiguratorColorSettingAssetArgs = {
  blockId: Scalars['ObjectID']['input'];
  colorSettingId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  type: VariantConfiguratorAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadVariantConfiguratorMatrixAssetArgs = {
  colorId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  trimId: Scalars['ObjectID']['input'];
  type: MatrixAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadVariantConfiguratorOptionAssetArgs = {
  blockId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  type: VariantConfiguratorAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadVariantConfiguratorOptionSettingAssetArgs = {
  blockId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  optionSettingId: Scalars['ObjectID']['input'];
  type: VariantConfiguratorAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadVariantConfiguratorPackageAdditionalDetailsAssetArgs = {
  additionalDetailsId: Scalars['ObjectID']['input'];
  blockId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  packageSettingId: Scalars['ObjectID']['input'];
  type: VariantConfiguratorAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadVariantConfiguratorPackageSectionImageAssetArgs = {
  blockId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  packageSettingId: Scalars['ObjectID']['input'];
  type: VariantConfiguratorAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadVariantConfiguratorTrimSettingAssetArgs = {
  blockId: Scalars['ObjectID']['input'];
  id: Scalars['ObjectID']['input'];
  trimSettingId: Scalars['ObjectID']['input'];
  type: VariantConfiguratorAsset;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadWebPageImageArgs = {
  upload: Scalars['Upload']['input'];
  webPageAsset: WebPageAsset;
  webPageBlockId?: InputMaybe<Scalars['ObjectID']['input']>;
  webPageBlockListId?: InputMaybe<Scalars['ObjectID']['input']>;
  webPageId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type MutationUploadWebsiteSocialMediaAssetArgs = {
  socialMediaId: Scalars['ObjectID']['input'];
  upload: Scalars['Upload']['input'];
};


export type MutationUpsertKycPresetInEventArgs = {
  eventId: Scalars['ObjectID']['input'];
  kycPreset: EventKycPresetInput;
};


export type MutationValidateRemoteJourneyPasscodeArgs = {
  code: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


export type MutationValidateSmsOtpForResetPasswordArgs = {
  code: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationValidateSmsOtpForUpdateEmailArgs = {
  code: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type MyInfoCallbackLink = {
  __typename: 'MyInfoCallbackLink';
  applicationJourney: ApplicationJourney;
  endpoint: Endpoint;
  linkId: Scalars['ObjectID']['output'];
  router: Router;
};

export type MyInfoData = {
  __typename: 'MyInfoData';
  customerFields: Array<LocalCustomerField>;
  tradeInVehicle?: Maybe<Array<TradeInVehicle>>;
};

export type MyInfoModule = Module & {
  __typename: 'MyInfoModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** MyInfo Setting */
  myInfoSettings: Array<MyInfoSetting>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type MyInfoModuleSettings = {
  /** Display Name */
  displayName: Scalars['String']['input'];
};

export type MyInfoSetting = {
  __typename: 'MyInfoSetting';
  /** Base URL */
  baseUrl: Scalars['String']['output'];
  /** Client ID */
  clientId: Scalars['String']['output'];
  /** Client Secret */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** ID */
  id: Scalars['ObjectID']['output'];
  isTestEnvironment: Scalars['Boolean']['output'];
  /** Module ID */
  moduleId: Scalars['ObjectID']['output'];
  /** PKI Signature */
  pkiSignature?: Maybe<Scalars['Boolean']['output']>;
  /** Private Key */
  privateKey?: Maybe<Scalars['String']['output']>;
  /** Public Certificate */
  publicCertificate?: Maybe<Scalars['String']['output']>;
  /** Request Purpose */
  requestPurpose?: Maybe<Scalars['String']['output']>;
  version: MyInfoSettingVersion;
};

export type MyInfoSettingInput = {
  /** Base URL */
  baseUrl: Scalars['String']['input'];
  /** Client ID */
  clientId: Scalars['String']['input'];
  /** Client Secret */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Display Name */
  displayName: Scalars['String']['input'];
  isTestEnvironment: Scalars['Boolean']['input'];
  /** PKI Signature */
  pkiSignature?: InputMaybe<Scalars['Boolean']['input']>;
  /** Private Key */
  privateKey?: InputMaybe<Scalars['String']['input']>;
  /** Public Certificate */
  publicCertificate?: InputMaybe<Scalars['String']['input']>;
  /** Request Purpose */
  requestPurpose?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<MyInfoSettingVersion>;
};

export enum MyInfoSettingVersion {
  MyInfoV3 = 'MyInfoV3',
  MyInfoV5 = 'MyInfoV5'
}

export type NamirialSetting = {
  __typename: 'NamirialSetting';
  /** API Token */
  apiToken: Scalars['String']['output'];
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** End point */
  endpoint: Scalars['String']['output'];
  /** ID */
  id: Scalars['ObjectID']['output'];
  /** Module ID */
  namirialModuleId: Scalars['ObjectID']['output'];
};

export type NamirialSettingsInput = {
  /** API Token */
  apiToken: Scalars['String']['input'];
  /** Endpoint */
  endpoint: Scalars['String']['input'];
};

export type NamirialSigningLink = {
  __typename: 'NamirialSigningLink';
  path: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type NamirialSigningModule = Module & {
  __typename: 'NamirialSigningModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Namirial Setting */
  namirialSetting: NamirialSetting;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type NamirialSigningModuleSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
};

/** Finance settings for New Zealand applications */
export type NewZealandApplicationFinanceSettings = {
  /** Assured Resale Value */
  assuredResaleValue?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Balloon Payment (HP with Balloon) */
  balloonPayment?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Bank EST Fee */
  bankEstFee: Scalars['Float']['input'];
  /** Starting price */
  carPrice: Scalars['Float']['input'];
  /** Remaining Cash After Trade In */
  cashAfterTradeIn?: InputMaybe<Scalars['Float']['input']>;
  /** Commission */
  commission?: InputMaybe<Scalars['Float']['input']>;
  /** Dealer Options */
  dealerOptions?: InputMaybe<Array<DealerOptionPayload>>;
  /** Deposit Payment */
  deposit?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Discount */
  discount?: InputMaybe<DiscountInput>;
  /** Displacement */
  displacement?: InputMaybe<Scalars['Int']['input']>;
  /** Down Payment */
  downPayment?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Down payment with additional */
  downPaymentWithAdditional?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Dealer EST Fee */
  estFee: Scalars['Float']['input'];
  /** Estimated Surplus After Assured Resale Value */
  estimatedSurplusBalloon?: InputMaybe<Scalars['Float']['input']>;
  /** Extra Amount */
  extraAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Extra Financed Amount */
  extraFinancedAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Finance product ID */
  financeProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Total Financing Price Application */
  financedAmount: Scalars['Float']['input'];
  /** Insurance Fee */
  insuranceFee?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Interest Rate */
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  /** License and Fuel Tax */
  licenseAndFuelTax?: InputMaybe<Scalars['Float']['input']>;
  /** License plate fee */
  licensePlateFee?: InputMaybe<Scalars['Float']['input']>;
  /** Loan */
  loan?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Mileage Value */
  mileage?: InputMaybe<Scalars['Float']['input']>;
  /** Monthly instalment */
  monthlyInstalment?: InputMaybe<Array<ApplicationMonthlyInstalmentPayload>>;
  /** Monthly payment fixed interest rate */
  monthlyPaymentFixedInterestRate?: InputMaybe<Scalars['Float']['input']>;
  /** Payment Mode */
  paymentMode?: InputMaybe<PaymentMode>;
  /** PPSR Fee */
  ppsr: Scalars['Float']['input'];
  /** Promo Code Value */
  promoCodeValue?: InputMaybe<Scalars['Float']['input']>;
  /** Residual Value */
  residualValue?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Tax Loss */
  taxLoss?: InputMaybe<Scalars['Float']['input']>;
  /** Number of Terms */
  term?: InputMaybe<Scalars['Int']['input']>;
  /** Total Amount Payable (HP with Balloon) */
  totalAmountPayable?: InputMaybe<Scalars['Float']['input']>;
  /** Total Price */
  totalPrice: Scalars['Float']['input'];
  /** Trade In Amount */
  tradeInAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type NewZealandApplicationFinancing = ApplicationFinancing & {
  __typename: 'NewZealandApplicationFinancing';
  /** Affin Auto Finance Centre */
  affinAutoFinanceCentre?: Maybe<AffinAutoFinanceCentre>;
  /** Balloon Payment (HP with Balloon) */
  balloonPayment?: Maybe<ApplicationValueSetting>;
  /** Bank EST Fee */
  bankEstFee: Scalars['Float']['output'];
  /** Car price */
  carPrice: Scalars['Float']['output'];
  /** Dealer Options */
  dealerOptions?: Maybe<Array<DealerOption>>;
  /** Deposit */
  deposit?: Maybe<ApplicationValueSetting>;
  /** Discount */
  discount?: Maybe<Discount>;
  /** Down Payment */
  downPayment?: Maybe<ApplicationValueSetting>;
  /** Down payment with additional */
  downPaymentWithAdditional?: Maybe<ApplicationValueSetting>;
  /** Dealer EST Fee */
  estFee: Scalars['Float']['output'];
  /** Extra Amount */
  extraAmount?: Maybe<Scalars['Float']['output']>;
  /** Extra Financed Amount */
  extraFinancedAmount?: Maybe<Scalars['Float']['output']>;
  /** Finance Product ID */
  financeProductId?: Maybe<Scalars['ObjectID']['output']>;
  /** Total Financing Price Application */
  financedAmount: Scalars['Float']['output'];
  /** Interest Rate */
  interestRate?: Maybe<Scalars['Float']['output']>;
  /** Loan */
  loan?: Maybe<ApplicationValueSetting>;
  /** Market */
  market: ApplicationMarket;
  /** Mileage Value */
  mileage?: Maybe<Scalars['Float']['output']>;
  /** Monthly Installment */
  monthlyInstalment?: Maybe<Array<ApplicationMonthlyInstalment>>;
  /** Payment Mode */
  paymentMode?: Maybe<PaymentMode>;
  /** PPSR Fee */
  ppsr: Scalars['Float']['output'];
  /** Promo Code Value */
  promoCodeValue?: Maybe<Scalars['Float']['output']>;
  /** Residual Value */
  residualValue?: Maybe<ApplicationValueSetting>;
  /** Term */
  term?: Maybe<Scalars['Int']['output']>;
  /** Total Amount Payable (HP with Balloon) */
  totalAmountPayable?: Maybe<Scalars['Float']['output']>;
  /** Total Price Application */
  totalPrice: Scalars['Float']['output'];
  /** Trade in amount */
  tradeInAmount?: Maybe<Scalars['Float']['output']>;
};

/**
 * New zealand insurance settings for applications
 *
 * Additional fees:
 * - PPSR
 * - Dealer Establishment Fee
 * - Bank Establishment Fee
 */
export type NewZealandApplicationInsuranceSettings = {
  /** Bank EST Fee */
  bankEstFee: Scalars['Float']['input'];
  /** Car Price */
  carPrice: Scalars['Float']['input'];
  /** Customer date of birth */
  dateOfBirth: Scalars['DateTime']['input'];
  /** Vehicle date of registration */
  dateOfRegistration: Scalars['DateTime']['input'];
  /** Dealer EST Fee */
  estFee: Scalars['Float']['input'];
  /** Insurance premium amount */
  insurancePremium?: InputMaybe<Scalars['Float']['input']>;
  /** Insurance Product ID */
  insuranceProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Insurer ID */
  insurerId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** No claim discount */
  ncd: Scalars['Float']['input'];
  /** PPSR Fee */
  ppsr: Scalars['Float']['input'];
  /** Total Price */
  totalPrice: Scalars['Float']['input'];
  /** Customer years of driving */
  yearsOfDriving: Scalars['Int']['input'];
};

export type NewZealandApplicationInsurancing = ApplicationInsurancing & {
  __typename: 'NewZealandApplicationInsurancing';
  /** Bank EST Fee */
  bankEstFee: Scalars['Float']['output'];
  /** Car Price */
  carPrice: Scalars['Float']['output'];
  /** Customer date of birth */
  dateOfBirth: Scalars['DateTime']['output'];
  /** Vehicle date of registration */
  dateOfRegistration: Scalars['DateTime']['output'];
  /** Dealer EST Fee */
  estFee: Scalars['Float']['output'];
  /** Insurance premium amount */
  insurancePremium?: Maybe<Scalars['Float']['output']>;
  /** Insurance Product ID */
  insuranceProductId: Scalars['ObjectID']['output'];
  /** Insurer ID */
  insurerId: Scalars['ObjectID']['output'];
  /** Market */
  market: ApplicationMarket;
  /** No claim discount */
  ncd: Scalars['Float']['output'];
  /** PPSR Fee */
  ppsr: Scalars['Float']['output'];
  /** Total Price */
  totalPrice: Scalars['Float']['output'];
  /** Customer years of driving */
  yearsOfDriving: Scalars['Int']['output'];
};

export type NewZealandApplicationMarket = ApplicationMarketType & {
  __typename: 'NewZealandApplicationMarket';
  bankEstFee: BankDealershipMarket;
  estFee: DealershipMarket;
  estFeeEditable: Scalars['Boolean']['output'];
  nzFees: NzFeesDealershipMarket;
  ppsr: DealershipMarket;
  ppsrEditable: Scalars['Boolean']['output'];
  type: ApplicationMarket;
};

export type NewZealandApplicationMarketTypeInput = {
  estFee: Scalars['Float']['input'];
  ppsr: Scalars['Float']['input'];
};

export type NewZealandApplicationModuleMarketTypeInput = {
  bankEstFee: BankDealershipMarketInput;
  estFee: DealershipMarketInput;
  nzFees: NzFeesDealershipMarketInput;
  ppsr: DealershipMarketInput;
};

export type NumberUnit = {
  __typename: 'NumberUnit';
  localize: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};


export type NumberUnitLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type NzFeesDealershipMarket = {
  __typename: 'NzFeesDealershipMarket';
  overrides: Array<NzFeesDealershipMarketOverrides>;
  viewable: Scalars['Boolean']['output'];
};

export type NzFeesDealershipMarketInput = {
  /** Overrides */
  overrides: Array<NzFeesDealershipMarketOverridesInput>;
  /** Viewable */
  viewable: Scalars['Boolean']['input'];
};

export type NzFeesDealershipMarketOverrides = {
  __typename: 'NzFeesDealershipMarketOverrides';
  dealer: Dealer;
  dealerId: Scalars['ObjectID']['output'];
  viewable: Scalars['Boolean']['output'];
};

export type NzFeesDealershipMarketOverridesInput = {
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['input'];
  /** Viewable */
  viewable: Scalars['Boolean']['input'];
};

export type OcrImage = {
  file: Scalars['Upload']['input'];
  kind: Scalars['String']['input'];
};

export enum OnlineOrderableState {
  Available = 'available',
  Reserved = 'reserved',
  Unavailable = 'unavailable'
}

export type Option = {
  __typename: 'Option';
  id: Scalars['ObjectID']['output'];
  /** Label */
  label: TranslatedString;
  /** Type */
  type: OptionType;
  /** Value price */
  valuePrice?: Maybe<Scalars['Float']['output']>;
  /** Value Text / description */
  valueText?: Maybe<TranslatedString>;
};

export type OptionInput = {
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  label: TranslatedStringInput;
  type: OptionType;
  valuePrice?: InputMaybe<Scalars['Float']['input']>;
  valueText?: InputMaybe<TranslatedStringInput>;
};

export enum OptionKind {
  Combo = 'Combo',
  Dropdown = 'Dropdown',
  MultiSelect = 'MultiSelect',
  SingleSelect = 'SingleSelect'
}

export type OptionSettings = ComboOptionSettings | DropdownOptionSettings | MultiSelectOptionSettings | SingleSelectOptionSettings;

export type OptionSettingsInput = {
  comboOptionSettingsInput?: InputMaybe<ComboOptionSettingsInput>;
  dropdownOptionSettingsInput?: InputMaybe<DropdownOptionSettingsInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  multiSelectOptionSettingsInput?: InputMaybe<MultiSelectOptionSettingsInput>;
  singleSelectOptionSettingsInput?: InputMaybe<SingleSelectOptionSettingsInput>;
  type: OptionKind;
};

export enum OptionType {
  Description = 'Description',
  Price = 'Price'
}

export type OptionalPhone = {
  __typename: 'OptionalPhone';
  prefix?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OptionalPhonePayload = {
  prefix?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OptionalRangeValue = {
  __typename: 'OptionalRangeValue';
  from?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['Int']['output']>;
};

export type OptionalRangeValuePayload = {
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type OptionsBlock = Block & {
  __typename: 'OptionsBlock';
  /** Financing option */
  financing: Scalars['Boolean']['output'];
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Option settings */
  optionSettings: OptionSettings;
  order?: Maybe<Scalars['Int']['output']>;
  /** Section description */
  sectionDescription: TranslatedString;
  /** Section images */
  sectionImages: Array<UploadedFileWithPreview>;
  /** Section title */
  sectionTitle: TranslatedString;
  type: BlockType;
};

export type OptionsBlockInput = {
  financing: Scalars['Boolean']['input'];
  isActive: Scalars['Boolean']['input'];
  optionSettings: OptionSettingsInput;
  order?: InputMaybe<Scalars['Int']['input']>;
  sectionDescription: TranslatedStringInput;
  sectionTitle: TranslatedStringInput;
};

export type OtherVehicleInformation = {
  __typename: 'OtherVehicleInformation';
  chassisNo?: Maybe<Scalars['String']['output']>;
  engineNo?: Maybe<Scalars['String']['output']>;
};

export type OtherVehicleInformationSettings = {
  chassisNo?: InputMaybe<Scalars['String']['input']>;
  engineNo?: InputMaybe<Scalars['String']['input']>;
};

export type PackageBlock = Block & {
  __typename: 'PackageBlock';
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Package Settings */
  packageSettings: Array<PackageSettings>;
  type: BlockType;
};

export type PackageBlockInput = {
  isActive: Scalars['Boolean']['input'];
};

export type PackageInformation = {
  __typename: 'PackageInformation';
  basicContent: Array<PackageInformationContent>;
  upgradedContent: Array<PackageInformationContent>;
};

export type PackageInformationContent = {
  __typename: 'PackageInformationContent';
  name: LocalizedString;
};

export enum PackageKind {
  Description = 'Description',
  Price = 'Price'
}

export type PackageSettings = {
  __typename: 'PackageSettings';
  /** Additional details */
  additionalDetails?: Maybe<Array<Maybe<AdditionalDetails>>>;
  /** Features */
  features: Array<TranslatedString>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Package name */
  packageName: TranslatedString;
  /** Package type */
  packageType: PackageType;
  /** Section image */
  sectionImage?: Maybe<UploadedFileWithPreview>;
};

export type PackageSettingsInput = {
  features: Array<TranslatedStringInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  packageName: TranslatedStringInput;
  packageType: PackageTypeInput;
};

export type PackageType = PackageTypeWithDescription | PackageTypeWithPrice;

export type PackageTypeInput = {
  packageTypeWithDescriptionInput?: InputMaybe<PackageTypeWithDescriptionInput>;
  packageTypeWithPriceInput?: InputMaybe<PackageTypeWithPriceInput>;
  type: PackageKind;
};

export type PackageTypeWithDescription = {
  __typename: 'PackageTypeWithDescription';
  description: Scalars['String']['output'];
};

export type PackageTypeWithDescriptionInput = {
  description: Scalars['String']['input'];
};

export type PackageTypeWithPrice = {
  __typename: 'PackageTypeWithPrice';
  financing: Scalars['Boolean']['output'];
  price: Scalars['Float']['output'];
};

export type PackageTypeWithPriceInput = {
  financing: Scalars['Boolean']['input'];
  price: Scalars['Float']['input'];
};

export type PaginatedAdyenPaymentSettings = {
  __typename: 'PaginatedAdyenPaymentSettings';
  count: Scalars['Int']['output'];
  items: Array<AdyenPaymentSetting>;
};

export type PaginatedApplications = {
  __typename: 'PaginatedApplications';
  /** Number of applications matching the original query */
  count: Scalars['Int']['output'];
  /** Applications on the request page */
  items: Array<Application>;
};

export type PaginatedAuditTrails = {
  __typename: 'PaginatedAuditTrails';
  count: Scalars['Int']['output'];
  items: Array<AuditTrail>;
};

export type PaginatedBanner = {
  __typename: 'PaginatedBanner';
  count: Scalars['Int']['output'];
  items: Array<Banner>;
};

export type PaginatedCompanies = {
  __typename: 'PaginatedCompanies';
  /** Number of company matching the original query */
  count: Scalars['Int']['output'];
  /** Companies on the request page */
  items: Array<Company>;
};

export type PaginatedCompanyOptions = {
  __typename: 'PaginatedCompanyOptions';
  /** Number of company matching the original query */
  count: Scalars['Int']['output'];
  /** Companies on the request page */
  items: Array<CompanyOptions>;
};

export type PaginatedConsentsAndDeclarations = {
  __typename: 'PaginatedConsentsAndDeclarations';
  /** Number of consents and declarations matching original query */
  count: Scalars['Int']['output'];
  /** Consents and Declarations on the request page */
  items: Array<ConsentsAndDeclarations>;
};

export type PaginatedCustomers = {
  __typename: 'PaginatedCustomers';
  /** Number of variants matching original query */
  count: Scalars['Int']['output'];
  /** Local variants on the request page */
  items: Array<Customer>;
};

export type PaginatedDealers = {
  __typename: 'PaginatedDealers';
  /** Number of dealers matching the original query */
  count: Scalars['Int']['output'];
  /** Dealers on the request page */
  items: Array<Dealer>;
};

export type PaginatedEvent = {
  __typename: 'PaginatedEvent';
  /** Number of event matching the original query */
  count: Scalars['Int']['output'];
  /** Events on the request page */
  items: Array<Event>;
};

export type PaginatedFinanceProducts = {
  __typename: 'PaginatedFinanceProducts';
  count: Scalars['Int']['output'];
  defaultFinanceProduct?: Maybe<FinanceProduct>;
  items: Array<FinanceProduct>;
};

export type PaginatedFiservPaymentSettings = {
  __typename: 'PaginatedFiservPaymentSettings';
  count: Scalars['Int']['output'];
  items: Array<FiservPaymentSetting>;
};

export type PaginatedGiftVoucher = {
  __typename: 'PaginatedGiftVoucher';
  count: Scalars['Int']['output'];
  items: Array<GiftVoucher>;
};

export type PaginatedInsuranceProducts = {
  __typename: 'PaginatedInsuranceProducts';
  count: Scalars['Int']['output'];
  defaultInsuranceProduct?: Maybe<InsuranceProduct>;
  items: Array<InsuranceProduct>;
};

export type PaginatedInsurers = {
  __typename: 'PaginatedInsurers';
  /** Number of insurers matching the original query */
  count: Scalars['Int']['output'];
  /** Insurers on the request page */
  items: Array<Insurer>;
};

export type PaginatedInventory = {
  __typename: 'PaginatedInventory';
  /** Number of inventory matching the original query */
  count: Scalars['Int']['output'];
  /** Inventories on the request page */
  items: Array<Inventory>;
};

export type PaginatedLabels = {
  __typename: 'PaginatedLabels';
  count: Scalars['Int']['output'];
  items: Array<Labels>;
};

export type PaginatedLanguagePacks = {
  __typename: 'PaginatedLanguagePacks';
  /** Number of language pack matching the original query */
  count: Scalars['Int']['output'];
  /** Language packs on the request page */
  items: Array<LanguagePack>;
};

export type PaginatedLocalMakes = {
  __typename: 'PaginatedLocalMakes';
  /** Number of makes matching original query */
  count: Scalars['Int']['output'];
  /** Local makes on the request page */
  items: Array<LocalMake>;
};

export type PaginatedLocalModels = {
  __typename: 'PaginatedLocalModels';
  /** Number of models matching original query */
  count: Scalars['Int']['output'];
  /** Local models on the request page */
  items: Array<LocalModel>;
};

export type PaginatedLocalVariants = {
  __typename: 'PaginatedLocalVariants';
  /** Number of variants matching original query */
  count: Scalars['Int']['output'];
  /** Local variants on the request page */
  items: Array<LocalVariant>;
};

export type PaginatedMobilities = {
  __typename: 'PaginatedMobilities';
  /** Number of mobilities matching the original query */
  count: Scalars['Int']['output'];
  /** Mobilities on the request page */
  items: Array<Mobility>;
};

export type PaginatedMobilityHomeDelivery = {
  __typename: 'PaginatedMobilityHomeDelivery';
  /** Number of modules matching the original query */
  count: Scalars['Int']['output'];
  /** List of Mobility Location */
  items: Array<MobilityModule>;
};

export type PaginatedMobilityLocation = {
  __typename: 'PaginatedMobilityLocation';
  /** Number of modules matching the original query */
  count: Scalars['Int']['output'];
  /** List of Mobility Location */
  items: Array<MobilityLocation>;
};

export type PaginatedModelConfigurator = {
  __typename: 'PaginatedModelConfigurator';
  /** Number of model configurators matching the original query */
  count: Scalars['Int']['output'];
  /** Model configurators on the request page */
  items: Array<ModelConfigurator>;
};

export type PaginatedModules = {
  __typename: 'PaginatedModules';
  /** Number of modules matching the original query */
  count: Scalars['Int']['output'];
  /** Modules on the request page */
  items: Array<Module>;
};

export type PaginatedModulesInDealer = {
  __typename: 'PaginatedModulesInDealer';
  /** Number of modules matching the original query */
  count: Scalars['Int']['output'];
  /** Modules on the request page */
  items: Array<Module>;
  /** ModuleType */
  moduleType: ModuleType;
};

export type PaginatedMyInfoModules = {
  __typename: 'PaginatedMyInfoModules';
  /** Number of modules matching the original query */
  count: Scalars['Int']['output'];
  /** Modules on the request page */
  items: Array<MyInfoModule>;
};

export type PaginatedMyInfoSettings = {
  __typename: 'PaginatedMyInfoSettings';
  count: Scalars['Int']['output'];
  items: Array<MyInfoSetting>;
};

export type PaginatedPayGatePaymentSettings = {
  __typename: 'PaginatedPayGatePaymentSettings';
  count: Scalars['Int']['output'];
  items: Array<PayGatePaymentSetting>;
};

export type PaginatedPorschePaymentSettings = {
  __typename: 'PaginatedPorschePaymentSettings';
  count: Scalars['Int']['output'];
  items: Array<PorschePaymentSetting>;
};

export type PaginatedPromoCode = {
  __typename: 'PaginatedPromoCode';
  /** Number of promo codes matching the original query */
  count: Scalars['Int']['output'];
  /** Promo codes on the request page */
  items: Array<PromoCode>;
};

export type PaginatedRoles = {
  __typename: 'PaginatedRoles';
  /** Number of Roles matching the original query */
  count: Scalars['Int']['output'];
  /** Roles on the request page */
  items: Array<Role>;
};

export type PaginatedRouters = {
  __typename: 'PaginatedRouters';
  /** Number of router matching the original query */
  count: Scalars['Int']['output'];
  /** Routers on the request page */
  items: Array<Router>;
};

export type PaginatedStockAuditTrails = {
  __typename: 'PaginatedStockAuditTrails';
  count: Scalars['Int']['output'];
  items: Array<AuditTrail>;
};

export type PaginatedStockInventory = {
  __typename: 'PaginatedStockInventory';
  /** Number of stock inventory matching the original query */
  count: Scalars['Int']['output'];
  /** Stock inventories on the request page */
  items: Array<StockInventory>;
};

export type PaginatedSystemBanks = {
  __typename: 'PaginatedSystemBanks';
  /** Number of bank matching the original query */
  count: Scalars['Int']['output'];
  /** Banks on the request page */
  items: Array<SystemBank>;
};

export type PaginatedTradeIns = {
  __typename: 'PaginatedTradeIns';
  /** Number of trade-ins matching the original query */
  count: Scalars['Int']['output'];
  /** TradeIns on the request page */
  items: Array<TradeIn>;
};

export type PaginatedTtbPaymentSettings = {
  __typename: 'PaginatedTtbPaymentSettings';
  /** Total count */
  totalCount: Scalars['Int']['output'];
  /** TtbPaymentSettings */
  ttbPaymentSettings: Array<TtbPaymentSetting>;
};

export type PaginatedUserGroups = {
  __typename: 'PaginatedUserGroups';
  /** Number of user groups matching the original query */
  count: Scalars['Int']['output'];
  /** User groups on the request page */
  items: Array<UserGroup>;
};

export type PaginatedUserlikeChatbotSettings = {
  __typename: 'PaginatedUserlikeChatbotSettings';
  count: Scalars['Int']['output'];
  items: Array<UserlikeChatbotSetting>;
};

export type PaginatedUsers = {
  __typename: 'PaginatedUsers';
  /** Number of user matching the original query */
  count: Scalars['Int']['output'];
  /** User on the request page */
  items: Array<User>;
};

export type PaginatedVariantConfigurator = {
  __typename: 'PaginatedVariantConfigurator';
  /** Number of variant configurators matching the original query */
  count: Scalars['Int']['output'];
  /** Variant configurators on the request page */
  items: Array<VariantConfigurator>;
};

export type PaginatedVehicles = {
  __typename: 'PaginatedVehicles';
  /** Number of vehicles matching original query */
  count: Scalars['Int']['output'];
  /** Vehicles on the request page */
  items: Array<Vehicle>;
};

export type PaginatedWebCalcSettings = {
  __typename: 'PaginatedWebCalcSettings';
  /** Number of settings matching the original query */
  count: Scalars['Int']['output'];
  /** Settings on the request page */
  items: Array<WebCalcSetting>;
};

export type PaginatedWebPage = {
  __typename: 'PaginatedWebPage';
  count: Scalars['Int']['output'];
  items: Array<WebPage>;
};

export type PaginatedWhatsappLiveChatSettings = {
  __typename: 'PaginatedWhatsappLiveChatSettings';
  count: Scalars['Int']['output'];
  items: Array<WhatsappLiveChatSetting>;
};

export type Pagination = {
  /** Number of items to fetch from a list */
  limit: Scalars['Int']['input'];
  /** Offset to apply when fetching a list */
  offset: Scalars['Int']['input'];
};

export type PaginationInfo = {
  __typename: 'PaginationInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export enum PasswordConfiguration {
  DateOfBirth = 'DateOfBirth',
  IdentityAndDateOfBirth = 'IdentityAndDateOfBirth',
  Off = 'Off',
  Random = 'Random'
}

export type PathScript = {
  __typename: 'PathScript';
  /** UID */
  id: Scalars['ObjectID']['output'];
  pathname: Scalars['String']['output'];
  script: Scalars['String']['output'];
};

export type PathScriptSettings = {
  /** UID */
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  pathname: Scalars['String']['input'];
  script: Scalars['String']['input'];
};

export type PayGatePaymentModule = Module & {
  __typename: 'PayGatePaymentModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Payment Settings */
  paymentSettings: Array<PayGatePaymentSetting>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type PayGatePaymentModuleSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
};

export type PayGatePaymentRedirectionLink = {
  __typename: 'PayGatePaymentRedirectionLink';
  path: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type PayGatePaymentSetting = PaymentSetting & {
  __typename: 'PayGatePaymentSetting';
  /** Amount */
  amount: Scalars['Float']['output'];
  /** API Key */
  apiKey: Scalars['String']['output'];
  /** Currency */
  currency: Scalars['String']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Payment Endpoint */
  paymentEndpoint: Scalars['String']['output'];
  /** Payment module ID */
  paymentModuleId: Scalars['ObjectID']['output'];
};

export type PayGatePaymentSettingsInput = {
  /** Amount */
  amount: Scalars['Float']['input'];
  /** API key */
  apiKey: Scalars['String']['input'];
  /** Currency */
  currency: Scalars['String']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Encryption Key */
  encryptionKey: Scalars['String']['input'];
  /** Payment Endpoint */
  paymentEndpoint: Scalars['String']['input'];
};

export type PayGatePaymentUpdateSettingsInput = {
  /** Amount */
  amount: Scalars['Float']['input'];
  /** API Key */
  apiKey: Scalars['String']['input'];
  /** Currency */
  currency: Scalars['String']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Encryption Key */
  encryptionKey?: InputMaybe<Scalars['String']['input']>;
  /** Payment Endpoint */
  paymentEndpoint: Scalars['String']['input'];
};

export enum PaymentMode {
  Advance = 'Advance',
  Arrears = 'Arrears'
}

export type PaymentSetting = {
  /** Amount */
  amount: Scalars['Float']['output'];
  /** Currency */
  currency: Scalars['String']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Payment module ID */
  paymentModuleId: Scalars['ObjectID']['output'];
};

export type PaymentSettings = {
  __typename: 'PaymentSettings';
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  mode: PaymentMode;
};

export type PaymentSettingsPayload = {
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
  mode: PaymentMode;
};

export enum PaymentStatus {
  Error = 'Error',
  Failed = 'Failed',
  Initialized = 'Initialized',
  PaymentCapturing = 'PaymentCapturing',
  Refunded = 'Refunded',
  Success = 'Success',
  Timeout = 'Timeout'
}

export type Period = {
  __typename: 'Period';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type PeriodPayload = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type Permission = {
  __typename: 'Permission';
  /** Is the permission from company */
  company?: Maybe<Company>;
  /** Description */
  description: Scalars['String']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is the permission a system permission */
  isFromSystem: Scalars['Boolean']['output'];
  /** Raw permissions */
  raw: Scalars['JSONObject']['output'];
  /** System name */
  systemName: Scalars['String']['output'];
  /** Tags */
  tags: Array<Scalars['String']['output']>;
};

export type PermissionWithOrigins = {
  __typename: 'PermissionWithOrigins';
  /** Origin roles */
  originRoles: Array<Role>;
  /** Permission ID */
  permission: Permission;
};

export type Phone = {
  __typename: 'Phone';
  prefix: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type PhonePayload = {
  prefix: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PorscheFinderVehicle = {
  __typename: 'PorscheFinderVehicle';
  accidentFree?: Maybe<Scalars['Boolean']['output']>;
  bodyType?: Maybe<LocalizedValue>;
  commissionNumber?: Maybe<Scalars['String']['output']>;
  condition: LocalizedValue;
  consumptionEmission?: Maybe<ConsumptionEmission>;
  displacement?: Maybe<Displacement>;
  driveSide?: Maybe<LocalizedValue>;
  drivetrain?: Maybe<LocalizedValue>;
  energyEfficiency?: Maybe<EnergyEfficiency>;
  engineType?: Maybe<LocalizedValue>;
  equipment?: Maybe<Array<Equipment>>;
  exteriorColor: ExteriorColor;
  firstRegistrationDate?: Maybe<FormattedDate>;
  fuelType?: Maybe<LocalizedValue>;
  fullServiceHistory?: Maybe<Scalars['Boolean']['output']>;
  images: VehicleImagesConnection;
  imagesType?: Maybe<Scalars['String']['output']>;
  interior?: Maybe<Interior>;
  mileage: NumberUnit;
  modelCategory?: Maybe<LocalizedValue>;
  modelGeneration: LocalizedValue;
  modelSeries?: Maybe<LocalizedValue>;
  modelYear?: Maybe<Scalars['Int']['output']>;
  name: LocalizedString;
  nextGeneralInspection?: Maybe<FormattedDate>;
  numberOfCylinders?: Maybe<Scalars['Int']['output']>;
  numberOfPreviousOwners?: Maybe<Scalars['Int']['output']>;
  orderTypeCode: Scalars['String']['output'];
  power?: Maybe<Power>;
  productionDate?: Maybe<Scalars['DateTime']['output']>;
  rooftopColor?: Maybe<RooftopColor>;
  standardEquipment?: Maybe<LocalizedStandardEquipment>;
  technicalData?: Maybe<LocalizedTechnicalData>;
  transmission: LocalizedValue;
  unladenWeight?: Maybe<UnladenWeight>;
  usageType?: Maybe<LocalizedValue>;
  vehicleVideo?: Maybe<VehicleVideo>;
  vin: Scalars['String']['output'];
};


export type PorscheFinderVehicleImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type PorscheMasterDataModule = Module & {
  __typename: 'PorscheMasterDataModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  setting: PorscheMasterDataSetting;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type PorscheMasterDataModuleSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Sales area ID */
  ggId: Scalars['String']['input'];
  /** PCCD Client ID */
  pccdClientId: Scalars['String']['input'];
  /** PCCD Client Secret */
  pccdClientSecret: Scalars['String']['input'];
  /** PCCD Token */
  pccdToken: Scalars['String']['input'];
  /** PCCD URL Prefix */
  pccdUrlPrefix: Scalars['String']['input'];
  /** PPN Client ID */
  ppnClientId: Scalars['String']['input'];
  /** PPN Client Secret */
  ppnClientSecret: Scalars['String']['input'];
  /** PPN Resource */
  ppnResource: Scalars['String']['input'];
  /** PPN URL */
  ppnUrl: Scalars['String']['input'];
};

export type PorscheMasterDataSecrets = {
  __typename: 'PorscheMasterDataSecrets';
  /** PCCD Client ID */
  pccdClientId: Scalars['String']['output'];
  /** PCCD Client Secret */
  pccdClientSecret: Scalars['String']['output'];
  /** PCCD Token */
  pccdToken: Scalars['String']['output'];
  /** PCCD URL Prefix */
  pccdUrlPrefix: Scalars['String']['output'];
  /** PPN Client ID */
  ppnClientId: Scalars['String']['output'];
  /** PPN Client Secret */
  ppnClientSecret: Scalars['String']['output'];
  /** PPN Resource */
  ppnResource: Scalars['String']['output'];
  /** PPN URL */
  ppnUrl: Scalars['String']['output'];
};

export type PorscheMasterDataSetting = {
  __typename: 'PorscheMasterDataSetting';
  /** Sales area ID */
  ggId: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  moduleId: Scalars['ObjectID']['output'];
  secrets: PorscheMasterDataSecrets;
};

export type PorscheMasterDataSyncCreated = {
  __typename: 'PorscheMasterDataSyncCreated';
  make?: Maybe<Array<Scalars['String']['output']>>;
  model?: Maybe<Array<Scalars['String']['output']>>;
  variant?: Maybe<Array<Scalars['String']['output']>>;
};

export type PorscheMasterDataSyncResult = {
  __typename: 'PorscheMasterDataSyncResult';
  created?: Maybe<PorscheMasterDataSyncCreated>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  updated?: Maybe<Array<Scalars['String']['output']>>;
};

export type PorschePaymentMethods = {
  __typename: 'PorschePaymentMethods';
  method: Scalars['String']['output'];
  types: Array<PorschePaymentType>;
};

export type PorschePaymentModule = Module & {
  __typename: 'PorschePaymentModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Payment Settings */
  paymentSettings: Array<PorschePaymentSetting>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type PorschePaymentModuleSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
};

export type PorschePaymentRedirectionLink = {
  __typename: 'PorschePaymentRedirectionLink';
  path: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type PorschePaymentSetting = PaymentSetting & {
  __typename: 'PorschePaymentSetting';
  /** Amount */
  amount: Scalars['Float']['output'];
  /** Porsche API Endpoint */
  apiEndpoint: Scalars['String']['output'];
  /** Porsche API Key */
  apiKey: Scalars['String']['output'];
  /** Currency */
  currency: Scalars['String']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Endpoint API Version. Available values is 'v1' */
  endpointApiVersion: Scalars['String']['output'];
  /** Environment */
  environment: Environment;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Porsche Login Endpoint */
  loginEndpoint: Scalars['String']['output'];
  /** Payment module ID */
  paymentModuleId: Scalars['ObjectID']['output'];
  /** Porsche Payment Widget Url */
  widgetUrl: Scalars['String']['output'];
};

export type PorschePaymentSettingsInput = {
  /** Amount */
  amount: Scalars['Float']['input'];
  /** Porsche API Endpoint */
  apiEndpoint: Scalars['String']['input'];
  /** Porsche API Key */
  apiKey: Scalars['String']['input'];
  /** Currency */
  currency: Scalars['String']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Endpoint API Version. Available values is 'v1' */
  endpointApiVersion: Scalars['String']['input'];
  /** Environment */
  environment: Environment;
  /** Porsche Login Endpoint */
  loginEndpoint: Scalars['String']['input'];
  /** Porsche Secret Key */
  secretKey: Scalars['String']['input'];
  /** Webhook Notification Key */
  webhookKey: Scalars['String']['input'];
  /** Porsche Payment Widget Url */
  widgetUrl: Scalars['String']['input'];
};

export type PorschePaymentType = {
  __typename: 'PorschePaymentType';
  displayName: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PorschePaymentUpdateSettingsInput = {
  /** Amount */
  amount: Scalars['Float']['input'];
  /** Porsche API Endpoint */
  apiEndpoint: Scalars['String']['input'];
  /** Porsche API Key */
  apiKey: Scalars['String']['input'];
  /** Currency */
  currency: Scalars['String']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Endpoint API Version. Available value is 'v1' */
  endpointApiVersion: Scalars['String']['input'];
  /** Environment */
  environment: Environment;
  /** Porsche Login Endpoint */
  loginEndpoint: Scalars['String']['input'];
  /** Porsche Secret Key */
  secretKey?: InputMaybe<Scalars['String']['input']>;
  /** Webhook Notification Key */
  webhookKey?: InputMaybe<Scalars['String']['input']>;
  /** Porsche Payment Widget Url */
  widgetUrl: Scalars['String']['input'];
};

export type Power = {
  __typename: 'Power';
  horsepower: NumberUnit;
  kilowatt: NumberUnit;
  localizeLabel?: Maybe<Scalars['String']['output']>;
  localizeValue?: Maybe<Scalars['String']['output']>;
};


export type PowerLocalizeLabelArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};


export type PowerLocalizeValueArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export enum PreferenceValue {
  No = 'No',
  Optional = 'Optional',
  Yes = 'Yes'
}

export type PrefetchKycConsents = {
  __typename: 'PrefetchKYCConsents';
  agreements: Array<ApplicationAgreement>;
  kycFields: Array<KycField>;
};

export type Price = ICurrencyType & {
  __typename: 'Price';
  currencyCode?: Maybe<Scalars['String']['output']>;
  downPayment?: Maybe<DownPayment>;
  localize?: Maybe<Scalars['String']['output']>;
  /** The type of recycle fee the seller offers for this car. Only used in Japan. */
  recycleFeeType?: Maybe<LocalizedValue>;
  value: Scalars['Float']['output'];
  vatDeductible?: Maybe<Scalars['Boolean']['output']>;
};


export type PriceLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type ProceedWithCustomerLink = {
  __typename: 'ProceedWithCustomerLink';
  applicationKind: ApplicationKind;
  endpoint: Endpoint;
  router: Router;
  secret: Scalars['String']['output'];
};

export type PromoCode = {
  __typename: 'PromoCode';
  /** Application Module Ids */
  applicationModuleIds: Array<Scalars['ObjectID']['output']>;
  /** Application Modules */
  applicationModules: Array<Module>;
  /** Dealer IDs */
  dealerIds: Array<Scalars['ObjectID']['output']>;
  /** Dealers */
  dealers: Array<Dealer>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Initial value */
  initialQuantity?: Maybe<Scalars['Int']['output']>;
  /** Is active */
  isActive: Scalars['Boolean']['output'];
  /** TODO: Promo code module */
  module: Module;
  /** Promo code module ID */
  moduleId: Scalars['ObjectID']['output'];
  /** Module Variant */
  moduleVariants: Array<ModuleVariant>;
  /** Period */
  period: Period;
  /** Permissions for the current user on this promo code */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Promo code */
  promoCode: Scalars['String']['output'];
  /** Promo type: gift or discount */
  promoType: PromoType;
  /** Track usage */
  trackUsage: Scalars['Boolean']['output'];
  /** Used value */
  usedValue: Scalars['Int']['output'];
  /** Versioning */
  versioning: AdvancedVersioning;
};

export type PromoCodeFilteringRule = {
  /** Company ID */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Dealer IDs */
  dealerIds: Array<Scalars['ObjectID']['input']>;
  /** Is Active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by module ID */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Promo Code */
  promoCode?: InputMaybe<Scalars['String']['input']>;
};

export type PromoCodeModule = Module & {
  __typename: 'PromoCodeModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type PromoCodeModuleSettings = {
  /** Display Name */
  displayName: Scalars['String']['input'];
};

export type PromoCodeSettings = {
  /** Application Module Ids */
  applicationModuleIds: Array<Scalars['ObjectID']['input']>;
  /** Dealer IDs */
  dealerIds: Array<Scalars['ObjectID']['input']>;
  /** Initial value */
  initialQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** Is active */
  isActive: Scalars['Boolean']['input'];
  /** Module Variant */
  moduleVariants: Array<ModuleVariantInput>;
  /** Period */
  period: PeriodPayload;
  /** Promo Code */
  promoCode: Scalars['String']['input'];
  /** Promo type: gift or discount */
  promoType: PromoTypeInput;
  /** Track usage */
  trackUsage: Scalars['Boolean']['input'];
};

export enum PromoCodeSortingField {
  Company = 'Company',
  IsActive = 'IsActive',
  PromoCode = 'PromoCode',
  PromoType = 'PromoType'
}

export type PromoCodeSortingRule = {
  field: PromoCodeSortingField;
  order: SortingOrder;
};

export type PromoType = {
  description: Scalars['String']['output'];
  type: PromoTypeEnum;
};

export enum PromoTypeEnum {
  Discount = 'Discount',
  Gift = 'Gift'
}

export type PromoTypeInput = {
  discountPromoType?: InputMaybe<DiscountPromoTypeInput>;
  giftPromoType?: InputMaybe<GiftPromoTypeInput>;
  type: PromoTypeEnum;
};

export enum PurchaseIntention {
  InMoreThanSixMonths = 'InMoreThanSixMonths',
  InOneToThreeMonths = 'InOneToThreeMonths',
  InThreeToSixMonths = 'InThreeToSixMonths',
  WithinAMonth = 'WithinAMonth'
}

export enum Purpose {
  /** For Admin Management */
  Admin = 'Admin',
  /** Default behavior using permissions */
  Default = 'Default',
  /**
   * For CI use
   * e.g. Ensuring only active entities are returned
   */
  Production = 'Production'
}

export type Query = {
  __typename: 'Query';
  /** Get lowest monthly payment */
  calculateLowestMonthlyInstalment?: Maybe<Scalars['Float']['output']>;
  /** Check availability of the variant configurator */
  checkAvailableInventoryStockByVariantConfiguratorSettings?: Maybe<StockInventory>;
  /** Companies for filter list */
  companyFilterList: Array<Company>;
  /** Fetch user document for the logged in user, returns null otherwise for anonymous */
  currentUser?: Maybe<User>;
  /** Generate challenge to authenticate with WebAuthn */
  generateAuthenticatorChallenge?: Maybe<AuthenticationWithWebPublicKeyCredential>;
  /** Generate authenticator secret and qrcode */
  generateAuthenticatorSetup: AuthenticatorSetup;
  /** Get an application by its ID */
  getApplication?: Maybe<Application>;
  /** Get audit trail kinds for an application */
  getApplicationAuditTrailKinds: Array<AuditTrailKind>;
  /** Get audit trails for an application */
  getApplicationAuditTrails: PaginatedAuditTrails;
  /** Get statistic for application counter */
  getApplicationCounter?: Maybe<StatisticCounterResult>;
  /** Get download link for an application document */
  getApplicationDocumentDownloadLink?: Maybe<Download>;
  /** Get an application journey */
  getApplicationJourney: ApplicationJourney;
  /** Get an application signing status */
  getApplicationSigningStatus?: Maybe<ApplicationSigningStatus>;
  /** Get Application List Filters */
  getApplicationsListFilters: ApplicationFilter;
  /** Get audi calculation module settings by company ID */
  getAudiCalculationSettings?: Maybe<Array<AudiCalculationModule>>;
  /** Get a bank by its ID */
  getBank?: Maybe<SystemBank>;
  getBanner: Banner;
  getBannerByModule?: Maybe<Banner>;
  /** Get a company by its ID */
  getCompany?: Maybe<Company>;
  /** Get a consent and declaration by its ID */
  getConsentsAndDeclarations?: Maybe<ConsentsAndDeclarations>;
  /** Get customer by ID */
  getCustomer?: Maybe<Customer>;
  /** Get audit trails for an customer */
  getCustomerAuditTrails: PaginatedAuditTrails;
  getCustomerFieldsFromFiles: Array<LocalCustomerField>;
  /** Get Customer List Filters */
  getCustomerListFilters: CustomerFilter;
  /** Get customer data from C@P */
  getDataFromCap?: Maybe<CapData>;
  /** Get data from MyInfo */
  getDataFromMyInfo?: Maybe<MyInfoData>;
  /** Get statistic for instant approval rate */
  getDbsInstantApprovalRate?: Maybe<StatisticInstantApprovalResult>;
  /** Get a dealer by ID */
  getDealer?: Maybe<Dealer>;
  /** Get dealers by IDs */
  getDealers?: Maybe<Array<Maybe<Dealer>>>;
  /** Get statistic for deposit payment per day */
  getDepositPaymentPerDay?: Maybe<StatisticMonthlyResult>;
  /** Retrieve Event */
  getEvent?: Maybe<Event>;
  /**
   * Retrieve related reservation/leads/appointments attached to an event
   *
   * Not using listApplication intentionally, considering the pagination and aggregation was used there
   * This is for delete event confirmation
   */
  getEventApplications: Array<EventApplication>;
  /** Get a finance product by its ID */
  getFinanceProduct?: Maybe<FinanceProduct>;
  /** Get finance products by filtering rules */
  getFinanceProducts: Array<FinanceProduct>;
  /** Get porsche finder detail */
  getFinderVehicle?: Maybe<FinderVehicle>;
  /** Get synchronization status for finder vehicle */
  getFinderVehicleSyncStatus: FinderVehicleSyncStatus;
  /** Get the first router path for an event module */
  getFirstEventRouterPath?: Maybe<Scalars['String']['output']>;
  getGiftVoucher: GiftVoucher;
  getGiftVoucherJourney: GiftVoucherJourneyContext;
  /** Get all options for list gift voucher filtering */
  getGiftVouchersListFilters: GiftVoucherFilter;
  /** Get insurance premium */
  getInsurancePremium?: Maybe<Scalars['Float']['output']>;
  /** Get a insurance product by its ID */
  getInsuranceProduct?: Maybe<InsuranceProduct>;
  /** Get insurance products by filtering rules */
  getInsuranceProducts: Array<InsuranceProduct>;
  /** Get a Insurer by its ID */
  getInsurer?: Maybe<Insurer>;
  /** Get Insures by Module ID */
  getInsurersByModuleID: Array<Insurer>;
  /** Get stock inventories by mobility module id */
  getInventoriesByMobilityModuleId: Array<MobilityInventory>;
  /** Get an inventory by its ID */
  getInventory?: Maybe<Inventory>;
  /** Get audit trails for an inventory */
  getInventoryAuditTrails: PaginatedAuditTrails;
  /** Get list of options for inventory inputs */
  getInventoryOptions: InventoryOptions;
  getLabel: Labels;
  getLabelsByFeatureModuleId: Array<Labels>;
  /** Get a language pack by its ID */
  getLanguagePack?: Maybe<LanguagePack>;
  /** Get language pack list filters */
  getLanguagePackListFilters: LanguagePackFilters;
  /** Get Mobility by Id */
  getMobility: Mobility;
  /** Get Home Delivery */
  getMobilityHomeDelivery?: Maybe<MobilityModule>;
  /** Get Mobility Location */
  getMobilityLocation?: Maybe<MobilityLocation>;
  /** Get mobility vehicle filters */
  getMobilityVehicleFilters: MobilityVehicleFilters;
  /** Get model configurator */
  getModelConfigurator?: Maybe<ModelConfigurator>;
  /** Get model configurator description images */
  getModelConfiguratorDescriptionImages: Array<UploadedFileWithPreview>;
  /** Get model configurator filters */
  getModelConfiguratorFilters: ModelConfiguratorFilters;
  /** Get a module by its ID */
  getModule?: Maybe<Module>;
  /** Get Module Options */
  getModuleOptions?: Maybe<Array<ModuleOption>>;
  /** Get myInfo authorized url */
  getMyInfoAuthorizeUrl: Scalars['String']['output'];
  /** Get statistic for popular event applications or leads */
  getPopularEvent?: Maybe<StatisticMonthlyResult>;
  /** Get statistic for popular variant applications or leads */
  getPopularVariant?: Maybe<StatisticMonthlyResult>;
  /** Get an Porsche Payment Methods */
  getPorschePaymentMethods: Array<PorschePaymentMethods>;
  /** Get a promo code */
  getPromoCode?: Maybe<PromoCode>;
  /** Promo Code Listing */
  getPromoCodeListing: PaginatedPromoCode;
  /** Get reference application list endpoints */
  getReferenceApplicationListEndpoints: Array<ApplicationListEndpoint>;
  /** Get a role by ID */
  getRole?: Maybe<Role>;
  /** Get router by its ID */
  getRouter?: Maybe<Router>;
  /**
   * Get an stock by its ID
   * Optional application id or token to be omitted as part of reservation list
   */
  getStock?: Maybe<StockInventory>;
  /** Get audit trails for a stock */
  getStockAuditTrails: PaginatedStockAuditTrails;
  /** Get Stock Inventory by Variant Configurator Id */
  getStockInventoryByVariantConfigurator: Array<Inventory>;
  /** Get statistic for submitted applications or leads */
  getSubmittedApplicationPerDay?: Maybe<StatisticMonthlyResult>;
  /** Get statistic for salesperson with most applications / leads */
  getTopSalesPersons?: Maybe<StatisticMonthlyResult>;
  /** Get an Trade-in Application by its ID */
  getTradeIn?: Maybe<TradeIn>;
  /** Get audit trails for an trade-in */
  getTradeInAuditTrails: PaginatedAuditTrails;
  /** Get Trade In List Filters */
  getTradeInListFilters: TradeInListFilter;
  /**
   * Get user
   *
   * Apply filter inside, so that returned roles/usergroup can be filtered out
   */
  getUser?: Maybe<User>;
  /** Get a user group by ID */
  getUserGroup?: Maybe<UserGroup>;
  /** Checks both gift code and promo code */
  getValidDiscountCode?: Maybe<DiscountCode>;
  /** Get a gift code */
  getValidGiftVoucherByCode?: Maybe<GiftVoucher>;
  /** Get a promo code */
  getValidPromoCodeByCode?: Maybe<PromoCode>;
  /** Get variant configurator */
  getVariantConfigurator?: Maybe<VariantConfigurator>;
  /** Get all variant lists from all model configurator */
  getVariantsOfAllConfigurators: Array<Vehicle>;
  /** Get vehicle by ID */
  getVehicle?: Maybe<Vehicle>;
  getWebPage: WebPage;
  getWebPageOptions: Array<WebPage>;
  /** Fetch WebAuthn security keys for a username */
  getWebauthnKeys: Array<Scalars['String']['output']>;
  /** Check if there is any valid promo code */
  hasValidPromoCode: Scalars['Boolean']['output'];
  /** Get Adyen Payment Settings */
  listAdyenPaymentSettings: PaginatedAdyenPaymentSettings;
  /** List applications */
  listApplications: PaginatedApplications;
  /** List Application Module */
  listApplicationsModules: Array<Module>;
  /** List Application Status */
  listApplicationsStatus: Array<ApplicationStatus>;
  /** List permissions available to the role based on the authenticated user */
  listAvailablePermissions: Array<Permission>;
  /** List user groups available to the user based on the authenticated user */
  listAvailableUserGroups: PaginatedUserGroups;
  /** List users available to the role based on the authenticated user */
  listAvailableUsersByRole: Array<User>;
  /** List available users for user group based on the authenticated user */
  listAvailableUsersForUserGroup: Array<User>;
  /** List bank options */
  listBankOptions: Array<BankOption>;
  /** List banks */
  listBanks: PaginatedSystemBanks;
  listBanners: PaginatedBanner;
  /** List companies */
  listCompanies: PaginatedCompanies;
  /** List companies for selection */
  listCompaniesForSelection: PaginatedCompanyOptions;
  /** List Consents and Declarations */
  listConsentsAndDeclarations: PaginatedConsentsAndDeclarations;
  /** List customers from application */
  listCustomers: PaginatedCustomers;
  /** list dealers */
  listDealers: PaginatedDealers;
  /** List of Event Mediums */
  listEventFilters: EventFilters;
  /** List of Events paginated */
  listEvents: PaginatedEvent;
  /** List finance products */
  listFinanceProducts: PaginatedFinanceProducts;
  /** List porsche finder vehicles */
  listFinderVehicles: ListFinderVehiclesInfo;
  /** Get Fiserv Payment Settings */
  listFiservPaymentSettings: PaginatedFiservPaymentSettings;
  listGiftVouchers: PaginatedGiftVoucher;
  /** List insurance products */
  listInsuranceProducts: PaginatedInsuranceProducts;
  /** List Insurers */
  listInsurers: PaginatedInsurers;
  /** List inventories */
  listInventories: PaginatedInventory;
  listInventoriesFilter: Array<Inventory>;
  listLabels: PaginatedLabels;
  /** List language packs */
  listLanguagePacks: PaginatedLanguagePacks;
  /** List local makes */
  listLocalMakes: PaginatedLocalMakes;
  /** List local models */
  listLocalModels: PaginatedLocalModels;
  /** List local variants */
  listLocalVariants: PaginatedLocalVariants;
  listLocationConditions: Array<Scalars['String']['output']>;
  /** List Mobility Locations */
  listLocations: PaginatedMobilityLocation;
  /** List Mobility */
  listMobilities: PaginatedMobilities;
  /** list Home Deliveries */
  listMobilityHomeDeliveries: PaginatedMobilityHomeDelivery;
  /** List model configurators */
  listModelConfigurators: PaginatedModelConfigurator;
  /** List Module Type */
  listModuleType: Array<ModuleType>;
  /** List modules */
  listModules: PaginatedModules;
  /** List Modules for Application Download */
  listModulesForApplicationDownload: Array<Module>;
  /** List MyInfo Modules */
  listMyInfoModules: PaginatedMyInfoModules;
  listMyInfoSetting: PaginatedMyInfoSettings;
  /** Get Porsche Payment Settings */
  listPorschePaymentSettings: PaginatedPorschePaymentSettings;
  /** List Promo Code Company */
  listPromoCodeCompanies: Array<Company>;
  /** List of public assignees */
  listPublicAssignees: Array<User>;
  /** List roles */
  listRoles: PaginatedRoles;
  /** List routers */
  listRouters: PaginatedRouters;
  /** List stock inventories */
  listStockInventories: PaginatedStockInventory;
  /** List Trade-in Applicaitons */
  listTradeIns: PaginatedTradeIns;
  /** List user groups */
  listUserGroups: PaginatedUserGroups;
  /** List Userlike Chatbot Settings */
  listUserlikeChatbotSettings: PaginatedUserlikeChatbotSettings;
  /**
   * List users
   *
   * Apply filter inside, so that returned roles/usergroup can be filtered out
   */
  listUsers: PaginatedUsers;
  /** List variant configurators */
  listVariantConfigurators: PaginatedVariantConfigurator;
  /** List vehicles */
  listVehicles: PaginatedVehicles;
  /** List WebCalc Settings */
  listWebCalcSettings: PaginatedWebCalcSettings;
  listWebPages: PaginatedWebPage;
  /** List Whatsapp Live Chat Settings */
  listWhatsappLiveChatSettings: PaginatedWhatsappLiveChatSettings;
  /** Prefetch agreements for event */
  prefetchAgreementsForEvent: Array<ApplicationAgreement>;
  /** Prefetch agreements for standard application */
  prefetchAgreementsForStandardApplication: Array<ApplicationAgreement>;
  prefetchGiftVoucherKYCConsents: PrefetchKycConsents;
  /** Prefetch KYC fields for Event */
  prefetchKYCFieldsForEvent: Array<KycField>;
  /** Prefetch KYC fields for Standard application */
  prefetchKYCFieldsForStandardApplication: Array<KycField>;
  /** Refining text using GenAI */
  refineText: Scalars['String']['output'];
  /** Retreive booked appointment slots */
  retrieveBlockedAppointmentTimeSlot: Array<Scalars['DateTime']['output']>;
  /** Retrieve a link information */
  retrieveLink?: Maybe<ExternalLink>;
  /** Retrieve all namespaces of the translation files */
  retrieveNamespaces: Array<Scalars['String']['output']>;
  /** Checking whether the uploaded file is safe */
  validateFile: Scalars['Boolean']['output'];
};


export type QueryCalculateLowestMonthlyInstalmentArgs = {
  data: LowestMonthlyInstalmentPayload;
};


export type QueryCheckAvailableInventoryStockByVariantConfiguratorSettingsArgs = {
  configuratorId: Scalars['ObjectID']['input'];
  settingId: Scalars['ObjectID']['input'];
};


export type QueryCompanyFilterListArgs = {
  filter?: InputMaybe<CompanyFilterListRule>;
};


export type QueryGenerateAuthenticatorChallengeArgs = {
  username: Scalars['String']['input'];
};


export type QueryGetApplicationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetApplicationAuditTrailKindsArgs = {
  applicationId: Scalars['ObjectID']['input'];
  stage?: InputMaybe<ApplicationStage>;
};


export type QueryGetApplicationAuditTrailsArgs = {
  applicationId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
  stage?: InputMaybe<ApplicationStage>;
};


export type QueryGetApplicationCounterArgs = {
  filter?: InputMaybe<StatisticFilterPayload>;
};


export type QueryGetApplicationDocumentDownloadLinkArgs = {
  applicationId: Scalars['ObjectID']['input'];
  documentId: Scalars['ObjectID']['input'];
  stage?: InputMaybe<ApplicationStage>;
};


export type QueryGetApplicationJourneyArgs = {
  refreshToken?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
};


export type QueryGetApplicationSigningStatusArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetApplicationsListFiltersArgs = {
  filter?: InputMaybe<ApplicationFilteringRule>;
};


export type QueryGetAudiCalculationSettingsArgs = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type QueryGetBankArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetBannerArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetBannerByModuleArgs = {
  moduleId: Scalars['ObjectID']['input'];
};


export type QueryGetCompanyArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetConsentsAndDeclarationsArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetCustomerArgs = {
  suiteId: Scalars['ObjectID']['input'];
};


export type QueryGetCustomerAuditTrailsArgs = {
  customerSuiteId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCustomerFieldsFromFilesArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  files: Array<OcrImage>;
};


export type QueryGetCustomerListFiltersArgs = {
  filter?: InputMaybe<CustomerFilteringRule>;
};


export type QueryGetDataFromCapArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type QueryGetDataFromMyInfoArgs = {
  applicationId: Scalars['ObjectID']['input'];
  code: Scalars['String']['input'];
  customerKind: CustomerKind;
  linkId: Scalars['ObjectID']['input'];
  withTestDrive?: InputMaybe<Scalars['Boolean']['input']>;
  withTradeIn?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetDbsInstantApprovalRateArgs = {
  filter?: InputMaybe<InstantApprovalStatisticFilterPayload>;
};


export type QueryGetDealerArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetDealersArgs = {
  ids: Array<Scalars['ObjectID']['input']>;
};


export type QueryGetDepositPaymentPerDayArgs = {
  filter?: InputMaybe<StatisticFilterPayload>;
};


export type QueryGetEventArgs = {
  eventModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  productionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  urlSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEventApplicationsArgs = {
  eventId: Scalars['ObjectID']['input'];
};


export type QueryGetFinanceProductArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetFinanceProductsArgs = {
  filter?: InputMaybe<GetFinanceProductsFilteringRule>;
};


export type QueryGetFinderVehicleArgs = {
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  productionOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetFinderVehicleSyncStatusArgs = {
  companyId: Scalars['ObjectID']['input'];
};


export type QueryGetFirstEventRouterPathArgs = {
  moduleId: Scalars['ObjectID']['input'];
};


export type QueryGetGiftVoucherArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetGiftVoucherJourneyArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetGiftVouchersListFiltersArgs = {
  filter?: InputMaybe<GiftVoucherFilteringRule>;
};


export type QueryGetInsurancePremiumArgs = {
  data: InsurancePremiumPayload;
};


export type QueryGetInsuranceProductArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetInsuranceProductsArgs = {
  filter?: InputMaybe<GetInsuranceProductsFilteringRule>;
};


export type QueryGetInsurerArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetInsurersByModuleIdArgs = {
  moduleId: Scalars['ObjectID']['input'];
};


export type QueryGetInventoriesByMobilityModuleIdArgs = {
  mobilityModuleId: Scalars['ObjectID']['input'];
};


export type QueryGetInventoryArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetInventoryAuditTrailsArgs = {
  inventoryId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetInventoryOptionsArgs = {
  filters?: InputMaybe<InventoryOptionsFilteringRule>;
};


export type QueryGetLabelArgs = {
  id?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type QueryGetLabelsByFeatureModuleIdArgs = {
  moduleId: Scalars['ObjectID']['input'];
};


export type QueryGetLanguagePackArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetLanguagePackListFiltersArgs = {
  filter?: InputMaybe<LanguagePackFilteringRule>;
};


export type QueryGetMobilityArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetMobilityHomeDeliveryArgs = {
  deliveryId: Scalars['ObjectID']['input'];
};


export type QueryGetMobilityLocationArgs = {
  locationId: Scalars['ObjectID']['input'];
};


export type QueryGetMobilityVehicleFiltersArgs = {
  moduleId: Scalars['ObjectID']['input'];
  productionOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetModelConfiguratorArgs = {
  applicationModuleIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  productionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  urlIdentifier?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetModelConfiguratorDescriptionImagesArgs = {
  modelConfiguratorId: Scalars['ObjectID']['input'];
};


export type QueryGetModelConfiguratorFiltersArgs = {
  moduleId: Scalars['ObjectID']['input'];
  productionOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetModuleArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetModuleOptionsArgs = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  kind: ModuleType;
};


export type QueryGetMyInfoAuthorizeUrlArgs = {
  applicationId: Scalars['ObjectID']['input'];
  customerKind: CustomerKind;
  endpointId: Scalars['ObjectID']['input'];
  routerId: Scalars['ObjectID']['input'];
  withTestDrive?: InputMaybe<Scalars['Boolean']['input']>;
  withTradeIn?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetPopularEventArgs = {
  filter?: InputMaybe<StatisticFilterPayload>;
};


export type QueryGetPopularVariantArgs = {
  filter?: InputMaybe<StatisticFilterPayload>;
};


export type QueryGetPorschePaymentMethodsArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetPromoCodeArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetPromoCodeListingArgs = {
  filter?: InputMaybe<PromoCodeFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<PromoCodeSortingRule>;
};


export type QueryGetReferenceApplicationListEndpointsArgs = {
  filter: ReferenceApplicationListEndpointFilter;
};


export type QueryGetRoleArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetRouterArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetStockArgs = {
  id: Scalars['ObjectID']['input'];
  omitApplicationId?: InputMaybe<Scalars['ObjectID']['input']>;
  productionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStockAuditTrailsArgs = {
  inventoryId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
  stockId: Scalars['ObjectID']['input'];
};


export type QueryGetStockInventoryByVariantConfiguratorArgs = {
  variantConfiguratorId: Scalars['ObjectID']['input'];
};


export type QueryGetSubmittedApplicationPerDayArgs = {
  filter?: InputMaybe<StatisticFilterPayload>;
};


export type QueryGetTopSalesPersonsArgs = {
  filter?: InputMaybe<StatisticFilterPayload>;
  sortParam?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTradeInArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetTradeInAuditTrailsArgs = {
  pagination?: InputMaybe<Pagination>;
  tradeInId: Scalars['ObjectID']['input'];
};


export type QueryGetTradeInListFiltersArgs = {
  filter?: InputMaybe<TradeInFilteringRule>;
};


export type QueryGetUserArgs = {
  filter?: InputMaybe<UserFilteringRule>;
  userId: Scalars['ObjectID']['input'];
};


export type QueryGetUserGroupArgs = {
  userGroupId: Scalars['ObjectID']['input'];
};


export type QueryGetValidDiscountCodeArgs = {
  applicationModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  code: Scalars['String']['input'];
  giftVoucherModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  promoCodeModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  variantId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type QueryGetValidGiftVoucherByCodeArgs = {
  giftCode: Scalars['String']['input'];
  moduleId: Scalars['ObjectID']['input'];
};


export type QueryGetValidPromoCodeByCodeArgs = {
  applicationModuleId: Scalars['ObjectID']['input'];
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
  promoCode: Scalars['String']['input'];
  variantId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type QueryGetVariantConfiguratorArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryGetVariantsOfAllConfiguratorsArgs = {
  moduleId: Scalars['ObjectID']['input'];
};


export type QueryGetVehicleArgs = {
  id: Scalars['ObjectID']['input'];
  productionOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetWebPageArgs = {
  id: Scalars['ObjectID']['input'];
  productionOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetWebPageOptionsArgs = {
  moduleId: Scalars['ObjectID']['input'];
};


export type QueryGetWebauthnKeysArgs = {
  username: Scalars['String']['input'];
};


export type QueryHasValidPromoCodeArgs = {
  applicationModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  variantId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type QueryListAdyenPaymentSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryListApplicationsArgs = {
  filter?: InputMaybe<ApplicationFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ApplicationSortingRule>;
};


export type QueryListApplicationsModulesArgs = {
  filter?: InputMaybe<ApplicationFilteringRule>;
};


export type QueryListApplicationsStatusArgs = {
  filter?: InputMaybe<ApplicationFilteringRule>;
};


export type QueryListAvailablePermissionsArgs = {
  roleId: Scalars['ObjectID']['input'];
};


export type QueryListAvailableUserGroupsArgs = {
  filter?: InputMaybe<UserGroupFilteringRule>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryListAvailableUsersByRoleArgs = {
  filter?: InputMaybe<UserFilteringRule>;
  roleId: Scalars['ObjectID']['input'];
};


export type QueryListAvailableUsersForUserGroupArgs = {
  userGroupId: Scalars['ObjectID']['input'];
};


export type QueryListBankOptionsArgs = {
  filter?: InputMaybe<BankOptionFilteringRule>;
  sort?: InputMaybe<BankSortingRule>;
};


export type QueryListBanksArgs = {
  filter?: InputMaybe<BankFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<BankSortingRule>;
};


export type QueryListBannersArgs = {
  filter?: InputMaybe<BannerFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<BannerSortingRule>;
};


export type QueryListCompaniesArgs = {
  filter?: InputMaybe<CompanyFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<CompanySortingRule>;
};


export type QueryListCompaniesForSelectionArgs = {
  filter?: InputMaybe<CompanyFilteringRule>;
};


export type QueryListConsentsAndDeclarationsArgs = {
  filter?: InputMaybe<ConsentsAndDeclarationsFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ConsentsAndDeclarationsSortingRule>;
};


export type QueryListCustomersArgs = {
  filter?: InputMaybe<CustomerFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<CustomerSortingRule>;
};


export type QueryListDealersArgs = {
  filter?: InputMaybe<DealerFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<DealerSortingRule>;
};


export type QueryListEventFiltersArgs = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  dealerIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  productionOnly: Scalars['Boolean']['input'];
};


export type QueryListEventsArgs = {
  filter?: InputMaybe<EventFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<EventSortingRule>;
};


export type QueryListFinanceProductsArgs = {
  filter?: InputMaybe<FinanceProductFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<FinanceProductSortingRule>;
};


export type QueryListFinderVehiclesArgs = {
  applicationModuleIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  filter?: InputMaybe<FilterVehicleFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<FinderVehicleSortingRule>;
};


export type QueryListFiservPaymentSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryListGiftVouchersArgs = {
  filter?: InputMaybe<GiftVoucherFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<GiftVoucherSortingRule>;
};


export type QueryListInsuranceProductsArgs = {
  filter?: InputMaybe<InsuranceProductFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<InsuranceProductSortingRule>;
};


export type QueryListInsurersArgs = {
  filter?: InputMaybe<InsurerFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<InsurerSortingRule>;
};


export type QueryListInventoriesArgs = {
  filter?: InputMaybe<InventoryFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<InventorySortingRule>;
};


export type QueryListInventoriesFilterArgs = {
  filter?: InputMaybe<InventoryFilteringRule>;
};


export type QueryListLabelsArgs = {
  filter?: InputMaybe<LabelsFilteringField>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<LabelsSortingRule>;
};


export type QueryListLanguagePacksArgs = {
  filter?: InputMaybe<LanguagePackFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<LanguagePackSortingRule>;
};


export type QueryListLocalMakesArgs = {
  filter?: InputMaybe<LocalMakeFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<LocalMakeSortingRule>;
};


export type QueryListLocalModelsArgs = {
  filter?: InputMaybe<LocalModelFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<LocalModelSortingRule>;
};


export type QueryListLocalVariantsArgs = {
  filter?: InputMaybe<LocalVariantFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<LocalVariantSortingRule>;
};


export type QueryListLocationConditionsArgs = {
  locationId: Scalars['ObjectID']['input'];
};


export type QueryListLocationsArgs = {
  filter?: InputMaybe<LocationFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<LocationSortingRule>;
};


export type QueryListMobilitiesArgs = {
  filter?: InputMaybe<MobilityFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<MobilitySortingRule>;
};


export type QueryListMobilityHomeDeliveriesArgs = {
  filter?: InputMaybe<HomeDeliveryFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<HomeDeliverySortingRule>;
};


export type QueryListModelConfiguratorsArgs = {
  filter?: InputMaybe<ModelConfiguratorFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ModelConfiguratorSortingRule>;
};


export type QueryListModuleTypeArgs = {
  filter?: InputMaybe<ModuleFilteringRule>;
};


export type QueryListModulesArgs = {
  filter?: InputMaybe<ModuleFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<ModuleSortingRule>;
};


export type QueryListModulesForApplicationDownloadArgs = {
  filter?: InputMaybe<ApplicationFilteringRule>;
};


export type QueryListMyInfoModulesArgs = {
  filter?: InputMaybe<ModuleFilteringRule>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryListMyInfoSettingArgs = {
  moduleId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryListPorschePaymentSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryListPromoCodeCompaniesArgs = {
  filter?: InputMaybe<PromoCodeFilteringRule>;
};


export type QueryListPublicAssigneesArgs = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  eventId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type QueryListRolesArgs = {
  filter?: InputMaybe<RoleFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<RoleSortingRule>;
};


export type QueryListRoutersArgs = {
  filter?: InputMaybe<RouterFilteringRule>;
  pagination: Pagination;
};


export type QueryListStockInventoriesArgs = {
  filter?: InputMaybe<StockFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<StockSortingRule>;
};


export type QueryListTradeInsArgs = {
  filter?: InputMaybe<TradeInFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<TradeInSortingRule>;
};


export type QueryListUserGroupsArgs = {
  filter?: InputMaybe<UserGroupFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<UserGroupSortingRule>;
};


export type QueryListUserlikeChatbotSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryListUsersArgs = {
  filter?: InputMaybe<UserFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<UserSortingRule>;
};


export type QueryListVariantConfiguratorsArgs = {
  filter?: InputMaybe<VariantConfiguratorFilteringRule>;
  modelConfiguratorId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<VariantConfiguratorSortingRule>;
};


export type QueryListVehiclesArgs = {
  filter?: InputMaybe<VehicleFilteringRule>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryListWebCalcSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryListWebPagesArgs = {
  filter?: InputMaybe<WebPageFilteringRule>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<WebPageSortingRule>;
};


export type QueryListWhatsappLiveChatSettingsArgs = {
  moduleId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryPrefetchAgreementsForEventArgs = {
  configuration: EventApplicationConfigurationPayload;
  customerKind?: InputMaybe<Scalars['String']['input']>;
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  eventId?: InputMaybe<Scalars['ObjectID']['input']>;
  eventModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  urlSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPrefetchAgreementsForStandardApplicationArgs = {
  applicationModuleId: Scalars['ObjectID']['input'];
  configuration: StandardApplicationConfiguration;
  customerKind?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPrefetchGiftVoucherKycConsentsArgs = {
  customerKind: Scalars['String']['input'];
  mobilityModuleId: Scalars['ObjectID']['input'];
};


export type QueryPrefetchKycFieldsForEventArgs = {
  configuration: EventApplicationConfigurationPayload;
  customerKind?: InputMaybe<Scalars['String']['input']>;
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
  eventId?: InputMaybe<Scalars['ObjectID']['input']>;
  eventModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  urlSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPrefetchKycFieldsForStandardApplicationArgs = {
  applicationModuleId: Scalars['ObjectID']['input'];
  configuration: StandardApplicationConfiguration;
  customerKind?: InputMaybe<Scalars['String']['input']>;
  placement?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRefineTextArgs = {
  languagePackId?: InputMaybe<Scalars['String']['input']>;
  source: ContentRefinementSourceType;
  text: Scalars['String']['input'];
};


export type QueryRetrieveBlockedAppointmentTimeSlotArgs = {
  appointmentModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type QueryRetrieveLinkArgs = {
  id: Scalars['String']['input'];
};


export type QueryValidateFileArgs = {
  assetFieldSource: Scalars['String']['input'];
  upload: Scalars['Upload']['input'];
};

export type RangeAmount = {
  __typename: 'RangeAmount';
  from: Scalars['Float']['output'];
  to: Scalars['Float']['output'];
};

export type RangeAmountPayload = {
  from: Scalars['Float']['input'];
  to: Scalars['Float']['input'];
};

export type Rate = ICurrencyType & {
  __typename: 'Rate';
  currencyCode: Scalars['String']['output'];
  localize: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};


export type RateLocalizeArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceApplicationListEndpointFilter = {
  /** Application Module ID */
  applicationModuleId: Scalars['ObjectID']['input'];
  /** Router ID */
  routerId: Scalars['ObjectID']['input'];
  /** Current Stage */
  stage: ApplicationStage;
};

export type ReferenceDetailPayload = {
  contactNumber?: InputMaybe<PhonePayload>;
  name?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export enum ReferenceDetailRelationship {
  Friend = 'Friend',
  Relative = 'Relative'
}

export type ReferenceDetailSet = {
  __typename: 'ReferenceDetailSet';
  /** Reference contact number */
  contactNumber?: Maybe<Phone>;
  /** Reference name */
  name?: Maybe<Scalars['String']['output']>;
  /** Reference relationship */
  relationship?: Maybe<Scalars['String']['output']>;
};

export enum RelationshipApplicant {
  Children = 'Children',
  Colleague = 'Colleague',
  CorporatePrincipal = 'CorporatePrincipal',
  Friend = 'Friend',
  Myself = 'Myself',
  Others = 'Others',
  Parent = 'Parent',
  Relative = 'Relative',
  Shareholder = 'Shareholder',
  Silbing = 'Silbing',
  Spouse = 'Spouse'
}

export type RequestReleaseLetterSettings = {
  /** Chassis No. */
  chassisNo: Scalars['String']['input'];
  /** Engine No. */
  engineNo: Scalars['String']['input'];
};

export type ReservationStage = ApplicationStageDetails & {
  __typename: 'ReservationStage';
  assignee?: Maybe<User>;
  /** Assignee */
  assigneeId?: Maybe<Scalars['ObjectID']['output']>;
  /** Identifier */
  identifier: Scalars['String']['output'];
  /** Current status */
  status: ApplicationStatus;
};

export enum ReservationStockStatus {
  Available = 'Available',
  ManuallyDeducted = 'ManuallyDeducted',
  Reserved = 'Reserved',
  SystemDeducted = 'SystemDeducted'
}

export type ResetPasswordLink = {
  __typename: 'ResetPasswordLink';
  /** Token to use with mutation `changePasswordFromToken` */
  token: Scalars['String']['output'];
  /** Verified status */
  verified: Scalars['Boolean']['output'];
};

export type ResetPasswordResponse = {
  __typename: 'ResetPasswordResponse';
  /** Token to use with mutation `changePasswordFromToken` */
  token: Scalars['String']['output'];
  /** Verified status */
  verified: Scalars['Boolean']['output'];
};

export enum ResidenceType {
  Owned = 'Owned',
  Rented = 'Rented'
}

export enum ResidentialStatus {
  Dormitory = 'Dormitory',
  Others = 'Others',
  RelativeOwned = 'RelativeOwned',
  Rental = 'Rental',
  SelfOwned = 'SelfOwned'
}

export type ResidualValueSettings = {
  __typename: 'ResidualValueSettings';
  averageMileage: AverageMileageSettings;
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  residualValueUnit: AmountUnit;
  table: Array<ResidualValueTableCell>;
  vehicleFilterParameterTable: Array<ResidualValueTableCellForVehicleParameterFilter>;
};

export type ResidualValueSettingsPayload = {
  averageMileage: AverageMileageSettingsPayload;
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
  residualValueUnit: AmountUnit;
  table: Array<ResidualValueTableCellPayload>;
  vehicleFilterParameterTable: Array<ResidualValueTableCellForVehicleParameterPayload>;
};

export type ResidualValueTableCell = {
  __typename: 'ResidualValueTableCell';
  mileage: Scalars['Int']['output'];
  term: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
  variantSuiteId: Scalars['ObjectID']['output'];
};

export type ResidualValueTableCellForVehicleParameterFilter = {
  __typename: 'ResidualValueTableCellForVehicleParameterFilter';
  mileage: Scalars['Int']['output'];
  term: Scalars['Int']['output'];
  type: VehicleKind;
  value: Scalars['Float']['output'];
};

export type ResidualValueTableCellForVehicleParameterPayload = {
  mileage: Scalars['Int']['input'];
  term: Scalars['Int']['input'];
  type: VehicleKind;
  value: Scalars['Float']['input'];
};

export type ResidualValueTableCellPayload = {
  mileage: Scalars['Int']['input'];
  term: Scalars['Int']['input'];
  value: Scalars['Float']['input'];
  variantSuiteId: Scalars['ObjectID']['input'];
};

export type Role = {
  __typename: 'Role';
  /** Company owning this user role */
  company: Company;
  /** Description */
  description: Scalars['String']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Active Status */
  isActive: Scalars['Boolean']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Number of permissions applied to the role */
  permissionCount: Scalars['Int']['output'];
  /** Permissions applied to the role */
  permissions: Array<Permission>;
  /** Permissions for the current user on this user role */
  rolePermissions: Array<Maybe<Scalars['String']['output']>>;
  /** Number of users in the role */
  userCount: Scalars['Int']['output'];
  /** Users in the role */
  users: Array<User>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type RoleFilteringRule = {
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Filter by display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type RoleSettings = {
  /** Description */
  description: Scalars['String']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Active Status */
  isActive: Scalars['Boolean']['input'];
};

export enum RoleSortingField {
  /** Sort by description */
  Description = 'Description',
  /** Sort by display name */
  DisplayName = 'DisplayName',
  /** Sort by user count */
  UserCount = 'UserCount'
}

export type RoleSortingRule = {
  /** Field on which apply the sorting */
  field: RoleSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type RooftopColor = {
  __typename: 'RooftopColor';
  colorGroup?: Maybe<LocalizedValue>;
  name: LocalizedString;
  value: Scalars['String']['output'];
};

export type Rounding = {
  __typename: 'Rounding';
  /** Number of decimal places */
  decimals: Scalars['Int']['output'];
};

export type RoundingPayload = {
  /** Number of decimal places */
  decimals: Scalars['Int']['input'];
};

export type Roundings = {
  __typename: 'Roundings';
  /** Rounding setting for amount */
  amount: Rounding;
  /** Rounding setting for percentage */
  percentage: Rounding;
};

export type RoundingsPayload = {
  /** Rounding setting for amount */
  amount: RoundingPayload;
  /** Rounding setting for percentage */
  percentage: RoundingPayload;
};

export type Router = {
  __typename: 'Router';
  /** BlueKai Id */
  blueKaiId?: Maybe<Scalars['String']['output']>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Endpoints */
  endpoints: Array<Endpoint>;
  /** Google Tag Manager Id */
  googleTagManagerId?: Maybe<Scalars['String']['output']>;
  hostname: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  /** Languages */
  languages: Array<LanguagePack>;
  /**
   * Layout
   *
   * NoneRouterLayout will return a null value on this field
   */
  layout?: Maybe<Layout>;
  /** LinkedIn Insight Tag Id */
  linkedInInsightTagId?: Maybe<Scalars['String']['output']>;
  /** Menu items */
  menuItems: Array<MenuItem>;
  pathname: Scalars['String']['output'];
  /** Permissions for the current user on this router */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Facebook Pixel Id */
  pixelId?: Maybe<Scalars['String']['output']>;
  /** Snap Chat Id */
  snapChatId?: Maybe<Scalars['String']['output']>;
  /** Tik Tok Id */
  tikTokId?: Maybe<Scalars['String']['output']>;
  /** Versioning */
  versioning: SimpleVersioning;
  withAdmin: Scalars['Boolean']['output'];
};

export type RouterFilteringRule = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type RouterSettings = {
  /** BlueKai Id */
  blueKaiId?: InputMaybe<Scalars['String']['input']>;
  /** Google Tag Manager Id */
  googleTagManagerId?: InputMaybe<Scalars['String']['input']>;
  /** Hostname */
  hostname: Scalars['String']['input'];
  /** Languages */
  languages: Array<Scalars['ObjectID']['input']>;
  /** LinkedIn Insight Tag Id */
  linkedInInsightTagId?: InputMaybe<Scalars['String']['input']>;
  /** Pathname */
  pathname: Scalars['String']['input'];
  /** Facebook Pixel Id */
  pixelId?: InputMaybe<Scalars['String']['input']>;
  /** Snap Chat Id */
  snapChatId?: InputMaybe<Scalars['String']['input']>;
  /** Tik Tok Id */
  tikTokId?: InputMaybe<Scalars['String']['input']>;
  /** With Admin Panel */
  withAdmin: Scalars['Boolean']['input'];
};

export type SdmApplication = Application & {
  __typename: 'SDMApplication';
  appointmentStage?: Maybe<AppointmentStage>;
  /** assignees this application can be assigned to */
  availableAssignees: Array<User>;
  /** Bank */
  bank?: Maybe<ExternalBank>;
  /** Bank ID */
  bankId?: Maybe<Scalars['ObjectID']['output']>;
  financingStage?: Maybe<FinancingStage>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  insuranceStage?: Maybe<InsuranceStage>;
  latestStage?: Maybe<ApplicationStageDetails>;
  leadStage?: Maybe<LeadStage>;
  mobilityStage?: Maybe<MobilityStage>;
  /** Module */
  module: Module;
  /** ModuleId */
  moduleId: Scalars['ObjectID']['output'];
  permissions: Array<Maybe<Scalars['String']['output']>>;
  remarks: Scalars['String']['output'];
  reservationStage?: Maybe<ReservationStage>;
  /** Sales Name */
  salesName: Scalars['String']['output'];
  /** Sales Reference */
  salesRef: Scalars['String']['output'];
  /** SDM Customer */
  sdmCustomer?: Maybe<SdmCustomer>;
  /** SDM Document */
  sdmDocuments: Array<SdmDocument>;
  /** SDM Financing */
  sdmFinancing: SdmFinancing;
  /** SDM State */
  sdmState?: Maybe<SdmState>;
  /** SDM Vehicle */
  sdmVehicle: SdmVehicle;
  stages: Array<ApplicationStage>;
  /** AdvancedVersioning */
  versioning: AdvancedVersioning;
};

export type SdmCustomer = {
  __typename: 'SDMCustomer';
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Full Name */
  fullName: Scalars['String']['output'];
  /** Customer ID */
  id: Scalars['String']['output'];
  /** Mobile */
  mobile: Scalars['String']['output'];
  /** NRIC */
  nric: Scalars['String']['output'];
};

export type SdmDocument = {
  __typename: 'SDMDocument';
  name: Scalars['String']['output'];
  type: SdmDocumentType;
};

export enum SdmDocumentType {
  FinPassBack = 'FINPassBack',
  FinPassFront = 'FINPassFront',
  IncomeDocument = 'IncomeDocument',
  LogCard = 'LogCard',
  MyIdentityCardBack = 'MYIdentityCardBack',
  MyIdentityCardFront = 'MYIdentityCardFront',
  Passport = 'Passport',
  SgIdentityCardBack = 'SGIdentityCardBack',
  SgIdentityCardFront = 'SGIdentityCardFront',
  VehicleSalesAgreement = 'VehicleSalesAgreement'
}

export enum SdmEngineType {
  Diesel = 'Diesel',
  DieselElectric = 'DieselElectric',
  Electric = 'Electric',
  Hybrid = 'Hybrid',
  Petrol = 'Petrol',
  PetrolCng = 'PetrolCNG',
  PetrolElectric = 'PetrolElectric',
  PetrolElectricDashed = 'PetrolElectricDashed',
  PetrolElectricPlugIn = 'PetrolElectricPlugIn',
  PetrolElectricPlugInDashed = 'PetrolElectricPlugInDashed'
}

export type SdmFinancing = {
  bank: Scalars['String']['output'];
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  type: FinanceType;
};

export type SdmNewVehicle = SdmVehicle & {
  __typename: 'SDMNewVehicle';
  accessories?: Maybe<Scalars['String']['output']>;
  condition: VehicleCondition;
  engineType: SdmEngineType;
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  ownerIdType: Scalars['String']['output'];
  parallelImport: Scalars['Boolean']['output'];
  scheme?: Maybe<VehicleScheme>;
};

export type SdmState = {
  __typename: 'SDMState';
  approvalExpiry?: Maybe<Scalars['String']['output']>;
  approvedAmount?: Maybe<Scalars['Float']['output']>;
  approvedPeriod?: Maybe<Scalars['Int']['output']>;
  creditProposalReference?: Maybe<Scalars['String']['output']>;
  status: SdmStateStatus;
  statusRemark?: Maybe<Scalars['String']['output']>;
};

export enum SdmStateStatus {
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  FailedToSubmit = 'FailedToSubmit',
  PendingDisbursement = 'PendingDisbursement',
  PendingSubmission = 'PendingSubmission',
  Rejected = 'Rejected',
  ReviewInProgress = 'ReviewInProgress',
  Submitted = 'Submitted'
}

export type SdmUsedVehicle = SdmVehicle & {
  __typename: 'SDMUsedVehicle';
  accessories?: Maybe<Scalars['String']['output']>;
  condition: VehicleCondition;
  engineType: SdmEngineType;
  inspected: Scalars['Boolean']['output'];
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  ownerIdType: Scalars['String']['output'];
  parallelImport: Scalars['Boolean']['output'];
  scheme?: Maybe<VehicleScheme>;
};

export type SdmVehicle = {
  accessories?: Maybe<Scalars['String']['output']>;
  condition: VehicleCondition;
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  ownerIdType: Scalars['String']['output'];
  parallelImport: Scalars['Boolean']['output'];
  scheme?: Maybe<VehicleScheme>;
};

export type SmtpEmailSettings = EmailSettings & {
  __typename: 'SMTPEmailSettings';
  /** SMTP Certificate, required only if the SMTP server is using self-signed certificate */
  certificate?: Maybe<Scalars['String']['output']>;
  /** Email sender */
  from: Scalars['String']['output'];
  /** SMTP Host */
  host: Scalars['String']['output'];
  /** SMTP requires authentication */
  isAuthenticationRequired: Scalars['Boolean']['output'];
  /** SMTP SSL */
  isSslEnabled: Scalars['Boolean']['output'];
  /** SMTP password */
  password?: Maybe<Scalars['String']['output']>;
  /** SMTP Port */
  port: Scalars['Int']['output'];
  /** Email provider type */
  provider: EmailProvider;
  /** SMTP username */
  user?: Maybe<Scalars['String']['output']>;
};

export type SalaryTransferredBankPayload = {
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  supportingDocuments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
};

export type SalaryTransferredBankSet = {
  __typename: 'SalaryTransferredBankSet';
  /** Account number, if salary is transferred to bank account */
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Bank name, if salary is transferred to bank account */
  bankName?: Maybe<Scalars['String']['output']>;
  /** Whether salary is transferred to bank account or not */
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum SalesFilter {
  OnlineOrderable = 'online_orderable',
  SalesIncentive = 'sales_incentive'
}

export type SalesForceSetting = {
  __typename: 'SalesForceSetting';
  /** CA, used for mTLS */
  authority?: Maybe<Scalars['String']['output']>;
  /** Base url for insurance */
  baseInsuranceUrl?: Maybe<Scalars['String']['output']>;
  /** Base url */
  baseUrl: Scalars['String']['output'];
  /** Client ID */
  clientId: Scalars['String']['output'];
  /** Module ID */
  financingModuleId: Scalars['ObjectID']['output'];
  /** Grant Type Authentication */
  grantType: Scalars['String']['output'];
  /** ID */
  id: Scalars['ObjectID']['output'];
  /** Private Key, used for mTLS */
  privateKey?: Maybe<Scalars['String']['output']>;
  /** Public Key, used for mTLS */
  publicCert?: Maybe<Scalars['String']['output']>;
};

export type SalesForceSettingInput = {
  /** CA, used for mTLS */
  authority?: InputMaybe<Scalars['String']['input']>;
  /** Base url for insurance */
  baseInsuranceUrl?: InputMaybe<Scalars['String']['input']>;
  /** Base url */
  baseUrl: Scalars['String']['input'];
  /** Client ID */
  clientId: Scalars['String']['input'];
  /** Client Secret */
  clientSecret: Scalars['String']['input'];
  /** Grant Type */
  grantType: Scalars['String']['input'];
  /** Private Key, used for mTLS */
  privateKey?: InputMaybe<Scalars['String']['input']>;
  /** Public Key, used for mTLS */
  publicCert?: InputMaybe<Scalars['String']['input']>;
};

export type SalesIncentive = {
  __typename: 'SalesIncentive';
  description: LocalizedString;
  title: LocalizedString;
};

export type SalesPersonCodeMapping = {
  __typename: 'SalesPersonCodeMapping';
  bankCode: Scalars['String']['output'];
  bankIds: Array<Scalars['ObjectID']['output']>;
  salesPersonCode: Scalars['String']['output'];
};

export type Salesforce = {
  __typename: 'Salesforce';
  _authorKind?: Maybe<Scalars['String']['output']>;
};

export type SdmModule = Module & {
  __typename: 'SdmModule';
  /** Authorization */
  authorization?: Maybe<Authorization>;
  /** Bank Integrations */
  banks: Array<ExternalBank>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Sales Force Setting */
  salesForceSetting: SalesForceSetting;
  /** Sales Person Code Mappings */
  salesPersonCodeMappings: Array<SalesPersonCodeMapping>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type SdmModuleSalesPersonCodeMapping = {
  bankCode: Scalars['String']['input'];
  bankIds: Array<Scalars['ObjectID']['input']>;
  salesPersonCode: Scalars['String']['input'];
};

export type SdmModuleSettings = {
  /** Display Name */
  displayName: Scalars['String']['input'];
};

export type Seller = {
  __typename: 'Seller';
  address?: Maybe<LocalizedString>;
  email?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['String']['output']>;
  name: LocalizedString;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  porschePartnerNumber: Scalars['String']['output'];
};

export enum SettingType {
  LocalMakeSettings = 'LocalMakeSettings',
  LocalModelSettings = 'LocalModelSettings',
  LocalVariantSettings = 'LocalVariantSettings'
}

export enum SettlementInstalmentOn {
  Last = 'Last',
  OneMonth = 'OneMonth',
  TwoMonth = 'TwoMonth'
}

export type SimpleVehicleManagementModule = Module & {
  __typename: 'SimpleVehicleManagementModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Default Template */
  defaultTemplate: TemplateType;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Link to Porsche MasterData Module */
  porscheMasterDataModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type SimpleVehicleManagementSettings = {
  /** Default Template */
  defaultTemplate: TemplateType;
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Link to Porsche MasterData Module */
  porscheMasterDataModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type SimpleVehicleManagementUpdateSettings = {
  /** Default Template */
  defaultTemplate: TemplateType;
  /** Link to Porsche MasterData Module */
  porscheMasterDataModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type SimpleVersioning = {
  __typename: 'SimpleVersioning';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Author>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Author>;
};

/** Finance settings for singapore applications (including COE) */
export type SingaporeApplicationFinanceSettings = {
  /** Assured Resale Value */
  assuredResaleValue?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Balloon Payment (HP with Balloon) */
  balloonPayment?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Starting price */
  carPrice: Scalars['Float']['input'];
  /** Remaining Cash After Trade In */
  cashAfterTradeIn?: InputMaybe<Scalars['Float']['input']>;
  /** COE */
  coe: Scalars['Float']['input'];
  /** Commission */
  commission?: InputMaybe<Scalars['Float']['input']>;
  /** Dealer Options */
  dealerOptions?: InputMaybe<Array<DealerOptionPayload>>;
  /** Deposit Payment */
  deposit?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Discount */
  discount?: InputMaybe<DiscountInput>;
  /** Displacement */
  displacement?: InputMaybe<Scalars['Int']['input']>;
  /** Down Payment */
  downPayment?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Down payment with additional */
  downPaymentWithAdditional?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Estimated Surplus After Assured Resale Value */
  estimatedSurplusBalloon?: InputMaybe<Scalars['Float']['input']>;
  /** Extra Amount */
  extraAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Extra Financed Amount */
  extraFinancedAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Finance product ID */
  financeProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Total Financing Price Application */
  financedAmount: Scalars['Float']['input'];
  /** Insurance Fee */
  insuranceFee?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Interest Rate */
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  /** License and Fuel Tax */
  licenseAndFuelTax?: InputMaybe<Scalars['Float']['input']>;
  /** License plate fee */
  licensePlateFee?: InputMaybe<Scalars['Float']['input']>;
  /** Loan */
  loan?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Mileage Value */
  mileage?: InputMaybe<Scalars['Float']['input']>;
  /** Monthly instalment */
  monthlyInstalment?: InputMaybe<Array<ApplicationMonthlyInstalmentPayload>>;
  /** Monthly payment fixed interest rate */
  monthlyPaymentFixedInterestRate?: InputMaybe<Scalars['Float']['input']>;
  /** Payment Mode */
  paymentMode?: InputMaybe<PaymentMode>;
  /** Promo Code Value */
  promoCodeValue?: InputMaybe<Scalars['Float']['input']>;
  /** Residual Value */
  residualValue?: InputMaybe<MandatoryCompoundValuePayload>;
  /** Tax Loss */
  taxLoss?: InputMaybe<Scalars['Float']['input']>;
  /** Number of Terms */
  term?: InputMaybe<Scalars['Int']['input']>;
  /** Total Price */
  totalPrice: Scalars['Float']['input'];
  /** Trade In Amount */
  tradeInAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type SingaporeApplicationFinancing = ApplicationFinancing & {
  __typename: 'SingaporeApplicationFinancing';
  /** Affin Auto Finance Centre */
  affinAutoFinanceCentre?: Maybe<AffinAutoFinanceCentre>;
  /** Balloon Payment (HP with Balloon) */
  balloonPayment?: Maybe<ApplicationValueSetting>;
  /** Car price */
  carPrice: Scalars['Float']['output'];
  /** COE */
  coe: Scalars['Float']['output'];
  /** Dealer Options */
  dealerOptions?: Maybe<Array<DealerOption>>;
  /** Deposit */
  deposit?: Maybe<ApplicationValueSetting>;
  /** Discount */
  discount?: Maybe<Discount>;
  /** Down Payment */
  downPayment?: Maybe<ApplicationValueSetting>;
  /** Down payment with additional */
  downPaymentWithAdditional?: Maybe<ApplicationValueSetting>;
  /** Extra Amount */
  extraAmount?: Maybe<Scalars['Float']['output']>;
  /** Extra Financed Amount */
  extraFinancedAmount?: Maybe<Scalars['Float']['output']>;
  /** Finance Product ID */
  financeProductId?: Maybe<Scalars['ObjectID']['output']>;
  /** Total Financing Price Application */
  financedAmount: Scalars['Float']['output'];
  /** Interest Rate */
  interestRate?: Maybe<Scalars['Float']['output']>;
  /** Loan */
  loan?: Maybe<ApplicationValueSetting>;
  /** Market */
  market: ApplicationMarket;
  /** Mileage Value */
  mileage?: Maybe<Scalars['Float']['output']>;
  /** Monthly Installment */
  monthlyInstalment?: Maybe<Array<ApplicationMonthlyInstalment>>;
  /** Payment Mode */
  paymentMode?: Maybe<PaymentMode>;
  /** Promo Code Value */
  promoCodeValue?: Maybe<Scalars['Float']['output']>;
  /** Residual Value */
  residualValue?: Maybe<ApplicationValueSetting>;
  /** Term */
  term?: Maybe<Scalars['Int']['output']>;
  /** Total Price Application */
  totalPrice: Scalars['Float']['output'];
  /** Trade in amount */
  tradeInAmount?: Maybe<Scalars['Float']['output']>;
};

/**
 * Singapore insurance settings for applications
 *
 * Additional fees:
 * - COE
 */
export type SingaporeApplicationInsuranceSettings = {
  /** Car Price */
  carPrice: Scalars['Float']['input'];
  /** COE amount */
  coe: Scalars['Float']['input'];
  /** Customer date of birth */
  dateOfBirth: Scalars['DateTime']['input'];
  /** Vehicle date of registration */
  dateOfRegistration: Scalars['DateTime']['input'];
  /** Insurance premium amount */
  insurancePremium?: InputMaybe<Scalars['Float']['input']>;
  /** Insurance Product ID */
  insuranceProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Insurer ID */
  insurerId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** No claim discount */
  ncd: Scalars['Float']['input'];
  /** Total Price */
  totalPrice: Scalars['Float']['input'];
  /** Customer years of driving */
  yearsOfDriving: Scalars['Int']['input'];
};

export type SingaporeApplicationInsurancing = ApplicationInsurancing & {
  __typename: 'SingaporeApplicationInsurancing';
  /** Car Price */
  carPrice: Scalars['Float']['output'];
  /** COE */
  coe: Scalars['Float']['output'];
  /** Customer date of birth */
  dateOfBirth: Scalars['DateTime']['output'];
  /** Vehicle date of registration */
  dateOfRegistration: Scalars['DateTime']['output'];
  /** Insurance premium amount */
  insurancePremium?: Maybe<Scalars['Float']['output']>;
  /** Insurance Product ID */
  insuranceProductId: Scalars['ObjectID']['output'];
  /** Insurer ID */
  insurerId: Scalars['ObjectID']['output'];
  /** Market */
  market: ApplicationMarket;
  /** No claim discount */
  ncd: Scalars['Float']['output'];
  /** Total Price */
  totalPrice: Scalars['Float']['output'];
  /** Customer years of driving */
  yearsOfDriving: Scalars['Int']['output'];
};

export type SingaporeApplicationMarket = ApplicationMarketType & {
  __typename: 'SingaporeApplicationMarket';
  coe: DealershipMarket;
  type: ApplicationMarket;
};

export type SingaporeApplicationMarketTypeInput = {
  coe: Scalars['Float']['input'];
};

export type SingaporeApplicationModuleMarketTypeInput = {
  coe: DealershipMarketInput;
};

export type SingleSelectOption = {
  __typename: 'SingleSelectOption';
  id: Scalars['ObjectID']['output'];
  /**
   * Image
   *
   * Image to be displayed for selected option
   * in CI or email
   */
  image?: Maybe<UploadedFileWithPreview>;
  /** Label */
  label: TranslatedString;
  /** Type */
  type: OptionType;
  /** Value price */
  valuePrice?: Maybe<Scalars['Float']['output']>;
  /** Value Text / description */
  valueText?: Maybe<TranslatedString>;
};

export type SingleSelectOptionSettings = {
  __typename: 'SingleSelectOptionSettings';
  kind?: Maybe<OptionKind>;
  options: Array<SingleSelectOption>;
};

export type SingleSelectOptionSettingsInput = {
  options: Array<OptionInput>;
};

export enum SmsProvider {
  System = 'System'
}

export type SmsSettings = {
  /** SMS provider type */
  provider: SmsProvider;
};

export type SmsSettingsPayload = {
  provider?: InputMaybe<SmsProvider>;
};

export enum SortOption {
  Closest = 'closest',
  MileageAsc = 'mileage_asc',
  MileageDesc = 'mileage_desc',
  MonthlyRateAsc = 'monthly_rate_asc',
  MonthlyRateDesc = 'monthly_rate_desc',
  Newest = 'newest',
  PriceAsc = 'price_asc',
  PriceDesc = 'price_desc',
  RecommendedDesc = 'recommended_desc'
}

export enum SortingOrder {
  /** Ascending order */
  Asc = 'Asc',
  /** Descending order */
  Desc = 'Desc'
}

export enum SortingRuleType {
  LocalMakeSortingRule = 'LocalMakeSortingRule',
  LocalModelSortingRule = 'LocalModelSortingRule',
  LocalVariantSortingRule = 'LocalVariantSortingRule'
}

export type StandardApplication = Application & {
  __typename: 'StandardApplication';
  /** Applicant */
  applicant: Customer;
  /** Agreements for the applicant */
  applicantAgreements: Array<ApplicationAgreement>;
  /** Applicant ID */
  applicantId: Scalars['ObjectID']['output'];
  /** KYC fields for the applicant */
  applicantKYC: Array<KycField>;
  appointmentStage?: Maybe<AppointmentStage>;
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['ObjectID']['output']>;
  /** assignees this application can be assigned to */
  availableAssignees: Array<User>;
  /** Bank */
  bank?: Maybe<SystemBank>;
  /** Bank ID */
  bankId?: Maybe<Scalars['ObjectID']['output']>;
  capValues?: Maybe<CapValuesOnApplication>;
  commentsToInsurer?: Maybe<Scalars['String']['output']>;
  /** Application Configuration */
  configuration: ApplicationConfiguration;
  /** Agreements for the corporate */
  corporateAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the corporate */
  corporateKYC: Array<KycField>;
  /** Dealer data */
  dealer: Dealer;
  /** Dealer ID */
  dealerId: Scalars['ObjectID']['output'];
  /** Application Deposit */
  deposit?: Maybe<ApplicationDeposit>;
  /** Application Document */
  documents: Array<ApplicationDocument>;
  /** Drafting flow */
  draftFlow: StandardApplicationDraftFlow;
  /** Endpoint */
  endpoint?: Maybe<Endpoint>;
  /** Financial Product */
  financeProduct?: Maybe<FinanceProduct>;
  /** Application Finance */
  financing?: Maybe<ApplicationFinancing>;
  financingStage?: Maybe<FinancingStage>;
  /**
   * Guarantor
   * currently only have 1 Guarantor
   * might have more guarantor in future
   */
  guarantor?: Maybe<Customer>;
  /** Agreements for the guarantor */
  guarantorAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the guarantor */
  guarantorKYC: Array<KycField>;
  /** Guarantor Application Signing */
  guarantorSigning?: Maybe<ApplicationSigning>;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Insurance Product */
  insuranceProduct?: Maybe<InsuranceProduct>;
  /** Insurance application signing */
  insuranceSigning?: Maybe<ApplicationSigning>;
  insuranceStage?: Maybe<InsuranceStage>;
  /** Application insurancing */
  insurancing?: Maybe<ApplicationInsurancing>;
  /** Insurer */
  insurer?: Maybe<Insurer>;
  /** Journey Steps Identifiers */
  journeySteps: Array<Scalars['String']['output']>;
  /** Language ID to determine what language user chose in journey */
  languageId?: Maybe<Scalars['ObjectID']['output']>;
  latestStage?: Maybe<ApplicationStageDetails>;
  leadStage?: Maybe<LeadStage>;
  /** Market */
  market: ApplicationMarket;
  mobilityStage?: Maybe<MobilityStage>;
  /** Module */
  module: Module;
  /** ModuleId */
  moduleId: Scalars['ObjectID']['output'];
  /** Other Vehicle Information */
  otherVehicleInformation?: Maybe<OtherVehicleInformation>;
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Promo Code data */
  promoCode?: Maybe<PromoCode>;
  /** Promo Code ID */
  promoCodeId?: Maybe<Scalars['ObjectID']['output']>;
  /** Quotation */
  quotation?: Maybe<ApplicationQuotation>;
  /** Finance application suite id */
  referenceApplicationSuiteIds: Array<Scalars['ObjectID']['output']>;
  /** Finance application suite id */
  referenceApplications: Array<Application>;
  remarks: Scalars['String']['output'];
  reservationStage?: Maybe<ReservationStage>;
  /** Router */
  router?: Maybe<Router>;
  /** Router ID */
  routerId?: Maybe<Scalars['ObjectID']['output']>;
  /** Application Signing */
  signing?: Maybe<ApplicationSigning>;
  stages: Array<ApplicationStage>;
  /** Agreements for the test drive */
  testDriveAgreements: Array<ApplicationAgreement>;
  /** KYC fields for the test drive */
  testDriveKYC: Array<KycField>;
  /** Redirect Url */
  testDriveRedirectUrl?: Maybe<Scalars['String']['output']>;
  /** Test Drive Signing */
  testDriveSigning?: Maybe<ApplicationSigning>;
  /** TradeIn Vehicle */
  tradeInVehicle: Array<TradeInVehicle>;
  /** As a flag whether user has use myinfo on kyc or no */
  useMyinfo?: Maybe<Scalars['Boolean']['output']>;
  /** Vehicle */
  vehicle: Vehicle;
  /** Vehicle ID */
  vehicleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: AdvancedVersioning;
  /** Application is proceeding with customer device */
  withCustomerDevice: Scalars['Boolean']['output'];
};

export type StandardApplicationConfiguration = {
  isAffinAutoFinanceCentreRequired?: InputMaybe<Scalars['Boolean']['input']>;
  testDrive: Scalars['Boolean']['input'];
  tradeIn: Scalars['Boolean']['input'];
  withFinancing: Scalars['Boolean']['input'];
  withInsurance: Scalars['Boolean']['input'];
};

export type StandardApplicationDraftFlow = {
  __typename: 'StandardApplicationDraftFlow';
  /** Application Drafted date */
  applicationDraftedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Application Shared date */
  applicationSharedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Application Submission date */
  applicationSubmissionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Are the applicant global agreements completed */
  areGlobalAgreementsCompleted: Scalars['Boolean']['output'];
  /** Are the guarantor global agreements completed */
  areGuarantorGlobalAgreementsCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Are the applicant payment agreements completed */
  arePaymentAgreementsCompleted: Scalars['Boolean']['output'];
  /** Are the test drive agreements completed */
  areTestDriveAgreementsCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Are the test drive KYC completed */
  areTestDriveKYCCompleted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * has Apply New Journey Before
   * this flag is to indicate whether this application had been underwent apply new submission before
   */
  hasApplyNewSubmission?: Maybe<Scalars['Boolean']['output']>;
  /** does Applicant add Guarantor */
  hasGuarantor: Scalars['Boolean']['output'];
  /**
   * this is to synchronize the applicant agreements and test drive agreements
   * prefilling test drive agreements if existed in applicant agreements
   * checked whether is there any `false` or `non-checked` agreements in test drive agreements
   * if no show steps
   */
  hasTestDriveKYCandConsents?: Maybe<Scalars['Boolean']['output']>;
  /** Are the applicant's KYC completed */
  isApplicantKYCCompleted: Scalars['Boolean']['output'];
  /** Is the appointment received */
  isApplyNewForAppointmentReceived: Scalars['Boolean']['output'];
  /** Is the financing received */
  isApplyNewForFinancingReceived: Scalars['Boolean']['output'];
  /** Is the insurance received */
  isApplyNewForInsuranceReceived: Scalars['Boolean']['output'];
  /**
   * Is applying for finance from application details completed
   *
   * If it's null/empty, means it's never run in the first place
   */
  isApplyingForFinanceCompleted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Is applying for insurance from application details completed
   *
   * If it's null/empty, means it's never run in the first place
   */
  isApplyingForInsuranceCompleted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Is applying for reservation from application details completed
   *
   * If it's null/empty, means it's never run in the first place
   */
  isApplyingForReservationCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Appointment Completed */
  isAppointmentCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Is Corporate Customer */
  isCorporateCustomer: Scalars['Boolean']['output'];
  /** Is the payment deposit completed */
  isDepositCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Is the payment deposit skipped */
  isDepositSkipped?: Maybe<Scalars['Boolean']['output']>;
  /** Are the guarantor's KYC completed */
  isGuarantorCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Is the Guarantor signing completed */
  isGuarantorSigningCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Is Insurance applicant signing completed */
  isInsuranceApplicantSigningCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Is the application received */
  isReceived: Scalars['Boolean']['output'];
  /** Is the signing completed */
  isSigningCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Submitted To Bank Before */
  isSubmittedToBank: Scalars['Boolean']['output'];
  /** Is submitted to insurer */
  isSubmittedToInsurer?: Maybe<Scalars['Boolean']['output']>;
  /** Is test drive process signing completed */
  isTestDriveProcessSigningCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Is test drive process started */
  isTestDriveProcessStarted?: Maybe<Scalars['Boolean']['output']>;
};

export type StandardApplicationEntrypoint = Endpoint & {
  __typename: 'StandardApplicationEntrypoint';
  /** Application Module */
  applicationModule: StandardApplicationModule;
  /** Application Module ID */
  applicationModuleId: Scalars['ObjectID']['output'];
  /** Application Stage */
  applicationStage: ApplicationStage;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Pathname */
  pathname: Scalars['String']['output'];
};

export type StandardApplicationEntrypointSettings = {
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** Pathname */
  pathname: Scalars['String']['input'];
};

export type StandardApplicationFinanceProductPayload = {
  financeProductSuiteIds: Array<Scalars['ObjectID']['input']>;
  moduleId: Scalars['ObjectID']['input'];
};

export type StandardApplicationLink = {
  __typename: 'StandardApplicationLink';
  applicationJourney: ApplicationJourney;
  endpoint: Endpoint;
  router: Router;
};

export type StandardApplicationModule = Module & {
  __typename: 'StandardApplicationModule';
  /** Agreements module */
  agreementsModule: Module;
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['output'];
  /** Counter for applications */
  applicationCounter: CounterSettings;
  /** Counter for reservations */
  appointmentCounter: CounterSettings;
  /** Appointment Module */
  appointmentModule?: Maybe<Module>;
  /** Appointment Module ID */
  appointmentModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Determine when to show Bank in Share PDF */
  bankDisplayInSharePdf: BankDisplayInSharePdf;
  /** Determine when to show Bank in Calculator */
  bankDisplayPreference: DisplayPreference;
  /** Bank IDs */
  bankIds: Array<Scalars['ObjectID']['output']>;
  /** Bank module */
  bankModule?: Maybe<Module>;
  /** Bank module ID */
  bankModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Banks */
  banks: Array<Bank>;
  /** C@P Module ID */
  capModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: Maybe<Scalars['Boolean']['output']>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Customer module */
  customerModule: Module;
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['output'];
  /** Dealer Finance Products */
  dealerFinanceProducts: Array<DealerFinanceProducts>;
  /** Dealer Insurance Products */
  dealerInsuranceProducts: Array<DealerInsuranceProducts>;
  /** Price Disclaimer */
  dealerPriceDisclaimer?: Maybe<DealerPriceDisclaimer>;
  /** Dealer Vehicles */
  dealerVehicles: Array<DealerVehicles>;
  /** Deposit Amount */
  depositAmount?: Maybe<DepositAmount>;
  displayAppointmentDatepicker: Scalars['Boolean']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Flexible Discount */
  flexibleDiscount: FlexibleDiscount;
  /** Has Dealer Options */
  hasDealerOptions: Scalars['Boolean']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /**
   * Include dealer option for financing
   *
   * Only applicable if hasDealerOptions is true
   * When true, dealer option will be included in finance amount
   * When false, dealer option will be included as downpayment and not included in finance amount
   *
   * When hasDealerOptions is false, revert this value to true
   */
  includeDealerOptionsForFinancing: Scalars['Boolean']['output'];
  insuranceCounter: CounterSettings;
  insuranceModule?: Maybe<Module>;
  insuranceModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Determine when to show Insurer in Calculator */
  insurerDisplayPreference: DisplayPreference;
  /** Insurer IDs */
  insurerIds: Array<Scalars['ObjectID']['output']>;
  /** Insurers */
  insurers: Array<Insurer>;
  /** Is Financing Optional */
  isFinancingOptional: Scalars['Boolean']['output'];
  /** Is Insurance Optional */
  isInsuranceOptional: Scalars['Boolean']['output'];
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['output'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: Maybe<Scalars['Boolean']['output']>;
  isTradeInAmountVisible?: Maybe<Scalars['Boolean']['output']>;
  /** KYC presets */
  kycPresets: Array<KycPreset>;
  /** Defining the campaign ID for C@P lead submission */
  leadCampaignId?: Maybe<Scalars['String']['output']>;
  /** Counter for leads */
  leadCounter: CounterSettings;
  /** Defining the lead medium for C@P lead submission */
  leadMedium?: Maybe<EventMediumType>;
  /** Defining the lead origin for C@P lead submission */
  leadOrigin?: Maybe<EventLeadOriginType>;
  /** Market */
  market: ApplicationMarket;
  /** Market Type */
  marketType: ApplicationMarketType;
  /** MyInfo Setting */
  myInfoSetting?: Maybe<MyInfoSetting>;
  /** MyInfo Setting */
  myInfoSettingId?: Maybe<Scalars['ObjectID']['output']>;
  /** Payment Settings */
  paymentSettings?: Maybe<PaymentSetting>;
  /** Payment Settings ID */
  paymentSettingsId?: Maybe<Scalars['ObjectID']['output']>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Promo code module */
  promoCodeModule?: Maybe<Module>;
  /** Promo code module id */
  promoCodeModuleId?: Maybe<Scalars['ObjectID']['output']>;
  /** Counter for reservations */
  reservationCounter: CounterSettings;
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show Finance Calculator */
  showFinanceCalculator: Scalars['Boolean']['output'];
  /** Show From Value on Vehicle Details in Calculator */
  showFromValueOnVehicleDetails: Scalars['Boolean']['output'];
  /** Show Insurance Calculator */
  showInsuranceCalculator: Scalars['Boolean']['output'];
  /** Show Remote Flow Button in Login Access KYC page */
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['output'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['output'];
  /** Skip for Deposit in KYC page */
  skipForDeposit: Scalars['Boolean']['output'];
  /** Test Drive */
  testDrive: Scalars['Boolean']['output'];
  /** Trade In */
  tradeIn: Scalars['Boolean']['output'];
  /** Vehicle management module */
  vehicleModule: Module;
  /** Vehicle management module ID */
  vehicleModuleId: Scalars['ObjectID']['output'];
  /** Versioning */
  versioning: SimpleVersioning;
};

export type StandardApplicationModuleInitialSettings = {
  /** Agreements module ID */
  agreementsModuleId: Scalars['ObjectID']['input'];
  /** Counter for applications */
  applicationCounter: CounterPayload;
  /** Counter for appointment */
  appointmentCounter: CounterPayload;
  /** Appointment module ID */
  appointmentModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Determine when to show Bank in Share PDF */
  bankDisplayInSharePdf: BankDisplayInSharePdf;
  /** Determine when to show Bank in Calculator */
  bankDisplayPreference: DisplayPreference;
  /** Banks */
  bankIds: Array<Scalars['ObjectID']['input']>;
  /** Bank module ID */
  bankModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** C@P Module ID */
  capModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Customer module ID */
  customerModuleId: Scalars['ObjectID']['input'];
  /** Deposit Amount */
  depositAmount?: InputMaybe<DealershipDepositAmountInput>;
  displayAppointmentDatepicker: Scalars['Boolean']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Flexible Discount */
  flexibleDiscount: FlexibleDiscountInput;
  /** Has Dealer Options */
  hasDealerOptions: Scalars['Boolean']['input'];
  /**
   * Include dealer option for financing
   *
   * Only applicable if hasDealerOptions is true
   * When true, dealer option will be included in finance amount
   * When false, dealer option will be included as downpayment and not included in finance amount
   *
   * When hasDealerOptions is false, revert this value to true
   */
  includeDealerOptionsForFinancing: Scalars['Boolean']['input'];
  /** Counter for insurance */
  insuranceCounter: CounterPayload;
  /** insurance module ID */
  insuranceModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Determine when to show Insurer in Calculator */
  insurerDisplayPreference: DisplayPreference;
  /** Insurers */
  insurerIds: Array<Scalars['ObjectID']['input']>;
  /** Is Financing Optional */
  isFinancingOptional: Scalars['Boolean']['input'];
  /** Is Insurance Optional */
  isInsuranceOptional: Scalars['Boolean']['input'];
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['input'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: InputMaybe<Scalars['Boolean']['input']>;
  isTradeInAmountVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defining the campaign ID for C@P lead submission */
  leadCampaignId?: InputMaybe<Scalars['String']['input']>;
  /** Counter for leads */
  leadCounter: CounterPayload;
  /** Defining the lead medium for C@P lead submission */
  leadMedium?: InputMaybe<EventMediumType>;
  /** Defining the lead origin for C@P lead submission */
  leadOrigin?: InputMaybe<EventLeadOriginType>;
  /** Market */
  market: ApplicationMarket;
  /** Market Type Input */
  marketType?: InputMaybe<ApplicationModuleMarketTypeInput>;
  /** MyInfo Setting ID */
  myInfoSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Payment settings ID */
  paymentSettingsId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Price Disclaimer */
  priceDisclaimer?: InputMaybe<DealerPriceDisclaimerInput>;
  /** Promo code module id */
  promoCodeModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Counter for reservations */
  reservationCounter: CounterPayload;
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show Finance Calculator */
  showFinanceCalculator: Scalars['Boolean']['input'];
  /** Show From Value on Vehicle Details in Calculator */
  showFromValueOnVehicleDetails: Scalars['Boolean']['input'];
  /** Show Insurance Calculator */
  showInsuranceCalculator: Scalars['Boolean']['input'];
  /** Show Remote Flow Button in Login Access KYC page */
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['input'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['input'];
  /** Skip for Deposit in KYC page */
  skipForDeposit: Scalars['Boolean']['input'];
  /** Test Drive */
  testDrive: Scalars['Boolean']['input'];
  /** Trade In */
  tradeIn: Scalars['Boolean']['input'];
  /** Vehicle management module ID */
  vehicleModuleId: Scalars['ObjectID']['input'];
};

export type StandardApplicationModuleUpdateSettings = {
  /** Appointment module ID */
  appointmentModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Determine when to show Bank in Share PDF */
  bankDisplayInSharePdf: BankDisplayInSharePdf;
  /** Determine when to show Bank in Calculator */
  bankDisplayPreference: DisplayPreference;
  /** Banks */
  bankIds: Array<Scalars['ObjectID']['input']>;
  /** Bank module id */
  bankModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** C@P Module ID */
  capModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Able to prequalify leads for C@P Module integration */
  capPrequalification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deposit Amount */
  depositAmount?: InputMaybe<DealershipDepositAmountInput>;
  /** Display appointment datepicker */
  displayAppointmentDatepicker: Scalars['Boolean']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Flexible Discount */
  flexibleDiscount: FlexibleDiscountInput;
  /** Has Dealer Options */
  hasDealerOptions: Scalars['Boolean']['input'];
  /**
   * Include dealer option for financing
   *
   * Only applicable if hasDealerOptions is true
   * When true, dealer option will be included in finance amount
   * When false, dealer option will be included as downpayment and not included in finance amount
   *
   * When hasDealerOptions is false, revert this value to true
   */
  includeDealerOptionsForFinancing: Scalars['Boolean']['input'];
  /** Insurance Module ID */
  insuranceModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Determine when to show Insurer in Calculator */
  insurerDisplayPreference: DisplayPreference;
  /** Insurers */
  insurerIds: Array<Scalars['ObjectID']['input']>;
  /** Is Financing Optional */
  isFinancingOptional: Scalars['Boolean']['input'];
  /** Is Insurance Optional */
  isInsuranceOptional: Scalars['Boolean']['input'];
  /** OCR enabled for extracting customer information */
  isOcrEnabled: Scalars['Boolean']['input'];
  /** Able to optionally search customer after C@P Module integration */
  isSearchCapCustomerOptional?: InputMaybe<Scalars['Boolean']['input']>;
  isTradeInAmountVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defining the campaign ID for C@P lead submission */
  leadCampaignId?: InputMaybe<Scalars['String']['input']>;
  /** Defining the lead medium for C@P lead submission */
  leadMedium?: InputMaybe<EventMediumType>;
  /** Defining the lead origin for C@P lead submission */
  leadOrigin?: InputMaybe<EventLeadOriginType>;
  /** Market */
  market: ApplicationMarket;
  /** Market Type Input */
  marketType?: InputMaybe<ApplicationModuleMarketTypeInput>;
  /** MyInfo Setting ID */
  myInfoSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Payment Setting ID */
  paymentSettingsId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Price Disclaimer */
  priceDisclaimer?: InputMaybe<DealerPriceDisclaimerInput>;
  /** Promo code module id */
  promoCodeModuleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Scenario */
  scenarios: Array<ApplicationScenario>;
  /** Show Finance Calculator */
  showFinanceCalculator: Scalars['Boolean']['input'];
  /** Show From Value on Vehicle Details in Calculator */
  showFromValueOnVehicleDetails: Scalars['Boolean']['input'];
  /** Show Insurance Calculator */
  showInsuranceCalculator: Scalars['Boolean']['input'];
  /** Show Remote Flow Button in Login Access KYC page */
  showRemoteFlowButtonInKYCPage: Scalars['Boolean']['input'];
  /** Show Reset KYC Button in KYC page */
  showResetKYCButton: Scalars['Boolean']['input'];
  /** Skip for Deposit in KYC page */
  skipForDeposit: Scalars['Boolean']['input'];
  /** Test Drive */
  testDrive: Scalars['Boolean']['input'];
  /** Trade In */
  tradeIn: Scalars['Boolean']['input'];
};

export type StandardApplicationPublicAccessEntrypoint = Endpoint & {
  __typename: 'StandardApplicationPublicAccessEntrypoint';
  /** Application Module */
  applicationModule: StandardApplicationModule;
  /** Application Module ID */
  applicationModuleId: Scalars['ObjectID']['output'];
  /** Application Stage */
  applicationStage: ApplicationStage;
  /** Dealer Ids */
  dealerIds: Array<Scalars['ObjectID']['output']>;
  /** Dealers */
  dealers: Array<Dealer>;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Pathname */
  pathname: Scalars['String']['output'];
};

export type StandardApplicationPublicAccessEntrypointSettings = {
  /** Dealer Ids */
  dealerIds: Array<Scalars['ObjectID']['input']>;
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** Pathname */
  pathname: Scalars['String']['input'];
};

export type StandardApplicationVehiclePayload = {
  moduleId: Scalars['ObjectID']['input'];
  vehicleSuiteIds: Array<Scalars['ObjectID']['input']>;
};

export type StandardEquipmentCategory = {
  __typename: 'StandardEquipmentCategory';
  items: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type StatisticCounterResult = {
  __typename: 'StatisticCounterResult';
  currentMonth?: Maybe<StatisticCounterResultMonth>;
  lastMonth?: Maybe<StatisticCounterResultMonth>;
};

export type StatisticCounterResultMonth = {
  __typename: 'StatisticCounterResultMonth';
  approved: Scalars['Int']['output'];
  customerInfoTurnAround: Scalars['Float']['output'];
  submitted: Scalars['Int']['output'];
  submittedTurnAround: Scalars['Float']['output'];
};

export type StatisticFilterPayload = {
  /** Filter for companyId */
  companyId: Scalars['ObjectID']['input'];
  /** Filter for multiple dealerIds */
  dealerIds: Array<Scalars['ObjectID']['input']>;
  /** Filter for specific roles */
  moduleRole?: InputMaybe<ModuleRole>;
  /** Filter by specific application stage */
  stage?: InputMaybe<ApplicationStage>;
};

export type StatisticInstantApprovalResult = {
  __typename: 'StatisticInstantApprovalResult';
  currentMonth?: Maybe<StatisticInstantApprovalResultMonth>;
  lastMonth?: Maybe<StatisticInstantApprovalResultMonth>;
};

export type StatisticInstantApprovalResultMonth = {
  __typename: 'StatisticInstantApprovalResultMonth';
  dbsInstantApprovalCount: Scalars['Int']['output'];
  dbsInstantApprovalRate: Scalars['Float']['output'];
  dbsTotalApplicationCount: Scalars['Int']['output'];
};

export type StatisticMonthlyResult = {
  __typename: 'StatisticMonthlyResult';
  currentMonth: Array<StatisticMonthlyResultItem>;
  lastMonth: Array<StatisticMonthlyResultItem>;
};

export type StatisticMonthlyResultItem = {
  __typename: 'StatisticMonthlyResultItem';
  alias?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StockBlockingPeriod = {
  __typename: 'StockBlockingPeriod';
  comment: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type StockBlockingPeriodInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StockFilteringRule = {
  /** Filter by inventory kind */
  kind?: InputMaybe<InventoryKind>;
  /** Filter by model names */
  modelNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by module ID */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Production mode */
  productionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by range vehicle price */
  rangeVehiclePrices?: InputMaybe<Array<RangeAmountPayload>>;
  /** Filter by submodel names */
  submodelNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StockInventory = {
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Inventory */
  inventory: Inventory;
  /** Inventory Id */
  inventoryId: Scalars['ObjectID']['output'];
  /** Kind */
  kind: StockInventoryKind;
};

export enum StockInventoryKind {
  ConfiguratorStock = 'ConfiguratorStock',
  MobilityStock = 'MobilityStock'
}

export type StockInventoryUpdationSettings = {
  applicationId?: InputMaybe<Scalars['ObjectID']['input']>;
  blockPeriod?: InputMaybe<Array<StockBlockingPeriodInput>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mileage?: InputMaybe<Scalars['Float']['input']>;
  period?: InputMaybe<PeriodPayload>;
  price?: InputMaybe<Scalars['Int']['input']>;
  reservationExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  reservationStatus?: InputMaybe<ReservationStockStatus>;
  vin?: InputMaybe<Scalars['String']['input']>;
};

export enum StockSortingField {
  /** Sort by model order then variant order */
  ModelOrderAndVariantOrder = 'ModelOrderAndVariantOrder',
  /** Sort by variant order */
  VariantOrder = 'VariantOrder'
}

export type StockSortingRule = {
  /** Field on which apply the sorting */
  field: StockSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type StringDescription = {
  __typename: 'StringDescription';
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type StringDescriptionPayload = {
  description?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type SubmitAppointmentBookingTimeSlot = {
  bookingLimit: Scalars['Int']['input'];
  slot?: InputMaybe<Scalars['DateTime']['input']>;
  useCurrentDateTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmodelFilter = {
  __typename: 'SubmodelFilter';
  name: TranslatedString;
  parentModel: LocalModel;
  parentModelId: Scalars['ObjectID']['output'];
};

export type Subscription = {
  __typename: 'Subscription';
  listenApplicationMessages: ApplicationMessage;
  listenSystemMessages: SystemMessage;
};


export type SubscriptionListenApplicationMessagesArgs = {
  sessionId: Scalars['ObjectID']['input'];
};


export type SubscriptionListenSystemMessagesArgs = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type SystemBank = Bank & {
  __typename: 'SystemBank';
  allowVariantCodeMapping: Scalars['Boolean']['output'];
  availableFinanceProductTypes: Array<FinanceProductType>;
  color: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  estFee: Scalars['Float']['output'];
  financeProducts: Array<FinanceProduct>;
  financingDisclaimer?: Maybe<DealerDisclaimersConfigurator>;
  font?: Maybe<UploadedFile>;
  hasUploadDocuments: Scalars['Boolean']['output'];
  hasVSOUpload: Scalars['Boolean']['output'];
  id: Scalars['ObjectID']['output'];
  integration: BankIntegration;
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  kind: BankKind;
  legalName: TranslatedString;
  logo?: Maybe<UploadedFileWithPreview>;
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  order: Scalars['Int']['output'];
  permissions: Array<Maybe<Scalars['String']['output']>>;
  reSubmissionApprovalModule?: Maybe<Module>;
  reSubmissionApprovalModuleId?: Maybe<Scalars['ObjectID']['output']>;
  remoteFlowAcknowledgmentInfo: Scalars['String']['output'];
  sendEmailToCustomer: Scalars['Boolean']['output'];
  sendPDFToCustomer: Scalars['Boolean']['output'];
  showCommentsField?: Maybe<Scalars['Boolean']['output']>;
  showMarginOfFinance: Scalars['Boolean']['output'];
  submissionApprovalModule?: Maybe<Module>;
  submissionApprovalModuleId?: Maybe<Scalars['ObjectID']['output']>;
  versioning: SimpleVersioning;
};

export type SystemEmailSettings = EmailSettings & {
  __typename: 'SystemEmailSettings';
  /** Email sender */
  from: Scalars['String']['output'];
  /** Email provider type */
  provider: EmailProvider;
};

export type SystemMessage = MaintenanceUpdate | MessageNotice | UserSessionRevoked;

export type SystemSmsSettings = SmsSettings & {
  __typename: 'SystemSmsSettings';
  /** SMS provider type */
  provider: SmsProvider;
};

export type TaxLossSettingPayload = {
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
};

export type TaxLossSettings = {
  __typename: 'TaxLossSettings';
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
};

export type TechnicalDataCategory = {
  __typename: 'TechnicalDataCategory';
  items: Array<TechnicalDataItem>;
  name: Scalars['String']['output'];
};

export type TechnicalDataItem = {
  __typename: 'TechnicalDataItem';
  disclaimer?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Template = {
  __typename: 'Template';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Template identifier */
  id: Scalars['String']['output'];
};

export enum TemplateType {
  AfcTemplate = 'AfcTemplate',
  BmwTemplate = 'BmwTemplate'
}

export type TermSettings = {
  default: Scalars['Int']['output'];
  isEditable: Scalars['Boolean']['output'];
  isViewable: Scalars['Boolean']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  step: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type TermSettingsPayload = {
  default: Scalars['Int']['input'];
  interestOnly?: InputMaybe<Scalars['Int']['input']>;
  isEditable: Scalars['Boolean']['input'];
  isViewable: Scalars['Boolean']['input'];
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
  step: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type TestDriveProcessRedirectionLink = {
  __typename: 'TestDriveProcessRedirectionLink';
  applicationJourney: ApplicationJourney;
};

export type TextApplicationAgreement = ApplicationAgreement & {
  __typename: 'TextApplicationAgreement';
  /** Conditions */
  conditions?: Maybe<Array<Condition>>;
  /** Data field */
  dataField: DataField;
  /** Description */
  description?: Maybe<TranslatedString>;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is agreed by the customer */
  isAgreed: Scalars['Boolean']['output'];
  /** Order Number */
  orderNumber: Scalars['Int']['output'];
  /** Purpose */
  purpose: Array<ConsentsAndDeclarationsPurpose>;
  /** Title */
  title?: Maybe<TranslatedString>;
  /** C&D type */
  type: ConsentsAndDeclarationsType;
};

export type TextCarouselWebPageBlock = WebPageBlock & {
  __typename: 'TextCarouselWebPageBlock';
  descriptions?: Maybe<Array<TranslatedString>>;
  id: Scalars['ObjectID']['output'];
  title?: Maybe<TranslatedString>;
  type: WebPageBlockType;
};

export type TextCarouselWebPageBlockInput = {
  descriptions?: InputMaybe<Array<TranslatedStringInput>>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  title?: InputMaybe<TranslatedStringInput>;
  type: WebPageBlockType;
};

export type TextConsentsAndDeclarations = ConsentsAndDeclarations & {
  __typename: 'TextConsentsAndDeclarations';
  /** Conditions */
  conditions?: Maybe<Array<Condition>>;
  /** Data field */
  dataField: DataField;
  /** Description */
  description?: Maybe<TranslatedString>;
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** Feature Purpose */
  featurePurpose: ConsentFeaturePurpose;
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Is active */
  isActive: Scalars['Boolean']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Module */
  module: Module;
  /** Module ID */
  moduleId: Scalars['ObjectID']['output'];
  /** Order Number */
  orderNumber: Scalars['Int']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Purpose */
  purpose: Array<ConsentsAndDeclarationsPurpose>;
  /** Title */
  title?: Maybe<TranslatedString>;
  /** C&D type */
  type: ConsentsAndDeclarationsType;
  /** Versioning */
  versioning: AdvancedVersioning;
};

export type TextConsentsAndDeclarationsSettings = {
  /** Data field */
  dataField: DataField;
  /** Description */
  description?: InputMaybe<TranslatedStringInput>;
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** Is active */
  isActive: Scalars['Boolean']['input'];
  /** Order Number */
  orderNumber: Scalars['Int']['input'];
  /** Purpose */
  purpose: Array<ConsentsAndDeclarationsPurpose>;
  /** Title */
  title?: InputMaybe<TranslatedStringInput>;
};

export type TextImageWebPageBlock = WebPageBlock & {
  __typename: 'TextImageWebPageBlock';
  backgroundType: WebPageBlockBackground;
  button?: Maybe<WebPageButton>;
  description?: Maybe<TranslatedString>;
  id: Scalars['ObjectID']['output'];
  image?: Maybe<UploadedFileWithPreview>;
  imagePosition: WebPageBlockPosition;
  title?: Maybe<TranslatedString>;
  type: WebPageBlockType;
};

export type TextImageWebPageBlockInput = {
  backgroundType: WebPageBlockBackground;
  button?: InputMaybe<WebPageButtonInput>;
  description?: InputMaybe<TranslatedStringInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  imagePosition: WebPageBlockPosition;
  title?: InputMaybe<TranslatedStringInput>;
  type: WebPageBlockType;
};

export type TextImageWebPageButton = {
  __typename: 'TextImageWebPageButton';
  isActive?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<TranslatedString>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum Timeframe {
  CurrentMonth = 'CurrentMonth',
  Last3Months = 'Last3Months',
  Last6Months = 'Last6Months',
  Last12Months = 'Last12Months',
  LastMonth = 'LastMonth'
}

export type TradeIn = {
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** TradeIn Transaction No. */
  identifier?: Maybe<Scalars['String']['output']>;
  /** TradeIn Module */
  module: Module;
  /** TradeIn Module Id */
  moduleId: Scalars['ObjectID']['output'];
  status: TradeInStatus;
  versioning: SimpleVersioning;
};

export type TradeInCondition = {
  __typename: 'TradeInCondition';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type TradeInFilteringRule = {
  /** Filter by Created Date Range */
  createdDateRange?: InputMaybe<PeriodPayload>;
  /** Filter by identifier */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Filter by vehicle manufacturing year */
  manufacturingYear?: InputMaybe<Scalars['String']['input']>;
  /** Filter by application module ID */
  moduleIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by selected dealer */
  selectedDealer?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Status */
  status?: InputMaybe<Array<TradeInStatus>>;
  /** Filter by vehicle make */
  vehicleMake?: InputMaybe<Scalars['String']['input']>;
  /** Filter by vehicle model */
  vehicleModel?: InputMaybe<Scalars['String']['input']>;
  /** Filter by vehicle No. */
  vehicleNo?: InputMaybe<Scalars['String']['input']>;
};

export type TradeInListFilter = {
  __typename: 'TradeInListFilter';
  statuses: Array<TradeInStatus>;
};

export type TradeInModule = Module & {
  __typename: 'TradeInModule';
  /** Authorization */
  authorization?: Maybe<Authorization>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display Name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Trade In Setting */
  setting: TradeInSetting;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type TradeInModuleSettings = {
  /** Display Name */
  displayName: Scalars['String']['input'];
  /** Trade In Setting */
  setting: TradeInSettingInput;
};

export type TradeInSetting = {
  __typename: 'TradeInSetting';
  /** Trade-in App Base url */
  baseUrl: Scalars['String']['output'];
  /** Trade-in App Client ID */
  clientId: Scalars['String']['output'];
  /** Trade-in App Client Secret */
  clientSecret: Scalars['String']['output'];
  /** ID */
  id: Scalars['ObjectID']['output'];
  /** Trade In Module ID */
  moduleId: Scalars['ObjectID']['output'];
};

export type TradeInSettingInput = {
  /** Base url */
  baseUrl: Scalars['String']['input'];
  /** Client ID */
  clientId: Scalars['String']['input'];
  /** Client Secret */
  clientSecret: Scalars['String']['input'];
};

export enum TradeInSortingField {
  ApplicationDate = 'ApplicationDate',
  Identifier = 'Identifier',
  ManufacturingYear = 'ManufacturingYear',
  OfferPrice = 'OfferPrice',
  SelectedDealer = 'SelectedDealer',
  Status = 'Status',
  VehicleMake = 'VehicleMake',
  VehicleModel = 'VehicleModel',
  VehicleNo = 'VehicleNo'
}

export type TradeInSortingRule = {
  field: TradeInSortingField;
  order: SortingOrder;
};

export enum TradeInStatus {
  Accepted = 'Accepted',
  BidClosed = 'BidClosed',
  Drafted = 'Drafted',
  Rejected = 'Rejected'
}

export type TradeInVehicle = {
  __typename: 'TradeInVehicle';
  coeCategory?: Maybe<Scalars['String']['output']>;
  coeExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  engineCapacity?: Maybe<Scalars['Int']['output']>;
  firstRegistrationDate?: Maybe<Scalars['DateTime']['output']>;
  isSelected: Scalars['Boolean']['output'];
  make?: Maybe<Scalars['String']['output']>;
  mileage?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  noOfTransfers?: Maybe<Scalars['Int']['output']>;
  openMarketValue?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  primaryColour?: Maybe<Scalars['String']['output']>;
  propellant?: Maybe<Scalars['String']['output']>;
  quotaPremium?: Maybe<Scalars['Float']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  roadTaxExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  scheme?: Maybe<Scalars['String']['output']>;
  secondaryColour?: Maybe<Scalars['String']['output']>;
  source: LocalCustomerFieldSource;
  status?: Maybe<Scalars['String']['output']>;
  yearOfManufacture?: Maybe<Scalars['Int']['output']>;
};

export type TradeInVehiclePayload = {
  coeCategory?: InputMaybe<Scalars['String']['input']>;
  coeExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  engineCapacity?: InputMaybe<Scalars['Int']['input']>;
  firstRegistrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  isSelected: Scalars['Boolean']['input'];
  make?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  noOfTransfers?: InputMaybe<Scalars['Int']['input']>;
  openMarketValue?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  primaryColour?: InputMaybe<Scalars['String']['input']>;
  propellant?: InputMaybe<Scalars['String']['input']>;
  quotaPremium?: InputMaybe<Scalars['Float']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  roadTaxExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheme?: InputMaybe<Scalars['String']['input']>;
  secondaryColour?: InputMaybe<Scalars['String']['input']>;
  source: LocalCustomerFieldSource;
  status?: InputMaybe<Scalars['String']['input']>;
  yearOfManufacture?: InputMaybe<Scalars['Int']['input']>;
};

export type TranslatedString = {
  __typename: 'TranslatedString';
  /** Default Value */
  defaultValue: Scalars['String']['output'];
  /** Overrides */
  overrides: Array<TranslatedStringOverrides>;
};

export type TranslatedStringInput = {
  /** Default Value */
  defaultValue: Scalars['String']['input'];
  /** Overrides */
  overrides: Array<TranslatedStringOverridesInput>;
};

export type TranslatedStringOverrides = {
  __typename: 'TranslatedStringOverrides';
  /** Language pack ID */
  languagePackId: Scalars['ObjectID']['output'];
  /** Value */
  value: Scalars['String']['output'];
};

export type TranslatedStringOverridesInput = {
  /** Language pack ID */
  languagePackId: Scalars['ObjectID']['input'];
  /** Value */
  value: Scalars['String']['input'];
};

export enum TransmissionKind {
  Auto = 'Auto',
  Manual = 'Manual'
}

export enum TransportProtocolType {
  /** With Email */
  Email = 'EMAIL',
  /** With SMS */
  Sms = 'SMS'
}

export type TrimBlock = Block & {
  __typename: 'TrimBlock';
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Section title */
  sectionTitle: TranslatedString;
  /** Trim Settings */
  trimSettings: Array<ColorAndTrimSettings>;
  type: BlockType;
};

export type TrimBlockInput = {
  isActive: Scalars['Boolean']['input'];
  sectionTitle: TranslatedStringInput;
  trimSettings: Array<ColorAndTrimSettingsInput>;
};

export enum TtbPaymentFlag3ds {
  /** No, will not use 3DS in prepayment API */
  No = 'No',
  /** Yes, will use 3DS in prepayment API */
  Yes = 'Yes'
}

export type TtbPaymentModule = Module & {
  __typename: 'TtbPaymentModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Payment settings */
  paymentSettings: Array<TtbPaymentSetting>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type TtbPaymentModuleSettings = {
  /** Display name */
  displayName: Scalars['String']['input'];
};

export type TtbPaymentRedirectionLink = {
  __typename: 'TtbPaymentRedirectionLink';
  path: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type TtbPaymentSetting = PaymentSetting & {
  __typename: 'TtbPaymentSetting';
  /** Amount (part of PaymentSetting interface) */
  amount: Scalars['Float']['output'];
  /** API Key, use in token payload */
  apiKey: Scalars['String']['output'];
  /**
   * Audience, to put inside token payload
   * eg: 'PacoAudience'
   */
  audience: Scalars['String']['output'];
  /** Currency (part of PaymentSetting interface) */
  currency: Scalars['String']['output'];
  /** Display name (part of PaymentSetting interface) */
  displayName: Scalars['String']['output'];
  /** ARC encryption private key, for decryption */
  encryptionPrivateKey: Scalars['String']['output'];
  /** TTB encryption public key, for encryption */
  encryptionPublicKey: Scalars['String']['output'];
  /**
   * Flag 3DS, during prepayment whether it's using 3DS or not
   * available value: 'Y', 'N'
   */
  flag3ds: TtbPaymentFlag3ds;
  /** UID (part of PaymentSetting interface) */
  id: Scalars['ObjectID']['output'];
  /** JWE key id (KID) header */
  kid: Scalars['String']['output'];
  /** Office ID, use in prepayment API */
  officeId: Scalars['String']['output'];
  /** Payment Endpoint */
  paymentEndpoint: Scalars['String']['output'];
  /** Payment module ID (part of PaymentSetting interface) */
  paymentModuleId: Scalars['ObjectID']['output'];
  /** ARC signing private key */
  signingPrivateKey: Scalars['String']['output'];
  /** TTB signing public key, for verification */
  signingPublicKey: Scalars['String']['output'];
};

export type TtbPaymentSettingsInput = {
  /** Amount */
  amount: Scalars['Float']['input'];
  /** API Key, use in token payload */
  apiKey: Scalars['String']['input'];
  /**
   * Audience, to put inside token payload
   * eg: 'PacoAudience'
   */
  audience: Scalars['String']['input'];
  /** Currency */
  currency: Scalars['String']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** ARC encryption private key, for decryption */
  encryptionPrivateKey: Scalars['String']['input'];
  /** TTB encryption public key, for encryption */
  encryptionPublicKey: Scalars['String']['input'];
  /**
   * Flag 3DS, during prepayment whether it's using 3DS or not
   * available value: 'Y', 'N'
   */
  flag3ds: TtbPaymentFlag3ds;
  /** JWE key id (KID) header */
  kid: Scalars['String']['input'];
  /** Office ID, use in prepayment API */
  officeId: Scalars['String']['input'];
  /** Payment Endpoint */
  paymentEndpoint: Scalars['String']['input'];
  /** ARC signing private key */
  signingPrivateKey: Scalars['String']['input'];
  /** TTB signing public key, for verification */
  signingPublicKey: Scalars['String']['input'];
};

export type TtbPaymentUpdateSettingsInput = {
  /** Amount */
  amount: Scalars['Float']['input'];
  /** API Key, use in token payload */
  apiKey: Scalars['String']['input'];
  /**
   * Audience, to put inside token payload
   * eg: 'PacoAudience'
   */
  audience: Scalars['String']['input'];
  /** Currency */
  currency: Scalars['String']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** ARC encryption private key, for decryption */
  encryptionPrivateKey?: InputMaybe<Scalars['String']['input']>;
  /** TTB encryption public key, for encryption */
  encryptionPublicKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * Flag 3DS, during prepayment whether it's using 3DS or not
   * available value: 'Y', 'N'
   */
  flag3ds: TtbPaymentFlag3ds;
  /** JWE key id (KID) header */
  kid: Scalars['String']['input'];
  /** Office ID, use in prepayment API */
  officeId: Scalars['String']['input'];
  /** Payment Endpoint */
  paymentEndpoint: Scalars['String']['input'];
  /** ARC signing private key */
  signingPrivateKey?: InputMaybe<Scalars['String']['input']>;
  /** TTB signing public key, for verification */
  signingPublicKey?: InputMaybe<Scalars['String']['input']>;
};

export type UaeIdentityPayload = {
  drivingLicenseExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  drivingLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  emiratesIdExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  emiratesIdNumber?: InputMaybe<Scalars['String']['input']>;
  passportExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  supportingDocuments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  uaeResidenceSince?: InputMaybe<Scalars['DateTime']['input']>;
  uaeVisaExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  uaeVisaIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  uaeVisaNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UaeIdentitySet = {
  __typename: 'UAEIdentitySet';
  /** Driving License Expiry Date */
  drivingLicenseExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Driving license number */
  drivingLicenseNumber?: Maybe<Scalars['String']['output']>;
  /** Emirates ID Expiry Date */
  emiratesIdExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Emirates ID number */
  emiratesIdNumber?: Maybe<Scalars['String']['output']>;
  /** Passport expiry date */
  passportExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Passport number */
  passportNumber?: Maybe<Scalars['String']['output']>;
  /** UAE Residence since */
  uaeResidenceSince?: Maybe<Scalars['DateTime']['output']>;
  /** UAE Visa Expiry Date */
  uaeVisaExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  /** UAE Visa Issue date */
  uaeVisaIssueDate?: Maybe<Scalars['DateTime']['output']>;
  /** UAE Visa number */
  uaeVisaNumber?: Maybe<Scalars['String']['output']>;
};

export type UobNewCarFinance = SdmFinancing & {
  __typename: 'UOBNewCarFinance';
  bank: Scalars['String']['output'];
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  type: FinanceType;
};

export type UobUsedCarFinance = SdmFinancing & {
  __typename: 'UOBUsedCarFinance';
  arf: Scalars['String']['output'];
  bank: Scalars['String']['output'];
  coe: Scalars['Float']['output'];
  loanAmount: Scalars['Float']['output'];
  omv: Scalars['Float']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  type: FinanceType;
  vehicleOriginalRegistrationDate: Scalars['String']['output'];
  vehicleRegistrationNumber: Scalars['String']['output'];
};

export type UnavailableListing = {
  __typename: 'UnavailableListing';
  additionalCustomerInformationAvailable: Scalars['Boolean']['output'];
  availableFrom?: Maybe<FormattedDate>;
  description?: Maybe<LocalizedString>;
  externalReference?: Maybe<ExternalReference>;
  financing?: Maybe<Financing>;
  firstVisibleAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  location?: Maybe<Location>;
  marketplaceId: Scalars['String']['output'];
  onlineOrderableState: OnlineOrderableState;
  price: Price;
  salesIncentives: Array<SalesIncentive>;
  seller: Seller;
  state: Scalars['String']['output'];
  stockNumber: Scalars['String']['output'];
  subtitle: LocalizedString;
  title: LocalizedString;
  updatedAt: Scalars['DateTime']['output'];
  vehicle: PorscheFinderVehicle;
  warranty?: Maybe<Warranty>;
};

export type UnladenWeight = {
  __typename: 'UnladenWeight';
  kilogramm: NumberUnit;
  pound: NumberUnit;
};

export type UobBankIntegration = BankIntegration & {
  __typename: 'UobBankIntegration';
  allowedIps: Scalars['String']['output'];
  apiKey: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  dealerCode?: Maybe<Scalars['String']['output']>;
  encryptionPrivateKey: Scalars['String']['output'];
  encryptionPublicCert: Scalars['String']['output'];
  host: Scalars['String']['output'];
  provider: BankIntegrationProvider;
  signaturePrivateKey: Scalars['String']['output'];
  sslPrivateKey: Scalars['String']['output'];
  sslPublicCert: Scalars['String']['output'];
};

export type UobBankIntegrationSettings = {
  allowedIps: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  applicationId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  dealerCode?: InputMaybe<Scalars['String']['input']>;
  encryptionPrivateKey: Scalars['String']['input'];
  encryptionPublicCert: Scalars['String']['input'];
  host: Scalars['String']['input'];
  signaturePrivateKey: Scalars['String']['input'];
  sslPrivateKey: Scalars['String']['input'];
  sslPublicCert: Scalars['String']['input'];
};

export type UpdateApplicationJourneyFinancingSettings = {
  affinAutoFinanceCentre?: InputMaybe<AffinAutoFinanceCentre>;
};

export type UpdateEmailResponse = {
  __typename: 'UpdateEmailResponse';
  /** Token */
  token: Scalars['String']['output'];
  /** Verified status */
  verified: Scalars['Boolean']['output'];
};

export type UpdateGiftVoucherSettings = {
  giftCode: Scalars['String']['input'];
  gifteeId: Scalars['ObjectID']['input'];
};

export type UpdateWebsiteModulePayload = {
  address?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  /** Live chat settings */
  liveChatSettingId?: InputMaybe<Scalars['ObjectID']['input']>;
  options: WebsiteModuleOptionsPayload;
  phone: PhonePayload;
};

export type UpdatedConfigurationSettings = {
  testDrive: Scalars['Boolean']['input'];
  tradeIn: Scalars['Boolean']['input'];
};

export type UpdatedMobilityApplication = {
  __typename: 'UpdatedMobilityApplication';
  /** Updated application */
  application: Application;
  /**
   * Redirection Link for amendment
   *
   * If there is kyc/consent bound to location change
   */
  redirectionLink?: Maybe<Scalars['String']['output']>;
};

export type UploadApplicationDocumentResult = {
  __typename: 'UploadApplicationDocumentResult';
  application: Application;
  uploadedFile: UploadedFile;
};

export type UploadFileInterface = {
  /** E-Tag */
  etag: Scalars['String']['output'];
  /** Original filename */
  filename: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Filesize */
  size: Scalars['Int']['output'];
  /** Upload date */
  uploadedAt: Scalars['DateTime']['output'];
  /**
   * Signed URL
   *
   * Private image will return a signed URL with a 1H validity
   */
  url?: Maybe<Scalars['String']['output']>;
};

export type UploadGiftVoucherDocumentResult = {
  __typename: 'UploadGiftVoucherDocumentResult';
  giftVoucher: GiftVoucher;
  uploadedFile: UploadedFile;
};

export type UploadedFile = UploadFileInterface & {
  __typename: 'UploadedFile';
  /** E-Tag */
  etag: Scalars['String']['output'];
  /** Original filename */
  filename: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Filesize */
  size: Scalars['Int']['output'];
  /** Upload date */
  uploadedAt: Scalars['DateTime']['output'];
  /**
   * Signed URL
   *
   * Private image will return a signed URL with a 1H validity
   */
  url?: Maybe<Scalars['String']['output']>;
};

export type UploadedFileWithPreview = UploadFileInterface & {
  __typename: 'UploadedFileWithPreview';
  /** E-Tag */
  etag: Scalars['String']['output'];
  /** Original filename */
  filename: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Preview image */
  preview?: Maybe<UploadedFile>;
  /** Filesize */
  size: Scalars['Int']['output'];
  /** Upload date */
  uploadedAt: Scalars['DateTime']['output'];
  /**
   * Signed URL
   *
   * Private image will return a signed URL with a 1H validity
   */
  url?: Maybe<Scalars['String']['output']>;
};

export type UploadedVariantAsset = {
  __typename: 'UploadedVariantAsset';
  /** Uploaded Variant Asset File */
  uploadedFile?: Maybe<UploadedFile>;
  /** Updated Variant ID */
  variantId?: Maybe<Scalars['ObjectID']['output']>;
};

export type UpsertUserPayload = {
  /** Alias for the user */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Public displayed on interfaces */
  displayName: Scalars['String']['input'];
  /** Email */
  email: Scalars['String']['input'];
  /** Mobile for the user */
  mobile: PhonePayload;
};

export type User = {
  __typename: 'User';
  /** Alias for the user */
  alias?: Maybe<Scalars['String']['output']>;
  /**
   * Companies that user has access to
   *
   * Passing companyId will only get the specific company
   *
   * Only populated when logged in user is same as this user or have company action manage users
   */
  availableCompanies: Array<Company>;
  /** Public displayed on interfaces */
  displayName: Scalars['String']['output'];
  /** Email address for the user */
  email: Scalars['String']['output'];
  /** User object ID */
  id: Scalars['ObjectID']['output'];
  /** Active Status */
  isActive: Scalars['Boolean']['output'];
  /** Is the authenticator enabled for this account */
  isAuthenticatorEnabled: Scalars['Boolean']['output'];
  /** Is the password expired for this account */
  isPasswordExpired: Scalars['Boolean']['output'];
  /** Last signed in */
  lastSignedIn?: Maybe<Scalars['DateTime']['output']>;
  /** Mobile for the user */
  mobile: Phone;
  /** Password expiration date */
  passwordExpiresAt: Scalars['DateTime']['output'];
  /** Permissions attached to the current user with role origins */
  permissionWithOrigins: Array<PermissionWithOrigins>;
  /** Permissions for the current user on this user */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Profile Image for the user */
  profileImage?: Maybe<UploadedFileWithPreview>;
  /**
   * Roles for the user
   *
   * Only populated when logged in user is same as this user or have company action manage users
   */
  roles: Array<Role>;
  /** Sessions */
  sessions: Array<UserSession>;
  /** List of user companies based on roles & user groups */
  userCompanyList: Array<Company>;
  /**
   * User Group for the user
   *
   * Only populated when logged in user is same as this user or have company action manage users
   */
  userGroups: Array<UserGroup>;
  /** Versioning */
  versioning: SimpleVersioning;
  /** WebAuthn keys */
  webAuthnKeys: Array<UserWebAuthnKey>;
};


export type UserAvailableCompaniesArgs = {
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type UserPermissionWithOriginsArgs = {
  filter?: InputMaybe<UserFilteringRule>;
};


export type UserRolesArgs = {
  filter?: InputMaybe<UserFilteringRule>;
};


export type UserUserGroupsArgs = {
  filter?: InputMaybe<UserFilteringRule>;
};

export enum UserAsset {
  ProfileImage = 'ProfileImage'
}

export type UserAssigned = {
  __typename: 'UserAssigned';
  applications?: Maybe<Array<Application>>;
  events?: Maybe<Array<Event>>;
  modules?: Maybe<Array<Module>>;
};

export type UserDeletionResult = {
  __typename: 'UserDeletionResult';
  assigned?: Maybe<UserAssigned>;
  availableAssignees?: Maybe<Array<Maybe<User>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UserFilteringRule = {
  /** Filter by active */
  actives?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Filter by multiple company IDs */
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Filter by last signed in */
  lastSignedIn?: InputMaybe<Array<Timeframe>>;
  /** Filter by mobile number */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Filter by role */
  roles?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by User Group */
  userGroups?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export type UserGroup = {
  __typename: 'UserGroup';
  /** Company owning this user group */
  company: Company;
  /** Dealer IDs */
  dealerIds: Array<Scalars['ObjectID']['output']>;
  /** Dealers related to user group */
  dealers: Array<Dealer>;
  /** Description */
  description: Scalars['String']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Active Status */
  isActive: Scalars['Boolean']['output'];
  /** Is parallel */
  isParallel: Scalars['Boolean']['output'];
  /** Superior User Groups ID */
  superiorUserGroupIds: Array<Scalars['ObjectID']['output']>;
  /** Superior User Groups */
  superiorUserGroups: Array<UserGroup>;
  /** Number of users in the user group */
  userCount: Scalars['Int']['output'];
  /** Permissions for the current user on this user group */
  userGroupPermissions: Array<Maybe<Scalars['String']['output']>>;
  /** Users in the user group */
  users: Array<User>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type UserGroupFilteringRule = {
  /** Filter by company ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type UserGroupSettings = {
  /** Description */
  description: Scalars['String']['input'];
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Active Status */
  isActive: Scalars['Boolean']['input'];
  /** Is parallel */
  isParallel: Scalars['Boolean']['input'];
  /** Superior user groups */
  superiorUserGroupIds: Array<Scalars['ObjectID']['input']>;
};

export enum UserGroupSortingField {
  /** Sort by display name */
  DisplayName = 'DisplayName',
  /** Sort by user count */
  UserCount = 'UserCount'
}

export type UserGroupSortingRule = {
  /** Field on which to apply the sorting */
  field: UserGroupSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type UserSession = {
  __typename: 'UserSession';
  /** Country */
  country?: Maybe<Scalars['String']['output']>;
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Expiration date */
  expiresAt: Scalars['DateTime']['output'];
  /** Session ID */
  id: Scalars['ObjectID']['output'];
  /** IP */
  ip: Scalars['String']['output'];
  /** Last activity date */
  lastActivityAt: Scalars['DateTime']['output'];
  /** User agent */
  userAgent: Scalars['String']['output'];
};

export type UserSessionRevoked = {
  __typename: 'UserSessionRevoked';
  date: Scalars['DateTime']['output'];
  displayNotice: Scalars['Boolean']['output'];
};

export type UserSettings = {
  /** Alias */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  /** Email */
  email: Scalars['String']['input'];
  /** Active */
  isActive: Scalars['Boolean']['input'];
  /** Mobile for the user */
  mobile: PhonePayload;
  /** Role IDs */
  roleIds: Array<Scalars['ObjectID']['input']>;
  /** Role IDs */
  userGroupIds: Array<Scalars['ObjectID']['input']>;
};

export enum UserSortingField {
  /** Sort by authenticator enabled state */
  Authenticator = 'Authenticator',
  /** Sort by company */
  Company = 'Company',
  /** Sort by name */
  DisplayName = 'DisplayName',
  /** Sort by email */
  Email = 'Email',
  /** Sort by last signin */
  LastSignedIn = 'LastSignedIn',
  /** Sort by mobile */
  Mobile = 'Mobile',
  /** Sort by role */
  Role = 'Role',
  /** Sort by user group */
  UserGroup = 'UserGroup'
}

export type UserSortingRule = {
  /** Field on which apply the sorting */
  field: UserSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type UserWebAuthnKey = {
  __typename: 'UserWebAuthnKey';
  /** Expiration date */
  expiresAt: Scalars['DateTime']['output'];
  /** Key object ID */
  id: Scalars['ObjectID']['output'];
  /** Last usage date */
  lastUsed?: Maybe<Scalars['DateTime']['output']>;
  /** Raw key ID */
  rawKeyId: Scalars['String']['output'];
  /** User Agent */
  userAgent: Scalars['String']['output'];
};

export type UserlikeChatbotModule = Module & {
  __typename: 'UserlikeChatbotModule';
  /** Chatbot settings under current module */
  chatbotSettings: Array<UserlikeChatbotSetting>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type UserlikeChatbotModuleInput = {
  displayName: Scalars['String']['input'];
};

export type UserlikeChatbotSetting = LiveChatSetting & {
  __typename: 'UserlikeChatbotSetting';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Chatbot Module Id */
  liveChatModuleId: Scalars['ObjectID']['output'];
  /** Userlike script */
  script: Scalars['String']['output'];
};

export type UserlikeChatbotSettingsInput = {
  displayName: Scalars['String']['input'];
  script: Scalars['String']['input'];
};

export type VatRateSettingItem = {
  __typename: 'VATRateSettingItem';
  /** start date of the VAT rate */
  startDate: Scalars['DateTime']['output'];
  /** Value */
  value: Scalars['Float']['output'];
};

export type VatRateSettingItemInput = {
  /** start date of the VAT rate */
  startDate: Scalars['DateTime']['input'];
  /** Value */
  value: Scalars['Float']['input'];
};

export type VatRateSettings = {
  __typename: 'VATRateSettings';
  /** The applied VAT rate */
  appliedVATRate?: Maybe<Scalars['Float']['output']>;
  /** VAT rate table settings */
  vatRateTable: Array<VatRateSettingItem>;
};

export type VatRateSettingsInput = {
  /** The applied VAT rate */
  appliedVATRate?: InputMaybe<Scalars['Float']['input']>;
  /** VAT rate table settings */
  vatRateTable: Array<VatRateSettingItemInput>;
};

export enum VariantAsset {
  Brochure = 'Brochure',
  Picture = 'Picture'
}

export type VariantBankCodeMapping = {
  __typename: 'VariantBankCodeMapping';
  /** bank */
  bank: SystemBank;
  /** bankId */
  bankId: Scalars['ObjectID']['output'];
  /** code */
  code: Scalars['String']['output'];
};

export type VariantBankCodeMappingInput = {
  /** Bank ID */
  bankId: Scalars['ObjectID']['input'];
  /** Code */
  code: Scalars['String']['input'];
};

export type VariantConfigurator = {
  __typename: 'VariantConfigurator';
  /** Block IDs */
  blockIds: Array<Scalars['ObjectID']['output']>;
  /** Array of blocks */
  blocks: Array<Block>;
  /** Color block */
  colorBlock?: Maybe<ColorBlock>;
  /** Company relevant to this variant, pulled from module */
  company: Company;
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Stock Inventory */
  inventories: Array<Inventory>;
  /** Image Matrix */
  matrix: Array<Matrix>;
  /** Model Configurator */
  modelConfigurator: ModelConfigurator;
  /** Model Configurator ID */
  modelConfiguratorId: Scalars['ObjectID']['output'];
  /** Configurator Module */
  module: Module;
  /** Configurator Module ID */
  moduleId: Scalars['ObjectID']['output'];
  /** Options blocks */
  optionsBlocks: Array<OptionsBlock>;
  /** Package blocks */
  packageBlock?: Maybe<PackageBlock>;
  /** Available permissions for variant configurator */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Trim blocks */
  trimBlock?: Maybe<TrimBlock>;
  /** Variant */
  variant: Vehicle;
  /** Variant Suite ID */
  variantId: Scalars['ObjectID']['output'];
  /** Vehicle Price */
  vehiclePrice: Scalars['Float']['output'];
  /** Versioning */
  versioning: SimpleVersioning;
};


export type VariantConfiguratorInventoriesArgs = {
  dealerId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum VariantConfiguratorAsset {
  AdditionalDetailsImage = 'AdditionalDetailsImage',
  ColorSettingImage = 'ColorSettingImage',
  OptionsSectionImages = 'OptionsSectionImages',
  OptionsSettingImage = 'OptionsSettingImage',
  PackageSectionImage = 'PackageSectionImage',
  TrimSettingImage = 'TrimSettingImage'
}

export type VariantConfiguratorFilteringRule = {
  /** Filter by display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type VariantConfiguratorSettings = {
  blocks: Array<BlockInput>;
};

export enum VariantConfiguratorSortingField {
  /** Sort by display name */
  DisplayName = 'DisplayName'
}

export type VariantConfiguratorSortingRule = {
  /** Field on which to apply the sorting */
  field: VariantConfiguratorSortingField;
  /** Sorting order */
  order: SortingOrder;
};

export type VariantReferenceParameters = {
  __typename: 'VariantReferenceParameters';
  engineType: Array<EngineType>;
  isAddOnSpecificVehicles: Scalars['Boolean']['output'];
};

export type VariantReferenceParametersPayload = {
  engineType: Array<EngineType>;
  isAddOnSpecificVehicles: Scalars['Boolean']['input'];
};

export type Vehicle = {
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** ID/ identifier */
  identifier: Scalars['String']['output'];
  /** Is Active */
  isActive: Scalars['Boolean']['output'];
  /** Is deletable */
  isDeletable: Scalars['Boolean']['output'];
  /** Is deleted */
  isDeleted: Scalars['Boolean']['output'];
  /** Module */
  module: Module;
  /** Module ID */
  moduleId: Scalars['ObjectID']['output'];
  /** Name */
  name: TranslatedString;
  /** Order Number */
  order: Scalars['Int']['output'];
  /** Versioning */
  versioning: AdvancedVersioning;
};

export type VehicleCharacteristic = {
  __typename: 'VehicleCharacteristic';
  highlighted: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export enum VehicleCondition {
  New = 'New',
  Used = 'Used'
}

export type VehicleFilteringRule = {
  /** Filter by compnay ID */
  companyId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter by model ids */
  modelIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Filter by vehicle module id */
  moduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Additional filter for submodel */
  parentModelId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter for specific vehicle kind */
  vehicleKind?: InputMaybe<VehicleKind>;
  /** Filter for grouped vehicle kinds */
  vehicleKinds?: InputMaybe<Array<VehicleKind>>;
};

export type VehicleImage = {
  __typename: 'VehicleImage';
  id: Scalars['String']['output'];
  variants: Array<VehicleImageVariant>;
};


export type VehicleImageVariantsArgs = {
  maximumWidth?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleImageTypeEdge = {
  __typename: 'VehicleImageTypeEdge';
  node: VehicleImage;
};

export type VehicleImageVariant = {
  __typename: 'VehicleImageVariant';
  height: Scalars['Int']['output'];
  mimeType: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type VehicleImagesConnection = {
  __typename: 'VehicleImagesConnection';
  edges: Array<VehicleImageTypeEdge>;
};

export enum VehicleKind {
  FinderVehicle = 'FinderVehicle',
  LocalMake = 'LocalMake',
  LocalModel = 'LocalModel',
  LocalVariant = 'LocalVariant'
}

export type VehicleModule = {
  __typename: 'VehicleModule';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Vehicle Module ID */
  id: Scalars['ObjectID']['output'];
};

export type VehicleReferenceParameters = {
  __typename: 'VehicleReferenceParameters';
  finderVehicle: FinderVehicleReferenceParameters;
  variant: VariantReferenceParameters;
};

export type VehicleReferenceParametersPayload = {
  finderVehicle: FinderVehicleReferenceParametersPayload;
  variant: VariantReferenceParametersPayload;
};

export enum VehicleScheme {
  Normal = 'Normal',
  Opc = 'OPC'
}

export type VehicleSortingRule = {
  localMakeSortingRule?: InputMaybe<LocalMakeSortingRule>;
  localModelSortingRule?: InputMaybe<LocalModelSortingRule>;
  localVariantSortingRule?: InputMaybe<LocalVariantSortingRule>;
  sortingRuleType: SortingRuleType;
};

export enum VehicleType {
  Classic = 'classic',
  New = 'new',
  PorscheApproved = 'porsche_approved',
  Used = 'used'
}

export type VehicleVideo = {
  __typename: 'VehicleVideo';
  id: Scalars['String']['output'];
};

export type VerifyEmailUpdateLink = {
  __typename: 'VerifyEmailUpdateLink';
  email: Scalars['String']['output'];
  token: Scalars['String']['output'];
  userId: Scalars['ObjectID']['output'];
};

export type Warranty = {
  __typename: 'Warranty';
  porscheApproved: Scalars['Boolean']['output'];
};

export type WebCalcSetting = {
  __typename: 'WebCalcSetting';
  calculationUrl: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
};

export type WebCalcSettingPayload = {
  calculationUrl: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  domain: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type WebPage = {
  __typename: 'WebPage';
  bannerImage?: Maybe<UploadedFileWithPreview>;
  bannerSubTitle?: Maybe<TranslatedString>;
  bannerTitle?: Maybe<TranslatedString>;
  id: Scalars['ObjectID']['output'];
  isActive: Scalars['Boolean']['output'];
  liveChatDisplay?: Maybe<Scalars['Boolean']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  mobileBannerImage?: Maybe<UploadedFileWithPreview>;
  module: Module;
  moduleId: Scalars['ObjectID']['output'];
  pageTitle: TranslatedString;
  urlSlug: Scalars['String']['output'];
  versioning: SimpleVersioning;
  webPageBlock: Array<WebPageBlock>;
};

export enum WebPageAsset {
  Column = 'Column',
  Details = 'Details',
  Image = 'Image',
  ImageDescription = 'ImageDescription',
  MobileDetails = 'MobileDetails',
  TypeImage = 'TypeImage'
}

export type WebPageBlock = {
  id: Scalars['ObjectID']['output'];
  type: WebPageBlockType;
};

export enum WebPageBlockBackground {
  Black = 'Black',
  White = 'White'
}

export type WebPageBlockInput = {
  columnBlockInput?: InputMaybe<ColumnWebPageBlockInput>;
  customBlockInput?: InputMaybe<CustomWebPageBlockInput>;
  imageBlockInput?: InputMaybe<ImageWebPageBlockInput>;
  textCarouselBlockInput?: InputMaybe<TextCarouselWebPageBlockInput>;
  textImageBlockInput?: InputMaybe<TextImageWebPageBlockInput>;
};

export enum WebPageBlockPosition {
  Left = 'Left',
  Right = 'Right'
}

export enum WebPageBlockType {
  Column = 'Column',
  Custom = 'Custom',
  Image = 'Image',
  TextCarousel = 'TextCarousel',
  TextImage = 'TextImage'
}

export type WebPageButton = {
  __typename: 'WebPageButton';
  isActive?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<TranslatedString>;
  url?: Maybe<Scalars['String']['output']>;
};

export type WebPageButtonInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<TranslatedStringInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WebPageEndpoint = Endpoint & {
  __typename: 'WebPageEndpoint';
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Pathname */
  pathname: Scalars['String']['output'];
  /** Endpoint Title */
  title: Scalars['String']['output'];
  /** Web Page ID */
  webPageId: Scalars['ObjectID']['output'];
  /** Webpage Paths */
  webpagePaths: Array<WebPagePath>;
  /** Website Module */
  websiteModule: WebsiteModule;
  /** Website Module ID */
  websiteModuleId: Scalars['ObjectID']['output'];
};

export type WebPageEndpointSettings = {
  /** Pathname */
  pathname: Scalars['String']['input'];
  /** Endpoint Title */
  title: Scalars['String']['input'];
  /** Web Page ID */
  webPageId: Scalars['ObjectID']['input'];
};

export type WebPageFilteringRule = {
  companyIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
};

export type WebPageInput = {
  bannerSubTitle?: InputMaybe<TranslatedStringInput>;
  bannerTitle?: InputMaybe<TranslatedStringInput>;
  isActive: Scalars['Boolean']['input'];
  liveChatDisplay?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle: TranslatedStringInput;
  urlSlug: Scalars['String']['input'];
};

export type WebPagePath = {
  __typename: 'WebPagePath';
  /** Webpage ID */
  webpageId: Scalars['ObjectID']['output'];
  /** Webpage subpath */
  webpageSubpath: Scalars['String']['output'];
};

export enum WebPageSortingField {
  Company = 'Company',
  Date = 'Date',
  PageTitle = 'PageTitle',
  IsActive = 'isActive'
}

export type WebPageSortingRule = {
  field: WebPageSortingField;
  order: SortingOrder;
};

export type WebPublicKeyCredentialRegistrationRequest = {
  __typename: 'WebPublicKeyCredentialRegistrationRequest';
  /** Options for WebAuthn */
  options: Scalars['JSONObject']['output'];
  /** Token to proceed with registration */
  token: Scalars['String']['output'];
};

export type WebsiteModule = Module & {
  __typename: 'WebsiteModule';
  address?: Maybe<Scalars['String']['output']>;
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Live chat setting */
  liveChatSetting?: Maybe<LiveChatSetting>;
  /** Live chat settings */
  liveChatSettingId?: Maybe<Scalars['ObjectID']['output']>;
  options: WebsiteModuleOptions;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  phone: Phone;
  socialMedia: Array<EdmEmailSocialMedia>;
  versioning: SimpleVersioning;
};

export type WebsiteModuleLocationOption = {
  __typename: 'WebsiteModuleLocationOption';
  country: Scalars['String']['output'];
  region: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type WebsiteModuleLocationOptionPayload = {
  country: Scalars['String']['input'];
  region: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type WebsiteModuleOptions = {
  __typename: 'WebsiteModuleOptions';
  locations: Array<WebsiteModuleLocationOption>;
};

export type WebsiteModuleOptionsPayload = {
  locations: Array<WebsiteModuleLocationOptionPayload>;
};

export type WhatsappLiveChatModule = Module & {
  __typename: 'WhatsappLiveChatModule';
  /** Company */
  company: Company;
  /** Company ID */
  companyId: Scalars['ObjectID']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Live chat settings under current module */
  liveChatSettings: Array<WhatsappLiveChatSetting>;
  /** Permissions */
  permissions: Array<Maybe<Scalars['String']['output']>>;
  /** Versioning */
  versioning: SimpleVersioning;
};

export type WhatsappLiveChatModuleInput = {
  displayName: Scalars['String']['input'];
};

export type WhatsappLiveChatSetting = LiveChatSetting & {
  __typename: 'WhatsappLiveChatSetting';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** UID */
  id: Scalars['ObjectID']['output'];
  /** Whatsapp Link */
  link: Scalars['String']['output'];
  /** Live Chat Module Id */
  liveChatModuleId: Scalars['ObjectID']['output'];
};

export type WhatsappLiveChatSettingsInput = {
  displayName: Scalars['String']['input'];
  link: Scalars['String']['input'];
};
